
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3QTul", function(module, exports) {
"use strict";

module.exports = (parcelRequire("iQfSc"));

});
parcelRegister("iQfSc", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $db796568947a23e2$export$ffb0004e005737fa; }, function (v) { return $db796568947a23e2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $db796568947a23e2$export$34b9dba7ce09269b; }, function (v) { return $db796568947a23e2$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $db796568947a23e2$export$25062201e9e25d76; }, function (v) { return $db796568947a23e2$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $db796568947a23e2$export$ffb0004e005737fa;
var $db796568947a23e2$export$34b9dba7ce09269b;
var $db796568947a23e2$export$25062201e9e25d76;
"use strict";
var $db796568947a23e2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $db796568947a23e2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $db796568947a23e2$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $db796568947a23e2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$db796568947a23e2$export$ffb0004e005737fa = $db796568947a23e2$var$REACT_FRAGMENT_TYPE;
$db796568947a23e2$export$34b9dba7ce09269b = $db796568947a23e2$var$jsxProd;
$db796568947a23e2$export$25062201e9e25d76 = $db796568947a23e2$var$jsxProd;

});


parcelRegister("40TyJ", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $2ec24268596b8ed9$export$882461b6382ed46c; }, function (v) { return $2ec24268596b8ed9$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $2ec24268596b8ed9$export$757ceba2d55c277e; }, function (v) { return $2ec24268596b8ed9$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $2ec24268596b8ed9$export$83d89fbfd8236492; }, function (v) { return $2ec24268596b8ed9$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $2ec24268596b8ed9$export$882461b6382ed46c;
var $2ec24268596b8ed9$export$757ceba2d55c277e;
var $2ec24268596b8ed9$export$83d89fbfd8236492;

var $jCqV7 = parcelRequire("jCqV7");
"use strict";

var $dns5Y = parcelRequire("dns5Y");

var $1kowh = parcelRequire("1kowh");

var $2exNI = parcelRequire("2exNI");
function $2ec24268596b8ed9$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $2ec24268596b8ed9$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $2ec24268596b8ed9$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $2ec24268596b8ed9$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $2ec24268596b8ed9$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $2ec24268596b8ed9$var$assertIsMounted(fiber) {
    if ($2ec24268596b8ed9$var$getNearestMountedFiber(fiber) !== fiber) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(188));
}
function $2ec24268596b8ed9$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $2ec24268596b8ed9$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $2ec24268596b8ed9$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $2ec24268596b8ed9$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $2ec24268596b8ed9$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $2ec24268596b8ed9$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $2ec24268596b8ed9$var$assign = Object.assign, $2ec24268596b8ed9$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $2ec24268596b8ed9$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $2ec24268596b8ed9$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $2ec24268596b8ed9$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $2ec24268596b8ed9$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $2ec24268596b8ed9$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $2ec24268596b8ed9$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $2ec24268596b8ed9$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $2ec24268596b8ed9$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $2ec24268596b8ed9$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $2ec24268596b8ed9$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $2ec24268596b8ed9$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $2ec24268596b8ed9$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $2ec24268596b8ed9$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $2ec24268596b8ed9$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $2ec24268596b8ed9$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $2ec24268596b8ed9$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $2ec24268596b8ed9$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$2ec24268596b8ed9$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $2ec24268596b8ed9$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $2ec24268596b8ed9$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $2ec24268596b8ed9$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $2ec24268596b8ed9$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $2ec24268596b8ed9$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $2ec24268596b8ed9$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $2ec24268596b8ed9$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $2ec24268596b8ed9$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $2ec24268596b8ed9$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $2ec24268596b8ed9$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $2ec24268596b8ed9$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $2ec24268596b8ed9$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $2ec24268596b8ed9$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $2ec24268596b8ed9$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $2ec24268596b8ed9$var$getComponentNameFromType(type.type) || "Memo";
        case $2ec24268596b8ed9$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $2ec24268596b8ed9$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $2ec24268596b8ed9$var$isArrayImpl = Array.isArray, $2ec24268596b8ed9$var$ReactSharedInternals = $1kowh.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $2ec24268596b8ed9$var$ReactDOMSharedInternals = $2exNI.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $2ec24268596b8ed9$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $2ec24268596b8ed9$var$valueStack = [], $2ec24268596b8ed9$var$index = -1;
function $2ec24268596b8ed9$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $2ec24268596b8ed9$var$pop(cursor) {
    0 > $2ec24268596b8ed9$var$index || (cursor.current = $2ec24268596b8ed9$var$valueStack[$2ec24268596b8ed9$var$index], $2ec24268596b8ed9$var$valueStack[$2ec24268596b8ed9$var$index] = null, $2ec24268596b8ed9$var$index--);
}
function $2ec24268596b8ed9$var$push(cursor, value) {
    $2ec24268596b8ed9$var$index++;
    $2ec24268596b8ed9$var$valueStack[$2ec24268596b8ed9$var$index] = cursor.current;
    cursor.current = value;
}
var $2ec24268596b8ed9$var$contextStackCursor = $2ec24268596b8ed9$var$createCursor(null), $2ec24268596b8ed9$var$contextFiberStackCursor = $2ec24268596b8ed9$var$createCursor(null), $2ec24268596b8ed9$var$rootInstanceStackCursor = $2ec24268596b8ed9$var$createCursor(null), $2ec24268596b8ed9$var$hostTransitionProviderCursor = $2ec24268596b8ed9$var$createCursor(null);
function $2ec24268596b8ed9$var$pushHostContainer(fiber, nextRootInstance) {
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$rootInstanceStackCursor, nextRootInstance);
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$contextFiberStackCursor, fiber);
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $2ec24268596b8ed9$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $2ec24268596b8ed9$var$getOwnHostContext(nextRootInstance), fiber = $2ec24268596b8ed9$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$contextStackCursor);
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$contextStackCursor, fiber);
}
function $2ec24268596b8ed9$var$popHostContainer() {
    $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$contextStackCursor);
    $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$contextFiberStackCursor);
    $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$rootInstanceStackCursor);
}
function $2ec24268596b8ed9$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$hostTransitionProviderCursor, fiber);
    var context = $2ec24268596b8ed9$var$contextStackCursor.current;
    var JSCompiler_inline_result = $2ec24268596b8ed9$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$contextFiberStackCursor, fiber), $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$contextStackCursor, JSCompiler_inline_result));
}
function $2ec24268596b8ed9$var$popHostContext(fiber) {
    $2ec24268596b8ed9$var$contextFiberStackCursor.current === fiber && ($2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$contextStackCursor), $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$contextFiberStackCursor));
    $2ec24268596b8ed9$var$hostTransitionProviderCursor.current === fiber && ($2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$hostTransitionProviderCursor), $2ec24268596b8ed9$var$HostTransitionContext._currentValue = $2ec24268596b8ed9$var$sharedNotPendingObject);
}
var $2ec24268596b8ed9$var$prefix, $2ec24268596b8ed9$var$suffix;
function $2ec24268596b8ed9$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $2ec24268596b8ed9$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $2ec24268596b8ed9$var$prefix = match && match[1] || "";
        $2ec24268596b8ed9$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $2ec24268596b8ed9$var$prefix + name + $2ec24268596b8ed9$var$suffix;
}
var $2ec24268596b8ed9$var$reentry = !1;
function $2ec24268596b8ed9$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $2ec24268596b8ed9$var$reentry) return "";
    $2ec24268596b8ed9$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $2ec24268596b8ed9$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $2ec24268596b8ed9$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $2ec24268596b8ed9$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $2ec24268596b8ed9$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $2ec24268596b8ed9$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $2ec24268596b8ed9$var$describeBuiltInComponentFrame("Suspense Fallback") : $2ec24268596b8ed9$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $2ec24268596b8ed9$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $2ec24268596b8ed9$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $2ec24268596b8ed9$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $2ec24268596b8ed9$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $2ec24268596b8ed9$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $2ec24268596b8ed9$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $2ec24268596b8ed9$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $2ec24268596b8ed9$var$hasOwnProperty = Object.prototype.hasOwnProperty, $2ec24268596b8ed9$var$scheduleCallback$3 = $dns5Y.unstable_scheduleCallback, $2ec24268596b8ed9$var$cancelCallback$1 = $dns5Y.unstable_cancelCallback, $2ec24268596b8ed9$var$shouldYield = $dns5Y.unstable_shouldYield, $2ec24268596b8ed9$var$requestPaint = $dns5Y.unstable_requestPaint, $2ec24268596b8ed9$var$now = $dns5Y.unstable_now, $2ec24268596b8ed9$var$getCurrentPriorityLevel = $dns5Y.unstable_getCurrentPriorityLevel, $2ec24268596b8ed9$var$ImmediatePriority = $dns5Y.unstable_ImmediatePriority, $2ec24268596b8ed9$var$UserBlockingPriority = $dns5Y.unstable_UserBlockingPriority, $2ec24268596b8ed9$var$NormalPriority$1 = $dns5Y.unstable_NormalPriority, $2ec24268596b8ed9$var$LowPriority = $dns5Y.unstable_LowPriority, $2ec24268596b8ed9$var$IdlePriority = $dns5Y.unstable_IdlePriority, $2ec24268596b8ed9$var$log$1 = $dns5Y.log, $2ec24268596b8ed9$var$unstable_setDisableYieldValue = $dns5Y.unstable_setDisableYieldValue, $2ec24268596b8ed9$var$rendererID = null, $2ec24268596b8ed9$var$injectedHook = null;
function $2ec24268596b8ed9$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $2ec24268596b8ed9$var$log$1 && $2ec24268596b8ed9$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($2ec24268596b8ed9$var$injectedHook && "function" === typeof $2ec24268596b8ed9$var$injectedHook.setStrictMode) try {
        $2ec24268596b8ed9$var$injectedHook.setStrictMode($2ec24268596b8ed9$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $2ec24268596b8ed9$var$clz32 = Math.clz32 ? Math.clz32 : $2ec24268596b8ed9$var$clz32Fallback, $2ec24268596b8ed9$var$log = Math.log, $2ec24268596b8ed9$var$LN2 = Math.LN2;
function $2ec24268596b8ed9$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($2ec24268596b8ed9$var$log(x) / $2ec24268596b8ed9$var$LN2 | 0) | 0;
}
var $2ec24268596b8ed9$var$nextTransitionUpdateLane = 256, $2ec24268596b8ed9$var$nextTransitionDeferredLane = 262144, $2ec24268596b8ed9$var$nextRetryLane = 4194304;
function $2ec24268596b8ed9$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $2ec24268596b8ed9$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $2ec24268596b8ed9$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $2ec24268596b8ed9$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $2ec24268596b8ed9$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $2ec24268596b8ed9$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $2ec24268596b8ed9$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $2ec24268596b8ed9$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $2ec24268596b8ed9$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $2ec24268596b8ed9$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $2ec24268596b8ed9$var$claimNextRetryLane() {
    var lane = $2ec24268596b8ed9$var$nextRetryLane;
    $2ec24268596b8ed9$var$nextRetryLane <<= 1;
    0 === ($2ec24268596b8ed9$var$nextRetryLane & 62914560) && ($2ec24268596b8ed9$var$nextRetryLane = 4194304);
    return lane;
}
function $2ec24268596b8ed9$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $2ec24268596b8ed9$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $2ec24268596b8ed9$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $2ec24268596b8ed9$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $2ec24268596b8ed9$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $2ec24268596b8ed9$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $2ec24268596b8ed9$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $2ec24268596b8ed9$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $2ec24268596b8ed9$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $2ec24268596b8ed9$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $2ec24268596b8ed9$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $2ec24268596b8ed9$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $2ec24268596b8ed9$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $2ec24268596b8ed9$var$resolveUpdatePriority() {
    var updatePriority = $2ec24268596b8ed9$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $2ec24268596b8ed9$var$getEventPriority(updatePriority.type);
}
function $2ec24268596b8ed9$var$runWithPriority(priority, fn) {
    var previousPriority = $2ec24268596b8ed9$var$ReactDOMSharedInternals.p;
    try {
        return $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $2ec24268596b8ed9$var$randomKey = Math.random().toString(36).slice(2), $2ec24268596b8ed9$var$internalInstanceKey = "__reactFiber$" + $2ec24268596b8ed9$var$randomKey, $2ec24268596b8ed9$var$internalPropsKey = "__reactProps$" + $2ec24268596b8ed9$var$randomKey, $2ec24268596b8ed9$var$internalContainerInstanceKey = "__reactContainer$" + $2ec24268596b8ed9$var$randomKey, $2ec24268596b8ed9$var$internalEventHandlersKey = "__reactEvents$" + $2ec24268596b8ed9$var$randomKey, $2ec24268596b8ed9$var$internalEventHandlerListenersKey = "__reactListeners$" + $2ec24268596b8ed9$var$randomKey, $2ec24268596b8ed9$var$internalEventHandlesSetKey = "__reactHandles$" + $2ec24268596b8ed9$var$randomKey, $2ec24268596b8ed9$var$internalRootNodeResourcesKey = "__reactResources$" + $2ec24268596b8ed9$var$randomKey, $2ec24268596b8ed9$var$internalHoistableMarker = "__reactMarker$" + $2ec24268596b8ed9$var$randomKey;
function $2ec24268596b8ed9$var$detachDeletedInstance(node) {
    delete node[$2ec24268596b8ed9$var$internalInstanceKey];
    delete node[$2ec24268596b8ed9$var$internalPropsKey];
    delete node[$2ec24268596b8ed9$var$internalEventHandlersKey];
    delete node[$2ec24268596b8ed9$var$internalEventHandlerListenersKey];
    delete node[$2ec24268596b8ed9$var$internalEventHandlesSetKey];
}
function $2ec24268596b8ed9$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$2ec24268596b8ed9$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$2ec24268596b8ed9$var$internalContainerInstanceKey] || parentNode[$2ec24268596b8ed9$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $2ec24268596b8ed9$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$2ec24268596b8ed9$var$internalInstanceKey]) return parentNode;
                targetNode = $2ec24268596b8ed9$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $2ec24268596b8ed9$var$getInstanceFromNode(node) {
    if (node = node[$2ec24268596b8ed9$var$internalInstanceKey] || node[$2ec24268596b8ed9$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $2ec24268596b8ed9$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(33));
}
function $2ec24268596b8ed9$var$getResourcesFromRoot(root) {
    var resources = root[$2ec24268596b8ed9$var$internalRootNodeResourcesKey];
    resources || (resources = root[$2ec24268596b8ed9$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $2ec24268596b8ed9$var$markNodeAsHoistable(node) {
    node[$2ec24268596b8ed9$var$internalHoistableMarker] = !0;
}
var $2ec24268596b8ed9$var$allNativeEvents = new Set(), $2ec24268596b8ed9$var$registrationNameDependencies = {};
function $2ec24268596b8ed9$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $2ec24268596b8ed9$var$registerDirectEvent(registrationName, dependencies);
    $2ec24268596b8ed9$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $2ec24268596b8ed9$var$registerDirectEvent(registrationName, dependencies) {
    $2ec24268596b8ed9$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$2ec24268596b8ed9$var$allNativeEvents.add(dependencies[registrationName]);
}
var $2ec24268596b8ed9$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $2ec24268596b8ed9$var$illegalAttributeNameCache = {}, $2ec24268596b8ed9$var$validatedAttributeNameCache = {};
function $2ec24268596b8ed9$var$isAttributeNameSafe(attributeName) {
    if ($2ec24268596b8ed9$var$hasOwnProperty.call($2ec24268596b8ed9$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($2ec24268596b8ed9$var$hasOwnProperty.call($2ec24268596b8ed9$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($2ec24268596b8ed9$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $2ec24268596b8ed9$var$validatedAttributeNameCache[attributeName] = !0;
    $2ec24268596b8ed9$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $2ec24268596b8ed9$var$setValueForAttribute(node, name, value) {
    if ($2ec24268596b8ed9$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $2ec24268596b8ed9$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $2ec24268596b8ed9$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $2ec24268596b8ed9$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $2ec24268596b8ed9$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $2ec24268596b8ed9$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $2ec24268596b8ed9$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $2ec24268596b8ed9$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $2ec24268596b8ed9$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $2ec24268596b8ed9$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $2ec24268596b8ed9$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $2ec24268596b8ed9$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $2ec24268596b8ed9$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $2ec24268596b8ed9$var$getToStringValue(value);
        } else element.value !== "" + $2ec24268596b8ed9$var$getToStringValue(value) && (element.value = "" + $2ec24268596b8ed9$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $2ec24268596b8ed9$var$setDefaultValue(element, type, $2ec24268596b8ed9$var$getToStringValue(value)) : null != defaultValue ? $2ec24268596b8ed9$var$setDefaultValue(element, type, $2ec24268596b8ed9$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $2ec24268596b8ed9$var$getToStringValue(name) : element.removeAttribute("name");
}
function $2ec24268596b8ed9$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $2ec24268596b8ed9$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $2ec24268596b8ed9$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $2ec24268596b8ed9$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $2ec24268596b8ed9$var$track(element);
}
function $2ec24268596b8ed9$var$setDefaultValue(node, type, value) {
    "number" === type && $2ec24268596b8ed9$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $2ec24268596b8ed9$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $2ec24268596b8ed9$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $2ec24268596b8ed9$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $2ec24268596b8ed9$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $2ec24268596b8ed9$var$getToStringValue(defaultValue) : "";
}
function $2ec24268596b8ed9$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(92));
            if ($2ec24268596b8ed9$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $2ec24268596b8ed9$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $2ec24268596b8ed9$var$track(element);
}
function $2ec24268596b8ed9$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $2ec24268596b8ed9$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $2ec24268596b8ed9$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $2ec24268596b8ed9$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $2ec24268596b8ed9$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $2ec24268596b8ed9$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $2ec24268596b8ed9$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $2ec24268596b8ed9$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $2ec24268596b8ed9$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $2ec24268596b8ed9$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $2ec24268596b8ed9$var$sanitizeURL(url) {
    return $2ec24268596b8ed9$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $2ec24268596b8ed9$var$noop$1() {}
var $2ec24268596b8ed9$var$currentReplayingEvent = null;
function $2ec24268596b8ed9$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $2ec24268596b8ed9$var$restoreTarget = null, $2ec24268596b8ed9$var$restoreQueue = null;
function $2ec24268596b8ed9$var$restoreStateOfTarget(target) {
    var internalInstance = $2ec24268596b8ed9$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$2ec24268596b8ed9$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $2ec24268596b8ed9$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$2ec24268596b8ed9$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(90));
                            $2ec24268596b8ed9$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $2ec24268596b8ed9$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $2ec24268596b8ed9$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $2ec24268596b8ed9$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $2ec24268596b8ed9$var$isInsideEventHandler = !1;
function $2ec24268596b8ed9$var$batchedUpdates$1(fn, a, b) {
    if ($2ec24268596b8ed9$var$isInsideEventHandler) return fn(a, b);
    $2ec24268596b8ed9$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($2ec24268596b8ed9$var$isInsideEventHandler = !1, null !== $2ec24268596b8ed9$var$restoreTarget || null !== $2ec24268596b8ed9$var$restoreQueue) {
            if ($2ec24268596b8ed9$var$flushSyncWork$1(), $2ec24268596b8ed9$var$restoreTarget && (a = $2ec24268596b8ed9$var$restoreTarget, fn = $2ec24268596b8ed9$var$restoreQueue, $2ec24268596b8ed9$var$restoreQueue = $2ec24268596b8ed9$var$restoreTarget = null, $2ec24268596b8ed9$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$2ec24268596b8ed9$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $2ec24268596b8ed9$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$2ec24268596b8ed9$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $2ec24268596b8ed9$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $2ec24268596b8ed9$var$passiveBrowserEventsSupported = !1;
if ($2ec24268596b8ed9$var$canUseDOM) try {
    var $2ec24268596b8ed9$var$options = {};
    Object.defineProperty($2ec24268596b8ed9$var$options, "passive", {
        get: function() {
            $2ec24268596b8ed9$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $2ec24268596b8ed9$var$options, $2ec24268596b8ed9$var$options);
    window.removeEventListener("test", $2ec24268596b8ed9$var$options, $2ec24268596b8ed9$var$options);
} catch (e) {
    $2ec24268596b8ed9$var$passiveBrowserEventsSupported = !1;
}
var $2ec24268596b8ed9$var$root = null, $2ec24268596b8ed9$var$startText = null, $2ec24268596b8ed9$var$fallbackText = null;
function $2ec24268596b8ed9$var$getData() {
    if ($2ec24268596b8ed9$var$fallbackText) return $2ec24268596b8ed9$var$fallbackText;
    var start, startValue = $2ec24268596b8ed9$var$startText, startLength = startValue.length, end, endValue = "value" in $2ec24268596b8ed9$var$root ? $2ec24268596b8ed9$var$root.value : $2ec24268596b8ed9$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $2ec24268596b8ed9$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $2ec24268596b8ed9$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $2ec24268596b8ed9$var$functionThatReturnsTrue() {
    return !0;
}
function $2ec24268596b8ed9$var$functionThatReturnsFalse() {
    return !1;
}
function $2ec24268596b8ed9$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $2ec24268596b8ed9$var$functionThatReturnsTrue : $2ec24268596b8ed9$var$functionThatReturnsFalse;
        this.isPropagationStopped = $2ec24268596b8ed9$var$functionThatReturnsFalse;
        return this;
    }
    $2ec24268596b8ed9$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $2ec24268596b8ed9$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $2ec24268596b8ed9$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $2ec24268596b8ed9$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $2ec24268596b8ed9$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $2ec24268596b8ed9$var$SyntheticEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$EventInterface), $2ec24268596b8ed9$var$UIEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$EventInterface, {
    view: 0,
    detail: 0
}), $2ec24268596b8ed9$var$SyntheticUIEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$UIEventInterface), $2ec24268596b8ed9$var$lastMovementX, $2ec24268596b8ed9$var$lastMovementY, $2ec24268596b8ed9$var$lastMouseEvent, $2ec24268596b8ed9$var$MouseEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $2ec24268596b8ed9$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $2ec24268596b8ed9$var$lastMouseEvent && ($2ec24268596b8ed9$var$lastMouseEvent && "mousemove" === event.type ? ($2ec24268596b8ed9$var$lastMovementX = event.screenX - $2ec24268596b8ed9$var$lastMouseEvent.screenX, $2ec24268596b8ed9$var$lastMovementY = event.screenY - $2ec24268596b8ed9$var$lastMouseEvent.screenY) : $2ec24268596b8ed9$var$lastMovementY = $2ec24268596b8ed9$var$lastMovementX = 0, $2ec24268596b8ed9$var$lastMouseEvent = event);
        return $2ec24268596b8ed9$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $2ec24268596b8ed9$var$lastMovementY;
    }
}), $2ec24268596b8ed9$var$SyntheticMouseEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$MouseEventInterface), $2ec24268596b8ed9$var$DragEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$MouseEventInterface, {
    dataTransfer: 0
}), $2ec24268596b8ed9$var$SyntheticDragEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$DragEventInterface), $2ec24268596b8ed9$var$FocusEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$UIEventInterface, {
    relatedTarget: 0
}), $2ec24268596b8ed9$var$SyntheticFocusEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$FocusEventInterface), $2ec24268596b8ed9$var$AnimationEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2ec24268596b8ed9$var$SyntheticAnimationEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$AnimationEventInterface), $2ec24268596b8ed9$var$ClipboardEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $2ec24268596b8ed9$var$SyntheticClipboardEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$ClipboardEventInterface), $2ec24268596b8ed9$var$CompositionEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$EventInterface, {
    data: 0
}), $2ec24268596b8ed9$var$SyntheticCompositionEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$CompositionEventInterface), $2ec24268596b8ed9$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $2ec24268596b8ed9$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $2ec24268596b8ed9$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $2ec24268596b8ed9$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $2ec24268596b8ed9$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $2ec24268596b8ed9$var$getEventModifierState() {
    return $2ec24268596b8ed9$var$modifierStateGetter;
}
var $2ec24268596b8ed9$var$KeyboardEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $2ec24268596b8ed9$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $2ec24268596b8ed9$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $2ec24268596b8ed9$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $2ec24268596b8ed9$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $2ec24268596b8ed9$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $2ec24268596b8ed9$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $2ec24268596b8ed9$var$SyntheticKeyboardEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$KeyboardEventInterface), $2ec24268596b8ed9$var$PointerEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $2ec24268596b8ed9$var$SyntheticPointerEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$PointerEventInterface), $2ec24268596b8ed9$var$TouchEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $2ec24268596b8ed9$var$getEventModifierState
}), $2ec24268596b8ed9$var$SyntheticTouchEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$TouchEventInterface), $2ec24268596b8ed9$var$TransitionEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2ec24268596b8ed9$var$SyntheticTransitionEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$TransitionEventInterface), $2ec24268596b8ed9$var$WheelEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $2ec24268596b8ed9$var$SyntheticWheelEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$WheelEventInterface), $2ec24268596b8ed9$var$ToggleEventInterface = $2ec24268596b8ed9$var$assign({}, $2ec24268596b8ed9$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $2ec24268596b8ed9$var$SyntheticToggleEvent = $2ec24268596b8ed9$var$createSyntheticEvent($2ec24268596b8ed9$var$ToggleEventInterface), $2ec24268596b8ed9$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $2ec24268596b8ed9$var$canUseCompositionEvent = $2ec24268596b8ed9$var$canUseDOM && "CompositionEvent" in window, $2ec24268596b8ed9$var$documentMode = null;
$2ec24268596b8ed9$var$canUseDOM && "documentMode" in document && ($2ec24268596b8ed9$var$documentMode = document.documentMode);
var $2ec24268596b8ed9$var$canUseTextInputEvent = $2ec24268596b8ed9$var$canUseDOM && "TextEvent" in window && !$2ec24268596b8ed9$var$documentMode, $2ec24268596b8ed9$var$useFallbackCompositionData = $2ec24268596b8ed9$var$canUseDOM && (!$2ec24268596b8ed9$var$canUseCompositionEvent || $2ec24268596b8ed9$var$documentMode && 8 < $2ec24268596b8ed9$var$documentMode && 11 >= $2ec24268596b8ed9$var$documentMode), $2ec24268596b8ed9$var$SPACEBAR_CHAR = String.fromCharCode(32), $2ec24268596b8ed9$var$hasSpaceKeypress = !1;
function $2ec24268596b8ed9$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $2ec24268596b8ed9$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $2ec24268596b8ed9$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $2ec24268596b8ed9$var$isComposing = !1;
function $2ec24268596b8ed9$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $2ec24268596b8ed9$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $2ec24268596b8ed9$var$hasSpaceKeypress = !0;
            return $2ec24268596b8ed9$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $2ec24268596b8ed9$var$SPACEBAR_CHAR && $2ec24268596b8ed9$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $2ec24268596b8ed9$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($2ec24268596b8ed9$var$isComposing) return "compositionend" === domEventName || !$2ec24268596b8ed9$var$canUseCompositionEvent && $2ec24268596b8ed9$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $2ec24268596b8ed9$var$getData(), $2ec24268596b8ed9$var$fallbackText = $2ec24268596b8ed9$var$startText = $2ec24268596b8ed9$var$root = null, $2ec24268596b8ed9$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $2ec24268596b8ed9$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $2ec24268596b8ed9$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $2ec24268596b8ed9$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$2ec24268596b8ed9$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $2ec24268596b8ed9$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $2ec24268596b8ed9$var$restoreTarget ? $2ec24268596b8ed9$var$restoreQueue ? $2ec24268596b8ed9$var$restoreQueue.push(target) : $2ec24268596b8ed9$var$restoreQueue = [
        target
    ] : $2ec24268596b8ed9$var$restoreTarget = target;
    inst = $2ec24268596b8ed9$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $2ec24268596b8ed9$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $2ec24268596b8ed9$var$activeElement$1 = null, $2ec24268596b8ed9$var$activeElementInst$1 = null;
function $2ec24268596b8ed9$var$runEventInBatch(dispatchQueue) {
    $2ec24268596b8ed9$var$processDispatchQueue(dispatchQueue, 0);
}
function $2ec24268596b8ed9$var$getInstIfValueChanged(targetInst) {
    var targetNode = $2ec24268596b8ed9$var$getNodeFromInstance(targetInst);
    if ($2ec24268596b8ed9$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $2ec24268596b8ed9$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $2ec24268596b8ed9$var$isInputEventSupported = !1;
if ($2ec24268596b8ed9$var$canUseDOM) {
    var $2ec24268596b8ed9$var$JSCompiler_inline_result$jscomp$286;
    if ($2ec24268596b8ed9$var$canUseDOM) {
        var $2ec24268596b8ed9$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$2ec24268596b8ed9$var$isSupported$jscomp$inline_427) {
            var $2ec24268596b8ed9$var$element$jscomp$inline_428 = document.createElement("div");
            $2ec24268596b8ed9$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $2ec24268596b8ed9$var$isSupported$jscomp$inline_427 = "function" === typeof $2ec24268596b8ed9$var$element$jscomp$inline_428.oninput;
        }
        $2ec24268596b8ed9$var$JSCompiler_inline_result$jscomp$286 = $2ec24268596b8ed9$var$isSupported$jscomp$inline_427;
    } else $2ec24268596b8ed9$var$JSCompiler_inline_result$jscomp$286 = !1;
    $2ec24268596b8ed9$var$isInputEventSupported = $2ec24268596b8ed9$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $2ec24268596b8ed9$var$stopWatchingForValueChange() {
    $2ec24268596b8ed9$var$activeElement$1 && ($2ec24268596b8ed9$var$activeElement$1.detachEvent("onpropertychange", $2ec24268596b8ed9$var$handlePropertyChange), $2ec24268596b8ed9$var$activeElementInst$1 = $2ec24268596b8ed9$var$activeElement$1 = null);
}
function $2ec24268596b8ed9$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $2ec24268596b8ed9$var$getInstIfValueChanged($2ec24268596b8ed9$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $2ec24268596b8ed9$var$createAndAccumulateChangeEvent(dispatchQueue, $2ec24268596b8ed9$var$activeElementInst$1, nativeEvent, $2ec24268596b8ed9$var$getEventTarget(nativeEvent));
        $2ec24268596b8ed9$var$batchedUpdates$1($2ec24268596b8ed9$var$runEventInBatch, dispatchQueue);
    }
}
function $2ec24268596b8ed9$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($2ec24268596b8ed9$var$stopWatchingForValueChange(), $2ec24268596b8ed9$var$activeElement$1 = target, $2ec24268596b8ed9$var$activeElementInst$1 = targetInst, $2ec24268596b8ed9$var$activeElement$1.attachEvent("onpropertychange", $2ec24268596b8ed9$var$handlePropertyChange)) : "focusout" === domEventName && $2ec24268596b8ed9$var$stopWatchingForValueChange();
}
function $2ec24268596b8ed9$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $2ec24268596b8ed9$var$getInstIfValueChanged($2ec24268596b8ed9$var$activeElementInst$1);
}
function $2ec24268596b8ed9$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $2ec24268596b8ed9$var$getInstIfValueChanged(targetInst);
}
function $2ec24268596b8ed9$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $2ec24268596b8ed9$var$getInstIfValueChanged(targetInst);
}
function $2ec24268596b8ed9$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $2ec24268596b8ed9$var$objectIs = "function" === typeof Object.is ? Object.is : $2ec24268596b8ed9$var$is;
function $2ec24268596b8ed9$var$shallowEqual(objA, objB) {
    if ($2ec24268596b8ed9$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$2ec24268596b8ed9$var$hasOwnProperty.call(objB, currentKey) || !$2ec24268596b8ed9$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $2ec24268596b8ed9$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $2ec24268596b8ed9$var$getNodeForCharacterOffset(root, offset) {
    var node = $2ec24268596b8ed9$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $2ec24268596b8ed9$var$getLeafNode(node);
    }
}
function $2ec24268596b8ed9$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $2ec24268596b8ed9$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $2ec24268596b8ed9$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $2ec24268596b8ed9$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $2ec24268596b8ed9$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $2ec24268596b8ed9$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $2ec24268596b8ed9$var$skipSelectionChangeEvent = $2ec24268596b8ed9$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $2ec24268596b8ed9$var$activeElement = null, $2ec24268596b8ed9$var$activeElementInst = null, $2ec24268596b8ed9$var$lastSelection = null, $2ec24268596b8ed9$var$mouseDown = !1;
function $2ec24268596b8ed9$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $2ec24268596b8ed9$var$mouseDown || null == $2ec24268596b8ed9$var$activeElement || $2ec24268596b8ed9$var$activeElement !== $2ec24268596b8ed9$var$getActiveElement(doc) || (doc = $2ec24268596b8ed9$var$activeElement, "selectionStart" in doc && $2ec24268596b8ed9$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $2ec24268596b8ed9$var$lastSelection && $2ec24268596b8ed9$var$shallowEqual($2ec24268596b8ed9$var$lastSelection, doc) || ($2ec24268596b8ed9$var$lastSelection = doc, doc = $2ec24268596b8ed9$var$accumulateTwoPhaseListeners($2ec24268596b8ed9$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $2ec24268596b8ed9$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $2ec24268596b8ed9$var$activeElement)));
}
function $2ec24268596b8ed9$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $2ec24268596b8ed9$var$vendorPrefixes = {
    animationend: $2ec24268596b8ed9$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $2ec24268596b8ed9$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $2ec24268596b8ed9$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $2ec24268596b8ed9$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $2ec24268596b8ed9$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $2ec24268596b8ed9$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $2ec24268596b8ed9$var$makePrefixMap("Transition", "TransitionEnd")
}, $2ec24268596b8ed9$var$prefixedEventNames = {}, $2ec24268596b8ed9$var$style = {};
$2ec24268596b8ed9$var$canUseDOM && ($2ec24268596b8ed9$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $2ec24268596b8ed9$var$vendorPrefixes.animationend.animation, delete $2ec24268596b8ed9$var$vendorPrefixes.animationiteration.animation, delete $2ec24268596b8ed9$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $2ec24268596b8ed9$var$vendorPrefixes.transitionend.transition);
function $2ec24268596b8ed9$var$getVendorPrefixedEventName(eventName) {
    if ($2ec24268596b8ed9$var$prefixedEventNames[eventName]) return $2ec24268596b8ed9$var$prefixedEventNames[eventName];
    if (!$2ec24268596b8ed9$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $2ec24268596b8ed9$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $2ec24268596b8ed9$var$style) return $2ec24268596b8ed9$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $2ec24268596b8ed9$var$ANIMATION_END = $2ec24268596b8ed9$var$getVendorPrefixedEventName("animationend"), $2ec24268596b8ed9$var$ANIMATION_ITERATION = $2ec24268596b8ed9$var$getVendorPrefixedEventName("animationiteration"), $2ec24268596b8ed9$var$ANIMATION_START = $2ec24268596b8ed9$var$getVendorPrefixedEventName("animationstart"), $2ec24268596b8ed9$var$TRANSITION_RUN = $2ec24268596b8ed9$var$getVendorPrefixedEventName("transitionrun"), $2ec24268596b8ed9$var$TRANSITION_START = $2ec24268596b8ed9$var$getVendorPrefixedEventName("transitionstart"), $2ec24268596b8ed9$var$TRANSITION_CANCEL = $2ec24268596b8ed9$var$getVendorPrefixedEventName("transitioncancel"), $2ec24268596b8ed9$var$TRANSITION_END = $2ec24268596b8ed9$var$getVendorPrefixedEventName("transitionend"), $2ec24268596b8ed9$var$topLevelEventsToReactNames = new Map(), $2ec24268596b8ed9$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$2ec24268596b8ed9$var$simpleEventPluginEvents.push("scrollEnd");
function $2ec24268596b8ed9$var$registerSimpleEvent(domEventName, reactName) {
    $2ec24268596b8ed9$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $2ec24268596b8ed9$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $2ec24268596b8ed9$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $jCqV7 && "function" === typeof $jCqV7.emit) {
        $jCqV7.emit("uncaughtException", error);
        return;
    }
    console.error(error);
}, $2ec24268596b8ed9$var$concurrentQueues = [], $2ec24268596b8ed9$var$concurrentQueuesIndex = 0, $2ec24268596b8ed9$var$concurrentlyUpdatedLanes = 0;
function $2ec24268596b8ed9$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $2ec24268596b8ed9$var$concurrentQueuesIndex, i = $2ec24268596b8ed9$var$concurrentlyUpdatedLanes = $2ec24268596b8ed9$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $2ec24268596b8ed9$var$concurrentQueues[i];
        $2ec24268596b8ed9$var$concurrentQueues[i++] = null;
        var queue = $2ec24268596b8ed9$var$concurrentQueues[i];
        $2ec24268596b8ed9$var$concurrentQueues[i++] = null;
        var update = $2ec24268596b8ed9$var$concurrentQueues[i];
        $2ec24268596b8ed9$var$concurrentQueues[i++] = null;
        var lane = $2ec24268596b8ed9$var$concurrentQueues[i];
        $2ec24268596b8ed9$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $2ec24268596b8ed9$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $2ec24268596b8ed9$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $2ec24268596b8ed9$var$concurrentQueues[$2ec24268596b8ed9$var$concurrentQueuesIndex++] = fiber;
    $2ec24268596b8ed9$var$concurrentQueues[$2ec24268596b8ed9$var$concurrentQueuesIndex++] = queue;
    $2ec24268596b8ed9$var$concurrentQueues[$2ec24268596b8ed9$var$concurrentQueuesIndex++] = update;
    $2ec24268596b8ed9$var$concurrentQueues[$2ec24268596b8ed9$var$concurrentQueuesIndex++] = lane;
    $2ec24268596b8ed9$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $2ec24268596b8ed9$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $2ec24268596b8ed9$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $2ec24268596b8ed9$var$getRootForUpdatedFiber(fiber);
}
function $2ec24268596b8ed9$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $2ec24268596b8ed9$var$enqueueUpdate$1(fiber, null, null, lane);
    return $2ec24268596b8ed9$var$getRootForUpdatedFiber(fiber);
}
function $2ec24268596b8ed9$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $2ec24268596b8ed9$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $2ec24268596b8ed9$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $2ec24268596b8ed9$var$nestedUpdateCount) throw $2ec24268596b8ed9$var$nestedUpdateCount = 0, $2ec24268596b8ed9$var$rootWithNestedUpdates = null, Error($2ec24268596b8ed9$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $2ec24268596b8ed9$var$emptyContextObject = {};
function $2ec24268596b8ed9$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $2ec24268596b8ed9$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $2ec24268596b8ed9$var$FiberNode(tag, pendingProps, key, mode);
}
function $2ec24268596b8ed9$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $2ec24268596b8ed9$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $2ec24268596b8ed9$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $2ec24268596b8ed9$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $2ec24268596b8ed9$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $2ec24268596b8ed9$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $2ec24268596b8ed9$var$isHostHoistableType(type, pendingProps, $2ec24268596b8ed9$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $2ec24268596b8ed9$var$REACT_ACTIVITY_TYPE:
            return type = $2ec24268596b8ed9$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $2ec24268596b8ed9$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $2ec24268596b8ed9$var$REACT_FRAGMENT_TYPE:
            return $2ec24268596b8ed9$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $2ec24268596b8ed9$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $2ec24268596b8ed9$var$REACT_PROFILER_TYPE:
            return type = $2ec24268596b8ed9$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $2ec24268596b8ed9$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $2ec24268596b8ed9$var$REACT_SUSPENSE_TYPE:
            return type = $2ec24268596b8ed9$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $2ec24268596b8ed9$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $2ec24268596b8ed9$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $2ec24268596b8ed9$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $2ec24268596b8ed9$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $2ec24268596b8ed9$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $2ec24268596b8ed9$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $2ec24268596b8ed9$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $2ec24268596b8ed9$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $2ec24268596b8ed9$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($2ec24268596b8ed9$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $2ec24268596b8ed9$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $2ec24268596b8ed9$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $2ec24268596b8ed9$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $2ec24268596b8ed9$var$createFiberFromText(content, mode, lanes) {
    content = $2ec24268596b8ed9$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $2ec24268596b8ed9$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $2ec24268596b8ed9$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $2ec24268596b8ed9$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $2ec24268596b8ed9$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $2ec24268596b8ed9$var$CapturedStacks = new WeakMap();
function $2ec24268596b8ed9$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $2ec24268596b8ed9$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $2ec24268596b8ed9$var$getStackByFiberInDevAndProd(source)
        };
        $2ec24268596b8ed9$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $2ec24268596b8ed9$var$getStackByFiberInDevAndProd(source)
    };
}
var $2ec24268596b8ed9$var$forkStack = [], $2ec24268596b8ed9$var$forkStackIndex = 0, $2ec24268596b8ed9$var$treeForkProvider = null, $2ec24268596b8ed9$var$treeForkCount = 0, $2ec24268596b8ed9$var$idStack = [], $2ec24268596b8ed9$var$idStackIndex = 0, $2ec24268596b8ed9$var$treeContextProvider = null, $2ec24268596b8ed9$var$treeContextId = 1, $2ec24268596b8ed9$var$treeContextOverflow = "";
function $2ec24268596b8ed9$var$pushTreeFork(workInProgress, totalChildren) {
    $2ec24268596b8ed9$var$forkStack[$2ec24268596b8ed9$var$forkStackIndex++] = $2ec24268596b8ed9$var$treeForkCount;
    $2ec24268596b8ed9$var$forkStack[$2ec24268596b8ed9$var$forkStackIndex++] = $2ec24268596b8ed9$var$treeForkProvider;
    $2ec24268596b8ed9$var$treeForkProvider = workInProgress;
    $2ec24268596b8ed9$var$treeForkCount = totalChildren;
}
function $2ec24268596b8ed9$var$pushTreeId(workInProgress, totalChildren, index) {
    $2ec24268596b8ed9$var$idStack[$2ec24268596b8ed9$var$idStackIndex++] = $2ec24268596b8ed9$var$treeContextId;
    $2ec24268596b8ed9$var$idStack[$2ec24268596b8ed9$var$idStackIndex++] = $2ec24268596b8ed9$var$treeContextOverflow;
    $2ec24268596b8ed9$var$idStack[$2ec24268596b8ed9$var$idStackIndex++] = $2ec24268596b8ed9$var$treeContextProvider;
    $2ec24268596b8ed9$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $2ec24268596b8ed9$var$treeContextId;
    workInProgress = $2ec24268596b8ed9$var$treeContextOverflow;
    var baseLength = 32 - $2ec24268596b8ed9$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $2ec24268596b8ed9$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $2ec24268596b8ed9$var$treeContextId = 1 << 32 - $2ec24268596b8ed9$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $2ec24268596b8ed9$var$treeContextOverflow = length + workInProgress;
    } else $2ec24268596b8ed9$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $2ec24268596b8ed9$var$treeContextOverflow = workInProgress;
}
function $2ec24268596b8ed9$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($2ec24268596b8ed9$var$pushTreeFork(workInProgress, 1), $2ec24268596b8ed9$var$pushTreeId(workInProgress, 1, 0));
}
function $2ec24268596b8ed9$var$popTreeContext(workInProgress) {
    for(; workInProgress === $2ec24268596b8ed9$var$treeForkProvider;)$2ec24268596b8ed9$var$treeForkProvider = $2ec24268596b8ed9$var$forkStack[--$2ec24268596b8ed9$var$forkStackIndex], $2ec24268596b8ed9$var$forkStack[$2ec24268596b8ed9$var$forkStackIndex] = null, $2ec24268596b8ed9$var$treeForkCount = $2ec24268596b8ed9$var$forkStack[--$2ec24268596b8ed9$var$forkStackIndex], $2ec24268596b8ed9$var$forkStack[$2ec24268596b8ed9$var$forkStackIndex] = null;
    for(; workInProgress === $2ec24268596b8ed9$var$treeContextProvider;)$2ec24268596b8ed9$var$treeContextProvider = $2ec24268596b8ed9$var$idStack[--$2ec24268596b8ed9$var$idStackIndex], $2ec24268596b8ed9$var$idStack[$2ec24268596b8ed9$var$idStackIndex] = null, $2ec24268596b8ed9$var$treeContextOverflow = $2ec24268596b8ed9$var$idStack[--$2ec24268596b8ed9$var$idStackIndex], $2ec24268596b8ed9$var$idStack[$2ec24268596b8ed9$var$idStackIndex] = null, $2ec24268596b8ed9$var$treeContextId = $2ec24268596b8ed9$var$idStack[--$2ec24268596b8ed9$var$idStackIndex], $2ec24268596b8ed9$var$idStack[$2ec24268596b8ed9$var$idStackIndex] = null;
}
function $2ec24268596b8ed9$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $2ec24268596b8ed9$var$idStack[$2ec24268596b8ed9$var$idStackIndex++] = $2ec24268596b8ed9$var$treeContextId;
    $2ec24268596b8ed9$var$idStack[$2ec24268596b8ed9$var$idStackIndex++] = $2ec24268596b8ed9$var$treeContextOverflow;
    $2ec24268596b8ed9$var$idStack[$2ec24268596b8ed9$var$idStackIndex++] = $2ec24268596b8ed9$var$treeContextProvider;
    $2ec24268596b8ed9$var$treeContextId = suspendedContext.id;
    $2ec24268596b8ed9$var$treeContextOverflow = suspendedContext.overflow;
    $2ec24268596b8ed9$var$treeContextProvider = workInProgress;
}
var $2ec24268596b8ed9$var$hydrationParentFiber = null, $2ec24268596b8ed9$var$nextHydratableInstance = null, $2ec24268596b8ed9$var$isHydrating = !1, $2ec24268596b8ed9$var$hydrationErrors = null, $2ec24268596b8ed9$var$rootOrSingletonContext = !1, $2ec24268596b8ed9$var$HydrationMismatchException = Error($2ec24268596b8ed9$var$formatProdErrorMessage(519));
function $2ec24268596b8ed9$var$throwOnHydrationMismatch(fiber) {
    var error = Error($2ec24268596b8ed9$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $2ec24268596b8ed9$var$queueHydrationError($2ec24268596b8ed9$var$createCapturedValueAtFiber(error, fiber));
    throw $2ec24268596b8ed9$var$HydrationMismatchException;
}
function $2ec24268596b8ed9$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$2ec24268596b8ed9$var$internalInstanceKey] = fiber;
    instance[$2ec24268596b8ed9$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("cancel", instance);
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $2ec24268596b8ed9$var$mediaEventTypes.length; type++)$2ec24268596b8ed9$var$listenToNonDelegatedEvent($2ec24268596b8ed9$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("error", instance);
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("invalid", instance);
            $2ec24268596b8ed9$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("invalid", instance), $2ec24268596b8ed9$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $2ec24268596b8ed9$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($2ec24268596b8ed9$var$listenToNonDelegatedEvent("beforetoggle", instance), $2ec24268596b8ed9$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $2ec24268596b8ed9$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $2ec24268596b8ed9$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $2ec24268596b8ed9$var$noop$1), instance = !0) : instance = !1;
    instance || $2ec24268596b8ed9$var$throwOnHydrationMismatch(fiber, !0);
}
function $2ec24268596b8ed9$var$popToNextHostParent(fiber) {
    for($2ec24268596b8ed9$var$hydrationParentFiber = fiber.return; $2ec24268596b8ed9$var$hydrationParentFiber;)switch($2ec24268596b8ed9$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $2ec24268596b8ed9$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $2ec24268596b8ed9$var$rootOrSingletonContext = !0;
            return;
        default:
            $2ec24268596b8ed9$var$hydrationParentFiber = $2ec24268596b8ed9$var$hydrationParentFiber.return;
    }
}
function $2ec24268596b8ed9$var$popHydrationState(fiber) {
    if (fiber !== $2ec24268596b8ed9$var$hydrationParentFiber) return !1;
    if (!$2ec24268596b8ed9$var$isHydrating) return $2ec24268596b8ed9$var$popToNextHostParent(fiber), $2ec24268596b8ed9$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $2ec24268596b8ed9$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $2ec24268596b8ed9$var$nextHydratableInstance && $2ec24268596b8ed9$var$throwOnHydrationMismatch(fiber);
    $2ec24268596b8ed9$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(317));
        $2ec24268596b8ed9$var$nextHydratableInstance = $2ec24268596b8ed9$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(317));
        $2ec24268596b8ed9$var$nextHydratableInstance = $2ec24268596b8ed9$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $2ec24268596b8ed9$var$nextHydratableInstance, $2ec24268596b8ed9$var$isSingletonScope(fiber.type) ? (fiber = $2ec24268596b8ed9$var$previousHydratableOnEnteringScopedSingleton, $2ec24268596b8ed9$var$previousHydratableOnEnteringScopedSingleton = null, $2ec24268596b8ed9$var$nextHydratableInstance = fiber) : $2ec24268596b8ed9$var$nextHydratableInstance = tag) : $2ec24268596b8ed9$var$nextHydratableInstance = $2ec24268596b8ed9$var$hydrationParentFiber ? $2ec24268596b8ed9$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $2ec24268596b8ed9$var$resetHydrationState() {
    $2ec24268596b8ed9$var$nextHydratableInstance = $2ec24268596b8ed9$var$hydrationParentFiber = null;
    $2ec24268596b8ed9$var$isHydrating = !1;
}
function $2ec24268596b8ed9$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $2ec24268596b8ed9$var$hydrationErrors;
    null !== queuedErrors && (null === $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors ? $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors = queuedErrors : $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors.push.apply($2ec24268596b8ed9$var$workInProgressRootRecoverableErrors, queuedErrors), $2ec24268596b8ed9$var$hydrationErrors = null);
    return queuedErrors;
}
function $2ec24268596b8ed9$var$queueHydrationError(error) {
    null === $2ec24268596b8ed9$var$hydrationErrors ? $2ec24268596b8ed9$var$hydrationErrors = [
        error
    ] : $2ec24268596b8ed9$var$hydrationErrors.push(error);
}
var $2ec24268596b8ed9$var$valueCursor = $2ec24268596b8ed9$var$createCursor(null), $2ec24268596b8ed9$var$currentlyRenderingFiber$1 = null, $2ec24268596b8ed9$var$lastContextDependency = null;
function $2ec24268596b8ed9$var$pushProvider(providerFiber, context, nextValue) {
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $2ec24268596b8ed9$var$popProvider(context) {
    context._currentValue = $2ec24268596b8ed9$var$valueCursor.current;
    $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$valueCursor);
}
function $2ec24268596b8ed9$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $2ec24268596b8ed9$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $2ec24268596b8ed9$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $2ec24268596b8ed9$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $2ec24268596b8ed9$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $2ec24268596b8ed9$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $2ec24268596b8ed9$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($2ec24268596b8ed9$var$HostTransitionContext) : current = [
                $2ec24268596b8ed9$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $2ec24268596b8ed9$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $2ec24268596b8ed9$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$2ec24268596b8ed9$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $2ec24268596b8ed9$var$prepareToReadContext(workInProgress) {
    $2ec24268596b8ed9$var$currentlyRenderingFiber$1 = workInProgress;
    $2ec24268596b8ed9$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $2ec24268596b8ed9$var$readContext(context) {
    return $2ec24268596b8ed9$var$readContextForConsumer($2ec24268596b8ed9$var$currentlyRenderingFiber$1, context);
}
function $2ec24268596b8ed9$var$readContextDuringReconciliation(consumer, context) {
    null === $2ec24268596b8ed9$var$currentlyRenderingFiber$1 && $2ec24268596b8ed9$var$prepareToReadContext(consumer);
    return $2ec24268596b8ed9$var$readContextForConsumer(consumer, context);
}
function $2ec24268596b8ed9$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $2ec24268596b8ed9$var$lastContextDependency) {
        if (null === consumer) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(308));
        $2ec24268596b8ed9$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $2ec24268596b8ed9$var$lastContextDependency = $2ec24268596b8ed9$var$lastContextDependency.next = context;
    return value;
}
var $2ec24268596b8ed9$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $2ec24268596b8ed9$var$scheduleCallback$2 = $dns5Y.unstable_scheduleCallback, $2ec24268596b8ed9$var$NormalPriority = $dns5Y.unstable_NormalPriority, $2ec24268596b8ed9$var$CacheContext = {
    $$typeof: $2ec24268596b8ed9$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $2ec24268596b8ed9$var$createCache() {
    return {
        controller: new $2ec24268596b8ed9$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $2ec24268596b8ed9$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $2ec24268596b8ed9$var$scheduleCallback$2($2ec24268596b8ed9$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $2ec24268596b8ed9$var$currentEntangledListeners = null, $2ec24268596b8ed9$var$currentEntangledPendingCount = 0, $2ec24268596b8ed9$var$currentEntangledLane = 0, $2ec24268596b8ed9$var$currentEntangledActionThenable = null;
function $2ec24268596b8ed9$var$entangleAsyncAction(transition, thenable) {
    if (null === $2ec24268596b8ed9$var$currentEntangledListeners) {
        var entangledListeners = $2ec24268596b8ed9$var$currentEntangledListeners = [];
        $2ec24268596b8ed9$var$currentEntangledPendingCount = 0;
        $2ec24268596b8ed9$var$currentEntangledLane = $2ec24268596b8ed9$var$requestTransitionLane();
        $2ec24268596b8ed9$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $2ec24268596b8ed9$var$currentEntangledPendingCount++;
    thenable.then($2ec24268596b8ed9$var$pingEngtangledActionScope, $2ec24268596b8ed9$var$pingEngtangledActionScope);
    return thenable;
}
function $2ec24268596b8ed9$var$pingEngtangledActionScope() {
    if (0 === --$2ec24268596b8ed9$var$currentEntangledPendingCount && null !== $2ec24268596b8ed9$var$currentEntangledListeners) {
        null !== $2ec24268596b8ed9$var$currentEntangledActionThenable && ($2ec24268596b8ed9$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $2ec24268596b8ed9$var$currentEntangledListeners;
        $2ec24268596b8ed9$var$currentEntangledListeners = null;
        $2ec24268596b8ed9$var$currentEntangledLane = 0;
        $2ec24268596b8ed9$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $2ec24268596b8ed9$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $2ec24268596b8ed9$var$prevOnStartTransitionFinish = $2ec24268596b8ed9$var$ReactSharedInternals.S;
$2ec24268596b8ed9$var$ReactSharedInternals.S = function(transition, returnValue) {
    $2ec24268596b8ed9$var$globalMostRecentTransitionTime = $2ec24268596b8ed9$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $2ec24268596b8ed9$var$entangleAsyncAction(transition, returnValue);
    null !== $2ec24268596b8ed9$var$prevOnStartTransitionFinish && $2ec24268596b8ed9$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $2ec24268596b8ed9$var$resumedCache = $2ec24268596b8ed9$var$createCursor(null);
function $2ec24268596b8ed9$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $2ec24268596b8ed9$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $2ec24268596b8ed9$var$workInProgressRoot.pooledCache;
}
function $2ec24268596b8ed9$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$resumedCache, $2ec24268596b8ed9$var$resumedCache.current) : $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$resumedCache, prevCachePool.pool);
}
function $2ec24268596b8ed9$var$getSuspendedCache() {
    var cacheFromPool = $2ec24268596b8ed9$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $2ec24268596b8ed9$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $2ec24268596b8ed9$var$SuspenseException = Error($2ec24268596b8ed9$var$formatProdErrorMessage(460)), $2ec24268596b8ed9$var$SuspenseyCommitException = Error($2ec24268596b8ed9$var$formatProdErrorMessage(474)), $2ec24268596b8ed9$var$SuspenseActionException = Error($2ec24268596b8ed9$var$formatProdErrorMessage(542)), $2ec24268596b8ed9$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $2ec24268596b8ed9$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $2ec24268596b8ed9$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($2ec24268596b8ed9$var$noop$1, $2ec24268596b8ed9$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $2ec24268596b8ed9$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($2ec24268596b8ed9$var$noop$1, $2ec24268596b8ed9$var$noop$1);
            else {
                thenableState = $2ec24268596b8ed9$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $2ec24268596b8ed9$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $2ec24268596b8ed9$var$suspendedThenable = thenable;
            throw $2ec24268596b8ed9$var$SuspenseException;
    }
}
function $2ec24268596b8ed9$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $2ec24268596b8ed9$var$suspendedThenable = x, $2ec24268596b8ed9$var$SuspenseException;
        throw x;
    }
}
var $2ec24268596b8ed9$var$suspendedThenable = null;
function $2ec24268596b8ed9$var$getSuspendedThenable() {
    if (null === $2ec24268596b8ed9$var$suspendedThenable) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(459));
    var thenable = $2ec24268596b8ed9$var$suspendedThenable;
    $2ec24268596b8ed9$var$suspendedThenable = null;
    return thenable;
}
function $2ec24268596b8ed9$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $2ec24268596b8ed9$var$SuspenseException || rejectedReason === $2ec24268596b8ed9$var$SuspenseActionException) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(483));
}
var $2ec24268596b8ed9$var$thenableState$1 = null, $2ec24268596b8ed9$var$thenableIndexCounter$1 = 0;
function $2ec24268596b8ed9$var$unwrapThenable(thenable) {
    var index = $2ec24268596b8ed9$var$thenableIndexCounter$1;
    $2ec24268596b8ed9$var$thenableIndexCounter$1 += 1;
    null === $2ec24268596b8ed9$var$thenableState$1 && ($2ec24268596b8ed9$var$thenableState$1 = []);
    return $2ec24268596b8ed9$var$trackUsedThenable($2ec24268596b8ed9$var$thenableState$1, thenable, index);
}
function $2ec24268596b8ed9$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $2ec24268596b8ed9$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $2ec24268596b8ed9$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $2ec24268596b8ed9$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $2ec24268596b8ed9$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $2ec24268596b8ed9$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $2ec24268596b8ed9$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $2ec24268596b8ed9$var$REACT_LAZY_TYPE && $2ec24268596b8ed9$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $2ec24268596b8ed9$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $2ec24268596b8ed9$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $2ec24268596b8ed9$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $2ec24268596b8ed9$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $2ec24268596b8ed9$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $2ec24268596b8ed9$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2ec24268596b8ed9$var$REACT_ELEMENT_TYPE:
                    return lanes = $2ec24268596b8ed9$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $2ec24268596b8ed9$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $2ec24268596b8ed9$var$REACT_PORTAL_TYPE:
                    return newChild = $2ec24268596b8ed9$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $2ec24268596b8ed9$var$REACT_LAZY_TYPE:
                    return newChild = $2ec24268596b8ed9$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($2ec24268596b8ed9$var$isArrayImpl(newChild) || $2ec24268596b8ed9$var$getIteratorFn(newChild)) return newChild = $2ec24268596b8ed9$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $2ec24268596b8ed9$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2ec24268596b8ed9$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $2ec24268596b8ed9$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2ec24268596b8ed9$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2ec24268596b8ed9$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $2ec24268596b8ed9$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $2ec24268596b8ed9$var$REACT_LAZY_TYPE:
                    return newChild = $2ec24268596b8ed9$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($2ec24268596b8ed9$var$isArrayImpl(newChild) || $2ec24268596b8ed9$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $2ec24268596b8ed9$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2ec24268596b8ed9$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $2ec24268596b8ed9$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2ec24268596b8ed9$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2ec24268596b8ed9$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $2ec24268596b8ed9$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $2ec24268596b8ed9$var$REACT_LAZY_TYPE:
                    return newChild = $2ec24268596b8ed9$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($2ec24268596b8ed9$var$isArrayImpl(newChild) || $2ec24268596b8ed9$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $2ec24268596b8ed9$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2ec24268596b8ed9$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $2ec24268596b8ed9$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2ec24268596b8ed9$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $2ec24268596b8ed9$var$isHydrating && $2ec24268596b8ed9$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $2ec24268596b8ed9$var$isHydrating && $2ec24268596b8ed9$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $2ec24268596b8ed9$var$isHydrating && $2ec24268596b8ed9$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $2ec24268596b8ed9$var$isHydrating && $2ec24268596b8ed9$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $2ec24268596b8ed9$var$isHydrating && $2ec24268596b8ed9$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $2ec24268596b8ed9$var$isHydrating && $2ec24268596b8ed9$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $2ec24268596b8ed9$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2ec24268596b8ed9$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $2ec24268596b8ed9$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $2ec24268596b8ed9$var$REACT_LAZY_TYPE && $2ec24268596b8ed9$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $2ec24268596b8ed9$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $2ec24268596b8ed9$var$REACT_FRAGMENT_TYPE ? (lanes = $2ec24268596b8ed9$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $2ec24268596b8ed9$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $2ec24268596b8ed9$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $2ec24268596b8ed9$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $2ec24268596b8ed9$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $2ec24268596b8ed9$var$REACT_LAZY_TYPE:
                    return newChild = $2ec24268596b8ed9$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($2ec24268596b8ed9$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($2ec24268596b8ed9$var$getIteratorFn(newChild)) {
                key = $2ec24268596b8ed9$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $2ec24268596b8ed9$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2ec24268596b8ed9$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $2ec24268596b8ed9$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2ec24268596b8ed9$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $2ec24268596b8ed9$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $2ec24268596b8ed9$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $2ec24268596b8ed9$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $2ec24268596b8ed9$var$SuspenseException || x === $2ec24268596b8ed9$var$SuspenseActionException) throw x;
            var fiber = $2ec24268596b8ed9$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $2ec24268596b8ed9$var$reconcileChildFibers = $2ec24268596b8ed9$var$createChildReconciler(!0), $2ec24268596b8ed9$var$mountChildFibers = $2ec24268596b8ed9$var$createChildReconciler(!1), $2ec24268596b8ed9$var$hasForceUpdate = !1;
function $2ec24268596b8ed9$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $2ec24268596b8ed9$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $2ec24268596b8ed9$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $2ec24268596b8ed9$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($2ec24268596b8ed9$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $2ec24268596b8ed9$var$getRootForUpdatedFiber(fiber);
        $2ec24268596b8ed9$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $2ec24268596b8ed9$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $2ec24268596b8ed9$var$getRootForUpdatedFiber(fiber);
}
function $2ec24268596b8ed9$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $2ec24268596b8ed9$var$markRootEntangled(root, lane);
    }
}
function $2ec24268596b8ed9$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $2ec24268596b8ed9$var$didReadFromEntangledAsyncAction = !1;
function $2ec24268596b8ed9$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($2ec24268596b8ed9$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $2ec24268596b8ed9$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $2ec24268596b8ed9$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $2ec24268596b8ed9$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $2ec24268596b8ed9$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $2ec24268596b8ed9$var$currentEntangledLane && ($2ec24268596b8ed9$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $2ec24268596b8ed9$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $2ec24268596b8ed9$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $2ec24268596b8ed9$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $2ec24268596b8ed9$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $2ec24268596b8ed9$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$2ec24268596b8ed9$var$callCallback(callbacks[updateQueue], context);
}
var $2ec24268596b8ed9$var$currentTreeHiddenStackCursor = $2ec24268596b8ed9$var$createCursor(null), $2ec24268596b8ed9$var$prevEntangledRenderLanesCursor = $2ec24268596b8ed9$var$createCursor(0);
function $2ec24268596b8ed9$var$pushHiddenContext(fiber, context) {
    fiber = $2ec24268596b8ed9$var$entangledRenderLanes;
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$prevEntangledRenderLanesCursor, fiber);
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$currentTreeHiddenStackCursor, context);
    $2ec24268596b8ed9$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $2ec24268596b8ed9$var$reuseHiddenContextOnStack() {
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$prevEntangledRenderLanesCursor, $2ec24268596b8ed9$var$entangledRenderLanes);
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$currentTreeHiddenStackCursor, $2ec24268596b8ed9$var$currentTreeHiddenStackCursor.current);
}
function $2ec24268596b8ed9$var$popHiddenContext() {
    $2ec24268596b8ed9$var$entangledRenderLanes = $2ec24268596b8ed9$var$prevEntangledRenderLanesCursor.current;
    $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$currentTreeHiddenStackCursor);
    $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$prevEntangledRenderLanesCursor);
}
var $2ec24268596b8ed9$var$suspenseHandlerStackCursor = $2ec24268596b8ed9$var$createCursor(null), $2ec24268596b8ed9$var$shellBoundary = null;
function $2ec24268596b8ed9$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$suspenseStackCursor, $2ec24268596b8ed9$var$suspenseStackCursor.current & 1);
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$suspenseHandlerStackCursor, handler);
    null === $2ec24268596b8ed9$var$shellBoundary && (null === current || null !== $2ec24268596b8ed9$var$currentTreeHiddenStackCursor.current ? $2ec24268596b8ed9$var$shellBoundary = handler : null !== current.memoizedState && ($2ec24268596b8ed9$var$shellBoundary = handler));
}
function $2ec24268596b8ed9$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$suspenseStackCursor, $2ec24268596b8ed9$var$suspenseStackCursor.current);
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$suspenseHandlerStackCursor, fiber);
    null === $2ec24268596b8ed9$var$shellBoundary && ($2ec24268596b8ed9$var$shellBoundary = fiber);
}
function $2ec24268596b8ed9$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$suspenseStackCursor, $2ec24268596b8ed9$var$suspenseStackCursor.current), $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$suspenseHandlerStackCursor, fiber), null === $2ec24268596b8ed9$var$shellBoundary && ($2ec24268596b8ed9$var$shellBoundary = fiber)) : $2ec24268596b8ed9$var$reuseSuspenseHandlerOnStack(fiber);
}
function $2ec24268596b8ed9$var$reuseSuspenseHandlerOnStack() {
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$suspenseStackCursor, $2ec24268596b8ed9$var$suspenseStackCursor.current);
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$suspenseHandlerStackCursor, $2ec24268596b8ed9$var$suspenseHandlerStackCursor.current);
}
function $2ec24268596b8ed9$var$popSuspenseHandler(fiber) {
    $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$suspenseHandlerStackCursor);
    $2ec24268596b8ed9$var$shellBoundary === fiber && ($2ec24268596b8ed9$var$shellBoundary = null);
    $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$suspenseStackCursor);
}
var $2ec24268596b8ed9$var$suspenseStackCursor = $2ec24268596b8ed9$var$createCursor(0);
function $2ec24268596b8ed9$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $2ec24268596b8ed9$var$isSuspenseInstancePending(state) || $2ec24268596b8ed9$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $2ec24268596b8ed9$var$renderLanes = 0, $2ec24268596b8ed9$var$currentlyRenderingFiber = null, $2ec24268596b8ed9$var$currentHook = null, $2ec24268596b8ed9$var$workInProgressHook = null, $2ec24268596b8ed9$var$didScheduleRenderPhaseUpdate = !1, $2ec24268596b8ed9$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $2ec24268596b8ed9$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $2ec24268596b8ed9$var$localIdCounter = 0, $2ec24268596b8ed9$var$thenableIndexCounter = 0, $2ec24268596b8ed9$var$thenableState = null, $2ec24268596b8ed9$var$globalClientIdCounter = 0;
function $2ec24268596b8ed9$var$throwInvalidHookError() {
    throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(321));
}
function $2ec24268596b8ed9$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$2ec24268596b8ed9$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $2ec24268596b8ed9$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $2ec24268596b8ed9$var$renderLanes = nextRenderLanes;
    $2ec24268596b8ed9$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $2ec24268596b8ed9$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $2ec24268596b8ed9$var$HooksDispatcherOnMount : $2ec24268596b8ed9$var$HooksDispatcherOnUpdate;
    $2ec24268596b8ed9$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $2ec24268596b8ed9$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $2ec24268596b8ed9$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $2ec24268596b8ed9$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $2ec24268596b8ed9$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $2ec24268596b8ed9$var$finishRenderingHooks(current) {
    $2ec24268596b8ed9$var$ReactSharedInternals.H = $2ec24268596b8ed9$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $2ec24268596b8ed9$var$currentHook && null !== $2ec24268596b8ed9$var$currentHook.next;
    $2ec24268596b8ed9$var$renderLanes = 0;
    $2ec24268596b8ed9$var$workInProgressHook = $2ec24268596b8ed9$var$currentHook = $2ec24268596b8ed9$var$currentlyRenderingFiber = null;
    $2ec24268596b8ed9$var$didScheduleRenderPhaseUpdate = !1;
    $2ec24268596b8ed9$var$thenableIndexCounter = 0;
    $2ec24268596b8ed9$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(300));
    null === current || $2ec24268596b8ed9$var$didReceiveUpdate || (current = current.dependencies, null !== current && $2ec24268596b8ed9$var$checkIfContextChanged(current) && ($2ec24268596b8ed9$var$didReceiveUpdate = !0));
}
function $2ec24268596b8ed9$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $2ec24268596b8ed9$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $2ec24268596b8ed9$var$didScheduleRenderPhaseUpdateDuringThisPass && ($2ec24268596b8ed9$var$thenableState = null);
        $2ec24268596b8ed9$var$thenableIndexCounter = 0;
        $2ec24268596b8ed9$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $2ec24268596b8ed9$var$workInProgressHook = $2ec24268596b8ed9$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $2ec24268596b8ed9$var$ReactSharedInternals.H = $2ec24268596b8ed9$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($2ec24268596b8ed9$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $2ec24268596b8ed9$var$TransitionAwareHostComponent() {
    var dispatcher = $2ec24268596b8ed9$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $2ec24268596b8ed9$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $2ec24268596b8ed9$var$currentHook ? $2ec24268596b8ed9$var$currentHook.memoizedState : null) !== dispatcher && ($2ec24268596b8ed9$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $2ec24268596b8ed9$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $2ec24268596b8ed9$var$localIdCounter;
    $2ec24268596b8ed9$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $2ec24268596b8ed9$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $2ec24268596b8ed9$var$resetHooksOnUnwind(workInProgress) {
    if ($2ec24268596b8ed9$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $2ec24268596b8ed9$var$didScheduleRenderPhaseUpdate = !1;
    }
    $2ec24268596b8ed9$var$renderLanes = 0;
    $2ec24268596b8ed9$var$workInProgressHook = $2ec24268596b8ed9$var$currentHook = $2ec24268596b8ed9$var$currentlyRenderingFiber = null;
    $2ec24268596b8ed9$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $2ec24268596b8ed9$var$thenableIndexCounter = $2ec24268596b8ed9$var$localIdCounter = 0;
    $2ec24268596b8ed9$var$thenableState = null;
}
function $2ec24268596b8ed9$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $2ec24268596b8ed9$var$workInProgressHook ? $2ec24268596b8ed9$var$currentlyRenderingFiber.memoizedState = $2ec24268596b8ed9$var$workInProgressHook = hook : $2ec24268596b8ed9$var$workInProgressHook = $2ec24268596b8ed9$var$workInProgressHook.next = hook;
    return $2ec24268596b8ed9$var$workInProgressHook;
}
function $2ec24268596b8ed9$var$updateWorkInProgressHook() {
    if (null === $2ec24268596b8ed9$var$currentHook) {
        var nextCurrentHook = $2ec24268596b8ed9$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $2ec24268596b8ed9$var$currentHook.next;
    var nextWorkInProgressHook = null === $2ec24268596b8ed9$var$workInProgressHook ? $2ec24268596b8ed9$var$currentlyRenderingFiber.memoizedState : $2ec24268596b8ed9$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $2ec24268596b8ed9$var$workInProgressHook = nextWorkInProgressHook, $2ec24268596b8ed9$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $2ec24268596b8ed9$var$currentlyRenderingFiber.alternate) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(467));
            throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(310));
        }
        $2ec24268596b8ed9$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $2ec24268596b8ed9$var$currentHook.memoizedState,
            baseState: $2ec24268596b8ed9$var$currentHook.baseState,
            baseQueue: $2ec24268596b8ed9$var$currentHook.baseQueue,
            queue: $2ec24268596b8ed9$var$currentHook.queue,
            next: null
        };
        null === $2ec24268596b8ed9$var$workInProgressHook ? $2ec24268596b8ed9$var$currentlyRenderingFiber.memoizedState = $2ec24268596b8ed9$var$workInProgressHook = nextCurrentHook : $2ec24268596b8ed9$var$workInProgressHook = $2ec24268596b8ed9$var$workInProgressHook.next = nextCurrentHook;
    }
    return $2ec24268596b8ed9$var$workInProgressHook;
}
function $2ec24268596b8ed9$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $2ec24268596b8ed9$var$useThenable(thenable) {
    var index = $2ec24268596b8ed9$var$thenableIndexCounter;
    $2ec24268596b8ed9$var$thenableIndexCounter += 1;
    null === $2ec24268596b8ed9$var$thenableState && ($2ec24268596b8ed9$var$thenableState = []);
    thenable = $2ec24268596b8ed9$var$trackUsedThenable($2ec24268596b8ed9$var$thenableState, thenable, index);
    index = $2ec24268596b8ed9$var$currentlyRenderingFiber;
    null === (null === $2ec24268596b8ed9$var$workInProgressHook ? index.memoizedState : $2ec24268596b8ed9$var$workInProgressHook.next) && (index = index.alternate, $2ec24268596b8ed9$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $2ec24268596b8ed9$var$HooksDispatcherOnMount : $2ec24268596b8ed9$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $2ec24268596b8ed9$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $2ec24268596b8ed9$var$useThenable(usable);
        if (usable.$$typeof === $2ec24268596b8ed9$var$REACT_CONTEXT_TYPE) return $2ec24268596b8ed9$var$readContext(usable);
    }
    throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(438, String(usable)));
}
function $2ec24268596b8ed9$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $2ec24268596b8ed9$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $2ec24268596b8ed9$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $2ec24268596b8ed9$var$createFunctionComponentUpdateQueue(), $2ec24268596b8ed9$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $2ec24268596b8ed9$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $2ec24268596b8ed9$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $2ec24268596b8ed9$var$updateReducer(reducer) {
    var hook = $2ec24268596b8ed9$var$updateWorkInProgressHook();
    return $2ec24268596b8ed9$var$updateReducerImpl(hook, $2ec24268596b8ed9$var$currentHook, reducer);
}
function $2ec24268596b8ed9$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($2ec24268596b8ed9$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $2ec24268596b8ed9$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($2ec24268596b8ed9$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $2ec24268596b8ed9$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $2ec24268596b8ed9$var$currentlyRenderingFiber.lanes |= revertLane, $2ec24268596b8ed9$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $2ec24268596b8ed9$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $2ec24268596b8ed9$var$currentlyRenderingFiber.lanes |= updateLane, $2ec24268596b8ed9$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$2ec24268596b8ed9$var$objectIs(pendingQueue, hook.memoizedState) && ($2ec24268596b8ed9$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $2ec24268596b8ed9$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $2ec24268596b8ed9$var$rerenderReducer(reducer) {
    var hook = $2ec24268596b8ed9$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $2ec24268596b8ed9$var$objectIs(newState, hook.memoizedState) || ($2ec24268596b8ed9$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $2ec24268596b8ed9$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $2ec24268596b8ed9$var$currentlyRenderingFiber, hook = $2ec24268596b8ed9$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $2ec24268596b8ed9$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$2ec24268596b8ed9$var$objectIs(($2ec24268596b8ed9$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $2ec24268596b8ed9$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $2ec24268596b8ed9$var$updateEffect($2ec24268596b8ed9$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $2ec24268596b8ed9$var$workInProgressHook && $2ec24268596b8ed9$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $2ec24268596b8ed9$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $2ec24268596b8ed9$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $2ec24268596b8ed9$var$workInProgressRoot) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($2ec24268596b8ed9$var$renderLanes & 127) || $2ec24268596b8ed9$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $2ec24268596b8ed9$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $2ec24268596b8ed9$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $2ec24268596b8ed9$var$createFunctionComponentUpdateQueue(), $2ec24268596b8ed9$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $2ec24268596b8ed9$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $2ec24268596b8ed9$var$checkIfSnapshotChanged(inst) && $2ec24268596b8ed9$var$forceStoreRerender(fiber);
}
function $2ec24268596b8ed9$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $2ec24268596b8ed9$var$checkIfSnapshotChanged(inst) && $2ec24268596b8ed9$var$forceStoreRerender(fiber);
    });
}
function $2ec24268596b8ed9$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$2ec24268596b8ed9$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $2ec24268596b8ed9$var$forceStoreRerender(fiber) {
    var root = $2ec24268596b8ed9$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $2ec24268596b8ed9$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $2ec24268596b8ed9$var$mountStateImpl(initialState) {
    var hook = $2ec24268596b8ed9$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($2ec24268596b8ed9$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $2ec24268596b8ed9$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $2ec24268596b8ed9$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2ec24268596b8ed9$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $2ec24268596b8ed9$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $2ec24268596b8ed9$var$updateReducerImpl(hook, $2ec24268596b8ed9$var$currentHook, "function" === typeof reducer ? reducer : $2ec24268596b8ed9$var$basicStateReducer);
}
function $2ec24268596b8ed9$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($2ec24268596b8ed9$var$isRenderPhaseUpdate(fiber)) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $2ec24268596b8ed9$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $2ec24268596b8ed9$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $2ec24268596b8ed9$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $2ec24268596b8ed9$var$ReactSharedInternals.T, currentTransition = {};
        $2ec24268596b8ed9$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $2ec24268596b8ed9$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $2ec24268596b8ed9$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $2ec24268596b8ed9$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $2ec24268596b8ed9$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $2ec24268596b8ed9$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $2ec24268596b8ed9$var$onActionError(actionQueue, node, error$66);
    }
}
function $2ec24268596b8ed9$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $2ec24268596b8ed9$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $2ec24268596b8ed9$var$onActionError(actionQueue, node, error);
    }) : $2ec24268596b8ed9$var$onActionSuccess(actionQueue, node, returnValue);
}
function $2ec24268596b8ed9$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $2ec24268596b8ed9$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $2ec24268596b8ed9$var$runActionStateAction(actionQueue, nextState)));
}
function $2ec24268596b8ed9$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $2ec24268596b8ed9$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $2ec24268596b8ed9$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $2ec24268596b8ed9$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $2ec24268596b8ed9$var$mountActionState(action, initialStateProp) {
    if ($2ec24268596b8ed9$var$isHydrating) {
        var ssrFormState = $2ec24268596b8ed9$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $2ec24268596b8ed9$var$currentlyRenderingFiber;
                if ($2ec24268596b8ed9$var$isHydrating) {
                    if ($2ec24268596b8ed9$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $2ec24268596b8ed9$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $2ec24268596b8ed9$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $2ec24268596b8ed9$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $2ec24268596b8ed9$var$nextHydratableInstance = $2ec24268596b8ed9$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $2ec24268596b8ed9$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $2ec24268596b8ed9$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2ec24268596b8ed9$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $2ec24268596b8ed9$var$dispatchSetState.bind(null, $2ec24268596b8ed9$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $2ec24268596b8ed9$var$mountStateImpl(!1);
    inRootOrSingleton = $2ec24268596b8ed9$var$dispatchOptimisticSetState.bind(null, $2ec24268596b8ed9$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $2ec24268596b8ed9$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $2ec24268596b8ed9$var$dispatchActionState.bind(null, $2ec24268596b8ed9$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $2ec24268596b8ed9$var$updateActionState(action) {
    var stateHook = $2ec24268596b8ed9$var$updateWorkInProgressHook();
    return $2ec24268596b8ed9$var$updateActionStateImpl(stateHook, $2ec24268596b8ed9$var$currentHook, action);
}
function $2ec24268596b8ed9$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $2ec24268596b8ed9$var$updateReducerImpl(stateHook, currentStateHook, $2ec24268596b8ed9$var$actionStateReducer)[0];
    stateHook = $2ec24268596b8ed9$var$updateReducer($2ec24268596b8ed9$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $2ec24268596b8ed9$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $2ec24268596b8ed9$var$SuspenseException) throw $2ec24268596b8ed9$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $2ec24268596b8ed9$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($2ec24268596b8ed9$var$currentlyRenderingFiber.flags |= 2048, $2ec24268596b8ed9$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $2ec24268596b8ed9$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $2ec24268596b8ed9$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $2ec24268596b8ed9$var$rerenderActionState(action) {
    var stateHook = $2ec24268596b8ed9$var$updateWorkInProgressHook(), currentStateHook = $2ec24268596b8ed9$var$currentHook;
    if (null !== currentStateHook) return $2ec24268596b8ed9$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $2ec24268596b8ed9$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $2ec24268596b8ed9$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $2ec24268596b8ed9$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $2ec24268596b8ed9$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $2ec24268596b8ed9$var$createFunctionComponentUpdateQueue(), $2ec24268596b8ed9$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $2ec24268596b8ed9$var$updateRef() {
    return $2ec24268596b8ed9$var$updateWorkInProgressHook().memoizedState;
}
function $2ec24268596b8ed9$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $2ec24268596b8ed9$var$mountWorkInProgressHook();
    $2ec24268596b8ed9$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $2ec24268596b8ed9$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $2ec24268596b8ed9$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $2ec24268596b8ed9$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $2ec24268596b8ed9$var$currentHook && null !== deps && $2ec24268596b8ed9$var$areHookInputsEqual(deps, $2ec24268596b8ed9$var$currentHook.memoizedState.deps) ? hook.memoizedState = $2ec24268596b8ed9$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($2ec24268596b8ed9$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $2ec24268596b8ed9$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $2ec24268596b8ed9$var$mountEffect(create, deps) {
    $2ec24268596b8ed9$var$mountEffectImpl(8390656, 8, create, deps);
}
function $2ec24268596b8ed9$var$updateEffect(create, deps) {
    $2ec24268596b8ed9$var$updateEffectImpl(2048, 8, create, deps);
}
function $2ec24268596b8ed9$var$useEffectEventImpl(payload) {
    $2ec24268596b8ed9$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $2ec24268596b8ed9$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $2ec24268596b8ed9$var$createFunctionComponentUpdateQueue(), $2ec24268596b8ed9$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $2ec24268596b8ed9$var$updateEvent(callback) {
    var ref = $2ec24268596b8ed9$var$updateWorkInProgressHook().memoizedState;
    $2ec24268596b8ed9$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($2ec24268596b8ed9$var$executionContext & 2)) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $2ec24268596b8ed9$var$updateInsertionEffect(create, deps) {
    return $2ec24268596b8ed9$var$updateEffectImpl(4, 2, create, deps);
}
function $2ec24268596b8ed9$var$updateLayoutEffect(create, deps) {
    return $2ec24268596b8ed9$var$updateEffectImpl(4, 4, create, deps);
}
function $2ec24268596b8ed9$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $2ec24268596b8ed9$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $2ec24268596b8ed9$var$updateEffectImpl(4, 4, $2ec24268596b8ed9$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $2ec24268596b8ed9$var$mountDebugValue() {}
function $2ec24268596b8ed9$var$updateCallback(callback, deps) {
    var hook = $2ec24268596b8ed9$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $2ec24268596b8ed9$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $2ec24268596b8ed9$var$updateMemo(nextCreate, deps) {
    var hook = $2ec24268596b8ed9$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $2ec24268596b8ed9$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($2ec24268596b8ed9$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $2ec24268596b8ed9$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $2ec24268596b8ed9$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $2ec24268596b8ed9$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($2ec24268596b8ed9$var$renderLanes & 1073741824) && 0 === ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $2ec24268596b8ed9$var$requestDeferredLane();
    $2ec24268596b8ed9$var$currentlyRenderingFiber.lanes |= hook;
    $2ec24268596b8ed9$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $2ec24268596b8ed9$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($2ec24268596b8ed9$var$objectIs(value, prevValue)) return value;
    if (null !== $2ec24268596b8ed9$var$currentTreeHiddenStackCursor.current) return hook = $2ec24268596b8ed9$var$mountDeferredValueImpl(hook, value, initialValue), $2ec24268596b8ed9$var$objectIs(hook, prevValue) || ($2ec24268596b8ed9$var$didReceiveUpdate = !0), hook;
    if (0 === ($2ec24268596b8ed9$var$renderLanes & 42) || 0 !== ($2ec24268596b8ed9$var$renderLanes & 1073741824) && 0 === ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & 261930)) return $2ec24268596b8ed9$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $2ec24268596b8ed9$var$requestDeferredLane();
    $2ec24268596b8ed9$var$currentlyRenderingFiber.lanes |= hook;
    $2ec24268596b8ed9$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $2ec24268596b8ed9$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $2ec24268596b8ed9$var$ReactDOMSharedInternals.p;
    $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $2ec24268596b8ed9$var$ReactSharedInternals.T, currentTransition = {};
    $2ec24268596b8ed9$var$ReactSharedInternals.T = currentTransition;
    $2ec24268596b8ed9$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $2ec24268596b8ed9$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $2ec24268596b8ed9$var$chainThenableValue(returnValue, finishedState);
            $2ec24268596b8ed9$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $2ec24268596b8ed9$var$requestUpdateLane(fiber));
        } else $2ec24268596b8ed9$var$dispatchSetStateInternal(fiber, queue, finishedState, $2ec24268596b8ed9$var$requestUpdateLane(fiber));
    } catch (error) {
        $2ec24268596b8ed9$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $2ec24268596b8ed9$var$requestUpdateLane());
    } finally{
        $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $2ec24268596b8ed9$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2ec24268596b8ed9$var$noop() {}
function $2ec24268596b8ed9$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(476));
    var queue = $2ec24268596b8ed9$var$ensureFormComponentIsStateful(formFiber).queue;
    $2ec24268596b8ed9$var$startTransition(formFiber, queue, pendingState, $2ec24268596b8ed9$var$sharedNotPendingObject, null === action ? $2ec24268596b8ed9$var$noop : function() {
        $2ec24268596b8ed9$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $2ec24268596b8ed9$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $2ec24268596b8ed9$var$sharedNotPendingObject,
        baseState: $2ec24268596b8ed9$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $2ec24268596b8ed9$var$basicStateReducer,
            lastRenderedState: $2ec24268596b8ed9$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $2ec24268596b8ed9$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $2ec24268596b8ed9$var$requestFormReset$1(formFiber) {
    var stateHook = $2ec24268596b8ed9$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $2ec24268596b8ed9$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $2ec24268596b8ed9$var$requestUpdateLane());
}
function $2ec24268596b8ed9$var$useHostTransitionStatus() {
    return $2ec24268596b8ed9$var$readContext($2ec24268596b8ed9$var$HostTransitionContext);
}
function $2ec24268596b8ed9$var$updateId() {
    return $2ec24268596b8ed9$var$updateWorkInProgressHook().memoizedState;
}
function $2ec24268596b8ed9$var$updateRefresh() {
    return $2ec24268596b8ed9$var$updateWorkInProgressHook().memoizedState;
}
function $2ec24268596b8ed9$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $2ec24268596b8ed9$var$requestUpdateLane();
                fiber = $2ec24268596b8ed9$var$createUpdate(lane);
                var root$69 = $2ec24268596b8ed9$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($2ec24268596b8ed9$var$scheduleUpdateOnFiber(root$69, provider, lane), $2ec24268596b8ed9$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $2ec24268596b8ed9$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $2ec24268596b8ed9$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $2ec24268596b8ed9$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $2ec24268596b8ed9$var$isRenderPhaseUpdate(fiber) ? $2ec24268596b8ed9$var$enqueueRenderPhaseUpdate(queue, action) : (action = $2ec24268596b8ed9$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($2ec24268596b8ed9$var$scheduleUpdateOnFiber(action, fiber, lane), $2ec24268596b8ed9$var$entangleTransitionUpdate(action, queue, lane)));
}
function $2ec24268596b8ed9$var$dispatchSetState(fiber, queue, action) {
    var lane = $2ec24268596b8ed9$var$requestUpdateLane();
    $2ec24268596b8ed9$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $2ec24268596b8ed9$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2ec24268596b8ed9$var$isRenderPhaseUpdate(fiber)) $2ec24268596b8ed9$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($2ec24268596b8ed9$var$objectIs(eagerState, currentState)) return $2ec24268596b8ed9$var$enqueueUpdate$1(fiber, queue, update, 0), null === $2ec24268596b8ed9$var$workInProgressRoot && $2ec24268596b8ed9$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $2ec24268596b8ed9$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $2ec24268596b8ed9$var$scheduleUpdateOnFiber(action, fiber, lane), $2ec24268596b8ed9$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $2ec24268596b8ed9$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $2ec24268596b8ed9$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2ec24268596b8ed9$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $2ec24268596b8ed9$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $2ec24268596b8ed9$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $2ec24268596b8ed9$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $2ec24268596b8ed9$var$currentlyRenderingFiber || null !== alternate && alternate === $2ec24268596b8ed9$var$currentlyRenderingFiber;
}
function $2ec24268596b8ed9$var$enqueueRenderPhaseUpdate(queue, update) {
    $2ec24268596b8ed9$var$didScheduleRenderPhaseUpdateDuringThisPass = $2ec24268596b8ed9$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $2ec24268596b8ed9$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $2ec24268596b8ed9$var$markRootEntangled(root, lane);
    }
}
var $2ec24268596b8ed9$var$ContextOnlyDispatcher = {
    readContext: $2ec24268596b8ed9$var$readContext,
    use: $2ec24268596b8ed9$var$use,
    useCallback: $2ec24268596b8ed9$var$throwInvalidHookError,
    useContext: $2ec24268596b8ed9$var$throwInvalidHookError,
    useEffect: $2ec24268596b8ed9$var$throwInvalidHookError,
    useImperativeHandle: $2ec24268596b8ed9$var$throwInvalidHookError,
    useLayoutEffect: $2ec24268596b8ed9$var$throwInvalidHookError,
    useInsertionEffect: $2ec24268596b8ed9$var$throwInvalidHookError,
    useMemo: $2ec24268596b8ed9$var$throwInvalidHookError,
    useReducer: $2ec24268596b8ed9$var$throwInvalidHookError,
    useRef: $2ec24268596b8ed9$var$throwInvalidHookError,
    useState: $2ec24268596b8ed9$var$throwInvalidHookError,
    useDebugValue: $2ec24268596b8ed9$var$throwInvalidHookError,
    useDeferredValue: $2ec24268596b8ed9$var$throwInvalidHookError,
    useTransition: $2ec24268596b8ed9$var$throwInvalidHookError,
    useSyncExternalStore: $2ec24268596b8ed9$var$throwInvalidHookError,
    useId: $2ec24268596b8ed9$var$throwInvalidHookError,
    useHostTransitionStatus: $2ec24268596b8ed9$var$throwInvalidHookError,
    useFormState: $2ec24268596b8ed9$var$throwInvalidHookError,
    useActionState: $2ec24268596b8ed9$var$throwInvalidHookError,
    useOptimistic: $2ec24268596b8ed9$var$throwInvalidHookError,
    useMemoCache: $2ec24268596b8ed9$var$throwInvalidHookError,
    useCacheRefresh: $2ec24268596b8ed9$var$throwInvalidHookError
};
$2ec24268596b8ed9$var$ContextOnlyDispatcher.useEffectEvent = $2ec24268596b8ed9$var$throwInvalidHookError;
var $2ec24268596b8ed9$var$HooksDispatcherOnMount = {
    readContext: $2ec24268596b8ed9$var$readContext,
    use: $2ec24268596b8ed9$var$use,
    useCallback: function(callback, deps) {
        $2ec24268596b8ed9$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $2ec24268596b8ed9$var$readContext,
    useEffect: $2ec24268596b8ed9$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $2ec24268596b8ed9$var$mountEffectImpl(4194308, 4, $2ec24268596b8ed9$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $2ec24268596b8ed9$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $2ec24268596b8ed9$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $2ec24268596b8ed9$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($2ec24268596b8ed9$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $2ec24268596b8ed9$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $2ec24268596b8ed9$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $2ec24268596b8ed9$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($2ec24268596b8ed9$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $2ec24268596b8ed9$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $2ec24268596b8ed9$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $2ec24268596b8ed9$var$dispatchReducerAction.bind(null, $2ec24268596b8ed9$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $2ec24268596b8ed9$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $2ec24268596b8ed9$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $2ec24268596b8ed9$var$dispatchSetState.bind(null, $2ec24268596b8ed9$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $2ec24268596b8ed9$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $2ec24268596b8ed9$var$mountWorkInProgressHook();
        return $2ec24268596b8ed9$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $2ec24268596b8ed9$var$mountStateImpl(!1);
        stateHook = $2ec24268596b8ed9$var$startTransition.bind(null, $2ec24268596b8ed9$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $2ec24268596b8ed9$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $2ec24268596b8ed9$var$currentlyRenderingFiber, hook = $2ec24268596b8ed9$var$mountWorkInProgressHook();
        if ($2ec24268596b8ed9$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $2ec24268596b8ed9$var$workInProgressRoot) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(349));
            0 !== ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & 127) || $2ec24268596b8ed9$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $2ec24268596b8ed9$var$mountEffect($2ec24268596b8ed9$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $2ec24268596b8ed9$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $2ec24268596b8ed9$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $2ec24268596b8ed9$var$mountWorkInProgressHook(), identifierPrefix = $2ec24268596b8ed9$var$workInProgressRoot.identifierPrefix;
        if ($2ec24268596b8ed9$var$isHydrating) {
            var JSCompiler_inline_result = $2ec24268596b8ed9$var$treeContextOverflow;
            var idWithLeadingBit = $2ec24268596b8ed9$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $2ec24268596b8ed9$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $2ec24268596b8ed9$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $2ec24268596b8ed9$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $2ec24268596b8ed9$var$useHostTransitionStatus,
    useFormState: $2ec24268596b8ed9$var$mountActionState,
    useActionState: $2ec24268596b8ed9$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $2ec24268596b8ed9$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $2ec24268596b8ed9$var$dispatchOptimisticSetState.bind(null, $2ec24268596b8ed9$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $2ec24268596b8ed9$var$useMemoCache,
    useCacheRefresh: function() {
        return $2ec24268596b8ed9$var$mountWorkInProgressHook().memoizedState = $2ec24268596b8ed9$var$refreshCache.bind(null, $2ec24268596b8ed9$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $2ec24268596b8ed9$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($2ec24268596b8ed9$var$executionContext & 2)) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $2ec24268596b8ed9$var$HooksDispatcherOnUpdate = {
    readContext: $2ec24268596b8ed9$var$readContext,
    use: $2ec24268596b8ed9$var$use,
    useCallback: $2ec24268596b8ed9$var$updateCallback,
    useContext: $2ec24268596b8ed9$var$readContext,
    useEffect: $2ec24268596b8ed9$var$updateEffect,
    useImperativeHandle: $2ec24268596b8ed9$var$updateImperativeHandle,
    useInsertionEffect: $2ec24268596b8ed9$var$updateInsertionEffect,
    useLayoutEffect: $2ec24268596b8ed9$var$updateLayoutEffect,
    useMemo: $2ec24268596b8ed9$var$updateMemo,
    useReducer: $2ec24268596b8ed9$var$updateReducer,
    useRef: $2ec24268596b8ed9$var$updateRef,
    useState: function() {
        return $2ec24268596b8ed9$var$updateReducer($2ec24268596b8ed9$var$basicStateReducer);
    },
    useDebugValue: $2ec24268596b8ed9$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $2ec24268596b8ed9$var$updateWorkInProgressHook();
        return $2ec24268596b8ed9$var$updateDeferredValueImpl(hook, $2ec24268596b8ed9$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $2ec24268596b8ed9$var$updateReducer($2ec24268596b8ed9$var$basicStateReducer)[0], start = $2ec24268596b8ed9$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $2ec24268596b8ed9$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $2ec24268596b8ed9$var$updateSyncExternalStore,
    useId: $2ec24268596b8ed9$var$updateId,
    useHostTransitionStatus: $2ec24268596b8ed9$var$useHostTransitionStatus,
    useFormState: $2ec24268596b8ed9$var$updateActionState,
    useActionState: $2ec24268596b8ed9$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $2ec24268596b8ed9$var$updateWorkInProgressHook();
        return $2ec24268596b8ed9$var$updateOptimisticImpl(hook, $2ec24268596b8ed9$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $2ec24268596b8ed9$var$useMemoCache,
    useCacheRefresh: $2ec24268596b8ed9$var$updateRefresh
};
$2ec24268596b8ed9$var$HooksDispatcherOnUpdate.useEffectEvent = $2ec24268596b8ed9$var$updateEvent;
var $2ec24268596b8ed9$var$HooksDispatcherOnRerender = {
    readContext: $2ec24268596b8ed9$var$readContext,
    use: $2ec24268596b8ed9$var$use,
    useCallback: $2ec24268596b8ed9$var$updateCallback,
    useContext: $2ec24268596b8ed9$var$readContext,
    useEffect: $2ec24268596b8ed9$var$updateEffect,
    useImperativeHandle: $2ec24268596b8ed9$var$updateImperativeHandle,
    useInsertionEffect: $2ec24268596b8ed9$var$updateInsertionEffect,
    useLayoutEffect: $2ec24268596b8ed9$var$updateLayoutEffect,
    useMemo: $2ec24268596b8ed9$var$updateMemo,
    useReducer: $2ec24268596b8ed9$var$rerenderReducer,
    useRef: $2ec24268596b8ed9$var$updateRef,
    useState: function() {
        return $2ec24268596b8ed9$var$rerenderReducer($2ec24268596b8ed9$var$basicStateReducer);
    },
    useDebugValue: $2ec24268596b8ed9$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $2ec24268596b8ed9$var$updateWorkInProgressHook();
        return null === $2ec24268596b8ed9$var$currentHook ? $2ec24268596b8ed9$var$mountDeferredValueImpl(hook, value, initialValue) : $2ec24268596b8ed9$var$updateDeferredValueImpl(hook, $2ec24268596b8ed9$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $2ec24268596b8ed9$var$rerenderReducer($2ec24268596b8ed9$var$basicStateReducer)[0], start = $2ec24268596b8ed9$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $2ec24268596b8ed9$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $2ec24268596b8ed9$var$updateSyncExternalStore,
    useId: $2ec24268596b8ed9$var$updateId,
    useHostTransitionStatus: $2ec24268596b8ed9$var$useHostTransitionStatus,
    useFormState: $2ec24268596b8ed9$var$rerenderActionState,
    useActionState: $2ec24268596b8ed9$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $2ec24268596b8ed9$var$updateWorkInProgressHook();
        if (null !== $2ec24268596b8ed9$var$currentHook) return $2ec24268596b8ed9$var$updateOptimisticImpl(hook, $2ec24268596b8ed9$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $2ec24268596b8ed9$var$useMemoCache,
    useCacheRefresh: $2ec24268596b8ed9$var$updateRefresh
};
$2ec24268596b8ed9$var$HooksDispatcherOnRerender.useEffectEvent = $2ec24268596b8ed9$var$updateEvent;
function $2ec24268596b8ed9$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $2ec24268596b8ed9$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $2ec24268596b8ed9$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $2ec24268596b8ed9$var$requestUpdateLane(), update = $2ec24268596b8ed9$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $2ec24268596b8ed9$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($2ec24268596b8ed9$var$scheduleUpdateOnFiber(payload, inst, lane), $2ec24268596b8ed9$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $2ec24268596b8ed9$var$requestUpdateLane(), update = $2ec24268596b8ed9$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $2ec24268596b8ed9$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($2ec24268596b8ed9$var$scheduleUpdateOnFiber(payload, inst, lane), $2ec24268596b8ed9$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $2ec24268596b8ed9$var$requestUpdateLane(), update = $2ec24268596b8ed9$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $2ec24268596b8ed9$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($2ec24268596b8ed9$var$scheduleUpdateOnFiber(callback, inst, lane), $2ec24268596b8ed9$var$entangleTransitions(callback, inst, lane));
    }
};
function $2ec24268596b8ed9$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$2ec24268596b8ed9$var$shallowEqual(oldProps, newProps) || !$2ec24268596b8ed9$var$shallowEqual(oldState, newState) : !0;
}
function $2ec24268596b8ed9$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $2ec24268596b8ed9$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $2ec24268596b8ed9$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $2ec24268596b8ed9$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $2ec24268596b8ed9$var$defaultOnUncaughtError(error) {
    $2ec24268596b8ed9$var$reportGlobalError(error);
}
function $2ec24268596b8ed9$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $2ec24268596b8ed9$var$defaultOnRecoverableError(error) {
    $2ec24268596b8ed9$var$reportGlobalError(error);
}
function $2ec24268596b8ed9$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $2ec24268596b8ed9$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $2ec24268596b8ed9$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $2ec24268596b8ed9$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $2ec24268596b8ed9$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $2ec24268596b8ed9$var$createClassErrorUpdate(lane) {
    lane = $2ec24268596b8ed9$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $2ec24268596b8ed9$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $2ec24268596b8ed9$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $2ec24268596b8ed9$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $2ec24268596b8ed9$var$legacyErrorBoundariesThatAlreadyFailed ? $2ec24268596b8ed9$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $2ec24268596b8ed9$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $2ec24268596b8ed9$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $2ec24268596b8ed9$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $2ec24268596b8ed9$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $2ec24268596b8ed9$var$shellBoundary ? $2ec24268596b8ed9$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $2ec24268596b8ed9$var$workInProgressRootExitStatus && ($2ec24268596b8ed9$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $2ec24268596b8ed9$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $2ec24268596b8ed9$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $2ec24268596b8ed9$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $2ec24268596b8ed9$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $2ec24268596b8ed9$var$attachPingListener(root, value, rootRenderLanes);
        $2ec24268596b8ed9$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($2ec24268596b8ed9$var$isHydrating) return returnFiber = $2ec24268596b8ed9$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $2ec24268596b8ed9$var$HydrationMismatchException && (root = Error($2ec24268596b8ed9$var$formatProdErrorMessage(422), {
        cause: value
    }), $2ec24268596b8ed9$var$queueHydrationError($2ec24268596b8ed9$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $2ec24268596b8ed9$var$HydrationMismatchException && (returnFiber = Error($2ec24268596b8ed9$var$formatProdErrorMessage(423), {
        cause: value
    }), $2ec24268596b8ed9$var$queueHydrationError($2ec24268596b8ed9$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $2ec24268596b8ed9$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $2ec24268596b8ed9$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $2ec24268596b8ed9$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $2ec24268596b8ed9$var$workInProgressRootExitStatus && ($2ec24268596b8ed9$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($2ec24268596b8ed9$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $2ec24268596b8ed9$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $2ec24268596b8ed9$var$workInProgressRootConcurrentErrors ? $2ec24268596b8ed9$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $2ec24268596b8ed9$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $2ec24268596b8ed9$var$workInProgressRootExitStatus && ($2ec24268596b8ed9$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $2ec24268596b8ed9$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $2ec24268596b8ed9$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $2ec24268596b8ed9$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $2ec24268596b8ed9$var$legacyErrorBoundariesThatAlreadyFailed || !$2ec24268596b8ed9$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $2ec24268596b8ed9$var$createClassErrorUpdate(rootRenderLanes), $2ec24268596b8ed9$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $2ec24268596b8ed9$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $2ec24268596b8ed9$var$SelectiveHydrationException = Error($2ec24268596b8ed9$var$formatProdErrorMessage(461)), $2ec24268596b8ed9$var$didReceiveUpdate = !1;
function $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $2ec24268596b8ed9$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $2ec24268596b8ed9$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $2ec24268596b8ed9$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $2ec24268596b8ed9$var$prepareToReadContext(workInProgress);
    nextProps = $2ec24268596b8ed9$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $2ec24268596b8ed9$var$checkDidRenderIdHook();
    if (null !== current && !$2ec24268596b8ed9$var$didReceiveUpdate) return $2ec24268596b8ed9$var$bailoutHooks(current, workInProgress, renderLanes), $2ec24268596b8ed9$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2ec24268596b8ed9$var$isHydrating && key && $2ec24268596b8ed9$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $2ec24268596b8ed9$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$2ec24268596b8ed9$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $2ec24268596b8ed9$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $2ec24268596b8ed9$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$2ec24268596b8ed9$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $2ec24268596b8ed9$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $2ec24268596b8ed9$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $2ec24268596b8ed9$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $2ec24268596b8ed9$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($2ec24268596b8ed9$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($2ec24268596b8ed9$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $2ec24268596b8ed9$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($2ec24268596b8ed9$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $2ec24268596b8ed9$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $2ec24268596b8ed9$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $2ec24268596b8ed9$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $2ec24268596b8ed9$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $2ec24268596b8ed9$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $2ec24268596b8ed9$var$pushHiddenContext(workInProgress, prevState) : $2ec24268596b8ed9$var$reuseHiddenContextOnStack(), $2ec24268596b8ed9$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $2ec24268596b8ed9$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($2ec24268596b8ed9$var$pushTransition(workInProgress, prevState.cachePool), $2ec24268596b8ed9$var$pushHiddenContext(workInProgress, prevState), $2ec24268596b8ed9$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $2ec24268596b8ed9$var$pushTransition(workInProgress, null), $2ec24268596b8ed9$var$reuseHiddenContextOnStack(), $2ec24268596b8ed9$var$reuseSuspenseHandlerOnStack(workInProgress));
    $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $2ec24268596b8ed9$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $2ec24268596b8ed9$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $2ec24268596b8ed9$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $2ec24268596b8ed9$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $2ec24268596b8ed9$var$pushTransition(workInProgress, null);
    $2ec24268596b8ed9$var$reuseHiddenContextOnStack();
    $2ec24268596b8ed9$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $2ec24268596b8ed9$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $2ec24268596b8ed9$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $2ec24268596b8ed9$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $2ec24268596b8ed9$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $2ec24268596b8ed9$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $2ec24268596b8ed9$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $2ec24268596b8ed9$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $2ec24268596b8ed9$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($2ec24268596b8ed9$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $2ec24268596b8ed9$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $2ec24268596b8ed9$var$bailoutOffscreenComponent(null, current);
            $2ec24268596b8ed9$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $2ec24268596b8ed9$var$nextHydratableInstance) ? (current = $2ec24268596b8ed9$var$canHydrateHydrationBoundary(current, $2ec24268596b8ed9$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $2ec24268596b8ed9$var$treeContextProvider ? {
                    id: $2ec24268596b8ed9$var$treeContextId,
                    overflow: $2ec24268596b8ed9$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $2ec24268596b8ed9$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $2ec24268596b8ed9$var$hydrationParentFiber = workInProgress, $2ec24268596b8ed9$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $2ec24268596b8ed9$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $2ec24268596b8ed9$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $2ec24268596b8ed9$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $2ec24268596b8ed9$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(558));
        } else if ($2ec24268596b8ed9$var$didReceiveUpdate || $2ec24268596b8ed9$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $2ec24268596b8ed9$var$didReceiveUpdate || didSuspend) {
            nextProps = $2ec24268596b8ed9$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $2ec24268596b8ed9$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $2ec24268596b8ed9$var$enqueueConcurrentRenderForLane(current, dehydrated), $2ec24268596b8ed9$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $2ec24268596b8ed9$var$SelectiveHydrationException;
            $2ec24268596b8ed9$var$renderDidSuspendDelayIfPossible();
            workInProgress = $2ec24268596b8ed9$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $2ec24268596b8ed9$var$nextHydratableInstance = $2ec24268596b8ed9$var$getNextHydratable(dehydrated.nextSibling), $2ec24268596b8ed9$var$hydrationParentFiber = workInProgress, $2ec24268596b8ed9$var$isHydrating = !0, $2ec24268596b8ed9$var$hydrationErrors = null, $2ec24268596b8ed9$var$rootOrSingletonContext = !1, null !== current && $2ec24268596b8ed9$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $2ec24268596b8ed9$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $2ec24268596b8ed9$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $2ec24268596b8ed9$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $2ec24268596b8ed9$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $2ec24268596b8ed9$var$prepareToReadContext(workInProgress);
    Component = $2ec24268596b8ed9$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $2ec24268596b8ed9$var$checkDidRenderIdHook();
    if (null !== current && !$2ec24268596b8ed9$var$didReceiveUpdate) return $2ec24268596b8ed9$var$bailoutHooks(current, workInProgress, renderLanes), $2ec24268596b8ed9$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2ec24268596b8ed9$var$isHydrating && nextProps && $2ec24268596b8ed9$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $2ec24268596b8ed9$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $2ec24268596b8ed9$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $2ec24268596b8ed9$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $2ec24268596b8ed9$var$finishRenderingHooks(current);
    Component = $2ec24268596b8ed9$var$checkDidRenderIdHook();
    if (null !== current && !$2ec24268596b8ed9$var$didReceiveUpdate) return $2ec24268596b8ed9$var$bailoutHooks(current, workInProgress, renderLanes), $2ec24268596b8ed9$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2ec24268596b8ed9$var$isHydrating && Component && $2ec24268596b8ed9$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $2ec24268596b8ed9$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $2ec24268596b8ed9$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $2ec24268596b8ed9$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $2ec24268596b8ed9$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $2ec24268596b8ed9$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $2ec24268596b8ed9$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $2ec24268596b8ed9$var$readContext(contextType) : $2ec24268596b8ed9$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($2ec24268596b8ed9$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $2ec24268596b8ed9$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $2ec24268596b8ed9$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $2ec24268596b8ed9$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $2ec24268596b8ed9$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $2ec24268596b8ed9$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $2ec24268596b8ed9$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $2ec24268596b8ed9$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $2ec24268596b8ed9$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $2ec24268596b8ed9$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $2ec24268596b8ed9$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $2ec24268596b8ed9$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($2ec24268596b8ed9$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $2ec24268596b8ed9$var$hasForceUpdate || $2ec24268596b8ed9$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $2ec24268596b8ed9$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $2ec24268596b8ed9$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $2ec24268596b8ed9$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $2ec24268596b8ed9$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $2ec24268596b8ed9$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $2ec24268596b8ed9$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $2ec24268596b8ed9$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $2ec24268596b8ed9$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $2ec24268596b8ed9$var$hasForceUpdate || null !== current && null !== current.dependencies && $2ec24268596b8ed9$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($2ec24268596b8ed9$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $2ec24268596b8ed9$var$hasForceUpdate || $2ec24268596b8ed9$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $2ec24268596b8ed9$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $2ec24268596b8ed9$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $2ec24268596b8ed9$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $2ec24268596b8ed9$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $2ec24268596b8ed9$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $2ec24268596b8ed9$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $2ec24268596b8ed9$var$resetHydrationState();
    workInProgress.flags |= 256;
    $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $2ec24268596b8ed9$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $2ec24268596b8ed9$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $2ec24268596b8ed9$var$getSuspendedCache()
    };
}
function $2ec24268596b8ed9$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $2ec24268596b8ed9$var$workInProgressDeferredLane);
    return current;
}
function $2ec24268596b8ed9$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($2ec24268596b8ed9$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($2ec24268596b8ed9$var$isHydrating) {
            showFallback ? $2ec24268596b8ed9$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $2ec24268596b8ed9$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $2ec24268596b8ed9$var$nextHydratableInstance) ? (current = $2ec24268596b8ed9$var$canHydrateHydrationBoundary(current, $2ec24268596b8ed9$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $2ec24268596b8ed9$var$treeContextProvider ? {
                    id: $2ec24268596b8ed9$var$treeContextId,
                    overflow: $2ec24268596b8ed9$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $2ec24268596b8ed9$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $2ec24268596b8ed9$var$hydrationParentFiber = workInProgress, $2ec24268596b8ed9$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $2ec24268596b8ed9$var$throwOnHydrationMismatch(workInProgress);
            $2ec24268596b8ed9$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $2ec24268596b8ed9$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $2ec24268596b8ed9$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $2ec24268596b8ed9$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $2ec24268596b8ed9$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $2ec24268596b8ed9$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2ec24268596b8ed9$var$SUSPENDED_MARKER, $2ec24268596b8ed9$var$bailoutOffscreenComponent(null, nextProps);
        $2ec24268596b8ed9$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $2ec24268596b8ed9$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($2ec24268596b8ed9$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $2ec24268596b8ed9$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($2ec24268596b8ed9$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($2ec24268596b8ed9$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $2ec24268596b8ed9$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $2ec24268596b8ed9$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $2ec24268596b8ed9$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $2ec24268596b8ed9$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $2ec24268596b8ed9$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2ec24268596b8ed9$var$SUSPENDED_MARKER, workInProgress = $2ec24268596b8ed9$var$bailoutOffscreenComponent(null, nextProps));
        else if ($2ec24268596b8ed9$var$pushPrimaryTreeSuspenseHandler(workInProgress), $2ec24268596b8ed9$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($2ec24268596b8ed9$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $2ec24268596b8ed9$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $2ec24268596b8ed9$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($2ec24268596b8ed9$var$didReceiveUpdate || $2ec24268596b8ed9$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $2ec24268596b8ed9$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $2ec24268596b8ed9$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $2ec24268596b8ed9$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $2ec24268596b8ed9$var$enqueueConcurrentRenderForLane(current, nextProps), $2ec24268596b8ed9$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $2ec24268596b8ed9$var$SelectiveHydrationException;
            $2ec24268596b8ed9$var$isSuspenseInstancePending(nextPrimaryChildren) || $2ec24268596b8ed9$var$renderDidSuspendDelayIfPossible();
            workInProgress = $2ec24268596b8ed9$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $2ec24268596b8ed9$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $2ec24268596b8ed9$var$nextHydratableInstance = $2ec24268596b8ed9$var$getNextHydratable(nextPrimaryChildren.nextSibling), $2ec24268596b8ed9$var$hydrationParentFiber = workInProgress, $2ec24268596b8ed9$var$isHydrating = !0, $2ec24268596b8ed9$var$hydrationErrors = null, $2ec24268596b8ed9$var$rootOrSingletonContext = !1, null !== current && $2ec24268596b8ed9$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $2ec24268596b8ed9$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $2ec24268596b8ed9$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $2ec24268596b8ed9$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $2ec24268596b8ed9$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $2ec24268596b8ed9$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $2ec24268596b8ed9$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $2ec24268596b8ed9$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $2ec24268596b8ed9$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $2ec24268596b8ed9$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $2ec24268596b8ed9$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2ec24268596b8ed9$var$SUSPENDED_MARKER, $2ec24268596b8ed9$var$bailoutOffscreenComponent(current.child, nextProps);
    $2ec24268596b8ed9$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $2ec24268596b8ed9$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $2ec24268596b8ed9$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $2ec24268596b8ed9$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $2ec24268596b8ed9$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $2ec24268596b8ed9$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $2ec24268596b8ed9$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $2ec24268596b8ed9$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $2ec24268596b8ed9$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $2ec24268596b8ed9$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $2ec24268596b8ed9$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $2ec24268596b8ed9$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $2ec24268596b8ed9$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $2ec24268596b8ed9$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$suspenseStackCursor, suspenseContext);
    $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $2ec24268596b8ed9$var$isHydrating ? $2ec24268596b8ed9$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $2ec24268596b8ed9$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $2ec24268596b8ed9$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $2ec24268596b8ed9$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $2ec24268596b8ed9$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $2ec24268596b8ed9$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $2ec24268596b8ed9$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $2ec24268596b8ed9$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $2ec24268596b8ed9$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $2ec24268596b8ed9$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($2ec24268596b8ed9$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $2ec24268596b8ed9$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $2ec24268596b8ed9$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $2ec24268596b8ed9$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $2ec24268596b8ed9$var$checkIfContextChanged(current) ? !0 : !1;
}
function $2ec24268596b8ed9$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $2ec24268596b8ed9$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $2ec24268596b8ed9$var$pushProvider(workInProgress, $2ec24268596b8ed9$var$CacheContext, current.memoizedState.cache);
            $2ec24268596b8ed9$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $2ec24268596b8ed9$var$pushHostContext(workInProgress);
            break;
        case 4:
            $2ec24268596b8ed9$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $2ec24268596b8ed9$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $2ec24268596b8ed9$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $2ec24268596b8ed9$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $2ec24268596b8ed9$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $2ec24268596b8ed9$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $2ec24268596b8ed9$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $2ec24268596b8ed9$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($2ec24268596b8ed9$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $2ec24268596b8ed9$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$suspenseStackCursor, $2ec24268596b8ed9$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $2ec24268596b8ed9$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $2ec24268596b8ed9$var$pushProvider(workInProgress, $2ec24268596b8ed9$var$CacheContext, current.memoizedState.cache);
    }
    return $2ec24268596b8ed9$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $2ec24268596b8ed9$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $2ec24268596b8ed9$var$didReceiveUpdate = !0;
        else {
            if (!$2ec24268596b8ed9$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $2ec24268596b8ed9$var$didReceiveUpdate = !1, $2ec24268596b8ed9$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $2ec24268596b8ed9$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $2ec24268596b8ed9$var$didReceiveUpdate = !1, $2ec24268596b8ed9$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $2ec24268596b8ed9$var$pushTreeId(workInProgress, $2ec24268596b8ed9$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $2ec24268596b8ed9$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $2ec24268596b8ed9$var$shouldConstruct(current) ? (props = $2ec24268596b8ed9$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $2ec24268596b8ed9$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $2ec24268596b8ed9$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $2ec24268596b8ed9$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $2ec24268596b8ed9$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $2ec24268596b8ed9$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $2ec24268596b8ed9$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $2ec24268596b8ed9$var$getComponentNameFromType(current) || current;
                    throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $2ec24268596b8ed9$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $2ec24268596b8ed9$var$resolveClassComponentProps(props, workInProgress.pendingProps), $2ec24268596b8ed9$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $2ec24268596b8ed9$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $2ec24268596b8ed9$var$cloneUpdateQueue(current, workInProgress);
                $2ec24268596b8ed9$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $2ec24268596b8ed9$var$pushProvider(workInProgress, $2ec24268596b8ed9$var$CacheContext, props);
                props !== prevState.cache && $2ec24268596b8ed9$var$propagateContextChanges(workInProgress, [
                    $2ec24268596b8ed9$var$CacheContext
                ], renderLanes, !0);
                $2ec24268596b8ed9$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $2ec24268596b8ed9$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $2ec24268596b8ed9$var$createCapturedValueAtFiber(Error($2ec24268596b8ed9$var$formatProdErrorMessage(424)), workInProgress);
                        $2ec24268596b8ed9$var$queueHydrationError($$typeof);
                        workInProgress = $2ec24268596b8ed9$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $2ec24268596b8ed9$var$nextHydratableInstance = $2ec24268596b8ed9$var$getNextHydratable(current.firstChild);
                        $2ec24268596b8ed9$var$hydrationParentFiber = workInProgress;
                        $2ec24268596b8ed9$var$isHydrating = !0;
                        $2ec24268596b8ed9$var$hydrationErrors = null;
                        $2ec24268596b8ed9$var$rootOrSingletonContext = !0;
                        renderLanes = $2ec24268596b8ed9$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $2ec24268596b8ed9$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $2ec24268596b8ed9$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $2ec24268596b8ed9$var$markRef(current, workInProgress), null === current ? (renderLanes = $2ec24268596b8ed9$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $2ec24268596b8ed9$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $2ec24268596b8ed9$var$getOwnerDocumentFromRootContainer($2ec24268596b8ed9$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$2ec24268596b8ed9$var$internalInstanceKey] = workInProgress, props[$2ec24268596b8ed9$var$internalPropsKey] = current, $2ec24268596b8ed9$var$setInitialProperties(props, renderLanes, current), $2ec24268596b8ed9$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $2ec24268596b8ed9$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $2ec24268596b8ed9$var$pushHostContext(workInProgress), null === current && $2ec24268596b8ed9$var$isHydrating && (props = workInProgress.stateNode = $2ec24268596b8ed9$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $2ec24268596b8ed9$var$rootInstanceStackCursor.current), $2ec24268596b8ed9$var$hydrationParentFiber = workInProgress, $2ec24268596b8ed9$var$rootOrSingletonContext = !0, $$typeof = $2ec24268596b8ed9$var$nextHydratableInstance, $2ec24268596b8ed9$var$isSingletonScope(workInProgress.type) ? ($2ec24268596b8ed9$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $2ec24268596b8ed9$var$nextHydratableInstance = $2ec24268596b8ed9$var$getNextHydratable(props.firstChild)) : $2ec24268596b8ed9$var$nextHydratableInstance = $$typeof), $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $2ec24268596b8ed9$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $2ec24268596b8ed9$var$isHydrating) {
                if ($$typeof = props = $2ec24268596b8ed9$var$nextHydratableInstance) props = $2ec24268596b8ed9$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $2ec24268596b8ed9$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $2ec24268596b8ed9$var$hydrationParentFiber = workInProgress, $2ec24268596b8ed9$var$nextHydratableInstance = $2ec24268596b8ed9$var$getNextHydratable(props.firstChild), $2ec24268596b8ed9$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $2ec24268596b8ed9$var$throwOnHydrationMismatch(workInProgress);
            }
            $2ec24268596b8ed9$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $2ec24268596b8ed9$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $2ec24268596b8ed9$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $2ec24268596b8ed9$var$renderWithHooks(current, workInProgress, $2ec24268596b8ed9$var$TransitionAwareHostComponent, null, null, renderLanes), $2ec24268596b8ed9$var$HostTransitionContext._currentValue = $$typeof);
            $2ec24268596b8ed9$var$markRef(current, workInProgress);
            $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $2ec24268596b8ed9$var$isHydrating) {
                if (current = renderLanes = $2ec24268596b8ed9$var$nextHydratableInstance) renderLanes = $2ec24268596b8ed9$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $2ec24268596b8ed9$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $2ec24268596b8ed9$var$hydrationParentFiber = workInProgress, $2ec24268596b8ed9$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $2ec24268596b8ed9$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $2ec24268596b8ed9$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $2ec24268596b8ed9$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $2ec24268596b8ed9$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $2ec24268596b8ed9$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $2ec24268596b8ed9$var$pushProvider(workInProgress, workInProgress.type, props.value), $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $2ec24268596b8ed9$var$prepareToReadContext(workInProgress), $$typeof = $2ec24268596b8ed9$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $2ec24268596b8ed9$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $2ec24268596b8ed9$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $2ec24268596b8ed9$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $2ec24268596b8ed9$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $2ec24268596b8ed9$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $2ec24268596b8ed9$var$prepareToReadContext(workInProgress), props = $2ec24268596b8ed9$var$readContext($2ec24268596b8ed9$var$CacheContext), null === current ? ($$typeof = $2ec24268596b8ed9$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $2ec24268596b8ed9$var$workInProgressRoot, prevState = $2ec24268596b8ed9$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $2ec24268596b8ed9$var$initializeUpdateQueue(workInProgress), $2ec24268596b8ed9$var$pushProvider(workInProgress, $2ec24268596b8ed9$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($2ec24268596b8ed9$var$cloneUpdateQueue(current, workInProgress), $2ec24268596b8ed9$var$processUpdateQueue(workInProgress, null, null, renderLanes), $2ec24268596b8ed9$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $2ec24268596b8ed9$var$pushProvider(workInProgress, $2ec24268596b8ed9$var$CacheContext, props)) : (props = prevState.cache, $2ec24268596b8ed9$var$pushProvider(workInProgress, $2ec24268596b8ed9$var$CacheContext, props), props !== $$typeof.cache && $2ec24268596b8ed9$var$propagateContextChanges(workInProgress, [
                $2ec24268596b8ed9$var$CacheContext
            ], renderLanes, !0))), $2ec24268596b8ed9$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $2ec24268596b8ed9$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $2ec24268596b8ed9$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($2ec24268596b8ed9$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $2ec24268596b8ed9$var$suspendedThenable = $2ec24268596b8ed9$var$noopSuspenseyCommitThenable, $2ec24268596b8ed9$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $2ec24268596b8ed9$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$2ec24268596b8ed9$var$preloadResource(resource)) {
        if ($2ec24268596b8ed9$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $2ec24268596b8ed9$var$suspendedThenable = $2ec24268596b8ed9$var$noopSuspenseyCommitThenable, $2ec24268596b8ed9$var$SuspenseyCommitException;
    }
}
function $2ec24268596b8ed9$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $2ec24268596b8ed9$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $2ec24268596b8ed9$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $2ec24268596b8ed9$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$2ec24268596b8ed9$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $2ec24268596b8ed9$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $2ec24268596b8ed9$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $2ec24268596b8ed9$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $2ec24268596b8ed9$var$bubbleProperties(workInProgress), null;
        case 1:
            return $2ec24268596b8ed9$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $2ec24268596b8ed9$var$popProvider($2ec24268596b8ed9$var$CacheContext);
            $2ec24268596b8ed9$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $2ec24268596b8ed9$var$popHydrationState(workInProgress) ? $2ec24268596b8ed9$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $2ec24268596b8ed9$var$upgradeHydrationErrorsToRecoverable());
            $2ec24268596b8ed9$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($2ec24268596b8ed9$var$markUpdate(workInProgress), null !== nextResource ? ($2ec24268596b8ed9$var$bubbleProperties(workInProgress), $2ec24268596b8ed9$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($2ec24268596b8ed9$var$bubbleProperties(workInProgress), $2ec24268596b8ed9$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($2ec24268596b8ed9$var$markUpdate(workInProgress), $2ec24268596b8ed9$var$bubbleProperties(workInProgress), $2ec24268596b8ed9$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($2ec24268596b8ed9$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $2ec24268596b8ed9$var$markUpdate(workInProgress), $2ec24268596b8ed9$var$bubbleProperties(workInProgress), $2ec24268596b8ed9$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $2ec24268596b8ed9$var$popHostContext(workInProgress);
            renderLanes = $2ec24268596b8ed9$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2ec24268596b8ed9$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(166));
                    $2ec24268596b8ed9$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $2ec24268596b8ed9$var$contextStackCursor.current;
                $2ec24268596b8ed9$var$popHydrationState(workInProgress) ? $2ec24268596b8ed9$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $2ec24268596b8ed9$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $2ec24268596b8ed9$var$markUpdate(workInProgress));
            }
            $2ec24268596b8ed9$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $2ec24268596b8ed9$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2ec24268596b8ed9$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(166));
                    $2ec24268596b8ed9$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $2ec24268596b8ed9$var$contextStackCursor.current;
                if ($2ec24268596b8ed9$var$popHydrationState(workInProgress)) $2ec24268596b8ed9$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $2ec24268596b8ed9$var$getOwnerDocumentFromRootContainer($2ec24268596b8ed9$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script></script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$2ec24268596b8ed9$var$internalInstanceKey] = workInProgress;
                    nextResource[$2ec24268596b8ed9$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($2ec24268596b8ed9$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $2ec24268596b8ed9$var$markUpdate(workInProgress);
                }
            }
            $2ec24268596b8ed9$var$bubbleProperties(workInProgress);
            $2ec24268596b8ed9$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2ec24268596b8ed9$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(166));
                current = $2ec24268596b8ed9$var$rootInstanceStackCursor.current;
                if ($2ec24268596b8ed9$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $2ec24268596b8ed9$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$2ec24268596b8ed9$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $2ec24268596b8ed9$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $2ec24268596b8ed9$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $2ec24268596b8ed9$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$2ec24268596b8ed9$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $2ec24268596b8ed9$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $2ec24268596b8ed9$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(557));
                        current[$2ec24268596b8ed9$var$internalInstanceKey] = workInProgress;
                    } else $2ec24268596b8ed9$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $2ec24268596b8ed9$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $2ec24268596b8ed9$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $2ec24268596b8ed9$var$popSuspenseHandler(workInProgress), workInProgress;
                    $2ec24268596b8ed9$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(558));
            }
            $2ec24268596b8ed9$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $2ec24268596b8ed9$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(317));
                        type[$2ec24268596b8ed9$var$internalInstanceKey] = workInProgress;
                    } else $2ec24268596b8ed9$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $2ec24268596b8ed9$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $2ec24268596b8ed9$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $2ec24268596b8ed9$var$popSuspenseHandler(workInProgress), workInProgress;
                    $2ec24268596b8ed9$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $2ec24268596b8ed9$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $2ec24268596b8ed9$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $2ec24268596b8ed9$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $2ec24268596b8ed9$var$popHostContainer(), null === current && $2ec24268596b8ed9$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $2ec24268596b8ed9$var$bubbleProperties(workInProgress), null;
        case 10:
            return $2ec24268596b8ed9$var$popProvider(workInProgress.type), $2ec24268596b8ed9$var$bubbleProperties(workInProgress), null;
        case 19:
            $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $2ec24268596b8ed9$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $2ec24268596b8ed9$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $2ec24268596b8ed9$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $2ec24268596b8ed9$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $2ec24268596b8ed9$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $2ec24268596b8ed9$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$2ec24268596b8ed9$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$suspenseStackCursor, $2ec24268596b8ed9$var$suspenseStackCursor.current & 1 | 2);
                            $2ec24268596b8ed9$var$isHydrating && $2ec24268596b8ed9$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $2ec24268596b8ed9$var$now() > $2ec24268596b8ed9$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $2ec24268596b8ed9$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $2ec24268596b8ed9$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $2ec24268596b8ed9$var$scheduleRetryEffect(workInProgress, current), $2ec24268596b8ed9$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$2ec24268596b8ed9$var$isHydrating) return $2ec24268596b8ed9$var$bubbleProperties(workInProgress), null;
                    } else 2 * $2ec24268596b8ed9$var$now() - newProps.renderingStartTime > $2ec24268596b8ed9$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $2ec24268596b8ed9$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $2ec24268596b8ed9$var$now(), current.sibling = null, renderLanes = $2ec24268596b8ed9$var$suspenseStackCursor.current, $2ec24268596b8ed9$var$push($2ec24268596b8ed9$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $2ec24268596b8ed9$var$isHydrating && $2ec24268596b8ed9$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $2ec24268596b8ed9$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $2ec24268596b8ed9$var$popSuspenseHandler(workInProgress), $2ec24268596b8ed9$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($2ec24268596b8ed9$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $2ec24268596b8ed9$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $2ec24268596b8ed9$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $2ec24268596b8ed9$var$popProvider($2ec24268596b8ed9$var$CacheContext), $2ec24268596b8ed9$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $2ec24268596b8ed9$var$unwindWork(current, workInProgress) {
    $2ec24268596b8ed9$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $2ec24268596b8ed9$var$popProvider($2ec24268596b8ed9$var$CacheContext), $2ec24268596b8ed9$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $2ec24268596b8ed9$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $2ec24268596b8ed9$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(340));
                $2ec24268596b8ed9$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $2ec24268596b8ed9$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(340));
                $2ec24268596b8ed9$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$suspenseStackCursor), null;
        case 4:
            return $2ec24268596b8ed9$var$popHostContainer(), null;
        case 10:
            return $2ec24268596b8ed9$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $2ec24268596b8ed9$var$popSuspenseHandler(workInProgress), $2ec24268596b8ed9$var$popHiddenContext(), null !== current && $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $2ec24268596b8ed9$var$popProvider($2ec24268596b8ed9$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $2ec24268596b8ed9$var$unwindInterruptedWork(current, interruptedWork) {
    $2ec24268596b8ed9$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $2ec24268596b8ed9$var$popProvider($2ec24268596b8ed9$var$CacheContext);
            $2ec24268596b8ed9$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $2ec24268596b8ed9$var$popHostContext(interruptedWork);
            break;
        case 4:
            $2ec24268596b8ed9$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $2ec24268596b8ed9$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $2ec24268596b8ed9$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$suspenseStackCursor);
            break;
        case 10:
            $2ec24268596b8ed9$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $2ec24268596b8ed9$var$popSuspenseHandler(interruptedWork);
            $2ec24268596b8ed9$var$popHiddenContext();
            null !== current && $2ec24268596b8ed9$var$pop($2ec24268596b8ed9$var$resumedCache);
            break;
        case 24:
            $2ec24268596b8ed9$var$popProvider($2ec24268596b8ed9$var$CacheContext);
    }
}
function $2ec24268596b8ed9$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2ec24268596b8ed9$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $2ec24268596b8ed9$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2ec24268596b8ed9$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $2ec24268596b8ed9$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $2ec24268596b8ed9$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $2ec24268596b8ed9$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $2ec24268596b8ed9$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $2ec24268596b8ed9$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $2ec24268596b8ed9$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $2ec24268596b8ed9$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $2ec24268596b8ed9$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $2ec24268596b8ed9$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $2ec24268596b8ed9$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2ec24268596b8ed9$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $2ec24268596b8ed9$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$2ec24268596b8ed9$var$internalPropsKey] = newProps;
    } catch (error) {
        $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2ec24268596b8ed9$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $2ec24268596b8ed9$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $2ec24268596b8ed9$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $2ec24268596b8ed9$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $2ec24268596b8ed9$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $2ec24268596b8ed9$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $2ec24268596b8ed9$var$noop$1));
    else if (4 !== tag && (27 === tag && $2ec24268596b8ed9$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($2ec24268596b8ed9$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$2ec24268596b8ed9$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $2ec24268596b8ed9$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $2ec24268596b8ed9$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($2ec24268596b8ed9$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$2ec24268596b8ed9$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $2ec24268596b8ed9$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $2ec24268596b8ed9$var$setInitialProperties(singleton, type, props);
        singleton[$2ec24268596b8ed9$var$internalInstanceKey] = finishedWork;
        singleton[$2ec24268596b8ed9$var$internalPropsKey] = props;
    } catch (error) {
        $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $2ec24268596b8ed9$var$offscreenSubtreeIsHidden = !1, $2ec24268596b8ed9$var$offscreenSubtreeWasHidden = !1, $2ec24268596b8ed9$var$needsFormReset = !1, $2ec24268596b8ed9$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $2ec24268596b8ed9$var$nextEffect = null;
function $2ec24268596b8ed9$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $2ec24268596b8ed9$var$eventsEnabled = $2ec24268596b8ed9$var$_enabled;
    root = $2ec24268596b8ed9$var$getActiveElementDeep(root);
    if ($2ec24268596b8ed9$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $2ec24268596b8ed9$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $2ec24268596b8ed9$var$_enabled = !1;
    for($2ec24268596b8ed9$var$nextEffect = firstChild; null !== $2ec24268596b8ed9$var$nextEffect;)if (firstChild = $2ec24268596b8ed9$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $2ec24268596b8ed9$var$nextEffect = root;
    else for(; null !== $2ec24268596b8ed9$var$nextEffect;){
        firstChild = $2ec24268596b8ed9$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $2ec24268596b8ed9$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $2ec24268596b8ed9$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $2ec24268596b8ed9$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $2ec24268596b8ed9$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $2ec24268596b8ed9$var$nextEffect = root;
            break;
        }
        $2ec24268596b8ed9$var$nextEffect = firstChild.return;
    }
}
function $2ec24268596b8ed9$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2ec24268596b8ed9$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2ec24268596b8ed9$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $2ec24268596b8ed9$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $2ec24268596b8ed9$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $2ec24268596b8ed9$var$commitClassCallbacks(finishedWork);
            flags & 512 && $2ec24268596b8ed9$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $2ec24268596b8ed9$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $2ec24268596b8ed9$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $2ec24268596b8ed9$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $2ec24268596b8ed9$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $2ec24268596b8ed9$var$commitHostMount(finishedWork);
            flags & 512 && $2ec24268596b8ed9$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $2ec24268596b8ed9$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $2ec24268596b8ed9$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2ec24268596b8ed9$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $2ec24268596b8ed9$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2ec24268596b8ed9$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $2ec24268596b8ed9$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $2ec24268596b8ed9$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $2ec24268596b8ed9$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $2ec24268596b8ed9$var$offscreenSubtreeWasHidden;
                prevProps = $2ec24268596b8ed9$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $2ec24268596b8ed9$var$offscreenSubtreeWasHidden;
                $2ec24268596b8ed9$var$offscreenSubtreeIsHidden = flags;
                ($2ec24268596b8ed9$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $2ec24268596b8ed9$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $2ec24268596b8ed9$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $2ec24268596b8ed9$var$offscreenSubtreeIsHidden = prevProps;
                $2ec24268596b8ed9$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $2ec24268596b8ed9$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $2ec24268596b8ed9$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $2ec24268596b8ed9$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $2ec24268596b8ed9$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $2ec24268596b8ed9$var$hostParent = null, $2ec24268596b8ed9$var$hostParentIsContainer = !1;
function $2ec24268596b8ed9$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$2ec24268596b8ed9$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $2ec24268596b8ed9$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($2ec24268596b8ed9$var$injectedHook && "function" === typeof $2ec24268596b8ed9$var$injectedHook.onCommitFiberUnmount) try {
        $2ec24268596b8ed9$var$injectedHook.onCommitFiberUnmount($2ec24268596b8ed9$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $2ec24268596b8ed9$var$offscreenSubtreeWasHidden || $2ec24268596b8ed9$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $2ec24268596b8ed9$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $2ec24268596b8ed9$var$offscreenSubtreeWasHidden || $2ec24268596b8ed9$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $2ec24268596b8ed9$var$hostParent, prevHostParentIsContainer = $2ec24268596b8ed9$var$hostParentIsContainer;
            $2ec24268596b8ed9$var$isSingletonScope(deletedFiber.type) && ($2ec24268596b8ed9$var$hostParent = deletedFiber.stateNode, $2ec24268596b8ed9$var$hostParentIsContainer = !1);
            $2ec24268596b8ed9$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2ec24268596b8ed9$var$releaseSingletonInstance(deletedFiber.stateNode);
            $2ec24268596b8ed9$var$hostParent = prevHostParent;
            $2ec24268596b8ed9$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $2ec24268596b8ed9$var$offscreenSubtreeWasHidden || $2ec24268596b8ed9$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $2ec24268596b8ed9$var$hostParent;
            prevHostParentIsContainer = $2ec24268596b8ed9$var$hostParentIsContainer;
            $2ec24268596b8ed9$var$hostParent = null;
            $2ec24268596b8ed9$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2ec24268596b8ed9$var$hostParent = prevHostParent;
            $2ec24268596b8ed9$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $2ec24268596b8ed9$var$hostParent) {
                if ($2ec24268596b8ed9$var$hostParentIsContainer) try {
                    (9 === $2ec24268596b8ed9$var$hostParent.nodeType ? $2ec24268596b8ed9$var$hostParent.body : "HTML" === $2ec24268596b8ed9$var$hostParent.nodeName ? $2ec24268596b8ed9$var$hostParent.ownerDocument.body : $2ec24268596b8ed9$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $2ec24268596b8ed9$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $2ec24268596b8ed9$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $2ec24268596b8ed9$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $2ec24268596b8ed9$var$hostParent && ($2ec24268596b8ed9$var$hostParentIsContainer ? (finishedRoot = $2ec24268596b8ed9$var$hostParent, $2ec24268596b8ed9$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $2ec24268596b8ed9$var$retryIfBlockedOn(finishedRoot)) : $2ec24268596b8ed9$var$clearHydrationBoundary($2ec24268596b8ed9$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $2ec24268596b8ed9$var$hostParent;
            prevHostParentIsContainer = $2ec24268596b8ed9$var$hostParentIsContainer;
            $2ec24268596b8ed9$var$hostParent = deletedFiber.stateNode.containerInfo;
            $2ec24268596b8ed9$var$hostParentIsContainer = !0;
            $2ec24268596b8ed9$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2ec24268596b8ed9$var$hostParent = prevHostParent;
            $2ec24268596b8ed9$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $2ec24268596b8ed9$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $2ec24268596b8ed9$var$offscreenSubtreeWasHidden || $2ec24268596b8ed9$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $2ec24268596b8ed9$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $2ec24268596b8ed9$var$offscreenSubtreeWasHidden || ($2ec24268596b8ed9$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $2ec24268596b8ed9$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $2ec24268596b8ed9$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $2ec24268596b8ed9$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $2ec24268596b8ed9$var$offscreenSubtreeWasHidden = (prevHostParent = $2ec24268596b8ed9$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $2ec24268596b8ed9$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2ec24268596b8ed9$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $2ec24268596b8ed9$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $2ec24268596b8ed9$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $2ec24268596b8ed9$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $2ec24268596b8ed9$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $2ec24268596b8ed9$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2ec24268596b8ed9$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $2ec24268596b8ed9$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $2ec24268596b8ed9$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $2ec24268596b8ed9$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $2ec24268596b8ed9$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $2ec24268596b8ed9$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($2ec24268596b8ed9$var$isSingletonScope(parent.type)) {
                        $2ec24268596b8ed9$var$hostParent = parent.stateNode;
                        $2ec24268596b8ed9$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $2ec24268596b8ed9$var$hostParent = parent.stateNode;
                    $2ec24268596b8ed9$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $2ec24268596b8ed9$var$hostParent = parent.stateNode.containerInfo;
                    $2ec24268596b8ed9$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $2ec24268596b8ed9$var$hostParent) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(160));
        $2ec24268596b8ed9$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $2ec24268596b8ed9$var$hostParent = null;
        $2ec24268596b8ed9$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$2ec24268596b8ed9$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $2ec24268596b8ed9$var$currentHoistableRoot = null;
function $2ec24268596b8ed9$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($2ec24268596b8ed9$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $2ec24268596b8ed9$var$commitHookEffectListMount(3, finishedWork), $2ec24268596b8ed9$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2ec24268596b8ed9$var$offscreenSubtreeWasHidden || null === current || $2ec24268596b8ed9$var$safelyDetachRef(current, current.return));
            flags & 64 && $2ec24268596b8ed9$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $2ec24268596b8ed9$var$currentHoistableRoot;
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2ec24268596b8ed9$var$offscreenSubtreeWasHidden || null === current || $2ec24268596b8ed9$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$2ec24268596b8ed9$var$internalHoistableMarker] || currentResource[$2ec24268596b8ed9$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $2ec24268596b8ed9$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$2ec24268596b8ed9$var$internalInstanceKey] = finishedWork;
                                        $2ec24268596b8ed9$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $2ec24268596b8ed9$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $2ec24268596b8ed9$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $2ec24268596b8ed9$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $2ec24268596b8ed9$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$2ec24268596b8ed9$var$internalInstanceKey] = finishedWork;
                                $2ec24268596b8ed9$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $2ec24268596b8ed9$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $2ec24268596b8ed9$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $2ec24268596b8ed9$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $2ec24268596b8ed9$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $2ec24268596b8ed9$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2ec24268596b8ed9$var$offscreenSubtreeWasHidden || null === current || $2ec24268596b8ed9$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $2ec24268596b8ed9$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2ec24268596b8ed9$var$offscreenSubtreeWasHidden || null === current || $2ec24268596b8ed9$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $2ec24268596b8ed9$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $2ec24268596b8ed9$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($2ec24268596b8ed9$var$needsFormReset = !0);
            break;
        case 6:
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $2ec24268596b8ed9$var$tagCaches = null;
            hoistableRoot = $2ec24268596b8ed9$var$currentHoistableRoot;
            $2ec24268596b8ed9$var$currentHoistableRoot = $2ec24268596b8ed9$var$getHoistableRoot(root.containerInfo);
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$currentHoistableRoot = hoistableRoot;
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $2ec24268596b8ed9$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $2ec24268596b8ed9$var$needsFormReset && ($2ec24268596b8ed9$var$needsFormReset = !1, $2ec24268596b8ed9$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $2ec24268596b8ed9$var$currentHoistableRoot;
            $2ec24268596b8ed9$var$currentHoistableRoot = $2ec24268596b8ed9$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            $2ec24268596b8ed9$var$currentHoistableRoot = flags;
            break;
        case 12:
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2ec24268596b8ed9$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($2ec24268596b8ed9$var$globalMostRecentFallbackTime = $2ec24268596b8ed9$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2ec24268596b8ed9$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $2ec24268596b8ed9$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $2ec24268596b8ed9$var$offscreenSubtreeWasHidden;
            $2ec24268596b8ed9$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $2ec24268596b8ed9$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $2ec24268596b8ed9$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $2ec24268596b8ed9$var$offscreenSubtreeIsHidden || $2ec24268596b8ed9$var$offscreenSubtreeWasHidden || $2ec24268596b8ed9$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $2ec24268596b8ed9$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $2ec24268596b8ed9$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $2ec24268596b8ed9$var$hideOrUnhideDehydratedBoundary(instance, !0) : $2ec24268596b8ed9$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $2ec24268596b8ed9$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $2ec24268596b8ed9$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2ec24268596b8ed9$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $2ec24268596b8ed9$var$recursivelyTraverseMutationEffects(root, finishedWork), $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork);
    }
}
function $2ec24268596b8ed9$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($2ec24268596b8ed9$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $2ec24268596b8ed9$var$getHostSibling(finishedWork);
                    $2ec24268596b8ed9$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($2ec24268596b8ed9$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $2ec24268596b8ed9$var$getHostSibling(finishedWork);
                    $2ec24268596b8ed9$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $2ec24268596b8ed9$var$getHostSibling(finishedWork);
                    $2ec24268596b8ed9$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $2ec24268596b8ed9$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $2ec24268596b8ed9$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $2ec24268596b8ed9$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$2ec24268596b8ed9$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $2ec24268596b8ed9$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $2ec24268596b8ed9$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $2ec24268596b8ed9$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $2ec24268596b8ed9$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $2ec24268596b8ed9$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $2ec24268596b8ed9$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $2ec24268596b8ed9$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $2ec24268596b8ed9$var$safelyDetachRef(finishedWork, finishedWork.return);
                $2ec24268596b8ed9$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $2ec24268596b8ed9$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $2ec24268596b8ed9$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $2ec24268596b8ed9$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2ec24268596b8ed9$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $2ec24268596b8ed9$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $2ec24268596b8ed9$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $2ec24268596b8ed9$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $2ec24268596b8ed9$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$2ec24268596b8ed9$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $2ec24268596b8ed9$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $2ec24268596b8ed9$var$commitClassCallbacks(finishedWork);
                $2ec24268596b8ed9$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $2ec24268596b8ed9$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $2ec24268596b8ed9$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $2ec24268596b8ed9$var$commitHostMount(finishedWork);
                $2ec24268596b8ed9$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $2ec24268596b8ed9$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $2ec24268596b8ed9$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $2ec24268596b8ed9$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $2ec24268596b8ed9$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $2ec24268596b8ed9$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $2ec24268596b8ed9$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $2ec24268596b8ed9$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $2ec24268596b8ed9$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2ec24268596b8ed9$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $2ec24268596b8ed9$var$releaseCache(previousCache));
}
function $2ec24268596b8ed9$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $2ec24268596b8ed9$var$releaseCache(current));
}
function $2ec24268596b8ed9$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$2ec24268596b8ed9$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $2ec24268596b8ed9$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2ec24268596b8ed9$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $2ec24268596b8ed9$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $2ec24268596b8ed9$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $2ec24268596b8ed9$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $2ec24268596b8ed9$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $2ec24268596b8ed9$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $2ec24268596b8ed9$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $2ec24268596b8ed9$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $2ec24268596b8ed9$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $2ec24268596b8ed9$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $2ec24268596b8ed9$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $2ec24268596b8ed9$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $2ec24268596b8ed9$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $2ec24268596b8ed9$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $2ec24268596b8ed9$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $2ec24268596b8ed9$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $2ec24268596b8ed9$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $2ec24268596b8ed9$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $2ec24268596b8ed9$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $2ec24268596b8ed9$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $2ec24268596b8ed9$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $2ec24268596b8ed9$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $2ec24268596b8ed9$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $2ec24268596b8ed9$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $2ec24268596b8ed9$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $2ec24268596b8ed9$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $2ec24268596b8ed9$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $2ec24268596b8ed9$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2ec24268596b8ed9$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $2ec24268596b8ed9$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $2ec24268596b8ed9$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $2ec24268596b8ed9$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $2ec24268596b8ed9$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $2ec24268596b8ed9$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $2ec24268596b8ed9$var$suspenseyCommitFlag = 8192;
function $2ec24268596b8ed9$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $2ec24268596b8ed9$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$2ec24268596b8ed9$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $2ec24268596b8ed9$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $2ec24268596b8ed9$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $2ec24268596b8ed9$var$suspenseyCommitFlag && null !== fiber.memoizedState && $2ec24268596b8ed9$var$suspendResource(suspendedState, $2ec24268596b8ed9$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $2ec24268596b8ed9$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $2ec24268596b8ed9$var$currentHoistableRoot;
            $2ec24268596b8ed9$var$currentHoistableRoot = $2ec24268596b8ed9$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $2ec24268596b8ed9$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $2ec24268596b8ed9$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $2ec24268596b8ed9$var$suspenseyCommitFlag, $2ec24268596b8ed9$var$suspenseyCommitFlag = 16777216, $2ec24268596b8ed9$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $2ec24268596b8ed9$var$suspenseyCommitFlag = previousHoistableRoot) : $2ec24268596b8ed9$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $2ec24268596b8ed9$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $2ec24268596b8ed9$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $2ec24268596b8ed9$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $2ec24268596b8ed9$var$nextEffect = childToDelete;
            $2ec24268596b8ed9$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $2ec24268596b8ed9$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$2ec24268596b8ed9$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $2ec24268596b8ed9$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2ec24268596b8ed9$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $2ec24268596b8ed9$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $2ec24268596b8ed9$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $2ec24268596b8ed9$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $2ec24268596b8ed9$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $2ec24268596b8ed9$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $2ec24268596b8ed9$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $2ec24268596b8ed9$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $2ec24268596b8ed9$var$nextEffect = childToDelete;
            $2ec24268596b8ed9$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $2ec24268596b8ed9$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $2ec24268596b8ed9$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $2ec24268596b8ed9$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $2ec24268596b8ed9$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $2ec24268596b8ed9$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2ec24268596b8ed9$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $2ec24268596b8ed9$var$nextEffect;){
        var fiber = $2ec24268596b8ed9$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $2ec24268596b8ed9$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $2ec24268596b8ed9$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $2ec24268596b8ed9$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $2ec24268596b8ed9$var$nextEffect;){
            cache = $2ec24268596b8ed9$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $2ec24268596b8ed9$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $2ec24268596b8ed9$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $2ec24268596b8ed9$var$nextEffect = sibling;
                break a;
            }
            $2ec24268596b8ed9$var$nextEffect = returnFiber;
        }
    }
}
var $2ec24268596b8ed9$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $2ec24268596b8ed9$var$readContext($2ec24268596b8ed9$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $2ec24268596b8ed9$var$readContext($2ec24268596b8ed9$var$CacheContext).controller.signal;
    }
}, $2ec24268596b8ed9$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $2ec24268596b8ed9$var$executionContext = 0, $2ec24268596b8ed9$var$workInProgressRoot = null, $2ec24268596b8ed9$var$workInProgress = null, $2ec24268596b8ed9$var$workInProgressRootRenderLanes = 0, $2ec24268596b8ed9$var$workInProgressSuspendedReason = 0, $2ec24268596b8ed9$var$workInProgressThrownValue = null, $2ec24268596b8ed9$var$workInProgressRootDidSkipSuspendedSiblings = !1, $2ec24268596b8ed9$var$workInProgressRootIsPrerendering = !1, $2ec24268596b8ed9$var$workInProgressRootDidAttachPingListener = !1, $2ec24268596b8ed9$var$entangledRenderLanes = 0, $2ec24268596b8ed9$var$workInProgressRootExitStatus = 0, $2ec24268596b8ed9$var$workInProgressRootSkippedLanes = 0, $2ec24268596b8ed9$var$workInProgressRootInterleavedUpdatedLanes = 0, $2ec24268596b8ed9$var$workInProgressRootPingedLanes = 0, $2ec24268596b8ed9$var$workInProgressDeferredLane = 0, $2ec24268596b8ed9$var$workInProgressSuspendedRetryLanes = 0, $2ec24268596b8ed9$var$workInProgressRootConcurrentErrors = null, $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors = null, $2ec24268596b8ed9$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $2ec24268596b8ed9$var$globalMostRecentFallbackTime = 0, $2ec24268596b8ed9$var$globalMostRecentTransitionTime = 0, $2ec24268596b8ed9$var$workInProgressRootRenderTargetTime = Infinity, $2ec24268596b8ed9$var$workInProgressTransitions = null, $2ec24268596b8ed9$var$legacyErrorBoundariesThatAlreadyFailed = null, $2ec24268596b8ed9$var$pendingEffectsStatus = 0, $2ec24268596b8ed9$var$pendingEffectsRoot = null, $2ec24268596b8ed9$var$pendingFinishedWork = null, $2ec24268596b8ed9$var$pendingEffectsLanes = 0, $2ec24268596b8ed9$var$pendingEffectsRemainingLanes = 0, $2ec24268596b8ed9$var$pendingPassiveTransitions = null, $2ec24268596b8ed9$var$pendingRecoverableErrors = null, $2ec24268596b8ed9$var$nestedUpdateCount = 0, $2ec24268596b8ed9$var$rootWithNestedUpdates = null;
function $2ec24268596b8ed9$var$requestUpdateLane() {
    return 0 !== ($2ec24268596b8ed9$var$executionContext & 2) && 0 !== $2ec24268596b8ed9$var$workInProgressRootRenderLanes ? $2ec24268596b8ed9$var$workInProgressRootRenderLanes & -$2ec24268596b8ed9$var$workInProgressRootRenderLanes : null !== $2ec24268596b8ed9$var$ReactSharedInternals.T ? $2ec24268596b8ed9$var$requestTransitionLane() : $2ec24268596b8ed9$var$resolveUpdatePriority();
}
function $2ec24268596b8ed9$var$requestDeferredLane() {
    if (0 === $2ec24268596b8ed9$var$workInProgressDeferredLane) {
        if (0 === ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & 536870912) || $2ec24268596b8ed9$var$isHydrating) {
            var lane = $2ec24268596b8ed9$var$nextTransitionDeferredLane;
            $2ec24268596b8ed9$var$nextTransitionDeferredLane <<= 1;
            0 === ($2ec24268596b8ed9$var$nextTransitionDeferredLane & 3932160) && ($2ec24268596b8ed9$var$nextTransitionDeferredLane = 262144);
            $2ec24268596b8ed9$var$workInProgressDeferredLane = lane;
        } else $2ec24268596b8ed9$var$workInProgressDeferredLane = 536870912;
    }
    lane = $2ec24268596b8ed9$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $2ec24268596b8ed9$var$workInProgressDeferredLane;
}
function $2ec24268596b8ed9$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $2ec24268596b8ed9$var$workInProgressRoot && (2 === $2ec24268596b8ed9$var$workInProgressSuspendedReason || 9 === $2ec24268596b8ed9$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $2ec24268596b8ed9$var$prepareFreshStack(root, 0), $2ec24268596b8ed9$var$markRootSuspended(root, $2ec24268596b8ed9$var$workInProgressRootRenderLanes, $2ec24268596b8ed9$var$workInProgressDeferredLane, !1);
    $2ec24268596b8ed9$var$markRootUpdated$1(root, lane);
    if (0 === ($2ec24268596b8ed9$var$executionContext & 2) || root !== $2ec24268596b8ed9$var$workInProgressRoot) root === $2ec24268596b8ed9$var$workInProgressRoot && (0 === ($2ec24268596b8ed9$var$executionContext & 2) && ($2ec24268596b8ed9$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $2ec24268596b8ed9$var$workInProgressRootExitStatus && $2ec24268596b8ed9$var$markRootSuspended(root, $2ec24268596b8ed9$var$workInProgressRootRenderLanes, $2ec24268596b8ed9$var$workInProgressDeferredLane, !1)), $2ec24268596b8ed9$var$ensureRootIsScheduled(root);
}
function $2ec24268596b8ed9$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($2ec24268596b8ed9$var$executionContext & 6)) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $2ec24268596b8ed9$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $2ec24268596b8ed9$var$renderRootConcurrent(root$jscomp$0, lanes) : $2ec24268596b8ed9$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $2ec24268596b8ed9$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $2ec24268596b8ed9$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$2ec24268596b8ed9$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $2ec24268596b8ed9$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $2ec24268596b8ed9$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($2ec24268596b8ed9$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $2ec24268596b8ed9$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($2ec24268596b8ed9$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $2ec24268596b8ed9$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors;
                            $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors ? $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors.push.apply($2ec24268596b8ed9$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $2ec24268596b8ed9$var$prepareFreshStack(root$jscomp$0, 0);
                $2ec24268596b8ed9$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $2ec24268596b8ed9$var$markRootSuspended(shouldTimeSlice, lanes, $2ec24268596b8ed9$var$workInProgressDeferredLane, !$2ec24268596b8ed9$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $2ec24268596b8ed9$var$globalMostRecentFallbackTime + 300 - $2ec24268596b8ed9$var$now(), 10 < exitStatus)) {
                    $2ec24268596b8ed9$var$markRootSuspended(shouldTimeSlice, lanes, $2ec24268596b8ed9$var$workInProgressDeferredLane, !$2ec24268596b8ed9$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $2ec24268596b8ed9$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $2ec24268596b8ed9$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $2ec24268596b8ed9$var$scheduleTimeout($2ec24268596b8ed9$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors, $2ec24268596b8ed9$var$workInProgressTransitions, $2ec24268596b8ed9$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $2ec24268596b8ed9$var$workInProgressDeferredLane, $2ec24268596b8ed9$var$workInProgressRootInterleavedUpdatedLanes, $2ec24268596b8ed9$var$workInProgressSuspendedRetryLanes, $2ec24268596b8ed9$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $2ec24268596b8ed9$var$commitRootWhenReady(shouldTimeSlice, forceSync, $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors, $2ec24268596b8ed9$var$workInProgressTransitions, $2ec24268596b8ed9$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $2ec24268596b8ed9$var$workInProgressDeferredLane, $2ec24268596b8ed9$var$workInProgressRootInterleavedUpdatedLanes, $2ec24268596b8ed9$var$workInProgressSuspendedRetryLanes, $2ec24268596b8ed9$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $2ec24268596b8ed9$var$ensureRootIsScheduled(root$jscomp$0);
}
function $2ec24268596b8ed9$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $2ec24268596b8ed9$var$noop$1
        };
        $2ec24268596b8ed9$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $2ec24268596b8ed9$var$globalMostRecentFallbackTime - $2ec24268596b8ed9$var$now() : (lanes & 4194048) === lanes ? $2ec24268596b8ed9$var$globalMostRecentTransitionTime - $2ec24268596b8ed9$var$now() : 0;
        timeoutOffset = $2ec24268596b8ed9$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $2ec24268596b8ed9$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($2ec24268596b8ed9$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $2ec24268596b8ed9$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $2ec24268596b8ed9$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $2ec24268596b8ed9$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$2ec24268596b8ed9$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $2ec24268596b8ed9$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$2ec24268596b8ed9$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$2ec24268596b8ed9$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $2ec24268596b8ed9$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $2ec24268596b8ed9$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $2ec24268596b8ed9$var$flushSyncWork$1() {
    return 0 === ($2ec24268596b8ed9$var$executionContext & 6) ? ($2ec24268596b8ed9$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $2ec24268596b8ed9$var$resetWorkInProgressStack() {
    if (null !== $2ec24268596b8ed9$var$workInProgress) {
        if (0 === $2ec24268596b8ed9$var$workInProgressSuspendedReason) var interruptedWork = $2ec24268596b8ed9$var$workInProgress.return;
        else interruptedWork = $2ec24268596b8ed9$var$workInProgress, $2ec24268596b8ed9$var$lastContextDependency = $2ec24268596b8ed9$var$currentlyRenderingFiber$1 = null, $2ec24268596b8ed9$var$resetHooksOnUnwind(interruptedWork), $2ec24268596b8ed9$var$thenableState$1 = null, $2ec24268596b8ed9$var$thenableIndexCounter$1 = 0, interruptedWork = $2ec24268596b8ed9$var$workInProgress;
        for(; null !== interruptedWork;)$2ec24268596b8ed9$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $2ec24268596b8ed9$var$workInProgress = null;
    }
}
function $2ec24268596b8ed9$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $2ec24268596b8ed9$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $2ec24268596b8ed9$var$pendingEffectsLanes = 0;
    $2ec24268596b8ed9$var$resetWorkInProgressStack();
    $2ec24268596b8ed9$var$workInProgressRoot = root;
    $2ec24268596b8ed9$var$workInProgress = timeoutHandle = $2ec24268596b8ed9$var$createWorkInProgress(root.current, null);
    $2ec24268596b8ed9$var$workInProgressRootRenderLanes = lanes;
    $2ec24268596b8ed9$var$workInProgressSuspendedReason = 0;
    $2ec24268596b8ed9$var$workInProgressThrownValue = null;
    $2ec24268596b8ed9$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $2ec24268596b8ed9$var$workInProgressRootIsPrerendering = $2ec24268596b8ed9$var$checkIfRootIsPrerendering(root, lanes);
    $2ec24268596b8ed9$var$workInProgressRootDidAttachPingListener = !1;
    $2ec24268596b8ed9$var$workInProgressSuspendedRetryLanes = $2ec24268596b8ed9$var$workInProgressDeferredLane = $2ec24268596b8ed9$var$workInProgressRootPingedLanes = $2ec24268596b8ed9$var$workInProgressRootInterleavedUpdatedLanes = $2ec24268596b8ed9$var$workInProgressRootSkippedLanes = $2ec24268596b8ed9$var$workInProgressRootExitStatus = 0;
    $2ec24268596b8ed9$var$workInProgressRootRecoverableErrors = $2ec24268596b8ed9$var$workInProgressRootConcurrentErrors = null;
    $2ec24268596b8ed9$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $2ec24268596b8ed9$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $2ec24268596b8ed9$var$entangledRenderLanes = lanes;
    $2ec24268596b8ed9$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $2ec24268596b8ed9$var$handleThrow(root, thrownValue) {
    $2ec24268596b8ed9$var$currentlyRenderingFiber = null;
    $2ec24268596b8ed9$var$ReactSharedInternals.H = $2ec24268596b8ed9$var$ContextOnlyDispatcher;
    thrownValue === $2ec24268596b8ed9$var$SuspenseException || thrownValue === $2ec24268596b8ed9$var$SuspenseActionException ? (thrownValue = $2ec24268596b8ed9$var$getSuspendedThenable(), $2ec24268596b8ed9$var$workInProgressSuspendedReason = 3) : thrownValue === $2ec24268596b8ed9$var$SuspenseyCommitException ? (thrownValue = $2ec24268596b8ed9$var$getSuspendedThenable(), $2ec24268596b8ed9$var$workInProgressSuspendedReason = 4) : $2ec24268596b8ed9$var$workInProgressSuspendedReason = thrownValue === $2ec24268596b8ed9$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $2ec24268596b8ed9$var$workInProgressThrownValue = thrownValue;
    null === $2ec24268596b8ed9$var$workInProgress && ($2ec24268596b8ed9$var$workInProgressRootExitStatus = 1, $2ec24268596b8ed9$var$logUncaughtError(root, $2ec24268596b8ed9$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $2ec24268596b8ed9$var$shouldRemainOnPreviousScreen() {
    var handler = $2ec24268596b8ed9$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & 4194048) === $2ec24268596b8ed9$var$workInProgressRootRenderLanes ? null === $2ec24268596b8ed9$var$shellBoundary ? !0 : !1 : ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & 62914560) === $2ec24268596b8ed9$var$workInProgressRootRenderLanes || 0 !== ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & 536870912) ? handler === $2ec24268596b8ed9$var$shellBoundary : !1;
}
function $2ec24268596b8ed9$var$pushDispatcher() {
    var prevDispatcher = $2ec24268596b8ed9$var$ReactSharedInternals.H;
    $2ec24268596b8ed9$var$ReactSharedInternals.H = $2ec24268596b8ed9$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $2ec24268596b8ed9$var$ContextOnlyDispatcher : prevDispatcher;
}
function $2ec24268596b8ed9$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $2ec24268596b8ed9$var$ReactSharedInternals.A;
    $2ec24268596b8ed9$var$ReactSharedInternals.A = $2ec24268596b8ed9$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $2ec24268596b8ed9$var$renderDidSuspendDelayIfPossible() {
    $2ec24268596b8ed9$var$workInProgressRootExitStatus = 4;
    $2ec24268596b8ed9$var$workInProgressRootDidSkipSuspendedSiblings || ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & 4194048) !== $2ec24268596b8ed9$var$workInProgressRootRenderLanes && null !== $2ec24268596b8ed9$var$suspenseHandlerStackCursor.current || ($2ec24268596b8ed9$var$workInProgressRootIsPrerendering = !0);
    0 === ($2ec24268596b8ed9$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($2ec24268596b8ed9$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $2ec24268596b8ed9$var$workInProgressRoot || $2ec24268596b8ed9$var$markRootSuspended($2ec24268596b8ed9$var$workInProgressRoot, $2ec24268596b8ed9$var$workInProgressRootRenderLanes, $2ec24268596b8ed9$var$workInProgressDeferredLane, !1);
}
function $2ec24268596b8ed9$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $2ec24268596b8ed9$var$executionContext;
    $2ec24268596b8ed9$var$executionContext |= 2;
    var prevDispatcher = $2ec24268596b8ed9$var$pushDispatcher(), prevAsyncDispatcher = $2ec24268596b8ed9$var$pushAsyncDispatcher();
    if ($2ec24268596b8ed9$var$workInProgressRoot !== root || $2ec24268596b8ed9$var$workInProgressRootRenderLanes !== lanes) $2ec24268596b8ed9$var$workInProgressTransitions = null, $2ec24268596b8ed9$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $2ec24268596b8ed9$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $2ec24268596b8ed9$var$workInProgressSuspendedReason && null !== $2ec24268596b8ed9$var$workInProgress) {
            var unitOfWork = $2ec24268596b8ed9$var$workInProgress, thrownValue = $2ec24268596b8ed9$var$workInProgressThrownValue;
            switch($2ec24268596b8ed9$var$workInProgressSuspendedReason){
                case 8:
                    $2ec24268596b8ed9$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $2ec24268596b8ed9$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $2ec24268596b8ed9$var$workInProgressSuspendedReason;
                    $2ec24268596b8ed9$var$workInProgressSuspendedReason = 0;
                    $2ec24268596b8ed9$var$workInProgressThrownValue = null;
                    $2ec24268596b8ed9$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $2ec24268596b8ed9$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $2ec24268596b8ed9$var$workInProgressSuspendedReason, $2ec24268596b8ed9$var$workInProgressSuspendedReason = 0, $2ec24268596b8ed9$var$workInProgressThrownValue = null, $2ec24268596b8ed9$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $2ec24268596b8ed9$var$workLoopSync();
        exitStatus = $2ec24268596b8ed9$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $2ec24268596b8ed9$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $2ec24268596b8ed9$var$lastContextDependency = $2ec24268596b8ed9$var$currentlyRenderingFiber$1 = null;
    $2ec24268596b8ed9$var$executionContext = prevExecutionContext;
    $2ec24268596b8ed9$var$ReactSharedInternals.H = prevDispatcher;
    $2ec24268596b8ed9$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $2ec24268596b8ed9$var$workInProgress && ($2ec24268596b8ed9$var$workInProgressRoot = null, $2ec24268596b8ed9$var$workInProgressRootRenderLanes = 0, $2ec24268596b8ed9$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $2ec24268596b8ed9$var$workLoopSync() {
    for(; null !== $2ec24268596b8ed9$var$workInProgress;)$2ec24268596b8ed9$var$performUnitOfWork($2ec24268596b8ed9$var$workInProgress);
}
function $2ec24268596b8ed9$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $2ec24268596b8ed9$var$executionContext;
    $2ec24268596b8ed9$var$executionContext |= 2;
    var prevDispatcher = $2ec24268596b8ed9$var$pushDispatcher(), prevAsyncDispatcher = $2ec24268596b8ed9$var$pushAsyncDispatcher();
    $2ec24268596b8ed9$var$workInProgressRoot !== root || $2ec24268596b8ed9$var$workInProgressRootRenderLanes !== lanes ? ($2ec24268596b8ed9$var$workInProgressTransitions = null, $2ec24268596b8ed9$var$workInProgressRootRenderTargetTime = $2ec24268596b8ed9$var$now() + 500, $2ec24268596b8ed9$var$prepareFreshStack(root, lanes)) : $2ec24268596b8ed9$var$workInProgressRootIsPrerendering = $2ec24268596b8ed9$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $2ec24268596b8ed9$var$workInProgressSuspendedReason && null !== $2ec24268596b8ed9$var$workInProgress) {
            lanes = $2ec24268596b8ed9$var$workInProgress;
            var thrownValue = $2ec24268596b8ed9$var$workInProgressThrownValue;
            b: switch($2ec24268596b8ed9$var$workInProgressSuspendedReason){
                case 1:
                    $2ec24268596b8ed9$var$workInProgressSuspendedReason = 0;
                    $2ec24268596b8ed9$var$workInProgressThrownValue = null;
                    $2ec24268596b8ed9$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($2ec24268596b8ed9$var$isThenableResolved(thrownValue)) {
                        $2ec24268596b8ed9$var$workInProgressSuspendedReason = 0;
                        $2ec24268596b8ed9$var$workInProgressThrownValue = null;
                        $2ec24268596b8ed9$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $2ec24268596b8ed9$var$workInProgressSuspendedReason && 9 !== $2ec24268596b8ed9$var$workInProgressSuspendedReason || $2ec24268596b8ed9$var$workInProgressRoot !== root || ($2ec24268596b8ed9$var$workInProgressSuspendedReason = 7);
                        $2ec24268596b8ed9$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $2ec24268596b8ed9$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $2ec24268596b8ed9$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $2ec24268596b8ed9$var$isThenableResolved(thrownValue) ? ($2ec24268596b8ed9$var$workInProgressSuspendedReason = 0, $2ec24268596b8ed9$var$workInProgressThrownValue = null, $2ec24268596b8ed9$var$replaySuspendedUnitOfWork(lanes)) : ($2ec24268596b8ed9$var$workInProgressSuspendedReason = 0, $2ec24268596b8ed9$var$workInProgressThrownValue = null, $2ec24268596b8ed9$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($2ec24268596b8ed9$var$workInProgress.tag){
                        case 26:
                            resource = $2ec24268596b8ed9$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $2ec24268596b8ed9$var$workInProgress;
                            if (resource ? $2ec24268596b8ed9$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $2ec24268596b8ed9$var$workInProgressSuspendedReason = 0;
                                $2ec24268596b8ed9$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $2ec24268596b8ed9$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($2ec24268596b8ed9$var$workInProgress = returnFiber, $2ec24268596b8ed9$var$completeUnitOfWork(returnFiber)) : $2ec24268596b8ed9$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $2ec24268596b8ed9$var$workInProgressSuspendedReason = 0;
                    $2ec24268596b8ed9$var$workInProgressThrownValue = null;
                    $2ec24268596b8ed9$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $2ec24268596b8ed9$var$workInProgressSuspendedReason = 0;
                    $2ec24268596b8ed9$var$workInProgressThrownValue = null;
                    $2ec24268596b8ed9$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $2ec24268596b8ed9$var$resetWorkInProgressStack();
                    $2ec24268596b8ed9$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(462));
            }
        }
        $2ec24268596b8ed9$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $2ec24268596b8ed9$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $2ec24268596b8ed9$var$lastContextDependency = $2ec24268596b8ed9$var$currentlyRenderingFiber$1 = null;
    $2ec24268596b8ed9$var$ReactSharedInternals.H = prevDispatcher;
    $2ec24268596b8ed9$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $2ec24268596b8ed9$var$executionContext = prevExecutionContext;
    if (null !== $2ec24268596b8ed9$var$workInProgress) return 0;
    $2ec24268596b8ed9$var$workInProgressRoot = null;
    $2ec24268596b8ed9$var$workInProgressRootRenderLanes = 0;
    $2ec24268596b8ed9$var$finishQueueingConcurrentUpdates();
    return $2ec24268596b8ed9$var$workInProgressRootExitStatus;
}
function $2ec24268596b8ed9$var$workLoopConcurrentByScheduler() {
    for(; null !== $2ec24268596b8ed9$var$workInProgress && !$2ec24268596b8ed9$var$shouldYield();)$2ec24268596b8ed9$var$performUnitOfWork($2ec24268596b8ed9$var$workInProgress);
}
function $2ec24268596b8ed9$var$performUnitOfWork(unitOfWork) {
    var next = $2ec24268596b8ed9$var$beginWork(unitOfWork.alternate, unitOfWork, $2ec24268596b8ed9$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $2ec24268596b8ed9$var$completeUnitOfWork(unitOfWork) : $2ec24268596b8ed9$var$workInProgress = next;
}
function $2ec24268596b8ed9$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $2ec24268596b8ed9$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $2ec24268596b8ed9$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $2ec24268596b8ed9$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $2ec24268596b8ed9$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $2ec24268596b8ed9$var$resetHooksOnUnwind(next);
        default:
            $2ec24268596b8ed9$var$unwindInterruptedWork(current, next), next = $2ec24268596b8ed9$var$workInProgress = $2ec24268596b8ed9$var$resetWorkInProgress(next, $2ec24268596b8ed9$var$entangledRenderLanes), next = $2ec24268596b8ed9$var$beginWork(current, next, $2ec24268596b8ed9$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $2ec24268596b8ed9$var$completeUnitOfWork(unitOfWork) : $2ec24268596b8ed9$var$workInProgress = next;
}
function $2ec24268596b8ed9$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $2ec24268596b8ed9$var$lastContextDependency = $2ec24268596b8ed9$var$currentlyRenderingFiber$1 = null;
    $2ec24268596b8ed9$var$resetHooksOnUnwind(unitOfWork);
    $2ec24268596b8ed9$var$thenableState$1 = null;
    $2ec24268596b8ed9$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($2ec24268596b8ed9$var$throwException(root, returnFiber, unitOfWork, thrownValue, $2ec24268596b8ed9$var$workInProgressRootRenderLanes)) {
            $2ec24268596b8ed9$var$workInProgressRootExitStatus = 1;
            $2ec24268596b8ed9$var$logUncaughtError(root, $2ec24268596b8ed9$var$createCapturedValueAtFiber(thrownValue, root.current));
            $2ec24268596b8ed9$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $2ec24268596b8ed9$var$workInProgress = returnFiber, error;
        $2ec24268596b8ed9$var$workInProgressRootExitStatus = 1;
        $2ec24268596b8ed9$var$logUncaughtError(root, $2ec24268596b8ed9$var$createCapturedValueAtFiber(thrownValue, root.current));
        $2ec24268596b8ed9$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($2ec24268596b8ed9$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($2ec24268596b8ed9$var$workInProgressRootIsPrerendering || 0 !== ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($2ec24268596b8ed9$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $2ec24268596b8ed9$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $2ec24268596b8ed9$var$unwindUnitOfWork(unitOfWork, root);
    } else $2ec24268596b8ed9$var$completeUnitOfWork(unitOfWork);
}
function $2ec24268596b8ed9$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $2ec24268596b8ed9$var$unwindUnitOfWork(completedWork, $2ec24268596b8ed9$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $2ec24268596b8ed9$var$completeWork(completedWork.alternate, completedWork, $2ec24268596b8ed9$var$entangledRenderLanes);
        if (null !== next) {
            $2ec24268596b8ed9$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $2ec24268596b8ed9$var$workInProgress = completedWork;
            return;
        }
        $2ec24268596b8ed9$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $2ec24268596b8ed9$var$workInProgressRootExitStatus && ($2ec24268596b8ed9$var$workInProgressRootExitStatus = 5);
}
function $2ec24268596b8ed9$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $2ec24268596b8ed9$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $2ec24268596b8ed9$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $2ec24268596b8ed9$var$workInProgress = unitOfWork;
            return;
        }
        $2ec24268596b8ed9$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $2ec24268596b8ed9$var$workInProgressRootExitStatus = 6;
    $2ec24268596b8ed9$var$workInProgress = null;
}
function $2ec24268596b8ed9$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $2ec24268596b8ed9$var$flushPendingEffects();
    while (0 !== $2ec24268596b8ed9$var$pendingEffectsStatus);
    if (0 !== ($2ec24268596b8ed9$var$executionContext & 6)) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $2ec24268596b8ed9$var$concurrentlyUpdatedLanes;
        $2ec24268596b8ed9$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $2ec24268596b8ed9$var$workInProgressRoot && ($2ec24268596b8ed9$var$workInProgress = $2ec24268596b8ed9$var$workInProgressRoot = null, $2ec24268596b8ed9$var$workInProgressRootRenderLanes = 0);
        $2ec24268596b8ed9$var$pendingFinishedWork = finishedWork;
        $2ec24268596b8ed9$var$pendingEffectsRoot = root;
        $2ec24268596b8ed9$var$pendingEffectsLanes = lanes;
        $2ec24268596b8ed9$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $2ec24268596b8ed9$var$pendingPassiveTransitions = transitions;
        $2ec24268596b8ed9$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $2ec24268596b8ed9$var$scheduleCallback$1($2ec24268596b8ed9$var$NormalPriority$1, function() {
            $2ec24268596b8ed9$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $2ec24268596b8ed9$var$ReactSharedInternals.T;
            $2ec24268596b8ed9$var$ReactSharedInternals.T = null;
            transitions = $2ec24268596b8ed9$var$ReactDOMSharedInternals.p;
            $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $2ec24268596b8ed9$var$executionContext;
            $2ec24268596b8ed9$var$executionContext |= 4;
            try {
                $2ec24268596b8ed9$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $2ec24268596b8ed9$var$executionContext = spawnedLane, $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = transitions, $2ec24268596b8ed9$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $2ec24268596b8ed9$var$pendingEffectsStatus = 1;
        $2ec24268596b8ed9$var$flushMutationEffects();
        $2ec24268596b8ed9$var$flushLayoutEffects();
        $2ec24268596b8ed9$var$flushSpawnedWork();
    }
}
function $2ec24268596b8ed9$var$flushMutationEffects() {
    if (1 === $2ec24268596b8ed9$var$pendingEffectsStatus) {
        $2ec24268596b8ed9$var$pendingEffectsStatus = 0;
        var root = $2ec24268596b8ed9$var$pendingEffectsRoot, finishedWork = $2ec24268596b8ed9$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $2ec24268596b8ed9$var$ReactSharedInternals.T;
            $2ec24268596b8ed9$var$ReactSharedInternals.T = null;
            var previousPriority = $2ec24268596b8ed9$var$ReactDOMSharedInternals.p;
            $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $2ec24268596b8ed9$var$executionContext;
            $2ec24268596b8ed9$var$executionContext |= 4;
            try {
                $2ec24268596b8ed9$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $2ec24268596b8ed9$var$selectionInformation, curFocusedElem = $2ec24268596b8ed9$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $2ec24268596b8ed9$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $2ec24268596b8ed9$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $2ec24268596b8ed9$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $2ec24268596b8ed9$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $2ec24268596b8ed9$var$_enabled = !!$2ec24268596b8ed9$var$eventsEnabled;
                $2ec24268596b8ed9$var$selectionInformation = $2ec24268596b8ed9$var$eventsEnabled = null;
            } finally{
                $2ec24268596b8ed9$var$executionContext = prevExecutionContext, $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = previousPriority, $2ec24268596b8ed9$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $2ec24268596b8ed9$var$pendingEffectsStatus = 2;
    }
}
function $2ec24268596b8ed9$var$flushLayoutEffects() {
    if (2 === $2ec24268596b8ed9$var$pendingEffectsStatus) {
        $2ec24268596b8ed9$var$pendingEffectsStatus = 0;
        var root = $2ec24268596b8ed9$var$pendingEffectsRoot, finishedWork = $2ec24268596b8ed9$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $2ec24268596b8ed9$var$ReactSharedInternals.T;
            $2ec24268596b8ed9$var$ReactSharedInternals.T = null;
            var previousPriority = $2ec24268596b8ed9$var$ReactDOMSharedInternals.p;
            $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $2ec24268596b8ed9$var$executionContext;
            $2ec24268596b8ed9$var$executionContext |= 4;
            try {
                $2ec24268596b8ed9$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $2ec24268596b8ed9$var$executionContext = prevExecutionContext, $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = previousPriority, $2ec24268596b8ed9$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $2ec24268596b8ed9$var$pendingEffectsStatus = 3;
    }
}
function $2ec24268596b8ed9$var$flushSpawnedWork() {
    if (4 === $2ec24268596b8ed9$var$pendingEffectsStatus || 3 === $2ec24268596b8ed9$var$pendingEffectsStatus) {
        $2ec24268596b8ed9$var$pendingEffectsStatus = 0;
        $2ec24268596b8ed9$var$requestPaint();
        var root = $2ec24268596b8ed9$var$pendingEffectsRoot, finishedWork = $2ec24268596b8ed9$var$pendingFinishedWork, lanes = $2ec24268596b8ed9$var$pendingEffectsLanes, recoverableErrors = $2ec24268596b8ed9$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $2ec24268596b8ed9$var$pendingEffectsStatus = 5 : ($2ec24268596b8ed9$var$pendingEffectsStatus = 0, $2ec24268596b8ed9$var$pendingFinishedWork = $2ec24268596b8ed9$var$pendingEffectsRoot = null, $2ec24268596b8ed9$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($2ec24268596b8ed9$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $2ec24268596b8ed9$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($2ec24268596b8ed9$var$injectedHook && "function" === typeof $2ec24268596b8ed9$var$injectedHook.onCommitFiberRoot) try {
            $2ec24268596b8ed9$var$injectedHook.onCommitFiberRoot($2ec24268596b8ed9$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $2ec24268596b8ed9$var$ReactSharedInternals.T;
            remainingLanes = $2ec24268596b8ed9$var$ReactDOMSharedInternals.p;
            $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = 2;
            $2ec24268596b8ed9$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $2ec24268596b8ed9$var$ReactSharedInternals.T = finishedWork, $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($2ec24268596b8ed9$var$pendingEffectsLanes & 3) && $2ec24268596b8ed9$var$flushPendingEffects();
        $2ec24268596b8ed9$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $2ec24268596b8ed9$var$rootWithNestedUpdates ? $2ec24268596b8ed9$var$nestedUpdateCount++ : ($2ec24268596b8ed9$var$nestedUpdateCount = 0, $2ec24268596b8ed9$var$rootWithNestedUpdates = root) : $2ec24268596b8ed9$var$nestedUpdateCount = 0;
        $2ec24268596b8ed9$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $2ec24268596b8ed9$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $2ec24268596b8ed9$var$releaseCache(remainingLanes)));
}
function $2ec24268596b8ed9$var$flushPendingEffects() {
    $2ec24268596b8ed9$var$flushMutationEffects();
    $2ec24268596b8ed9$var$flushLayoutEffects();
    $2ec24268596b8ed9$var$flushSpawnedWork();
    return $2ec24268596b8ed9$var$flushPassiveEffects();
}
function $2ec24268596b8ed9$var$flushPassiveEffects() {
    if (5 !== $2ec24268596b8ed9$var$pendingEffectsStatus) return !1;
    var root = $2ec24268596b8ed9$var$pendingEffectsRoot, remainingLanes = $2ec24268596b8ed9$var$pendingEffectsRemainingLanes;
    $2ec24268596b8ed9$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $2ec24268596b8ed9$var$lanesToEventPriority($2ec24268596b8ed9$var$pendingEffectsLanes), prevTransition = $2ec24268596b8ed9$var$ReactSharedInternals.T, previousPriority = $2ec24268596b8ed9$var$ReactDOMSharedInternals.p;
    try {
        $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $2ec24268596b8ed9$var$ReactSharedInternals.T = null;
        renderPriority = $2ec24268596b8ed9$var$pendingPassiveTransitions;
        $2ec24268596b8ed9$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $2ec24268596b8ed9$var$pendingEffectsRoot, lanes = $2ec24268596b8ed9$var$pendingEffectsLanes;
        $2ec24268596b8ed9$var$pendingEffectsStatus = 0;
        $2ec24268596b8ed9$var$pendingFinishedWork = $2ec24268596b8ed9$var$pendingEffectsRoot = null;
        $2ec24268596b8ed9$var$pendingEffectsLanes = 0;
        if (0 !== ($2ec24268596b8ed9$var$executionContext & 6)) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(331));
        var prevExecutionContext = $2ec24268596b8ed9$var$executionContext;
        $2ec24268596b8ed9$var$executionContext |= 4;
        $2ec24268596b8ed9$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $2ec24268596b8ed9$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $2ec24268596b8ed9$var$executionContext = prevExecutionContext;
        $2ec24268596b8ed9$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($2ec24268596b8ed9$var$injectedHook && "function" === typeof $2ec24268596b8ed9$var$injectedHook.onPostCommitFiberRoot) try {
            $2ec24268596b8ed9$var$injectedHook.onPostCommitFiberRoot($2ec24268596b8ed9$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = previousPriority, $2ec24268596b8ed9$var$ReactSharedInternals.T = prevTransition, $2ec24268596b8ed9$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $2ec24268596b8ed9$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $2ec24268596b8ed9$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $2ec24268596b8ed9$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $2ec24268596b8ed9$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($2ec24268596b8ed9$var$markRootUpdated$1(rootFiber, 2), $2ec24268596b8ed9$var$ensureRootIsScheduled(rootFiber));
}
function $2ec24268596b8ed9$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $2ec24268596b8ed9$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $2ec24268596b8ed9$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $2ec24268596b8ed9$var$legacyErrorBoundariesThatAlreadyFailed || !$2ec24268596b8ed9$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $2ec24268596b8ed9$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $2ec24268596b8ed9$var$createClassErrorUpdate(2);
                instance = $2ec24268596b8ed9$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($2ec24268596b8ed9$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $2ec24268596b8ed9$var$markRootUpdated$1(instance, 2), $2ec24268596b8ed9$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $2ec24268596b8ed9$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $2ec24268596b8ed9$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($2ec24268596b8ed9$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $2ec24268596b8ed9$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $2ec24268596b8ed9$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $2ec24268596b8ed9$var$workInProgressRoot === root && ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $2ec24268596b8ed9$var$workInProgressRootExitStatus || 3 === $2ec24268596b8ed9$var$workInProgressRootExitStatus && ($2ec24268596b8ed9$var$workInProgressRootRenderLanes & 62914560) === $2ec24268596b8ed9$var$workInProgressRootRenderLanes && 300 > $2ec24268596b8ed9$var$now() - $2ec24268596b8ed9$var$globalMostRecentFallbackTime ? 0 === ($2ec24268596b8ed9$var$executionContext & 2) && $2ec24268596b8ed9$var$prepareFreshStack(root, 0) : $2ec24268596b8ed9$var$workInProgressRootPingedLanes |= pingedLanes, $2ec24268596b8ed9$var$workInProgressSuspendedRetryLanes === $2ec24268596b8ed9$var$workInProgressRootRenderLanes && ($2ec24268596b8ed9$var$workInProgressSuspendedRetryLanes = 0));
    $2ec24268596b8ed9$var$ensureRootIsScheduled(root);
}
function $2ec24268596b8ed9$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $2ec24268596b8ed9$var$claimNextRetryLane());
    boundaryFiber = $2ec24268596b8ed9$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($2ec24268596b8ed9$var$markRootUpdated$1(boundaryFiber, retryLane), $2ec24268596b8ed9$var$ensureRootIsScheduled(boundaryFiber));
}
function $2ec24268596b8ed9$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $2ec24268596b8ed9$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $2ec24268596b8ed9$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $2ec24268596b8ed9$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $2ec24268596b8ed9$var$scheduleCallback$1(priorityLevel, callback) {
    return $2ec24268596b8ed9$var$scheduleCallback$3(priorityLevel, callback);
}
var $2ec24268596b8ed9$var$firstScheduledRoot = null, $2ec24268596b8ed9$var$lastScheduledRoot = null, $2ec24268596b8ed9$var$didScheduleMicrotask = !1, $2ec24268596b8ed9$var$mightHavePendingSyncWork = !1, $2ec24268596b8ed9$var$isFlushingWork = !1, $2ec24268596b8ed9$var$currentEventTransitionLane = 0;
function $2ec24268596b8ed9$var$ensureRootIsScheduled(root) {
    root !== $2ec24268596b8ed9$var$lastScheduledRoot && null === root.next && (null === $2ec24268596b8ed9$var$lastScheduledRoot ? $2ec24268596b8ed9$var$firstScheduledRoot = $2ec24268596b8ed9$var$lastScheduledRoot = root : $2ec24268596b8ed9$var$lastScheduledRoot = $2ec24268596b8ed9$var$lastScheduledRoot.next = root);
    $2ec24268596b8ed9$var$mightHavePendingSyncWork = !0;
    $2ec24268596b8ed9$var$didScheduleMicrotask || ($2ec24268596b8ed9$var$didScheduleMicrotask = !0, $2ec24268596b8ed9$var$scheduleImmediateRootScheduleTask());
}
function $2ec24268596b8ed9$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$2ec24268596b8ed9$var$isFlushingWork && $2ec24268596b8ed9$var$mightHavePendingSyncWork) {
        $2ec24268596b8ed9$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $2ec24268596b8ed9$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $2ec24268596b8ed9$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $2ec24268596b8ed9$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $2ec24268596b8ed9$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $2ec24268596b8ed9$var$getNextLanes(root$170, root$170 === $2ec24268596b8ed9$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $2ec24268596b8ed9$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $2ec24268596b8ed9$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $2ec24268596b8ed9$var$isFlushingWork = !1;
    }
}
function $2ec24268596b8ed9$var$processRootScheduleInImmediateTask() {
    $2ec24268596b8ed9$var$processRootScheduleInMicrotask();
}
function $2ec24268596b8ed9$var$processRootScheduleInMicrotask() {
    $2ec24268596b8ed9$var$mightHavePendingSyncWork = $2ec24268596b8ed9$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $2ec24268596b8ed9$var$currentEventTransitionLane && $2ec24268596b8ed9$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $2ec24268596b8ed9$var$currentEventTransitionLane);
    for(var currentTime = $2ec24268596b8ed9$var$now(), prev = null, root = $2ec24268596b8ed9$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $2ec24268596b8ed9$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $2ec24268596b8ed9$var$firstScheduledRoot = next : prev.next = next, null === next && ($2ec24268596b8ed9$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $2ec24268596b8ed9$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $2ec24268596b8ed9$var$pendingEffectsStatus && 5 !== $2ec24268596b8ed9$var$pendingEffectsStatus || $2ec24268596b8ed9$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $2ec24268596b8ed9$var$currentEventTransitionLane && ($2ec24268596b8ed9$var$currentEventTransitionLane = 0);
}
function $2ec24268596b8ed9$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $2ec24268596b8ed9$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $2ec24268596b8ed9$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $2ec24268596b8ed9$var$workInProgressRoot;
    suspendedLanes = $2ec24268596b8ed9$var$workInProgressRootRenderLanes;
    suspendedLanes = $2ec24268596b8ed9$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $2ec24268596b8ed9$var$workInProgressSuspendedReason || 9 === $2ec24268596b8ed9$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $2ec24268596b8ed9$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $2ec24268596b8ed9$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $2ec24268596b8ed9$var$cancelCallback$1(pingedLanes);
        switch($2ec24268596b8ed9$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $2ec24268596b8ed9$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $2ec24268596b8ed9$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $2ec24268596b8ed9$var$IdlePriority;
                break;
            default:
                suspendedLanes = $2ec24268596b8ed9$var$NormalPriority$1;
        }
        pingedLanes = $2ec24268596b8ed9$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $2ec24268596b8ed9$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $2ec24268596b8ed9$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $2ec24268596b8ed9$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $2ec24268596b8ed9$var$pendingEffectsStatus && 5 !== $2ec24268596b8ed9$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($2ec24268596b8ed9$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $2ec24268596b8ed9$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $2ec24268596b8ed9$var$getNextLanes(root, root === $2ec24268596b8ed9$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $2ec24268596b8ed9$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $2ec24268596b8ed9$var$scheduleTaskForRootDuringMicrotask(root, $2ec24268596b8ed9$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $2ec24268596b8ed9$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $2ec24268596b8ed9$var$performSyncWorkOnRoot(root, lanes) {
    if ($2ec24268596b8ed9$var$flushPendingEffects()) return null;
    $2ec24268596b8ed9$var$performWorkOnRoot(root, lanes, !0);
}
function $2ec24268596b8ed9$var$scheduleImmediateRootScheduleTask() {
    $2ec24268596b8ed9$var$scheduleMicrotask(function() {
        0 !== ($2ec24268596b8ed9$var$executionContext & 6) ? $2ec24268596b8ed9$var$scheduleCallback$3($2ec24268596b8ed9$var$ImmediatePriority, $2ec24268596b8ed9$var$processRootScheduleInImmediateTask) : $2ec24268596b8ed9$var$processRootScheduleInMicrotask();
    });
}
function $2ec24268596b8ed9$var$requestTransitionLane() {
    if (0 === $2ec24268596b8ed9$var$currentEventTransitionLane) {
        var actionScopeLane = $2ec24268596b8ed9$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $2ec24268596b8ed9$var$nextTransitionUpdateLane, $2ec24268596b8ed9$var$nextTransitionUpdateLane <<= 1, 0 === ($2ec24268596b8ed9$var$nextTransitionUpdateLane & 261888) && ($2ec24268596b8ed9$var$nextTransitionUpdateLane = 256));
        $2ec24268596b8ed9$var$currentEventTransitionLane = actionScopeLane;
    }
    return $2ec24268596b8ed9$var$currentEventTransitionLane;
}
function $2ec24268596b8ed9$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $2ec24268596b8ed9$var$sanitizeURL("" + actionProp);
}
function $2ec24268596b8ed9$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $2ec24268596b8ed9$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $2ec24268596b8ed9$var$coerceFormActionProp((nativeEventTarget[$2ec24268596b8ed9$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$2ec24268596b8ed9$var$internalPropsKey] || null) ? $2ec24268596b8ed9$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $2ec24268596b8ed9$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $2ec24268596b8ed9$var$currentEventTransitionLane) {
                                var formData = submitter ? $2ec24268596b8ed9$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $2ec24268596b8ed9$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $2ec24268596b8ed9$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $2ec24268596b8ed9$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $2ec24268596b8ed9$var$i$jscomp$inline_1577 = 0; $2ec24268596b8ed9$var$i$jscomp$inline_1577 < $2ec24268596b8ed9$var$simpleEventPluginEvents.length; $2ec24268596b8ed9$var$i$jscomp$inline_1577++){
    var $2ec24268596b8ed9$var$eventName$jscomp$inline_1578 = $2ec24268596b8ed9$var$simpleEventPluginEvents[$2ec24268596b8ed9$var$i$jscomp$inline_1577], $2ec24268596b8ed9$var$domEventName$jscomp$inline_1579 = $2ec24268596b8ed9$var$eventName$jscomp$inline_1578.toLowerCase(), $2ec24268596b8ed9$var$capitalizedEvent$jscomp$inline_1580 = $2ec24268596b8ed9$var$eventName$jscomp$inline_1578[0].toUpperCase() + $2ec24268596b8ed9$var$eventName$jscomp$inline_1578.slice(1);
    $2ec24268596b8ed9$var$registerSimpleEvent($2ec24268596b8ed9$var$domEventName$jscomp$inline_1579, "on" + $2ec24268596b8ed9$var$capitalizedEvent$jscomp$inline_1580);
}
$2ec24268596b8ed9$var$registerSimpleEvent($2ec24268596b8ed9$var$ANIMATION_END, "onAnimationEnd");
$2ec24268596b8ed9$var$registerSimpleEvent($2ec24268596b8ed9$var$ANIMATION_ITERATION, "onAnimationIteration");
$2ec24268596b8ed9$var$registerSimpleEvent($2ec24268596b8ed9$var$ANIMATION_START, "onAnimationStart");
$2ec24268596b8ed9$var$registerSimpleEvent("dblclick", "onDoubleClick");
$2ec24268596b8ed9$var$registerSimpleEvent("focusin", "onFocus");
$2ec24268596b8ed9$var$registerSimpleEvent("focusout", "onBlur");
$2ec24268596b8ed9$var$registerSimpleEvent($2ec24268596b8ed9$var$TRANSITION_RUN, "onTransitionRun");
$2ec24268596b8ed9$var$registerSimpleEvent($2ec24268596b8ed9$var$TRANSITION_START, "onTransitionStart");
$2ec24268596b8ed9$var$registerSimpleEvent($2ec24268596b8ed9$var$TRANSITION_CANCEL, "onTransitionCancel");
$2ec24268596b8ed9$var$registerSimpleEvent($2ec24268596b8ed9$var$TRANSITION_END, "onTransitionEnd");
$2ec24268596b8ed9$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$2ec24268596b8ed9$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$2ec24268596b8ed9$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$2ec24268596b8ed9$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$2ec24268596b8ed9$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$2ec24268596b8ed9$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$2ec24268596b8ed9$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$2ec24268596b8ed9$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$2ec24268596b8ed9$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$2ec24268596b8ed9$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $2ec24268596b8ed9$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $2ec24268596b8ed9$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($2ec24268596b8ed9$var$mediaEventTypes));
function $2ec24268596b8ed9$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $2ec24268596b8ed9$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $2ec24268596b8ed9$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $2ec24268596b8ed9$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$2ec24268596b8ed9$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$2ec24268596b8ed9$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($2ec24268596b8ed9$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $2ec24268596b8ed9$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $2ec24268596b8ed9$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $2ec24268596b8ed9$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $2ec24268596b8ed9$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$2ec24268596b8ed9$var$listeningMarker]) {
        rootContainerElement[$2ec24268596b8ed9$var$listeningMarker] = !0;
        $2ec24268596b8ed9$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($2ec24268596b8ed9$var$nonDelegatedEvents.has(domEventName) || $2ec24268596b8ed9$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $2ec24268596b8ed9$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$2ec24268596b8ed9$var$listeningMarker] || (ownerDocument[$2ec24268596b8ed9$var$listeningMarker] = !0, $2ec24268596b8ed9$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $2ec24268596b8ed9$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($2ec24268596b8ed9$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $2ec24268596b8ed9$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $2ec24268596b8ed9$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $2ec24268596b8ed9$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$2ec24268596b8ed9$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $2ec24268596b8ed9$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $2ec24268596b8ed9$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $2ec24268596b8ed9$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $2ec24268596b8ed9$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $2ec24268596b8ed9$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $2ec24268596b8ed9$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticTouchEvent;
                        break;
                    case $2ec24268596b8ed9$var$ANIMATION_END:
                    case $2ec24268596b8ed9$var$ANIMATION_ITERATION:
                    case $2ec24268596b8ed9$var$ANIMATION_START:
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticAnimationEvent;
                        break;
                    case $2ec24268596b8ed9$var$TRANSITION_END:
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $2ec24268596b8ed9$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $2ec24268596b8ed9$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($2ec24268596b8ed9$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $2ec24268596b8ed9$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($2ec24268596b8ed9$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$2ec24268596b8ed9$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $2ec24268596b8ed9$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $2ec24268596b8ed9$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $2ec24268596b8ed9$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $2ec24268596b8ed9$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $2ec24268596b8ed9$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $2ec24268596b8ed9$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $2ec24268596b8ed9$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $2ec24268596b8ed9$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $2ec24268596b8ed9$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $2ec24268596b8ed9$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $2ec24268596b8ed9$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $2ec24268596b8ed9$var$getTargetInstForChangeEvent;
                else if ($2ec24268596b8ed9$var$isTextInputElement(reactName)) {
                    if ($2ec24268596b8ed9$var$isInputEventSupported) getTargetInstFunc = $2ec24268596b8ed9$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $2ec24268596b8ed9$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $2ec24268596b8ed9$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $2ec24268596b8ed9$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $2ec24268596b8ed9$var$getTargetInstForChangeEvent) : getTargetInstFunc = $2ec24268596b8ed9$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $2ec24268596b8ed9$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $2ec24268596b8ed9$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $2ec24268596b8ed9$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($2ec24268596b8ed9$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $2ec24268596b8ed9$var$activeElement = handleEventFunc, $2ec24268596b8ed9$var$activeElementInst = targetInst, $2ec24268596b8ed9$var$lastSelection = null;
                    break;
                case "focusout":
                    $2ec24268596b8ed9$var$lastSelection = $2ec24268596b8ed9$var$activeElementInst = $2ec24268596b8ed9$var$activeElement = null;
                    break;
                case "mousedown":
                    $2ec24268596b8ed9$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $2ec24268596b8ed9$var$mouseDown = !1;
                    $2ec24268596b8ed9$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($2ec24268596b8ed9$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $2ec24268596b8ed9$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($2ec24268596b8ed9$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $2ec24268596b8ed9$var$isComposing ? $2ec24268596b8ed9$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($2ec24268596b8ed9$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($2ec24268596b8ed9$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $2ec24268596b8ed9$var$isComposing && (fallbackData = $2ec24268596b8ed9$var$getData()) : ($2ec24268596b8ed9$var$root = nativeEventTarget, $2ec24268596b8ed9$var$startText = "value" in $2ec24268596b8ed9$var$root ? $2ec24268596b8ed9$var$root.value : $2ec24268596b8ed9$var$root.textContent, $2ec24268596b8ed9$var$isComposing = !0)), handleEventFunc = $2ec24268596b8ed9$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $2ec24268596b8ed9$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $2ec24268596b8ed9$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $2ec24268596b8ed9$var$canUseTextInputEvent ? $2ec24268596b8ed9$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $2ec24268596b8ed9$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $2ec24268596b8ed9$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $2ec24268596b8ed9$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $2ec24268596b8ed9$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $2ec24268596b8ed9$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $2ec24268596b8ed9$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $2ec24268596b8ed9$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $2ec24268596b8ed9$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($2ec24268596b8ed9$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $2ec24268596b8ed9$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($2ec24268596b8ed9$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $2ec24268596b8ed9$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $2ec24268596b8ed9$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $2ec24268596b8ed9$var$getListener(target, registrationName), null != stateNode && listeners.unshift($2ec24268596b8ed9$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $2ec24268596b8ed9$var$getListener(target, registrationName), null != stateNode && listeners.push($2ec24268596b8ed9$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $2ec24268596b8ed9$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $2ec24268596b8ed9$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $2ec24268596b8ed9$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($2ec24268596b8ed9$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($2ec24268596b8ed9$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $2ec24268596b8ed9$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $2ec24268596b8ed9$var$normalizeMarkupForTextOrAttribute(clientText);
    return $2ec24268596b8ed9$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $2ec24268596b8ed9$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $2ec24268596b8ed9$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $2ec24268596b8ed9$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $2ec24268596b8ed9$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $2ec24268596b8ed9$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $2ec24268596b8ed9$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $2ec24268596b8ed9$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $2ec24268596b8ed9$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $2ec24268596b8ed9$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $2ec24268596b8ed9$var$setProp(domElement, tag, "name", props.name, props, null), $2ec24268596b8ed9$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $2ec24268596b8ed9$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $2ec24268596b8ed9$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($2ec24268596b8ed9$var$setProp(domElement, tag, "encType", props.encType, props, null), $2ec24268596b8ed9$var$setProp(domElement, tag, "method", props.method, props, null), $2ec24268596b8ed9$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $2ec24268596b8ed9$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $2ec24268596b8ed9$var$noop$1);
            break;
        case "onScroll":
            null != value && $2ec24268596b8ed9$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $2ec24268596b8ed9$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $2ec24268596b8ed9$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("toggle", domElement);
            $2ec24268596b8ed9$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $2ec24268596b8ed9$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $2ec24268596b8ed9$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $2ec24268596b8ed9$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $2ec24268596b8ed9$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $2ec24268596b8ed9$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $2ec24268596b8ed9$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $2ec24268596b8ed9$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $2ec24268596b8ed9$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $2ec24268596b8ed9$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $2ec24268596b8ed9$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $2ec24268596b8ed9$var$aliases.get(key) || key, $2ec24268596b8ed9$var$setValueForAttribute(domElement, key, value);
    }
}
function $2ec24268596b8ed9$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $2ec24268596b8ed9$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $2ec24268596b8ed9$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $2ec24268596b8ed9$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $2ec24268596b8ed9$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $2ec24268596b8ed9$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $2ec24268596b8ed9$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$2ec24268596b8ed9$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$2ec24268596b8ed9$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $2ec24268596b8ed9$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $2ec24268596b8ed9$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("error", domElement);
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(137, tag));
                    default:
                        $2ec24268596b8ed9$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $2ec24268596b8ed9$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $2ec24268596b8ed9$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $2ec24268596b8ed9$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $2ec24268596b8ed9$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $2ec24268596b8ed9$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $2ec24268596b8ed9$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $2ec24268596b8ed9$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(91));
                    break;
                default:
                    $2ec24268596b8ed9$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $2ec24268596b8ed9$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $2ec24268596b8ed9$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("toggle", domElement);
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("cancel", domElement);
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $2ec24268596b8ed9$var$mediaEventTypes.length; hasSrc++)$2ec24268596b8ed9$var$listenToNonDelegatedEvent($2ec24268596b8ed9$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("error", domElement);
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $2ec24268596b8ed9$var$listenToNonDelegatedEvent("error", domElement), $2ec24268596b8ed9$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(137, tag));
                default:
                    $2ec24268596b8ed9$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($2ec24268596b8ed9$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $2ec24268596b8ed9$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $2ec24268596b8ed9$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $2ec24268596b8ed9$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $2ec24268596b8ed9$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $2ec24268596b8ed9$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $2ec24268596b8ed9$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $2ec24268596b8ed9$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $2ec24268596b8ed9$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $2ec24268596b8ed9$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $2ec24268596b8ed9$var$updateOptions(domElement, !!lastProps, tag, !0) : $2ec24268596b8ed9$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $2ec24268596b8ed9$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $2ec24268596b8ed9$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $2ec24268596b8ed9$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $2ec24268596b8ed9$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $2ec24268596b8ed9$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $2ec24268596b8ed9$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $2ec24268596b8ed9$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($2ec24268596b8ed9$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $2ec24268596b8ed9$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $2ec24268596b8ed9$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $2ec24268596b8ed9$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $2ec24268596b8ed9$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $2ec24268596b8ed9$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $2ec24268596b8ed9$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $2ec24268596b8ed9$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $2ec24268596b8ed9$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $2ec24268596b8ed9$var$eventsEnabled = null, $2ec24268596b8ed9$var$selectionInformation = null;
function $2ec24268596b8ed9$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $2ec24268596b8ed9$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $2ec24268596b8ed9$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $2ec24268596b8ed9$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $2ec24268596b8ed9$var$currentPopstateTransitionEvent = null;
function $2ec24268596b8ed9$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $2ec24268596b8ed9$var$currentPopstateTransitionEvent) return !1;
        $2ec24268596b8ed9$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $2ec24268596b8ed9$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $2ec24268596b8ed9$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $2ec24268596b8ed9$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $2ec24268596b8ed9$var$localPromise = "function" === typeof Promise ? Promise : void 0, $2ec24268596b8ed9$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $2ec24268596b8ed9$var$localPromise ? function(callback) {
    return $2ec24268596b8ed9$var$localPromise.resolve(null).then(callback).catch($2ec24268596b8ed9$var$handleErrorInNextTick);
} : $2ec24268596b8ed9$var$scheduleTimeout;
function $2ec24268596b8ed9$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $2ec24268596b8ed9$var$isSingletonScope(type) {
    return "head" === type;
}
function $2ec24268596b8ed9$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $2ec24268596b8ed9$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $2ec24268596b8ed9$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $2ec24268596b8ed9$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$2ec24268596b8ed9$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $2ec24268596b8ed9$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $2ec24268596b8ed9$var$retryIfBlockedOn(hydrationInstance);
}
function $2ec24268596b8ed9$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $2ec24268596b8ed9$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $2ec24268596b8ed9$var$clearContainerSparingly(node);
                $2ec24268596b8ed9$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $2ec24268596b8ed9$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$2ec24268596b8ed9$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $2ec24268596b8ed9$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $2ec24268596b8ed9$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $2ec24268596b8ed9$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $2ec24268596b8ed9$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $2ec24268596b8ed9$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $2ec24268596b8ed9$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $2ec24268596b8ed9$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $2ec24268596b8ed9$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $2ec24268596b8ed9$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $2ec24268596b8ed9$var$previousHydratableOnEnteringScopedSingleton = null;
function $2ec24268596b8ed9$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $2ec24268596b8ed9$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $2ec24268596b8ed9$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $2ec24268596b8ed9$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $2ec24268596b8ed9$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(451));
    }
}
function $2ec24268596b8ed9$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $2ec24268596b8ed9$var$detachDeletedInstance(instance);
}
var $2ec24268596b8ed9$var$preloadPropsMap = new Map(), $2ec24268596b8ed9$var$preconnectsSet = new Set();
function $2ec24268596b8ed9$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $2ec24268596b8ed9$var$previousDispatcher = $2ec24268596b8ed9$var$ReactDOMSharedInternals.d;
$2ec24268596b8ed9$var$ReactDOMSharedInternals.d = {
    f: $2ec24268596b8ed9$var$flushSyncWork,
    r: $2ec24268596b8ed9$var$requestFormReset,
    D: $2ec24268596b8ed9$var$prefetchDNS,
    C: $2ec24268596b8ed9$var$preconnect,
    L: $2ec24268596b8ed9$var$preload,
    m: $2ec24268596b8ed9$var$preloadModule,
    X: $2ec24268596b8ed9$var$preinitScript,
    S: $2ec24268596b8ed9$var$preinitStyle,
    M: $2ec24268596b8ed9$var$preinitModuleScript
};
function $2ec24268596b8ed9$var$flushSyncWork() {
    var previousWasRendering = $2ec24268596b8ed9$var$previousDispatcher.f(), wasRendering = $2ec24268596b8ed9$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $2ec24268596b8ed9$var$requestFormReset(form) {
    var formInst = $2ec24268596b8ed9$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $2ec24268596b8ed9$var$requestFormReset$1(formInst) : $2ec24268596b8ed9$var$previousDispatcher.r(form);
}
var $2ec24268596b8ed9$var$globalDocument = "undefined" === typeof document ? null : document;
function $2ec24268596b8ed9$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $2ec24268596b8ed9$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $2ec24268596b8ed9$var$preconnectsSet.has(limitedEscapedHref) || ($2ec24268596b8ed9$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $2ec24268596b8ed9$var$setInitialProperties(href, "link", rel), $2ec24268596b8ed9$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $2ec24268596b8ed9$var$prefetchDNS(href) {
    $2ec24268596b8ed9$var$previousDispatcher.D(href);
    $2ec24268596b8ed9$var$preconnectAs("dns-prefetch", href, null);
}
function $2ec24268596b8ed9$var$preconnect(href, crossOrigin) {
    $2ec24268596b8ed9$var$previousDispatcher.C(href, crossOrigin);
    $2ec24268596b8ed9$var$preconnectAs("preconnect", href, crossOrigin);
}
function $2ec24268596b8ed9$var$preload(href, as, options) {
    $2ec24268596b8ed9$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $2ec24268596b8ed9$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $2ec24268596b8ed9$var$getStyleKey(href);
                break;
            case "script":
                key = $2ec24268596b8ed9$var$getScriptKey(href);
        }
        $2ec24268596b8ed9$var$preloadPropsMap.has(key) || (href = $2ec24268596b8ed9$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $2ec24268596b8ed9$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($2ec24268596b8ed9$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($2ec24268596b8ed9$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $2ec24268596b8ed9$var$setInitialProperties(as, "link", href), $2ec24268596b8ed9$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $2ec24268596b8ed9$var$preloadModule(href, options) {
    $2ec24268596b8ed9$var$previousDispatcher.m(href, options);
    var ownerDocument = $2ec24268596b8ed9$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $2ec24268596b8ed9$var$getScriptKey(href);
        }
        if (!$2ec24268596b8ed9$var$preloadPropsMap.has(key) && (href = $2ec24268596b8ed9$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $2ec24268596b8ed9$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($2ec24268596b8ed9$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $2ec24268596b8ed9$var$setInitialProperties(as, "link", href);
            $2ec24268596b8ed9$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $2ec24268596b8ed9$var$preinitStyle(href, precedence, options) {
    $2ec24268596b8ed9$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $2ec24268596b8ed9$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $2ec24268596b8ed9$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $2ec24268596b8ed9$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($2ec24268596b8ed9$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $2ec24268596b8ed9$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $2ec24268596b8ed9$var$preloadPropsMap.get(key)) && $2ec24268596b8ed9$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $2ec24268596b8ed9$var$markNodeAsHoistable(link);
                $2ec24268596b8ed9$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $2ec24268596b8ed9$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $2ec24268596b8ed9$var$preinitScript(src, options) {
    $2ec24268596b8ed9$var$previousDispatcher.X(src, options);
    var ownerDocument = $2ec24268596b8ed9$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $2ec24268596b8ed9$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $2ec24268596b8ed9$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($2ec24268596b8ed9$var$getScriptSelectorFromKey(key)), resource || (src = $2ec24268596b8ed9$var$assign({
            src: src,
            async: !0
        }, options), (options = $2ec24268596b8ed9$var$preloadPropsMap.get(key)) && $2ec24268596b8ed9$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $2ec24268596b8ed9$var$markNodeAsHoistable(resource), $2ec24268596b8ed9$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $2ec24268596b8ed9$var$preinitModuleScript(src, options) {
    $2ec24268596b8ed9$var$previousDispatcher.M(src, options);
    var ownerDocument = $2ec24268596b8ed9$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $2ec24268596b8ed9$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $2ec24268596b8ed9$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($2ec24268596b8ed9$var$getScriptSelectorFromKey(key)), resource || (src = $2ec24268596b8ed9$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $2ec24268596b8ed9$var$preloadPropsMap.get(key)) && $2ec24268596b8ed9$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $2ec24268596b8ed9$var$markNodeAsHoistable(resource), $2ec24268596b8ed9$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $2ec24268596b8ed9$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $2ec24268596b8ed9$var$rootInstanceStackCursor.current) ? $2ec24268596b8ed9$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $2ec24268596b8ed9$var$getStyleKey(pendingProps.href), pendingProps = $2ec24268596b8ed9$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $2ec24268596b8ed9$var$getStyleKey(pendingProps.href);
                var styles$243 = $2ec24268596b8ed9$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($2ec24268596b8ed9$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $2ec24268596b8ed9$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $2ec24268596b8ed9$var$preloadPropsMap.set(type, pendingProps), styles$243 || $2ec24268596b8ed9$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $2ec24268596b8ed9$var$getScriptKey(pendingProps), pendingProps = $2ec24268596b8ed9$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(444, type));
    }
}
function $2ec24268596b8ed9$var$getStyleKey(href) {
    return 'href="' + $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $2ec24268596b8ed9$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $2ec24268596b8ed9$var$stylesheetPropsFromRawProps(rawProps) {
    return $2ec24268596b8ed9$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $2ec24268596b8ed9$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $2ec24268596b8ed9$var$setInitialProperties(key, "link", preloadProps), $2ec24268596b8ed9$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $2ec24268596b8ed9$var$getScriptKey(src) {
    return '[src="' + $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $2ec24268596b8ed9$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $2ec24268596b8ed9$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $2ec24268596b8ed9$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $2ec24268596b8ed9$var$markNodeAsHoistable(instance), instance;
            var styleProps = $2ec24268596b8ed9$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $2ec24268596b8ed9$var$markNodeAsHoistable(instance);
            $2ec24268596b8ed9$var$setInitialProperties(instance, "style", styleProps);
            $2ec24268596b8ed9$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $2ec24268596b8ed9$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($2ec24268596b8ed9$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $2ec24268596b8ed9$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $2ec24268596b8ed9$var$stylesheetPropsFromRawProps(props);
            (styleProps = $2ec24268596b8ed9$var$preloadPropsMap.get(styleProps)) && $2ec24268596b8ed9$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $2ec24268596b8ed9$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $2ec24268596b8ed9$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $2ec24268596b8ed9$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $2ec24268596b8ed9$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($2ec24268596b8ed9$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $2ec24268596b8ed9$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $2ec24268596b8ed9$var$preloadPropsMap.get(instance$249)) instance = $2ec24268596b8ed9$var$assign({}, props), $2ec24268596b8ed9$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $2ec24268596b8ed9$var$markNodeAsHoistable(styleProps);
            $2ec24268596b8ed9$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $2ec24268596b8ed9$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $2ec24268596b8ed9$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $2ec24268596b8ed9$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $2ec24268596b8ed9$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $2ec24268596b8ed9$var$tagCaches = null;
function $2ec24268596b8ed9$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $2ec24268596b8ed9$var$tagCaches) {
        var cache = new Map();
        var caches = $2ec24268596b8ed9$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $2ec24268596b8ed9$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$2ec24268596b8ed9$var$internalHoistableMarker] || node[$2ec24268596b8ed9$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $2ec24268596b8ed9$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $2ec24268596b8ed9$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $2ec24268596b8ed9$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $2ec24268596b8ed9$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $2ec24268596b8ed9$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($2ec24268596b8ed9$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $2ec24268596b8ed9$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $2ec24268596b8ed9$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $2ec24268596b8ed9$var$stylesheetPropsFromRawProps(props);
            (key = $2ec24268596b8ed9$var$preloadPropsMap.get(key)) && $2ec24268596b8ed9$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $2ec24268596b8ed9$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $2ec24268596b8ed9$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $2ec24268596b8ed9$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $2ec24268596b8ed9$var$estimatedBytesWithinLimit = 0;
function $2ec24268596b8ed9$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $2ec24268596b8ed9$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $2ec24268596b8ed9$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $2ec24268596b8ed9$var$estimatedBytesWithinLimit && ($2ec24268596b8ed9$var$estimatedBytesWithinLimit = 62500 * $2ec24268596b8ed9$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $2ec24268596b8ed9$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $2ec24268596b8ed9$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $2ec24268596b8ed9$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $2ec24268596b8ed9$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $2ec24268596b8ed9$var$precedencesByRoot = null;
function $2ec24268596b8ed9$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $2ec24268596b8ed9$var$precedencesByRoot = new Map(), resources.forEach($2ec24268596b8ed9$var$insertStylesheetIntoRoot, state), $2ec24268596b8ed9$var$precedencesByRoot = null, $2ec24268596b8ed9$var$onUnsuspend.call(state));
}
function $2ec24268596b8ed9$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $2ec24268596b8ed9$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $2ec24268596b8ed9$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $2ec24268596b8ed9$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $2ec24268596b8ed9$var$HostTransitionContext = {
    $$typeof: $2ec24268596b8ed9$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $2ec24268596b8ed9$var$sharedNotPendingObject,
    _currentValue2: $2ec24268596b8ed9$var$sharedNotPendingObject,
    _threadCount: 0
};
function $2ec24268596b8ed9$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $2ec24268596b8ed9$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $2ec24268596b8ed9$var$createLaneMap(0);
    this.hiddenUpdates = $2ec24268596b8ed9$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $2ec24268596b8ed9$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $2ec24268596b8ed9$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $2ec24268596b8ed9$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $2ec24268596b8ed9$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $2ec24268596b8ed9$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $2ec24268596b8ed9$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $2ec24268596b8ed9$var$emptyContextObject;
    parentComponent = $2ec24268596b8ed9$var$emptyContextObject;
    return parentComponent;
}
function $2ec24268596b8ed9$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $2ec24268596b8ed9$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $2ec24268596b8ed9$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $2ec24268596b8ed9$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($2ec24268596b8ed9$var$scheduleUpdateOnFiber(element, rootFiber, lane), $2ec24268596b8ed9$var$entangleTransitions(element, rootFiber, lane));
}
function $2ec24268596b8ed9$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $2ec24268596b8ed9$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $2ec24268596b8ed9$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $2ec24268596b8ed9$var$markRetryLaneImpl(fiber, retryLane);
}
function $2ec24268596b8ed9$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $2ec24268596b8ed9$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $2ec24268596b8ed9$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $2ec24268596b8ed9$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $2ec24268596b8ed9$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $2ec24268596b8ed9$var$requestUpdateLane();
        lane = $2ec24268596b8ed9$var$getBumpedLaneForHydrationByLane(lane);
        var root = $2ec24268596b8ed9$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $2ec24268596b8ed9$var$scheduleUpdateOnFiber(root, fiber, lane);
        $2ec24268596b8ed9$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $2ec24268596b8ed9$var$_enabled = !0;
function $2ec24268596b8ed9$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $2ec24268596b8ed9$var$ReactSharedInternals.T;
    $2ec24268596b8ed9$var$ReactSharedInternals.T = null;
    var previousPriority = $2ec24268596b8ed9$var$ReactDOMSharedInternals.p;
    try {
        $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = 2, $2ec24268596b8ed9$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = previousPriority, $2ec24268596b8ed9$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2ec24268596b8ed9$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $2ec24268596b8ed9$var$ReactSharedInternals.T;
    $2ec24268596b8ed9$var$ReactSharedInternals.T = null;
    var previousPriority = $2ec24268596b8ed9$var$ReactDOMSharedInternals.p;
    try {
        $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = 8, $2ec24268596b8ed9$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $2ec24268596b8ed9$var$ReactDOMSharedInternals.p = previousPriority, $2ec24268596b8ed9$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2ec24268596b8ed9$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($2ec24268596b8ed9$var$_enabled) {
        var blockedOn = $2ec24268596b8ed9$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $2ec24268596b8ed9$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $2ec24268596b8ed9$var$return_targetInst, targetContainer), $2ec24268596b8ed9$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($2ec24268596b8ed9$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($2ec24268596b8ed9$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $2ec24268596b8ed9$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $2ec24268596b8ed9$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $2ec24268596b8ed9$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $2ec24268596b8ed9$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $2ec24268596b8ed9$var$ensureRootIsScheduled(fiber);
                                0 === ($2ec24268596b8ed9$var$executionContext & 6) && ($2ec24268596b8ed9$var$workInProgressRootRenderTargetTime = $2ec24268596b8ed9$var$now() + 500, $2ec24268596b8ed9$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $2ec24268596b8ed9$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $2ec24268596b8ed9$var$scheduleUpdateOnFiber(root, fiber, 2), $2ec24268596b8ed9$var$flushSyncWork$1(), $2ec24268596b8ed9$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $2ec24268596b8ed9$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $2ec24268596b8ed9$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $2ec24268596b8ed9$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $2ec24268596b8ed9$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $2ec24268596b8ed9$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $2ec24268596b8ed9$var$getEventTarget(nativeEvent);
    return $2ec24268596b8ed9$var$findInstanceBlockingTarget(nativeEvent);
}
var $2ec24268596b8ed9$var$return_targetInst = null;
function $2ec24268596b8ed9$var$findInstanceBlockingTarget(targetNode) {
    $2ec24268596b8ed9$var$return_targetInst = null;
    targetNode = $2ec24268596b8ed9$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $2ec24268596b8ed9$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $2ec24268596b8ed9$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $2ec24268596b8ed9$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $2ec24268596b8ed9$var$return_targetInst = targetNode;
    return null;
}
function $2ec24268596b8ed9$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($2ec24268596b8ed9$var$getCurrentPriorityLevel()){
                case $2ec24268596b8ed9$var$ImmediatePriority:
                    return 2;
                case $2ec24268596b8ed9$var$UserBlockingPriority:
                    return 8;
                case $2ec24268596b8ed9$var$NormalPriority$1:
                case $2ec24268596b8ed9$var$LowPriority:
                    return 32;
                case $2ec24268596b8ed9$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $2ec24268596b8ed9$var$hasScheduledReplayAttempt = !1, $2ec24268596b8ed9$var$queuedFocus = null, $2ec24268596b8ed9$var$queuedDrag = null, $2ec24268596b8ed9$var$queuedMouse = null, $2ec24268596b8ed9$var$queuedPointers = new Map(), $2ec24268596b8ed9$var$queuedPointerCaptures = new Map(), $2ec24268596b8ed9$var$queuedExplicitHydrationTargets = [], $2ec24268596b8ed9$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $2ec24268596b8ed9$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $2ec24268596b8ed9$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $2ec24268596b8ed9$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $2ec24268596b8ed9$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $2ec24268596b8ed9$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $2ec24268596b8ed9$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $2ec24268596b8ed9$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $2ec24268596b8ed9$var$getInstanceFromNode(blockedOn), null !== blockedOn && $2ec24268596b8ed9$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $2ec24268596b8ed9$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $2ec24268596b8ed9$var$queuedFocus = $2ec24268596b8ed9$var$accumulateOrCreateContinuousQueuedReplayableEvent($2ec24268596b8ed9$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $2ec24268596b8ed9$var$queuedDrag = $2ec24268596b8ed9$var$accumulateOrCreateContinuousQueuedReplayableEvent($2ec24268596b8ed9$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $2ec24268596b8ed9$var$queuedMouse = $2ec24268596b8ed9$var$accumulateOrCreateContinuousQueuedReplayableEvent($2ec24268596b8ed9$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $2ec24268596b8ed9$var$queuedPointers.set(pointerId, $2ec24268596b8ed9$var$accumulateOrCreateContinuousQueuedReplayableEvent($2ec24268596b8ed9$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $2ec24268596b8ed9$var$queuedPointerCaptures.set(pointerId, $2ec24268596b8ed9$var$accumulateOrCreateContinuousQueuedReplayableEvent($2ec24268596b8ed9$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $2ec24268596b8ed9$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $2ec24268596b8ed9$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $2ec24268596b8ed9$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $2ec24268596b8ed9$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $2ec24268596b8ed9$var$runWithPriority(queuedTarget.priority, function() {
                        $2ec24268596b8ed9$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $2ec24268596b8ed9$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $2ec24268596b8ed9$var$runWithPriority(queuedTarget.priority, function() {
                        $2ec24268596b8ed9$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $2ec24268596b8ed9$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $2ec24268596b8ed9$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $2ec24268596b8ed9$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $2ec24268596b8ed9$var$currentReplayingEvent = null;
        } else return targetContainers = $2ec24268596b8ed9$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $2ec24268596b8ed9$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $2ec24268596b8ed9$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $2ec24268596b8ed9$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $2ec24268596b8ed9$var$replayUnblockedEvents() {
    $2ec24268596b8ed9$var$hasScheduledReplayAttempt = !1;
    null !== $2ec24268596b8ed9$var$queuedFocus && $2ec24268596b8ed9$var$attemptReplayContinuousQueuedEvent($2ec24268596b8ed9$var$queuedFocus) && ($2ec24268596b8ed9$var$queuedFocus = null);
    null !== $2ec24268596b8ed9$var$queuedDrag && $2ec24268596b8ed9$var$attemptReplayContinuousQueuedEvent($2ec24268596b8ed9$var$queuedDrag) && ($2ec24268596b8ed9$var$queuedDrag = null);
    null !== $2ec24268596b8ed9$var$queuedMouse && $2ec24268596b8ed9$var$attemptReplayContinuousQueuedEvent($2ec24268596b8ed9$var$queuedMouse) && ($2ec24268596b8ed9$var$queuedMouse = null);
    $2ec24268596b8ed9$var$queuedPointers.forEach($2ec24268596b8ed9$var$attemptReplayContinuousQueuedEventInMap);
    $2ec24268596b8ed9$var$queuedPointerCaptures.forEach($2ec24268596b8ed9$var$attemptReplayContinuousQueuedEventInMap);
}
function $2ec24268596b8ed9$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $2ec24268596b8ed9$var$hasScheduledReplayAttempt || ($2ec24268596b8ed9$var$hasScheduledReplayAttempt = !0, $dns5Y.unstable_scheduleCallback($dns5Y.unstable_NormalPriority, $2ec24268596b8ed9$var$replayUnblockedEvents)));
}
var $2ec24268596b8ed9$var$lastScheduledReplayQueue = null;
function $2ec24268596b8ed9$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $2ec24268596b8ed9$var$lastScheduledReplayQueue !== formReplayingQueue && ($2ec24268596b8ed9$var$lastScheduledReplayQueue = formReplayingQueue, $dns5Y.unstable_scheduleCallback($dns5Y.unstable_NormalPriority, function() {
        $2ec24268596b8ed9$var$lastScheduledReplayQueue === formReplayingQueue && ($2ec24268596b8ed9$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $2ec24268596b8ed9$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $2ec24268596b8ed9$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $2ec24268596b8ed9$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $2ec24268596b8ed9$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $2ec24268596b8ed9$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $2ec24268596b8ed9$var$queuedFocus && $2ec24268596b8ed9$var$scheduleCallbackIfUnblocked($2ec24268596b8ed9$var$queuedFocus, unblocked);
    null !== $2ec24268596b8ed9$var$queuedDrag && $2ec24268596b8ed9$var$scheduleCallbackIfUnblocked($2ec24268596b8ed9$var$queuedDrag, unblocked);
    null !== $2ec24268596b8ed9$var$queuedMouse && $2ec24268596b8ed9$var$scheduleCallbackIfUnblocked($2ec24268596b8ed9$var$queuedMouse, unblocked);
    $2ec24268596b8ed9$var$queuedPointers.forEach(unblock);
    $2ec24268596b8ed9$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $2ec24268596b8ed9$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $2ec24268596b8ed9$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $2ec24268596b8ed9$var$queuedExplicitHydrationTargets.length && (i = $2ec24268596b8ed9$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$2ec24268596b8ed9$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $2ec24268596b8ed9$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$2ec24268596b8ed9$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $2ec24268596b8ed9$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$2ec24268596b8ed9$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $2ec24268596b8ed9$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $2ec24268596b8ed9$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $2ec24268596b8ed9$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $2ec24268596b8ed9$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$2ec24268596b8ed9$var$ReactDOMHydrationRoot.prototype.render = $2ec24268596b8ed9$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(409));
    var current = root.current, lane = $2ec24268596b8ed9$var$requestUpdateLane();
    $2ec24268596b8ed9$var$updateContainerImpl(current, lane, children, root, null, null);
};
$2ec24268596b8ed9$var$ReactDOMHydrationRoot.prototype.unmount = $2ec24268596b8ed9$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $2ec24268596b8ed9$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $2ec24268596b8ed9$var$flushSyncWork$1();
        container[$2ec24268596b8ed9$var$internalContainerInstanceKey] = null;
    }
};
function $2ec24268596b8ed9$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$2ec24268596b8ed9$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $2ec24268596b8ed9$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $2ec24268596b8ed9$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $2ec24268596b8ed9$var$queuedExplicitHydrationTargets[i].priority; i++);
        $2ec24268596b8ed9$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $2ec24268596b8ed9$var$attemptExplicitHydrationTarget(target);
    }
};
var $2ec24268596b8ed9$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $1kowh.version;
if ("19.2.1" !== $2ec24268596b8ed9$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(527, $2ec24268596b8ed9$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.1"));
$2ec24268596b8ed9$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $2ec24268596b8ed9$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $2ec24268596b8ed9$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $2ec24268596b8ed9$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $2ec24268596b8ed9$var$ReactSharedInternals,
    reconcilerVersion: "19.2.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $2ec24268596b8ed9$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$2ec24268596b8ed9$var$hook$jscomp$inline_2348.isDisabled && $2ec24268596b8ed9$var$hook$jscomp$inline_2348.supportsFiber) try {
        $2ec24268596b8ed9$var$rendererID = $2ec24268596b8ed9$var$hook$jscomp$inline_2348.inject($2ec24268596b8ed9$var$internals$jscomp$inline_2347), $2ec24268596b8ed9$var$injectedHook = $2ec24268596b8ed9$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$2ec24268596b8ed9$export$882461b6382ed46c = function(container, options) {
    if (!$2ec24268596b8ed9$var$isValidContainer(container)) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $2ec24268596b8ed9$var$defaultOnUncaughtError, onCaughtError = $2ec24268596b8ed9$var$defaultOnCaughtError, onRecoverableError = $2ec24268596b8ed9$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $2ec24268596b8ed9$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $2ec24268596b8ed9$var$defaultOnDefaultTransitionIndicator);
    container[$2ec24268596b8ed9$var$internalContainerInstanceKey] = options.current;
    $2ec24268596b8ed9$var$listenToAllSupportedEvents(container);
    return new $2ec24268596b8ed9$var$ReactDOMRoot(options);
};
$2ec24268596b8ed9$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$2ec24268596b8ed9$var$isValidContainer(container)) throw Error($2ec24268596b8ed9$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $2ec24268596b8ed9$var$defaultOnUncaughtError, onCaughtError = $2ec24268596b8ed9$var$defaultOnCaughtError, onRecoverableError = $2ec24268596b8ed9$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $2ec24268596b8ed9$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $2ec24268596b8ed9$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $2ec24268596b8ed9$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $2ec24268596b8ed9$var$requestUpdateLane();
    isStrictMode = $2ec24268596b8ed9$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $2ec24268596b8ed9$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $2ec24268596b8ed9$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $2ec24268596b8ed9$var$markRootUpdated$1(initialChildren, options);
    $2ec24268596b8ed9$var$ensureRootIsScheduled(initialChildren);
    container[$2ec24268596b8ed9$var$internalContainerInstanceKey] = initialChildren.current;
    $2ec24268596b8ed9$var$listenToAllSupportedEvents(container);
    return new $2ec24268596b8ed9$var$ReactDOMHydrationRoot(initialChildren);
};
$2ec24268596b8ed9$export$83d89fbfd8236492 = "19.2.1";

});
parcelRegister("jCqV7", function(module, exports) {
// shim for using process in browser
var $e48672b8da5d738b$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $e48672b8da5d738b$var$cachedSetTimeout;
var $e48672b8da5d738b$var$cachedClearTimeout;
function $e48672b8da5d738b$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $e48672b8da5d738b$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $e48672b8da5d738b$var$cachedSetTimeout = setTimeout;
        else $e48672b8da5d738b$var$cachedSetTimeout = $e48672b8da5d738b$var$defaultSetTimout;
    } catch (e) {
        $e48672b8da5d738b$var$cachedSetTimeout = $e48672b8da5d738b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $e48672b8da5d738b$var$cachedClearTimeout = clearTimeout;
        else $e48672b8da5d738b$var$cachedClearTimeout = $e48672b8da5d738b$var$defaultClearTimeout;
    } catch (e) {
        $e48672b8da5d738b$var$cachedClearTimeout = $e48672b8da5d738b$var$defaultClearTimeout;
    }
})();
function $e48672b8da5d738b$var$runTimeout(fun) {
    if ($e48672b8da5d738b$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($e48672b8da5d738b$var$cachedSetTimeout === $e48672b8da5d738b$var$defaultSetTimout || !$e48672b8da5d738b$var$cachedSetTimeout) && setTimeout) {
        $e48672b8da5d738b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e48672b8da5d738b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $e48672b8da5d738b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $e48672b8da5d738b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $e48672b8da5d738b$var$runClearTimeout(marker) {
    if ($e48672b8da5d738b$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($e48672b8da5d738b$var$cachedClearTimeout === $e48672b8da5d738b$var$defaultClearTimeout || !$e48672b8da5d738b$var$cachedClearTimeout) && clearTimeout) {
        $e48672b8da5d738b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e48672b8da5d738b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $e48672b8da5d738b$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $e48672b8da5d738b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $e48672b8da5d738b$var$queue = [];
var $e48672b8da5d738b$var$draining = false;
var $e48672b8da5d738b$var$currentQueue;
var $e48672b8da5d738b$var$queueIndex = -1;
function $e48672b8da5d738b$var$cleanUpNextTick() {
    if (!$e48672b8da5d738b$var$draining || !$e48672b8da5d738b$var$currentQueue) return;
    $e48672b8da5d738b$var$draining = false;
    if ($e48672b8da5d738b$var$currentQueue.length) $e48672b8da5d738b$var$queue = $e48672b8da5d738b$var$currentQueue.concat($e48672b8da5d738b$var$queue);
    else $e48672b8da5d738b$var$queueIndex = -1;
    if ($e48672b8da5d738b$var$queue.length) $e48672b8da5d738b$var$drainQueue();
}
function $e48672b8da5d738b$var$drainQueue() {
    if ($e48672b8da5d738b$var$draining) return;
    var timeout = $e48672b8da5d738b$var$runTimeout($e48672b8da5d738b$var$cleanUpNextTick);
    $e48672b8da5d738b$var$draining = true;
    var len = $e48672b8da5d738b$var$queue.length;
    while(len){
        $e48672b8da5d738b$var$currentQueue = $e48672b8da5d738b$var$queue;
        $e48672b8da5d738b$var$queue = [];
        while(++$e48672b8da5d738b$var$queueIndex < len)if ($e48672b8da5d738b$var$currentQueue) $e48672b8da5d738b$var$currentQueue[$e48672b8da5d738b$var$queueIndex].run();
        $e48672b8da5d738b$var$queueIndex = -1;
        len = $e48672b8da5d738b$var$queue.length;
    }
    $e48672b8da5d738b$var$currentQueue = null;
    $e48672b8da5d738b$var$draining = false;
    $e48672b8da5d738b$var$runClearTimeout(timeout);
}
$e48672b8da5d738b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $e48672b8da5d738b$var$queue.push(new $e48672b8da5d738b$var$Item(fun, args));
    if ($e48672b8da5d738b$var$queue.length === 1 && !$e48672b8da5d738b$var$draining) $e48672b8da5d738b$var$runTimeout($e48672b8da5d738b$var$drainQueue);
};
// v8 likes predictible objects
function $e48672b8da5d738b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$e48672b8da5d738b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$e48672b8da5d738b$var$process.title = "browser";
$e48672b8da5d738b$var$process.browser = true;
$e48672b8da5d738b$var$process.env = {};
$e48672b8da5d738b$var$process.argv = [];
$e48672b8da5d738b$var$process.version = ""; // empty string to avoid regexp issues
$e48672b8da5d738b$var$process.versions = {};
function $e48672b8da5d738b$var$noop() {}
$e48672b8da5d738b$var$process.on = $e48672b8da5d738b$var$noop;
$e48672b8da5d738b$var$process.addListener = $e48672b8da5d738b$var$noop;
$e48672b8da5d738b$var$process.once = $e48672b8da5d738b$var$noop;
$e48672b8da5d738b$var$process.off = $e48672b8da5d738b$var$noop;
$e48672b8da5d738b$var$process.removeListener = $e48672b8da5d738b$var$noop;
$e48672b8da5d738b$var$process.removeAllListeners = $e48672b8da5d738b$var$noop;
$e48672b8da5d738b$var$process.emit = $e48672b8da5d738b$var$noop;
$e48672b8da5d738b$var$process.prependListener = $e48672b8da5d738b$var$noop;
$e48672b8da5d738b$var$process.prependOnceListener = $e48672b8da5d738b$var$noop;
$e48672b8da5d738b$var$process.listeners = function(name) {
    return [];
};
$e48672b8da5d738b$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$e48672b8da5d738b$var$process.cwd = function() {
    return "/";
};
$e48672b8da5d738b$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$e48672b8da5d738b$var$process.umask = function() {
    return 0;
};

});

parcelRegister("dns5Y", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5LAXv"));

});
parcelRegister("5LAXv", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $432e02c641bc17ad$export$c4744153514ff05d; }, function (v) { return $432e02c641bc17ad$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $432e02c641bc17ad$export$3e506c1ccc9cc1a7; }, function (v) { return $432e02c641bc17ad$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $432e02c641bc17ad$export$e26fe2ed2fa76875; }, function (v) { return $432e02c641bc17ad$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $432e02c641bc17ad$export$502329bbf4b505b1; }, function (v) { return $432e02c641bc17ad$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $432e02c641bc17ad$export$6e3807111c4874c4; }, function (v) { return $432e02c641bc17ad$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $432e02c641bc17ad$export$c27134553091fb3a; }, function (v) { return $432e02c641bc17ad$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $432e02c641bc17ad$export$33ee1acdc04fd2a2; }, function (v) { return $432e02c641bc17ad$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $432e02c641bc17ad$export$b00a404bbd5edef2; }, function (v) { return $432e02c641bc17ad$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $432e02c641bc17ad$export$d66a1c1c77bd778b; }, function (v) { return $432e02c641bc17ad$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $432e02c641bc17ad$export$d3dfb8e4810cb555; }, function (v) { return $432e02c641bc17ad$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $432e02c641bc17ad$export$72fdf0e06517287b; }, function (v) { return $432e02c641bc17ad$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $432e02c641bc17ad$export$816d2913ae6b83b1; }, function (v) { return $432e02c641bc17ad$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $432e02c641bc17ad$export$61bcfe829111a1d0; }, function (v) { return $432e02c641bc17ad$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $432e02c641bc17ad$export$7ee8c9beb337bc3f; }, function (v) { return $432e02c641bc17ad$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $432e02c641bc17ad$export$b5836b71941fa3ed; }, function (v) { return $432e02c641bc17ad$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $432e02c641bc17ad$export$cf845f2c119da08a; }, function (v) { return $432e02c641bc17ad$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $432e02c641bc17ad$export$c4744153514ff05d;
var $432e02c641bc17ad$export$3e506c1ccc9cc1a7;
var $432e02c641bc17ad$export$e26fe2ed2fa76875;
var $432e02c641bc17ad$export$502329bbf4b505b1;
var $432e02c641bc17ad$export$6e3807111c4874c4;
var $432e02c641bc17ad$export$c27134553091fb3a;
var $432e02c641bc17ad$export$33ee1acdc04fd2a2;
var $432e02c641bc17ad$export$b00a404bbd5edef2;
var $432e02c641bc17ad$export$d66a1c1c77bd778b;
var $432e02c641bc17ad$export$d3dfb8e4810cb555;
var $432e02c641bc17ad$export$72fdf0e06517287b;
var $432e02c641bc17ad$export$816d2913ae6b83b1;
var $432e02c641bc17ad$export$61bcfe829111a1d0;
var $432e02c641bc17ad$export$7ee8c9beb337bc3f;
var $432e02c641bc17ad$export$b5836b71941fa3ed;
var $432e02c641bc17ad$export$cf845f2c119da08a;
"use strict";
function $432e02c641bc17ad$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $432e02c641bc17ad$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $432e02c641bc17ad$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $432e02c641bc17ad$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $432e02c641bc17ad$var$compare(left, last)) rightIndex < length && 0 > $432e02c641bc17ad$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $432e02c641bc17ad$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $432e02c641bc17ad$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$432e02c641bc17ad$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $432e02c641bc17ad$var$localPerformance = performance;
    $432e02c641bc17ad$export$c4744153514ff05d = function() {
        return $432e02c641bc17ad$var$localPerformance.now();
    };
} else {
    var $432e02c641bc17ad$var$localDate = Date, $432e02c641bc17ad$var$initialTime = $432e02c641bc17ad$var$localDate.now();
    $432e02c641bc17ad$export$c4744153514ff05d = function() {
        return $432e02c641bc17ad$var$localDate.now() - $432e02c641bc17ad$var$initialTime;
    };
}
var $432e02c641bc17ad$var$taskQueue = [], $432e02c641bc17ad$var$timerQueue = [], $432e02c641bc17ad$var$taskIdCounter = 1, $432e02c641bc17ad$var$currentTask = null, $432e02c641bc17ad$var$currentPriorityLevel = 3, $432e02c641bc17ad$var$isPerformingWork = !1, $432e02c641bc17ad$var$isHostCallbackScheduled = !1, $432e02c641bc17ad$var$isHostTimeoutScheduled = !1, $432e02c641bc17ad$var$needsPaint = !1, $432e02c641bc17ad$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $432e02c641bc17ad$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $432e02c641bc17ad$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $432e02c641bc17ad$var$advanceTimers(currentTime) {
    for(var timer = $432e02c641bc17ad$var$peek($432e02c641bc17ad$var$timerQueue); null !== timer;){
        if (null === timer.callback) $432e02c641bc17ad$var$pop($432e02c641bc17ad$var$timerQueue);
        else if (timer.startTime <= currentTime) $432e02c641bc17ad$var$pop($432e02c641bc17ad$var$timerQueue), timer.sortIndex = timer.expirationTime, $432e02c641bc17ad$var$push($432e02c641bc17ad$var$taskQueue, timer);
        else break;
        timer = $432e02c641bc17ad$var$peek($432e02c641bc17ad$var$timerQueue);
    }
}
function $432e02c641bc17ad$var$handleTimeout(currentTime) {
    $432e02c641bc17ad$var$isHostTimeoutScheduled = !1;
    $432e02c641bc17ad$var$advanceTimers(currentTime);
    if (!$432e02c641bc17ad$var$isHostCallbackScheduled) {
        if (null !== $432e02c641bc17ad$var$peek($432e02c641bc17ad$var$taskQueue)) $432e02c641bc17ad$var$isHostCallbackScheduled = !0, $432e02c641bc17ad$var$isMessageLoopRunning || ($432e02c641bc17ad$var$isMessageLoopRunning = !0, $432e02c641bc17ad$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $432e02c641bc17ad$var$peek($432e02c641bc17ad$var$timerQueue);
            null !== firstTimer && $432e02c641bc17ad$var$requestHostTimeout($432e02c641bc17ad$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $432e02c641bc17ad$var$isMessageLoopRunning = !1, $432e02c641bc17ad$var$taskTimeoutID = -1, $432e02c641bc17ad$var$frameInterval = 5, $432e02c641bc17ad$var$startTime = -1;
function $432e02c641bc17ad$var$shouldYieldToHost() {
    return $432e02c641bc17ad$var$needsPaint ? !0 : $432e02c641bc17ad$export$c4744153514ff05d() - $432e02c641bc17ad$var$startTime < $432e02c641bc17ad$var$frameInterval ? !1 : !0;
}
function $432e02c641bc17ad$var$performWorkUntilDeadline() {
    $432e02c641bc17ad$var$needsPaint = !1;
    if ($432e02c641bc17ad$var$isMessageLoopRunning) {
        var currentTime = $432e02c641bc17ad$export$c4744153514ff05d();
        $432e02c641bc17ad$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $432e02c641bc17ad$var$isHostCallbackScheduled = !1;
                $432e02c641bc17ad$var$isHostTimeoutScheduled && ($432e02c641bc17ad$var$isHostTimeoutScheduled = !1, $432e02c641bc17ad$var$localClearTimeout($432e02c641bc17ad$var$taskTimeoutID), $432e02c641bc17ad$var$taskTimeoutID = -1);
                $432e02c641bc17ad$var$isPerformingWork = !0;
                var previousPriorityLevel = $432e02c641bc17ad$var$currentPriorityLevel;
                try {
                    b: {
                        $432e02c641bc17ad$var$advanceTimers(currentTime);
                        for($432e02c641bc17ad$var$currentTask = $432e02c641bc17ad$var$peek($432e02c641bc17ad$var$taskQueue); null !== $432e02c641bc17ad$var$currentTask && !($432e02c641bc17ad$var$currentTask.expirationTime > currentTime && $432e02c641bc17ad$var$shouldYieldToHost());){
                            var callback = $432e02c641bc17ad$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $432e02c641bc17ad$var$currentTask.callback = null;
                                $432e02c641bc17ad$var$currentPriorityLevel = $432e02c641bc17ad$var$currentTask.priorityLevel;
                                var continuationCallback = callback($432e02c641bc17ad$var$currentTask.expirationTime <= currentTime);
                                currentTime = $432e02c641bc17ad$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $432e02c641bc17ad$var$currentTask.callback = continuationCallback;
                                    $432e02c641bc17ad$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $432e02c641bc17ad$var$currentTask === $432e02c641bc17ad$var$peek($432e02c641bc17ad$var$taskQueue) && $432e02c641bc17ad$var$pop($432e02c641bc17ad$var$taskQueue);
                                $432e02c641bc17ad$var$advanceTimers(currentTime);
                            } else $432e02c641bc17ad$var$pop($432e02c641bc17ad$var$taskQueue);
                            $432e02c641bc17ad$var$currentTask = $432e02c641bc17ad$var$peek($432e02c641bc17ad$var$taskQueue);
                        }
                        if (null !== $432e02c641bc17ad$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $432e02c641bc17ad$var$peek($432e02c641bc17ad$var$timerQueue);
                            null !== firstTimer && $432e02c641bc17ad$var$requestHostTimeout($432e02c641bc17ad$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $432e02c641bc17ad$var$currentTask = null, $432e02c641bc17ad$var$currentPriorityLevel = previousPriorityLevel, $432e02c641bc17ad$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $432e02c641bc17ad$var$schedulePerformWorkUntilDeadline() : $432e02c641bc17ad$var$isMessageLoopRunning = !1;
        }
    }
}
var $432e02c641bc17ad$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $432e02c641bc17ad$var$localSetImmediate) $432e02c641bc17ad$var$schedulePerformWorkUntilDeadline = function() {
    $432e02c641bc17ad$var$localSetImmediate($432e02c641bc17ad$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $432e02c641bc17ad$var$channel = new MessageChannel(), $432e02c641bc17ad$var$port = $432e02c641bc17ad$var$channel.port2;
    $432e02c641bc17ad$var$channel.port1.onmessage = $432e02c641bc17ad$var$performWorkUntilDeadline;
    $432e02c641bc17ad$var$schedulePerformWorkUntilDeadline = function() {
        $432e02c641bc17ad$var$port.postMessage(null);
    };
} else $432e02c641bc17ad$var$schedulePerformWorkUntilDeadline = function() {
    $432e02c641bc17ad$var$localSetTimeout($432e02c641bc17ad$var$performWorkUntilDeadline, 0);
};
function $432e02c641bc17ad$var$requestHostTimeout(callback, ms) {
    $432e02c641bc17ad$var$taskTimeoutID = $432e02c641bc17ad$var$localSetTimeout(function() {
        callback($432e02c641bc17ad$export$c4744153514ff05d());
    }, ms);
}
$432e02c641bc17ad$export$3e506c1ccc9cc1a7 = 5;
$432e02c641bc17ad$export$e26fe2ed2fa76875 = 1;
$432e02c641bc17ad$export$502329bbf4b505b1 = 4;
$432e02c641bc17ad$export$6e3807111c4874c4 = 3;
$432e02c641bc17ad$export$c27134553091fb3a = null;
$432e02c641bc17ad$export$33ee1acdc04fd2a2 = 2;
$432e02c641bc17ad$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$432e02c641bc17ad$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $432e02c641bc17ad$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$432e02c641bc17ad$export$d3dfb8e4810cb555 = function() {
    return $432e02c641bc17ad$var$currentPriorityLevel;
};
$432e02c641bc17ad$export$72fdf0e06517287b = function(eventHandler) {
    switch($432e02c641bc17ad$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $432e02c641bc17ad$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $432e02c641bc17ad$var$currentPriorityLevel;
    $432e02c641bc17ad$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $432e02c641bc17ad$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$432e02c641bc17ad$export$816d2913ae6b83b1 = function() {
    $432e02c641bc17ad$var$needsPaint = !0;
};
$432e02c641bc17ad$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $432e02c641bc17ad$var$currentPriorityLevel;
    $432e02c641bc17ad$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $432e02c641bc17ad$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$432e02c641bc17ad$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $432e02c641bc17ad$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $432e02c641bc17ad$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $432e02c641bc17ad$var$push($432e02c641bc17ad$var$timerQueue, priorityLevel), null === $432e02c641bc17ad$var$peek($432e02c641bc17ad$var$taskQueue) && priorityLevel === $432e02c641bc17ad$var$peek($432e02c641bc17ad$var$timerQueue) && ($432e02c641bc17ad$var$isHostTimeoutScheduled ? ($432e02c641bc17ad$var$localClearTimeout($432e02c641bc17ad$var$taskTimeoutID), $432e02c641bc17ad$var$taskTimeoutID = -1) : $432e02c641bc17ad$var$isHostTimeoutScheduled = !0, $432e02c641bc17ad$var$requestHostTimeout($432e02c641bc17ad$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $432e02c641bc17ad$var$push($432e02c641bc17ad$var$taskQueue, priorityLevel), $432e02c641bc17ad$var$isHostCallbackScheduled || $432e02c641bc17ad$var$isPerformingWork || ($432e02c641bc17ad$var$isHostCallbackScheduled = !0, $432e02c641bc17ad$var$isMessageLoopRunning || ($432e02c641bc17ad$var$isMessageLoopRunning = !0, $432e02c641bc17ad$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$432e02c641bc17ad$export$b5836b71941fa3ed = $432e02c641bc17ad$var$shouldYieldToHost;
$432e02c641bc17ad$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $432e02c641bc17ad$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $432e02c641bc17ad$var$currentPriorityLevel;
        $432e02c641bc17ad$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $432e02c641bc17ad$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1kowh", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ekaK6"));

});
parcelRegister("ekaK6", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $a6db442d924eb391$export$9c16c1426311996d; }, function (v) { return $a6db442d924eb391$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $a6db442d924eb391$export$dca3b0875bd9a954; }, function (v) { return $a6db442d924eb391$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $a6db442d924eb391$export$16fa2f45be04daa8; }, function (v) { return $a6db442d924eb391$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a6db442d924eb391$export$ffb0004e005737fa; }, function (v) { return $a6db442d924eb391$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $a6db442d924eb391$export$e2c29f18771995cb; }, function (v) { return $a6db442d924eb391$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $a6db442d924eb391$export$221d75b3f55bb0bd; }, function (v) { return $a6db442d924eb391$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a6db442d924eb391$export$5f8d39834fd61797; }, function (v) { return $a6db442d924eb391$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a6db442d924eb391$export$74bf444e3cd11ea5; }, function (v) { return $a6db442d924eb391$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $a6db442d924eb391$export$1ced07cd6b1985ce; }, function (v) { return $a6db442d924eb391$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $a6db442d924eb391$export$abd8e32b826d7ea7; }, function (v) { return $a6db442d924eb391$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $a6db442d924eb391$export$69a3209f1a06c04d; }, function (v) { return $a6db442d924eb391$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $a6db442d924eb391$export$8c538325882c7eec; }, function (v) { return $a6db442d924eb391$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $a6db442d924eb391$export$e530037191fcd5d7; }, function (v) { return $a6db442d924eb391$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $a6db442d924eb391$export$fd42f52fd3ae1109; }, function (v) { return $a6db442d924eb391$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $a6db442d924eb391$export$c8a8987d4410bf2d; }, function (v) { return $a6db442d924eb391$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $a6db442d924eb391$export$7d1e3a5e95ceca43; }, function (v) { return $a6db442d924eb391$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $a6db442d924eb391$export$257a8862b851cb5b; }, function (v) { return $a6db442d924eb391$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $a6db442d924eb391$export$a8257692ac88316c; }, function (v) { return $a6db442d924eb391$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $a6db442d924eb391$export$488013bae63b21da; }, function (v) { return $a6db442d924eb391$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $a6db442d924eb391$export$7c73462e0d25e514; }, function (v) { return $a6db442d924eb391$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $a6db442d924eb391$export$7568632d0d33d16d; }, function (v) { return $a6db442d924eb391$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $a6db442d924eb391$export$f93f40ac0ca7e3a8; }, function (v) { return $a6db442d924eb391$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $a6db442d924eb391$export$1f96ae73734a86cc; }, function (v) { return $a6db442d924eb391$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $a6db442d924eb391$export$9a47ced3238df325; }, function (v) { return $a6db442d924eb391$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $a6db442d924eb391$export$35808ee640e87ca7; }, function (v) { return $a6db442d924eb391$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $a6db442d924eb391$export$fae74005e78b1a27; }, function (v) { return $a6db442d924eb391$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $a6db442d924eb391$export$dc8fbce3eb94dc1e; }, function (v) { return $a6db442d924eb391$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $a6db442d924eb391$export$6a7bc4e911dc01cf; }, function (v) { return $a6db442d924eb391$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $a6db442d924eb391$export$6d9c69b0de29b591; }, function (v) { return $a6db442d924eb391$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $a6db442d924eb391$export$7f54fc3180508a52; }, function (v) { return $a6db442d924eb391$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $a6db442d924eb391$export$f680877a34711e37; }, function (v) { return $a6db442d924eb391$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $a6db442d924eb391$export$d5a552a76deda3c2; }, function (v) { return $a6db442d924eb391$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $a6db442d924eb391$export$aaabe4eda9ed9969; }, function (v) { return $a6db442d924eb391$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $a6db442d924eb391$export$e5c5a5f917a5871c; }, function (v) { return $a6db442d924eb391$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $a6db442d924eb391$export$1538c33de8887b59; }, function (v) { return $a6db442d924eb391$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $a6db442d924eb391$export$fca7f784ae7a249a; }, function (v) { return $a6db442d924eb391$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $a6db442d924eb391$export$13e3392192263954; }, function (v) { return $a6db442d924eb391$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $a6db442d924eb391$export$b8f5890fc79d6aca; }, function (v) { return $a6db442d924eb391$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $a6db442d924eb391$export$60241385465d0a34; }, function (v) { return $a6db442d924eb391$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $a6db442d924eb391$export$306c0aa65ff9ec16; }, function (v) { return $a6db442d924eb391$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $a6db442d924eb391$export$7b286972b8d8ccbf; }, function (v) { return $a6db442d924eb391$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $a6db442d924eb391$export$83d89fbfd8236492; }, function (v) { return $a6db442d924eb391$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a6db442d924eb391$export$9c16c1426311996d;
var $a6db442d924eb391$export$dca3b0875bd9a954;
var $a6db442d924eb391$export$16fa2f45be04daa8;
var $a6db442d924eb391$export$ffb0004e005737fa;
var $a6db442d924eb391$export$e2c29f18771995cb;
var $a6db442d924eb391$export$221d75b3f55bb0bd;
var $a6db442d924eb391$export$5f8d39834fd61797;
var $a6db442d924eb391$export$74bf444e3cd11ea5;
var $a6db442d924eb391$export$1ced07cd6b1985ce;
var $a6db442d924eb391$export$abd8e32b826d7ea7;
var $a6db442d924eb391$export$69a3209f1a06c04d;
var $a6db442d924eb391$export$8c538325882c7eec;
var $a6db442d924eb391$export$e530037191fcd5d7;
var $a6db442d924eb391$export$fd42f52fd3ae1109;
var $a6db442d924eb391$export$c8a8987d4410bf2d;
var $a6db442d924eb391$export$7d1e3a5e95ceca43;
var $a6db442d924eb391$export$257a8862b851cb5b;
var $a6db442d924eb391$export$a8257692ac88316c;
var $a6db442d924eb391$export$488013bae63b21da;
var $a6db442d924eb391$export$7c73462e0d25e514;
var $a6db442d924eb391$export$7568632d0d33d16d;
var $a6db442d924eb391$export$f93f40ac0ca7e3a8;
var $a6db442d924eb391$export$1f96ae73734a86cc;
var $a6db442d924eb391$export$9a47ced3238df325;
var $a6db442d924eb391$export$35808ee640e87ca7;
var $a6db442d924eb391$export$fae74005e78b1a27;
var $a6db442d924eb391$export$dc8fbce3eb94dc1e;
var $a6db442d924eb391$export$6a7bc4e911dc01cf;
var $a6db442d924eb391$export$6d9c69b0de29b591;
var $a6db442d924eb391$export$7f54fc3180508a52;
var $a6db442d924eb391$export$f680877a34711e37;
var $a6db442d924eb391$export$d5a552a76deda3c2;
var $a6db442d924eb391$export$aaabe4eda9ed9969;
var $a6db442d924eb391$export$e5c5a5f917a5871c;
var $a6db442d924eb391$export$1538c33de8887b59;
var $a6db442d924eb391$export$fca7f784ae7a249a;
var $a6db442d924eb391$export$13e3392192263954;
var $a6db442d924eb391$export$b8f5890fc79d6aca;
var $a6db442d924eb391$export$60241385465d0a34;
var $a6db442d924eb391$export$306c0aa65ff9ec16;
var $a6db442d924eb391$export$7b286972b8d8ccbf;
var $a6db442d924eb391$export$83d89fbfd8236492;

var $jCqV7 = parcelRequire("jCqV7");
"use strict";
var $a6db442d924eb391$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a6db442d924eb391$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $a6db442d924eb391$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $a6db442d924eb391$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $a6db442d924eb391$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $a6db442d924eb391$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $a6db442d924eb391$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $a6db442d924eb391$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $a6db442d924eb391$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $a6db442d924eb391$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $a6db442d924eb391$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $a6db442d924eb391$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $a6db442d924eb391$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $a6db442d924eb391$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $a6db442d924eb391$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$a6db442d924eb391$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $a6db442d924eb391$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $a6db442d924eb391$var$assign = Object.assign, $a6db442d924eb391$var$emptyObject = {};
function $a6db442d924eb391$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $a6db442d924eb391$var$emptyObject;
    this.updater = updater || $a6db442d924eb391$var$ReactNoopUpdateQueue;
}
$a6db442d924eb391$var$Component.prototype.isReactComponent = {};
$a6db442d924eb391$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$a6db442d924eb391$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $a6db442d924eb391$var$ComponentDummy() {}
$a6db442d924eb391$var$ComponentDummy.prototype = $a6db442d924eb391$var$Component.prototype;
function $a6db442d924eb391$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $a6db442d924eb391$var$emptyObject;
    this.updater = updater || $a6db442d924eb391$var$ReactNoopUpdateQueue;
}
var $a6db442d924eb391$var$pureComponentPrototype = $a6db442d924eb391$var$PureComponent.prototype = new $a6db442d924eb391$var$ComponentDummy();
$a6db442d924eb391$var$pureComponentPrototype.constructor = $a6db442d924eb391$var$PureComponent;
$a6db442d924eb391$var$assign($a6db442d924eb391$var$pureComponentPrototype, $a6db442d924eb391$var$Component.prototype);
$a6db442d924eb391$var$pureComponentPrototype.isPureReactComponent = !0;
var $a6db442d924eb391$var$isArrayImpl = Array.isArray;
function $a6db442d924eb391$var$noop() {}
var $a6db442d924eb391$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $a6db442d924eb391$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $a6db442d924eb391$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $a6db442d924eb391$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $a6db442d924eb391$var$cloneAndReplaceKey(oldElement, newKey) {
    return $a6db442d924eb391$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $a6db442d924eb391$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $a6db442d924eb391$var$REACT_ELEMENT_TYPE;
}
function $a6db442d924eb391$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $a6db442d924eb391$var$userProvidedKeyEscapeRegex = /\/+/g;
function $a6db442d924eb391$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $a6db442d924eb391$var$escape("" + element.key) : index.toString(36);
}
function $a6db442d924eb391$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($a6db442d924eb391$var$noop, $a6db442d924eb391$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $a6db442d924eb391$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $a6db442d924eb391$var$REACT_ELEMENT_TYPE:
                case $a6db442d924eb391$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $a6db442d924eb391$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $a6db442d924eb391$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $a6db442d924eb391$var$getElementKey(children, 0) : nameSoFar, $a6db442d924eb391$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($a6db442d924eb391$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $a6db442d924eb391$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($a6db442d924eb391$var$isValidElement(callback) && (callback = $a6db442d924eb391$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($a6db442d924eb391$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($a6db442d924eb391$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $a6db442d924eb391$var$getElementKey(nameSoFar, i), invokeCallback += $a6db442d924eb391$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $a6db442d924eb391$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $a6db442d924eb391$var$getElementKey(nameSoFar, i++), invokeCallback += $a6db442d924eb391$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $a6db442d924eb391$var$mapIntoArray($a6db442d924eb391$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $a6db442d924eb391$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $a6db442d924eb391$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $a6db442d924eb391$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $a6db442d924eb391$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $jCqV7 && "function" === typeof $jCqV7.emit) {
        $jCqV7.emit("uncaughtException", error);
        return;
    }
    console.error(error);
}, $a6db442d924eb391$var$Children = {
    map: $a6db442d924eb391$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $a6db442d924eb391$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $a6db442d924eb391$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $a6db442d924eb391$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$a6db442d924eb391$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$a6db442d924eb391$export$9c16c1426311996d = $a6db442d924eb391$var$REACT_ACTIVITY_TYPE;
$a6db442d924eb391$export$dca3b0875bd9a954 = $a6db442d924eb391$var$Children;
$a6db442d924eb391$export$16fa2f45be04daa8 = $a6db442d924eb391$var$Component;
$a6db442d924eb391$export$ffb0004e005737fa = $a6db442d924eb391$var$REACT_FRAGMENT_TYPE;
$a6db442d924eb391$export$e2c29f18771995cb = $a6db442d924eb391$var$REACT_PROFILER_TYPE;
$a6db442d924eb391$export$221d75b3f55bb0bd = $a6db442d924eb391$var$PureComponent;
$a6db442d924eb391$export$5f8d39834fd61797 = $a6db442d924eb391$var$REACT_STRICT_MODE_TYPE;
$a6db442d924eb391$export$74bf444e3cd11ea5 = $a6db442d924eb391$var$REACT_SUSPENSE_TYPE;
$a6db442d924eb391$export$1ced07cd6b1985ce = $a6db442d924eb391$var$ReactSharedInternals;
$a6db442d924eb391$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $a6db442d924eb391$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$a6db442d924eb391$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$a6db442d924eb391$export$8c538325882c7eec = function() {
    return null;
};
$a6db442d924eb391$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $a6db442d924eb391$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$a6db442d924eb391$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $a6db442d924eb391$var$ReactElement(element.type, key, props);
};
$a6db442d924eb391$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $a6db442d924eb391$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $a6db442d924eb391$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$a6db442d924eb391$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$a6db442d924eb391$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $a6db442d924eb391$var$ReactElement(type, key, props);
};
$a6db442d924eb391$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$a6db442d924eb391$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $a6db442d924eb391$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$a6db442d924eb391$export$a8257692ac88316c = $a6db442d924eb391$var$isValidElement;
$a6db442d924eb391$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $a6db442d924eb391$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $a6db442d924eb391$var$lazyInitializer
    };
};
$a6db442d924eb391$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $a6db442d924eb391$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$a6db442d924eb391$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $a6db442d924eb391$var$ReactSharedInternals.T, currentTransition = {};
    $a6db442d924eb391$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $a6db442d924eb391$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($a6db442d924eb391$var$noop, $a6db442d924eb391$var$reportGlobalError);
    } catch (error) {
        $a6db442d924eb391$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $a6db442d924eb391$var$ReactSharedInternals.T = prevTransition;
    }
};
$a6db442d924eb391$export$f93f40ac0ca7e3a8 = function() {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useCacheRefresh();
};
$a6db442d924eb391$export$1f96ae73734a86cc = function(usable) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.use(usable);
};
$a6db442d924eb391$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$a6db442d924eb391$export$35808ee640e87ca7 = function(callback, deps) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$a6db442d924eb391$export$fae74005e78b1a27 = function(Context) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useContext(Context);
};
$a6db442d924eb391$export$dc8fbce3eb94dc1e = function() {};
$a6db442d924eb391$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$a6db442d924eb391$export$6d9c69b0de29b591 = function(create, deps) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useEffect(create, deps);
};
$a6db442d924eb391$export$7f54fc3180508a52 = function(callback) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$a6db442d924eb391$export$f680877a34711e37 = function() {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useId();
};
$a6db442d924eb391$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$a6db442d924eb391$export$aaabe4eda9ed9969 = function(create, deps) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$a6db442d924eb391$export$e5c5a5f917a5871c = function(create, deps) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$a6db442d924eb391$export$1538c33de8887b59 = function(create, deps) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useMemo(create, deps);
};
$a6db442d924eb391$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$a6db442d924eb391$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$a6db442d924eb391$export$b8f5890fc79d6aca = function(initialValue) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useRef(initialValue);
};
$a6db442d924eb391$export$60241385465d0a34 = function(initialState) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useState(initialState);
};
$a6db442d924eb391$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$a6db442d924eb391$export$7b286972b8d8ccbf = function() {
    return $a6db442d924eb391$var$ReactSharedInternals.H.useTransition();
};
$a6db442d924eb391$export$83d89fbfd8236492 = "19.2.1";

});


parcelRegister("2exNI", function(module, exports) {
"use strict";
function $1a071bbcc6e2f2cb$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1a071bbcc6e2f2cb$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1a071bbcc6e2f2cb$var$checkDCE();

module.exports = (parcelRequire("4Apto"));

});
parcelRegister("4Apto", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $356e48a4e68f094a$export$69ce8ef3fe5cead0; }, function (v) { return $356e48a4e68f094a$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $356e48a4e68f094a$export$d39a5bbd09211389; }, function (v) { return $356e48a4e68f094a$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $356e48a4e68f094a$export$cd75ccfd720a3cd4; }, function (v) { return $356e48a4e68f094a$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $356e48a4e68f094a$export$a0816fa17a9e79be; }, function (v) { return $356e48a4e68f094a$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $356e48a4e68f094a$export$7292efcadded39f3; }, function (v) { return $356e48a4e68f094a$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $356e48a4e68f094a$export$da407abadb9b8f86; }, function (v) { return $356e48a4e68f094a$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $356e48a4e68f094a$export$314cfea32580671c; }, function (v) { return $356e48a4e68f094a$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $356e48a4e68f094a$export$513ccb98c53b8039; }, function (v) { return $356e48a4e68f094a$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $356e48a4e68f094a$export$dbca993bc2d264a; }, function (v) { return $356e48a4e68f094a$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $356e48a4e68f094a$export$4797a8006f0655d0; }, function (v) { return $356e48a4e68f094a$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $356e48a4e68f094a$export$c78a37762a8d58e1; }, function (v) { return $356e48a4e68f094a$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $356e48a4e68f094a$export$606f11b2eb45ecc6; }, function (v) { return $356e48a4e68f094a$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $356e48a4e68f094a$export$f7e8a0bf92324b1e; }, function (v) { return $356e48a4e68f094a$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $356e48a4e68f094a$export$83d89fbfd8236492; }, function (v) { return $356e48a4e68f094a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $356e48a4e68f094a$export$69ce8ef3fe5cead0;
var $356e48a4e68f094a$export$d39a5bbd09211389;
var $356e48a4e68f094a$export$cd75ccfd720a3cd4;
var $356e48a4e68f094a$export$a0816fa17a9e79be;
var $356e48a4e68f094a$export$7292efcadded39f3;
var $356e48a4e68f094a$export$da407abadb9b8f86;
var $356e48a4e68f094a$export$314cfea32580671c;
var $356e48a4e68f094a$export$513ccb98c53b8039;
var $356e48a4e68f094a$export$dbca993bc2d264a;
var $356e48a4e68f094a$export$4797a8006f0655d0;
var $356e48a4e68f094a$export$c78a37762a8d58e1;
var $356e48a4e68f094a$export$606f11b2eb45ecc6;
var $356e48a4e68f094a$export$f7e8a0bf92324b1e;
var $356e48a4e68f094a$export$83d89fbfd8236492;
"use strict";

var $1kowh = parcelRequire("1kowh");
function $356e48a4e68f094a$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $356e48a4e68f094a$var$noop() {}
var $356e48a4e68f094a$var$Internals = {
    d: {
        f: $356e48a4e68f094a$var$noop,
        r: function() {
            throw Error($356e48a4e68f094a$var$formatProdErrorMessage(522));
        },
        D: $356e48a4e68f094a$var$noop,
        C: $356e48a4e68f094a$var$noop,
        L: $356e48a4e68f094a$var$noop,
        m: $356e48a4e68f094a$var$noop,
        X: $356e48a4e68f094a$var$noop,
        S: $356e48a4e68f094a$var$noop,
        M: $356e48a4e68f094a$var$noop
    },
    p: 0,
    findDOMNode: null
}, $356e48a4e68f094a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $356e48a4e68f094a$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $356e48a4e68f094a$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $356e48a4e68f094a$var$ReactSharedInternals = $1kowh.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $356e48a4e68f094a$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$356e48a4e68f094a$export$69ce8ef3fe5cead0 = $356e48a4e68f094a$var$Internals;
$356e48a4e68f094a$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($356e48a4e68f094a$var$formatProdErrorMessage(299));
    return $356e48a4e68f094a$var$createPortal$1(children, container, null, key);
};
$356e48a4e68f094a$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $356e48a4e68f094a$var$ReactSharedInternals.T, previousUpdatePriority = $356e48a4e68f094a$var$Internals.p;
    try {
        if ($356e48a4e68f094a$var$ReactSharedInternals.T = null, $356e48a4e68f094a$var$Internals.p = 2, fn) return fn();
    } finally{
        $356e48a4e68f094a$var$ReactSharedInternals.T = previousTransition, $356e48a4e68f094a$var$Internals.p = previousUpdatePriority, $356e48a4e68f094a$var$Internals.d.f();
    }
};
$356e48a4e68f094a$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $356e48a4e68f094a$var$Internals.d.C(href, options));
};
$356e48a4e68f094a$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $356e48a4e68f094a$var$Internals.d.D(href);
};
$356e48a4e68f094a$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $356e48a4e68f094a$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $356e48a4e68f094a$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $356e48a4e68f094a$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$356e48a4e68f094a$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $356e48a4e68f094a$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $356e48a4e68f094a$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $356e48a4e68f094a$var$Internals.d.M(href);
    }
};
$356e48a4e68f094a$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $356e48a4e68f094a$var$getCrossOriginStringAs(as, options.crossOrigin);
        $356e48a4e68f094a$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$356e48a4e68f094a$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $356e48a4e68f094a$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $356e48a4e68f094a$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $356e48a4e68f094a$var$Internals.d.m(href);
    }
};
$356e48a4e68f094a$export$4797a8006f0655d0 = function(form) {
    $356e48a4e68f094a$var$Internals.d.r(form);
};
$356e48a4e68f094a$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$356e48a4e68f094a$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $356e48a4e68f094a$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$356e48a4e68f094a$export$f7e8a0bf92324b1e = function() {
    return $356e48a4e68f094a$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$356e48a4e68f094a$export$83d89fbfd8236492 = "19.2.1";

});



parcelRegister("f0C8E", function(module, exports) {

$parcel$export(module.exports, "ColorModeContext", function () { return $5c121a02b943fe91$export$49ddd74a6729fdb0; });
$parcel$export(module.exports, "default", function () { return $5c121a02b943fe91$export$2e2bcd8739ae039; });

var $3QTul = parcelRequire("3QTul");

var $1kowh = parcelRequire("1kowh");


var $jpntN = parcelRequire("jpntN");

var $jadBd = parcelRequire("jadBd");
var $D2szs = parcelRequire("D2szs");

var $RD2UU = parcelRequire("RD2UU");

var $fgCTa = parcelRequire("fgCTa");

var $lNqKO = parcelRequire("lNqKO");

var $glGBC = parcelRequire("glGBC");

var $RD2UU = parcelRequire("RD2UU");

var $i9aPd = parcelRequire("i9aPd");

var $4usDK = parcelRequire("4usDK");

var $eaYKj = parcelRequire("eaYKj");

const $5c121a02b943fe91$var$BasicInformation = /*#__PURE__*/ (0, $1kowh.lazy)(()=>(parcelRequire("TYiiF")));

const $5c121a02b943fe91$var$Navbar = /*#__PURE__*/ (0, $1kowh.lazy)(()=>(parcelRequire("cUYUb")));

const $5c121a02b943fe91$var$CssBaseline = /*#__PURE__*/ (0, $1kowh.lazy)(()=>(parcelRequire("5mfdE")));

const $5c121a02b943fe91$var$Box = /*#__PURE__*/ (0, $1kowh.lazy)(()=>(parcelRequire("6HttA")));

const $5c121a02b943fe91$var$GlobalStyles = /*#__PURE__*/ (0, $1kowh.lazy)(()=>(parcelRequire("55XjS")));
const $5c121a02b943fe91$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $1kowh.createContext)({
    toggleColorMode: ()=>{}
});
function $5c121a02b943fe91$var$App() {
    const [mode, setMode] = (0, $1kowh.useState)((0, $lNqKO.default)("(prefers-color-scheme: dark)") ? "dark" : "light");
    const isMobile = (0, $i9aPd.useIsMobile)();
    const theme = (0, $1kowh.useMemo)(()=>(0, $jadBd.default)({
            //...baseTheme,
            palette: {
                mode: mode
            }
        }), [
        mode
    ]);
    const layoutBreak = (0, $lNqKO.default)("(max-width: 1529px)");
    const isDarkTheme = (0, $i9aPd.useIsDarkTheme)(theme);
    const globalStyle = (0, $1kowh.useMemo)(()=>({
            "::-webkit-scrollbar": {
                width: "15px"
            },
            "::-webkit-scrollbar-track": {
                backgroundColor: "transparent"
            },
            "::-webkit-scrollbar-thumb": {
                backgroundColor: isDarkTheme ? (0, $RD2UU.darken)(theme.palette.text.primary, 0.4) : (0, $RD2UU.lighten)(theme.palette.text.primary, 0.4),
                borderRadius: "15px",
                border: "4px solid transparent",
                backgroundClip: "content-box"
            },
            "::-webkit-scrollbar-thumb:hover": {
                backgroundColor: isDarkTheme ? (0, $RD2UU.darken)(theme.palette.text.primary, 0.2) : (0, $RD2UU.lighten)(theme.palette.text.primary, 0.2)
            },
            body: {
                backgroundImage: `url(${isDarkTheme ? (0, (/*@__PURE__*/$parcel$interopDefault($eaYKj))) : (0, (/*@__PURE__*/$parcel$interopDefault($4usDK)))})`
            }
        }), [
        theme.palette.text.primary,
        isDarkTheme
    ]);
    return /*#__PURE__*/ (0, $3QTul.jsx)($5c121a02b943fe91$export$49ddd74a6729fdb0.Provider, {
        value: {
            toggleColorMode: ()=>setMode((prevMode)=>prevMode === "light" ? "dark" : "light")
        },
        children: /*#__PURE__*/ (0, $3QTul.jsxs)((0, $D2szs.default), {
            theme: theme,
            children: [
                /*#__PURE__*/ (0, $3QTul.jsx)($5c121a02b943fe91$var$GlobalStyles, {
                    styles: isMobile ? undefined : globalStyle
                }),
                /*#__PURE__*/ (0, $3QTul.jsx)((0, $jpntN.BrowserRouter), {
                    children: /*#__PURE__*/ (0, $3QTul.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            height: "100vh",
                            width: "100vw"
                        },
                        children: [
                            /*#__PURE__*/ (0, $3QTul.jsx)($5c121a02b943fe91$var$CssBaseline, {}),
                            /*#__PURE__*/ (0, $3QTul.jsx)($5c121a02b943fe91$var$Navbar, {}),
                            /*#__PURE__*/ (0, $3QTul.jsxs)("div", {
                                style: {
                                    height: "100%",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    overflow: "auto",
                                    flexDirection: "row-reverse"
                                },
                                id: "main-content",
                                children: [
                                    layoutBreak ? null : /*#__PURE__*/ (0, $3QTul.jsx)("div", {
                                        style: {
                                            flexGrow: 1
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $3QTul.jsx)("div", {
                                        style: {
                                            justifySelf: "center",
                                            padding: 0,
                                            display: "flex",
                                            flexDirection: layoutBreak ? "row" : "column",
                                            flexGrow: 1,
                                            width: layoutBreak ? undefined : "60vw"
                                        },
                                        children: /*#__PURE__*/ (0, $3QTul.jsx)((0, $jpntN.Routes), {
                                            children: Object.values((0, $glGBC.pages)).map(({ path: path, Element: Element, title: title })=>/*#__PURE__*/ (0, $3QTul.jsx)((0, $jpntN.Route), {
                                                    path: path,
                                                    element: /*#__PURE__*/ (0, $3QTul.jsx)((0, $1kowh.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $3QTul.jsx)("div", {
                                                            style: {
                                                                flexGrow: 1,
                                                                padding: "auto",
                                                                alignSelf: "center",
                                                                display: "flex",
                                                                top: "50%",
                                                                position: "absolute"
                                                            },
                                                            children: /*#__PURE__*/ (0, $3QTul.jsx)((0, $fgCTa.default), {})
                                                        }),
                                                        children: /*#__PURE__*/ (0, $3QTul.jsx)(Element, {})
                                                    })
                                                }, title))
                                        })
                                    }),
                                    layoutBreak ? null : /*#__PURE__*/ (0, $3QTul.jsx)("div", {
                                        style: {
                                            flexGrow: 1
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $3QTul.jsx)($5c121a02b943fe91$var$Box, {
                                        sx: layoutBreak ? {
                                            margin: "auto"
                                        } : {
                                            pt: 24,
                                            width: 400,
                                            marginLeft: 0,
                                            left: 0
                                        },
                                        children: /*#__PURE__*/ (0, $3QTul.jsx)($5c121a02b943fe91$var$BasicInformation, {
                                            compact: layoutBreak
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $5c121a02b943fe91$export$2e2bcd8739ae039 = $5c121a02b943fe91$var$App;

});
parcelRegister("jpntN", function(module, exports) {

$parcel$export(module.exports, "useLocation", function () { return $7ac35536217f28c8$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $7ac35536217f28c8$export$9770f232ac06a008; });
$parcel$export(module.exports, "Route", function () { return $7ac35536217f28c8$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $7ac35536217f28c8$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "BrowserRouter", function () { return $7ac35536217f28c8$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $7ac35536217f28c8$export$a6c7ac8248d6e38a; });
/**
 * react-router v7.10.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $1kowh = parcelRequire("1kowh");
var $7ac35536217f28c8$import_meta = Object.assign(Object.create(null), {
    url: "file:///.yarn/__virtual__/react-router-virtual-8f0c7899e9/0/cache/react-router-npm-7.10.1-fda1361f9c-0de854fe2d.zip/node_modules/react-router/dist/development/chunk-WWGJGFF6.mjs"
});
var $7ac35536217f28c8$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $7ac35536217f28c8$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $7ac35536217f28c8$var$__typeError("Cannot " + msg);
var $7ac35536217f28c8$var$__privateGet = (obj, member, getter)=>($7ac35536217f28c8$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $7ac35536217f28c8$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $7ac35536217f28c8$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $7ac35536217f28c8$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($7ac35536217f28c8$export$e19cd5f9376f8cee || {});
var $7ac35536217f28c8$var$PopStateEventType = "popstate";
function $7ac35536217f28c8$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $7ac35536217f28c8$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $7ac35536217f28c8$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $7ac35536217f28c8$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $7ac35536217f28c8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $7ac35536217f28c8$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $7ac35536217f28c8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $7ac35536217f28c8$export$fe53371bee54353d(to);
    }
    return $7ac35536217f28c8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $7ac35536217f28c8$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $7ac35536217f28c8$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $7ac35536217f28c8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $7ac35536217f28c8$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $7ac35536217f28c8$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $7ac35536217f28c8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $7ac35536217f28c8$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $7ac35536217f28c8$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $7ac35536217f28c8$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $7ac35536217f28c8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $7ac35536217f28c8$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $7ac35536217f28c8$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $7ac35536217f28c8$var$createKey()
    };
    return location;
}
function $7ac35536217f28c8$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $7ac35536217f28c8$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $7ac35536217f28c8$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $7ac35536217f28c8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $7ac35536217f28c8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $7ac35536217f28c8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $7ac35536217f28c8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $7ac35536217f28c8$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($7ac35536217f28c8$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($7ac35536217f28c8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $7ac35536217f28c8$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $7ac35536217f28c8$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $7ac35536217f28c8$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $7ac35536217f28c8$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $7ac35536217f28c8$var$_map;
var $7ac35536217f28c8$export$b8d3e69d4b3eff04 = class {
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($7ac35536217f28c8$var$__privateGet(this, $7ac35536217f28c8$var$_map).has(context)) return $7ac35536217f28c8$var$__privateGet(this, $7ac35536217f28c8$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $7ac35536217f28c8$var$__privateGet(this, $7ac35536217f28c8$var$_map).set(context, value);
    }
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $7ac35536217f28c8$var$__privateAdd(this, $7ac35536217f28c8$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
};
$7ac35536217f28c8$var$_map = new WeakMap();
var $7ac35536217f28c8$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $7ac35536217f28c8$var$isUnsupportedLazyRouteObjectKey(key) {
    return $7ac35536217f28c8$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $7ac35536217f28c8$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $7ac35536217f28c8$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $7ac35536217f28c8$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $7ac35536217f28c8$var$isIndexRoute(route) {
    return route.index === true;
}
function $7ac35536217f28c8$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $7ac35536217f28c8$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $7ac35536217f28c8$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($7ac35536217f28c8$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $7ac35536217f28c8$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $7ac35536217f28c8$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $7ac35536217f28c8$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $7ac35536217f28c8$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $7ac35536217f28c8$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $7ac35536217f28c8$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $7ac35536217f28c8$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $7ac35536217f28c8$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $7ac35536217f28c8$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $7ac35536217f28c8$var$flattenRoutes(routes);
    $7ac35536217f28c8$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $7ac35536217f28c8$var$decodePath(pathname);
        matches = $7ac35536217f28c8$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $7ac35536217f28c8$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $7ac35536217f28c8$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $7ac35536217f28c8$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $7ac35536217f28c8$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $7ac35536217f28c8$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $7ac35536217f28c8$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $7ac35536217f28c8$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route_path;
        if (route.path === "" || !((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $7ac35536217f28c8$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $7ac35536217f28c8$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $7ac35536217f28c8$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $7ac35536217f28c8$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $7ac35536217f28c8$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $7ac35536217f28c8$var$paramRe = /^:[\w-]+$/;
var $7ac35536217f28c8$var$dynamicSegmentValue = 3;
var $7ac35536217f28c8$var$indexRouteValue = 2;
var $7ac35536217f28c8$var$emptySegmentValue = 1;
var $7ac35536217f28c8$var$staticSegmentValue = 10;
var $7ac35536217f28c8$var$splatPenalty = -2;
var $7ac35536217f28c8$var$isSplat = (s)=>s === "*";
function $7ac35536217f28c8$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($7ac35536217f28c8$var$isSplat)) initialScore += $7ac35536217f28c8$var$splatPenalty;
    if (index) initialScore += $7ac35536217f28c8$var$indexRouteValue;
    return segments.filter((s)=>!$7ac35536217f28c8$var$isSplat(s)).reduce((score, segment)=>score + ($7ac35536217f28c8$var$paramRe.test(segment) ? $7ac35536217f28c8$var$dynamicSegmentValue : segment === "" ? $7ac35536217f28c8$var$emptySegmentValue : $7ac35536217f28c8$var$staticSegmentValue), initialScore);
}
function $7ac35536217f28c8$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $7ac35536217f28c8$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $7ac35536217f28c8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $7ac35536217f28c8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $7ac35536217f28c8$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $7ac35536217f28c8$var$normalizePathname($7ac35536217f28c8$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $7ac35536217f28c8$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $7ac35536217f28c8$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $7ac35536217f28c8$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $7ac35536217f28c8$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param));
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $7ac35536217f28c8$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $7ac35536217f28c8$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $7ac35536217f28c8$var$compilePath(path, caseSensitive = false, end = true) {
    $7ac35536217f28c8$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $7ac35536217f28c8$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $7ac35536217f28c8$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $7ac35536217f28c8$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $7ac35536217f28c8$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $7ac35536217f28c8$var$joinPaths([
        basename,
        pathname
    ]);
}
var $7ac35536217f28c8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $7ac35536217f28c8$var$isAbsoluteUrl = (url)=>$7ac35536217f28c8$var$ABSOLUTE_URL_REGEX.test(url);
function $7ac35536217f28c8$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $7ac35536217f28c8$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($7ac35536217f28c8$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $7ac35536217f28c8$var$warning(false, `Pathnames cannot have embedded double slashes - normalizing ${oldPathname} -> ${toPathname}`);
            }
            if (toPathname.startsWith("/")) pathname = $7ac35536217f28c8$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $7ac35536217f28c8$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $7ac35536217f28c8$var$normalizeSearch(search),
        hash: $7ac35536217f28c8$var$normalizeHash(hash)
    };
}
function $7ac35536217f28c8$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $7ac35536217f28c8$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $7ac35536217f28c8$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $7ac35536217f28c8$var$getResolveToMatches(matches) {
    let pathMatches = $7ac35536217f28c8$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $7ac35536217f28c8$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $7ac35536217f28c8$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $7ac35536217f28c8$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $7ac35536217f28c8$var$getInvalidPathError("?", "pathname", "search", to));
        $7ac35536217f28c8$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $7ac35536217f28c8$var$getInvalidPathError("#", "pathname", "hash", to));
        $7ac35536217f28c8$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $7ac35536217f28c8$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $7ac35536217f28c8$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $7ac35536217f28c8$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $7ac35536217f28c8$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $7ac35536217f28c8$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $7ac35536217f28c8$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $7ac35536217f28c8$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $7ac35536217f28c8$export$4051a07651545597(data2, init) {
    return new $7ac35536217f28c8$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $7ac35536217f28c8$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $7ac35536217f28c8$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $7ac35536217f28c8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $7ac35536217f28c8$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $7ac35536217f28c8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $7ac35536217f28c8$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $7ac35536217f28c8$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $7ac35536217f28c8$var$getRoutePattern(matches) {
    return matches.map((m)=>m.route.path).filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
// lib/router/instrumentation.ts
var $7ac35536217f28c8$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $7ac35536217f28c8$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $7ac35536217f28c8$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $7ac35536217f28c8$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            var _handler_UninstrumentedSymbol;
            let original = (_handler_UninstrumentedSymbol = handler[$7ac35536217f28c8$var$UninstrumentedSymbol]) !== null && _handler_UninstrumentedSymbol !== void 0 ? _handler_UninstrumentedSymbol : handler;
            let instrumented = $7ac35536217f28c8$var$wrapImpl(aggregated[key], original, (...args)=>$7ac35536217f28c8$var$getHandlerInfo(args[0]));
            if (instrumented) {
                instrumented[$7ac35536217f28c8$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        var _middleware_UninstrumentedSymbol;
        let original = (_middleware_UninstrumentedSymbol = middleware[$7ac35536217f28c8$var$UninstrumentedSymbol]) !== null && _middleware_UninstrumentedSymbol !== void 0 ? _middleware_UninstrumentedSymbol : middleware;
        let instrumented = $7ac35536217f28c8$var$wrapImpl(aggregated.middleware, original, (...args)=>$7ac35536217f28c8$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$7ac35536217f28c8$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $7ac35536217f28c8$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        var _router_navigate_UninstrumentedSymbol;
        let navigate = (_router_navigate_UninstrumentedSymbol = router.navigate[$7ac35536217f28c8$var$UninstrumentedSymbol]) !== null && _router_navigate_UninstrumentedSymbol !== void 0 ? _router_navigate_UninstrumentedSymbol : router.navigate;
        let instrumentedNavigate = $7ac35536217f28c8$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $7ac35536217f28c8$export$fe53371bee54353d(to) : ".",
                ...$7ac35536217f28c8$var$getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$7ac35536217f28c8$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        var _router_fetch_UninstrumentedSymbol;
        let fetch2 = (_router_fetch_UninstrumentedSymbol = router.fetch[$7ac35536217f28c8$var$UninstrumentedSymbol]) !== null && _router_fetch_UninstrumentedSymbol !== void 0 ? _router_fetch_UninstrumentedSymbol : router.fetch;
        let instrumentedFetch = $7ac35536217f28c8$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href !== null && href !== void 0 ? href : ".",
                fetcherKey: key,
                ...$7ac35536217f28c8$var$getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$7ac35536217f28c8$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $7ac35536217f28c8$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $7ac35536217f28c8$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $7ac35536217f28c8$var$getReadonlyRequest(request),
            context: context != null ? $7ac35536217f28c8$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $7ac35536217f28c8$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $7ac35536217f28c8$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $7ac35536217f28c8$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $7ac35536217f28c8$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $7ac35536217f28c8$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $7ac35536217f28c8$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $7ac35536217f28c8$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $7ac35536217f28c8$var$getReadonlyContext(context)
    };
}
function $7ac35536217f28c8$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $7ac35536217f28c8$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $7ac35536217f28c8$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $7ac35536217f28c8$var$getReadonlyContext(context) {
    if ($7ac35536217f28c8$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $7ac35536217f28c8$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $7ac35536217f28c8$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $7ac35536217f28c8$var$objectProtoNames;
}
// lib/router/router.ts
var $7ac35536217f28c8$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $7ac35536217f28c8$var$validMutationMethods = new Set($7ac35536217f28c8$var$validMutationMethodsArr);
var $7ac35536217f28c8$var$validRequestMethodsArr = [
    "GET",
    ...$7ac35536217f28c8$var$validMutationMethodsArr
];
var $7ac35536217f28c8$var$validRequestMethods = new Set($7ac35536217f28c8$var$validRequestMethodsArr);
var $7ac35536217f28c8$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $7ac35536217f28c8$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $7ac35536217f28c8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $7ac35536217f28c8$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $7ac35536217f28c8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $7ac35536217f28c8$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $7ac35536217f28c8$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $7ac35536217f28c8$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $7ac35536217f28c8$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $7ac35536217f28c8$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $7ac35536217f28c8$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$7ac35536217f28c8$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $7ac35536217f28c8$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $7ac35536217f28c8$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $7ac35536217f28c8$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $7ac35536217f28c8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $7ac35536217f28c8$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>$7ac35536217f28c8$var$routeHasLoaderOrMiddleware(m.route))) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$7ac35536217f28c8$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$7ac35536217f28c8$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $7ac35536217f28c8$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $7ac35536217f28c8$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $7ac35536217f28c8$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $7ac35536217f28c8$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$7ac35536217f28c8$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>{
            var _newState_errors;
            return subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        var _location_state, _location_state1;
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $7ac35536217f28c8$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $7ac35536217f28c8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $7ac35536217f28c8$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $7ac35536217f28c8$export$cbae47800eb95bc3(state.navigation.formMethod) && ((_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $7ac35536217f28c8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd === null || pendingRevalidationDfd === void 0 ? void 0 : pendingRevalidationDfd.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $7ac35536217f28c8$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $7ac35536217f28c8$var$normalizeTo(state.location, state.matches, basename, to, opts === null || opts === void 0 ? void 0 : opts.fromRouteId, opts === null || opts === void 0 ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $7ac35536217f28c8$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $7ac35536217f28c8$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $7ac35536217f28c8$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $7ac35536217f28c8$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $7ac35536217f28c8$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = (opts === null || opts === void 0 ? void 0 : opts.initialHydration) && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $7ac35536217f28c8$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $7ac35536217f28c8$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $7ac35536217f28c8$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $7ac35536217f28c8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $7ac35536217f28c8$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $7ac35536217f28c8$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $7ac35536217f28c8$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($7ac35536217f28c8$var$isErrorResult(result) && $7ac35536217f28c8$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $7ac35536217f28c8$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $7ac35536217f28c8$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$7ac35536217f28c8$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $7ac35536217f28c8$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $7ac35536217f28c8$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $7ac35536217f28c8$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $7ac35536217f28c8$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $7ac35536217f28c8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $7ac35536217f28c8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($7ac35536217f28c8$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $7ac35536217f28c8$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($7ac35536217f28c8$var$isErrorResult(result)) {
            let boundaryMatch = $7ac35536217f28c8$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $7ac35536217f28c8$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $7ac35536217f28c8$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $7ac35536217f28c8$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $7ac35536217f28c8$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $7ac35536217f28c8$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $7ac35536217f28c8$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$7ac35536217f28c8$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $7ac35536217f28c8$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $7ac35536217f28c8$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $7ac35536217f28c8$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$7ac35536217f28c8$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $7ac35536217f28c8$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $7ac35536217f28c8$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts === null || opts === void 0 ? void 0 : opts.relative);
        let matches = $7ac35536217f28c8$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $7ac35536217f28c8$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $7ac35536217f28c8$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $7ac35536217f28c8$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $7ac35536217f28c8$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $7ac35536217f28c8$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $7ac35536217f28c8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $7ac35536217f28c8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $7ac35536217f28c8$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $7ac35536217f28c8$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $7ac35536217f28c8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($7ac35536217f28c8$var$isRedirectResult(actionResult) || $7ac35536217f28c8$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $7ac35536217f28c8$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($7ac35536217f28c8$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $7ac35536217f28c8$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $7ac35536217f28c8$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($7ac35536217f28c8$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $7ac35536217f28c8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $7ac35536217f28c8$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $7ac35536217f28c8$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $7ac35536217f28c8$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $7ac35536217f28c8$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $7ac35536217f28c8$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $7ac35536217f28c8$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $7ac35536217f28c8$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $7ac35536217f28c8$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $7ac35536217f28c8$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $7ac35536217f28c8$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $7ac35536217f28c8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $7ac35536217f28c8$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $7ac35536217f28c8$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $7ac35536217f28c8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $7ac35536217f28c8$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $7ac35536217f28c8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $7ac35536217f28c8$var$getDoneFetcher(void 0));
            return;
        }
        if ($7ac35536217f28c8$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $7ac35536217f28c8$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($7ac35536217f28c8$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $7ac35536217f28c8$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $7ac35536217f28c8$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $7ac35536217f28c8$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $7ac35536217f28c8$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($7ac35536217f28c8$var$isAbsoluteUrl(location)) {
                const url = $7ac35536217f28c8$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $7ac35536217f28c8$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $7ac35536217f28c8$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($7ac35536217f28c8$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $7ac35536217f28c8$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $7ac35536217f28c8$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $7ac35536217f28c8$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if ($7ac35536217f28c8$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $7ac35536217f28c8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $7ac35536217f28c8$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $7ac35536217f28c8$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $7ac35536217f28c8$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $7ac35536217f28c8$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts === null || opts === void 0 ? void 0 : opts.reason);
        updateFetcherState(key, $7ac35536217f28c8$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $7ac35536217f28c8$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $7ac35536217f28c8$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $7ac35536217f28c8$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $7ac35536217f28c8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $7ac35536217f28c8$export$386d57f03f0b2883;
        $7ac35536217f28c8$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $7ac35536217f28c8$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $7ac35536217f28c8$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $7ac35536217f28c8$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $7ac35536217f28c8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$7ac35536217f28c8$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $7ac35536217f28c8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $7ac35536217f28c8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $7ac35536217f28c8$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $7ac35536217f28c8$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $7ac35536217f28c8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $7ac35536217f28c8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $7ac35536217f28c8$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $7ac35536217f28c8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $7ac35536217f28c8$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $7ac35536217f28c8$export$3336b097a6fbc59a(routes, opts) {
    $7ac35536217f28c8$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = (opts === null || opts === void 0 ? void 0 : opts.mapRouteProperties) || $7ac35536217f28c8$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts === null || opts === void 0 ? void 0 : opts.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$7ac35536217f28c8$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $7ac35536217f28c8$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $7ac35536217f28c8$var$createLocation("", $7ac35536217f28c8$export$fe53371bee54353d(url), null, "default");
        let matches = $7ac35536217f28c8$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $7ac35536217f28c8$export$b8d3e69d4b3eff04();
        if (!$7ac35536217f28c8$var$isValidMethod(method) && method !== "HEAD") {
            let error = $7ac35536217f28c8$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $7ac35536217f28c8$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $7ac35536217f28c8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $7ac35536217f28c8$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $7ac35536217f28c8$export$f5708dca728d7177(requestContext instanceof $7ac35536217f28c8$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $7ac35536217f28c8$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $7ac35536217f28c8$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $7ac35536217f28c8$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        var _opts2_filterMatchesToLoad;
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? (_opts2_filterMatchesToLoad = opts2.filterMatchesToLoad) !== null && _opts2_filterMatchesToLoad !== void 0 ? _opts2_filterMatchesToLoad : null : filterMatchesToLoad !== null && filterMatchesToLoad !== void 0 ? filterMatchesToLoad : null, skipRevalidation === true);
                        if ($7ac35536217f28c8$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($7ac35536217f28c8$export$6e80290866a84dd4(error)) return error;
                    if ($7ac35536217f28c8$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $7ac35536217f28c8$export$f2680fa305b734ca(error.status, error.statusText, await $7ac35536217f28c8$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($7ac35536217f28c8$export$e0163cfdf7bc9cfa(error)) error = $7ac35536217f28c8$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $7ac35536217f28c8$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $7ac35536217f28c8$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        var _matches_find;
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $7ac35536217f28c8$var$findNearestBoundary(matches, ((_matches_find = matches.find((m)=>m.route.id === routeId || m.route.loader)) === null || _matches_find === void 0 ? void 0 : _matches_find.route.id) || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $7ac35536217f28c8$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $7ac35536217f28c8$export$f5708dca728d7177($7ac35536217f28c8$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($7ac35536217f28c8$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($7ac35536217f28c8$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $7ac35536217f28c8$var$createLocation("", $7ac35536217f28c8$export$fe53371bee54353d(url), null, "default");
        let matches = $7ac35536217f28c8$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $7ac35536217f28c8$export$b8d3e69d4b3eff04();
        if (!$7ac35536217f28c8$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $7ac35536217f28c8$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $7ac35536217f28c8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $7ac35536217f28c8$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $7ac35536217f28c8$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $7ac35536217f28c8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $7ac35536217f28c8$export$f5708dca728d7177(requestContext instanceof $7ac35536217f28c8$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $7ac35536217f28c8$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $7ac35536217f28c8$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $7ac35536217f28c8$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $7ac35536217f28c8$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($7ac35536217f28c8$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($7ac35536217f28c8$var$dataWithResponseInitToResponse(error));
                if ($7ac35536217f28c8$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($7ac35536217f28c8$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $7ac35536217f28c8$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($7ac35536217f28c8$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $7ac35536217f28c8$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $7ac35536217f28c8$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($7ac35536217f28c8$var$isDataStrategyResult(e) && $7ac35536217f28c8$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($7ac35536217f28c8$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $7ac35536217f28c8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $7ac35536217f28c8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $7ac35536217f28c8$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($7ac35536217f28c8$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($7ac35536217f28c8$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($7ac35536217f28c8$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $7ac35536217f28c8$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $7ac35536217f28c8$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($7ac35536217f28c8$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $7ac35536217f28c8$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $7ac35536217f28c8$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.loader) && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.lazy)) throw $7ac35536217f28c8$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $7ac35536217f28c8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $7ac35536217f28c8$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $7ac35536217f28c8$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $7ac35536217f28c8$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $7ac35536217f28c8$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $7ac35536217f28c8$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $7ac35536217f28c8$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $7ac35536217f28c8$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $7ac35536217f28c8$var$callDataStrategyImpl(dataStrategy || $7ac35536217f28c8$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($7ac35536217f28c8$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $7ac35536217f28c8$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($7ac35536217f28c8$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($7ac35536217f28c8$export$e0163cfdf7bc9cfa(result.result)) throw $7ac35536217f28c8$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $7ac35536217f28c8$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $7ac35536217f28c8$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $7ac35536217f28c8$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $7ac35536217f28c8$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $7ac35536217f28c8$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $7ac35536217f28c8$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $7ac35536217f28c8$var$resolveTo(to ? to : ".", $7ac35536217f28c8$var$getResolveToMatches(contextualMatches), $7ac35536217f28c8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $7ac35536217f28c8$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $7ac35536217f28c8$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $7ac35536217f28c8$export$fe53371bee54353d(path);
}
function $7ac35536217f28c8$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$7ac35536217f28c8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$7ac35536217f28c8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $7ac35536217f28c8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $7ac35536217f28c8$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $7ac35536217f28c8$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$7ac35536217f28c8$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$7ac35536217f28c8$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $7ac35536217f28c8$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $7ac35536217f28c8$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $7ac35536217f28c8$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $7ac35536217f28c8$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $7ac35536217f28c8$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($7ac35536217f28c8$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $7ac35536217f28c8$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $7ac35536217f28c8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $7ac35536217f28c8$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $7ac35536217f28c8$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    var _state_matches_;
    let actionResult = pendingActionResult ? $7ac35536217f28c8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $7ac35536217f28c8$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: ((_state_matches_ = state.matches[0]) === null || _state_matches_ === void 0 ? void 0 : _state_matches_.params) || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $7ac35536217f28c8$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$7ac35536217f28c8$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $7ac35536217f28c8$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($7ac35536217f28c8$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $7ac35536217f28c8$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || $7ac35536217f28c8$var$isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $7ac35536217f28c8$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $7ac35536217f28c8$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $7ac35536217f28c8$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $7ac35536217f28c8$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $7ac35536217f28c8$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $7ac35536217f28c8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $7ac35536217f28c8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if ($7ac35536217f28c8$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $7ac35536217f28c8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $7ac35536217f28c8$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $7ac35536217f28c8$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!$7ac35536217f28c8$var$routeHasLoaderOrMiddleware(route)) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $7ac35536217f28c8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $7ac35536217f28c8$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $7ac35536217f28c8$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $7ac35536217f28c8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $7ac35536217f28c8$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$7ac35536217f28c8$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $7ac35536217f28c8$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String((childrenToPatch === null || childrenToPatch === void 0 ? void 0 : childrenToPatch.length) || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $7ac35536217f28c8$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $7ac35536217f28c8$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute_children;
        return (_existingRoute_children = existingRoute.children) === null || _existingRoute_children === void 0 ? void 0 : _existingRoute_children.some((bChild)=>$7ac35536217f28c8$var$isSameRoute(aChild, bChild));
    });
}
var $7ac35536217f28c8$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $7ac35536217f28c8$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $7ac35536217f28c8$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $7ac35536217f28c8$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $7ac35536217f28c8$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $7ac35536217f28c8$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $7ac35536217f28c8$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $7ac35536217f28c8$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $7ac35536217f28c8$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $7ac35536217f28c8$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $7ac35536217f28c8$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $7ac35536217f28c8$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $7ac35536217f28c8$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $7ac35536217f28c8$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $7ac35536217f28c8$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $7ac35536217f28c8$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $7ac35536217f28c8$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $7ac35536217f28c8$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise === null || lazyRoutePromise === void 0 ? void 0 : lazyRoutePromise.catch(()=>{});
    lazyHandlerPromise === null || lazyHandlerPromise === void 0 ? void 0 : lazyHandlerPromise.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $7ac35536217f28c8$var$isNonNullable(value) {
    return value !== void 0;
}
function $7ac35536217f28c8$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $7ac35536217f28c8$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($7ac35536217f28c8$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $7ac35536217f28c8$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $7ac35536217f28c8$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $7ac35536217f28c8$var$defaultDataStrategy(args);
    return $7ac35536217f28c8$var$runClientMiddlewarePipeline(args, ()=>$7ac35536217f28c8$var$defaultDataStrategy(args));
}
function $7ac35536217f28c8$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $7ac35536217f28c8$var$runMiddlewarePipeline(args, handler, processResult, $7ac35536217f28c8$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $7ac35536217f28c8$export$e0163cfdf7bc9cfa(result) ? $7ac35536217f28c8$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $7ac35536217f28c8$var$runClientMiddlewarePipeline(args, handler) {
    return $7ac35536217f28c8$var$runMiddlewarePipeline(args, handler, (r)=>r, // No post-processing needed on the client
    $7ac35536217f28c8$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $7ac35536217f28c8$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $7ac35536217f28c8$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $7ac35536217f28c8$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $7ac35536217f28c8$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    var _request_signal_reason;
    if (request.signal.aborted) throw (_request_signal_reason = request.signal.reason) !== null && _request_signal_reason !== void 0 ? _request_signal_reason : new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $7ac35536217f28c8$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result !== null && result !== void 0 ? result : nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $7ac35536217f28c8$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $7ac35536217f28c8$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $7ac35536217f28c8$var$loadLazyRoute(match.route, $7ac35536217f28c8$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $7ac35536217f28c8$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = $7ac35536217f28c8$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return $7ac35536217f28c8$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $7ac35536217f28c8$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$7ac35536217f28c8$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($7ac35536217f28c8$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $7ac35536217f28c8$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.handler,
                lazyRoutePromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $7ac35536217f28c8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $7ac35536217f28c8$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $7ac35536217f28c8$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $7ac35536217f28c8$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $7ac35536217f28c8$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>{
        var _m__lazyPromises;
        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
    })) await Promise.all(matches.map((m)=>{
        var _m__lazyPromises;
        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
    }));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $7ac35536217f28c8$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $7ac35536217f28c8$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>{
            var _m__lazyPromises, _m__lazyPromises1;
            return [
                (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.handler,
                (_m__lazyPromises1 = m._lazyPromises) === null || _m__lazyPromises1 === void 0 ? void 0 : _m__lazyPromises1.route
            ];
        }));
    } catch (e) {}
    return results;
}
async function $7ac35536217f28c8$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $7ac35536217f28c8$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $7ac35536217f28c8$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $7ac35536217f28c8$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $7ac35536217f28c8$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $7ac35536217f28c8$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    var _result_init, _result_init1;
    let { result: result, type: type } = dataStrategyResult;
    if ($7ac35536217f28c8$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $7ac35536217f28c8$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $7ac35536217f28c8$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($7ac35536217f28c8$export$e0163cfdf7bc9cfa(result)) {
            var _result_init2, _result_init3, _result_init4;
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: (_result_init2 = result.init) === null || _result_init2 === void 0 ? void 0 : _result_init2.status,
                headers: ((_result_init3 = result.init) === null || _result_init3 === void 0 ? void 0 : _result_init3.headers) ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $7ac35536217f28c8$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $7ac35536217f28c8$export$972111febbeef05b(result) ? result.status : void 0,
                headers: ((_result_init4 = result.init) === null || _result_init4 === void 0 ? void 0 : _result_init4.headers) ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $7ac35536217f28c8$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($7ac35536217f28c8$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: (_result_init = result.init) === null || _result_init === void 0 ? void 0 : _result_init.status,
        headers: ((_result_init1 = result.init) === null || _result_init1 === void 0 ? void 0 : _result_init1.headers) ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $7ac35536217f28c8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $7ac35536217f28c8$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$7ac35536217f28c8$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $7ac35536217f28c8$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $7ac35536217f28c8$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($7ac35536217f28c8$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $7ac35536217f28c8$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $7ac35536217f28c8$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($7ac35536217f28c8$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $7ac35536217f28c8$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $7ac35536217f28c8$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $7ac35536217f28c8$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $7ac35536217f28c8$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $7ac35536217f28c8$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $7ac35536217f28c8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $7ac35536217f28c8$export$f5708dca728d7177(!$7ac35536217f28c8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($7ac35536217f28c8$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $7ac35536217f28c8$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $7ac35536217f28c8$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $7ac35536217f28c8$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $7ac35536217f28c8$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $7ac35536217f28c8$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $7ac35536217f28c8$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($7ac35536217f28c8$var$isErrorResult(result)) {
            let boundaryMatch = $7ac35536217f28c8$var$findNearestBoundary(state.matches, match === null || match === void 0 ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($7ac35536217f28c8$var$isRedirectResult(result)) $7ac35536217f28c8$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $7ac35536217f28c8$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $7ac35536217f28c8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $7ac35536217f28c8$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $7ac35536217f28c8$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $7ac35536217f28c8$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $7ac35536217f28c8$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $7ac35536217f28c8$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $7ac35536217f28c8$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $7ac35536217f28c8$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $7ac35536217f28c8$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($7ac35536217f28c8$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $7ac35536217f28c8$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $7ac35536217f28c8$export$8ccf933b0513f8d0(path) : path;
    return $7ac35536217f28c8$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $7ac35536217f28c8$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $7ac35536217f28c8$var$dataWithResponseInitToResponse(data2) {
    var _data2_init;
    return Response.json(data2.data, (_data2_init = data2.init) !== null && _data2_init !== void 0 ? _data2_init : void 0);
}
function $7ac35536217f28c8$var$dataWithResponseInitToErrorResponse(data2) {
    var _data2_init, _data2_init1;
    var _data2_init_status, _data2_init_statusText;
    return new $7ac35536217f28c8$export$f2680fa305b734ca((_data2_init_status = (_data2_init = data2.init) === null || _data2_init === void 0 ? void 0 : _data2_init.status) !== null && _data2_init_status !== void 0 ? _data2_init_status : 500, (_data2_init_statusText = (_data2_init1 = data2.init) === null || _data2_init1 === void 0 ? void 0 : _data2_init1.statusText) !== null && _data2_init_statusText !== void 0 ? _data2_init_statusText : "Internal Server Error", data2.data);
}
function $7ac35536217f28c8$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $7ac35536217f28c8$var$isDataStrategyResult(value));
}
function $7ac35536217f28c8$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $7ac35536217f28c8$var$isRedirectDataStrategyResult(result) {
    return $7ac35536217f28c8$export$3f1eb41d9a6a6a27(result.result) && $7ac35536217f28c8$var$redirectStatusCodes.has(result.result.status);
}
function $7ac35536217f28c8$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $7ac35536217f28c8$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $7ac35536217f28c8$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $7ac35536217f28c8$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $7ac35536217f28c8$export$794b2760043cf8cd(statusCode) {
    return $7ac35536217f28c8$var$redirectStatusCodes.has(statusCode);
}
function $7ac35536217f28c8$export$6e80290866a84dd4(result) {
    return $7ac35536217f28c8$export$3f1eb41d9a6a6a27(result) && $7ac35536217f28c8$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $7ac35536217f28c8$var$isValidMethod(method) {
    return $7ac35536217f28c8$var$validRequestMethods.has(method.toUpperCase());
}
function $7ac35536217f28c8$export$cbae47800eb95bc3(method) {
    return $7ac35536217f28c8$var$validMutationMethods.has(method.toUpperCase());
}
function $7ac35536217f28c8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $7ac35536217f28c8$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $7ac35536217f28c8$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $7ac35536217f28c8$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $7ac35536217f28c8$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $7ac35536217f28c8$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $7ac35536217f28c8$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $7ac35536217f28c8$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $7ac35536217f28c8$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $7ac35536217f28c8$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $7ac35536217f28c8$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $7ac35536217f28c8$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($7ac35536217f28c8$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $7ac35536217f28c8$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($7ac35536217f28c8$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $7ac35536217f28c8$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $7ac35536217f28c8$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $7ac35536217f28c8$export$2eeee58951ff3c1c = $1kowh.createContext(null);
$7ac35536217f28c8$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $7ac35536217f28c8$export$315e3ffb01f217 = $1kowh.createContext(null);
$7ac35536217f28c8$export$315e3ffb01f217.displayName = "DataRouterState";
var $7ac35536217f28c8$export$717f757c655223f1 = $1kowh.createContext(false);
function $7ac35536217f28c8$var$useIsRSCRouterContext() {
    return $1kowh.useContext($7ac35536217f28c8$export$717f757c655223f1);
}
var $7ac35536217f28c8$export$3681f408decb40d1 = $1kowh.createContext({
    isTransitioning: false
});
$7ac35536217f28c8$export$3681f408decb40d1.displayName = "ViewTransition";
var $7ac35536217f28c8$export$cb3f1df1bef00a39 = $1kowh.createContext(/* @__PURE__ */ new Map());
$7ac35536217f28c8$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $7ac35536217f28c8$var$AwaitContext = $1kowh.createContext(null);
$7ac35536217f28c8$var$AwaitContext.displayName = "Await";
var $7ac35536217f28c8$export$2666c20e15407622 = (props)=>$1kowh.createElement($7ac35536217f28c8$var$AwaitContext.Provider, props);
var $7ac35536217f28c8$export$3044ab7fdabeaee6 = $1kowh.createContext(null);
$7ac35536217f28c8$export$3044ab7fdabeaee6.displayName = "Navigation";
var $7ac35536217f28c8$export$e6a44b110a0c44d3 = $1kowh.createContext(null);
$7ac35536217f28c8$export$e6a44b110a0c44d3.displayName = "Location";
var $7ac35536217f28c8$export$aac280ed165a4397 = $1kowh.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$7ac35536217f28c8$export$aac280ed165a4397.displayName = "Route";
var $7ac35536217f28c8$var$RouteErrorContext = $1kowh.createContext(null);
$7ac35536217f28c8$var$RouteErrorContext.displayName = "RouteError";
var $7ac35536217f28c8$export$945fecf35a8ef089 = true;
function $7ac35536217f28c8$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $7ac35536217f28c8$export$f5708dca728d7177($7ac35536217f28c8$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $1kowh.useContext($7ac35536217f28c8$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $7ac35536217f28c8$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $7ac35536217f28c8$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $7ac35536217f28c8$export$9c954a9d03d32f4a() {
    return $1kowh.useContext($7ac35536217f28c8$export$e6a44b110a0c44d3) != null;
}
function $7ac35536217f28c8$export$45d76561a5302f2b() {
    $7ac35536217f28c8$export$f5708dca728d7177($7ac35536217f28c8$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $1kowh.useContext($7ac35536217f28c8$export$e6a44b110a0c44d3).location;
}
function $7ac35536217f28c8$export$1b3f31771c5d07c() {
    return $1kowh.useContext($7ac35536217f28c8$export$e6a44b110a0c44d3).navigationType;
}
function $7ac35536217f28c8$export$6c330e8992e8a295(pattern) {
    $7ac35536217f28c8$export$f5708dca728d7177($7ac35536217f28c8$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $7ac35536217f28c8$export$45d76561a5302f2b();
    return $1kowh.useMemo(()=>$7ac35536217f28c8$export$81336c211d5ff295(pattern, $7ac35536217f28c8$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $7ac35536217f28c8$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $7ac35536217f28c8$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $1kowh.useContext($7ac35536217f28c8$export$3044ab7fdabeaee6).static;
    if (!isStatic) $1kowh.useLayoutEffect(cb);
}
function $7ac35536217f28c8$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $1kowh.useContext($7ac35536217f28c8$export$aac280ed165a4397);
    return isDataRoute ? $7ac35536217f28c8$var$useNavigateStable() : $7ac35536217f28c8$var$useNavigateUnstable();
}
function $7ac35536217f28c8$var$useNavigateUnstable() {
    $7ac35536217f28c8$export$f5708dca728d7177($7ac35536217f28c8$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $1kowh.useContext($7ac35536217f28c8$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $1kowh.useContext($7ac35536217f28c8$export$3044ab7fdabeaee6);
    let { matches: matches } = $1kowh.useContext($7ac35536217f28c8$export$aac280ed165a4397);
    let { pathname: locationPathname } = $7ac35536217f28c8$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($7ac35536217f28c8$var$getResolveToMatches(matches));
    let activeRef = $1kowh.useRef(false);
    $7ac35536217f28c8$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $1kowh.useCallback((to, options = {})=>{
        $7ac35536217f28c8$var$warning(activeRef.current, $7ac35536217f28c8$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $7ac35536217f28c8$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $7ac35536217f28c8$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $7ac35536217f28c8$var$OutletContext = $1kowh.createContext(null);
function $7ac35536217f28c8$export$4138103a3ae699cc() {
    return $1kowh.useContext($7ac35536217f28c8$var$OutletContext);
}
function $7ac35536217f28c8$export$a3be3530d8e40d0b(context) {
    let outlet = $1kowh.useContext($7ac35536217f28c8$export$aac280ed165a4397).outlet;
    return $1kowh.useMemo(()=>outlet && /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $7ac35536217f28c8$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $1kowh.useContext($7ac35536217f28c8$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $7ac35536217f28c8$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $1kowh.useContext($7ac35536217f28c8$export$aac280ed165a4397);
    let { pathname: locationPathname } = $7ac35536217f28c8$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($7ac35536217f28c8$var$getResolveToMatches(matches));
    return $1kowh.useMemo(()=>$7ac35536217f28c8$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $7ac35536217f28c8$export$5d3fca4a98652595(routes, locationArg) {
    return $7ac35536217f28c8$var$useRoutesImpl(routes, locationArg);
}
function $7ac35536217f28c8$var$useRoutesImpl(routes, locationArg, dataRouterState, unstable_onError, future) {
    $7ac35536217f28c8$export$f5708dca728d7177($7ac35536217f28c8$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $1kowh.useContext($7ac35536217f28c8$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $1kowh.useContext($7ac35536217f28c8$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($7ac35536217f28c8$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $7ac35536217f28c8$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $7ac35536217f28c8$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg_pathname;
        let parsedLocationArg = typeof locationArg === "string" ? $7ac35536217f28c8$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $7ac35536217f28c8$export$f5708dca728d7177(parentPathnameBase === "/" || ((_parsedLocationArg_pathname = parsedLocationArg.pathname) === null || _parsedLocationArg_pathname === void 0 ? void 0 : _parsedLocationArg_pathname.startsWith(parentPathnameBase)), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $7ac35536217f28c8$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($7ac35536217f28c8$export$945fecf35a8ef089) {
        $7ac35536217f28c8$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $7ac35536217f28c8$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $7ac35536217f28c8$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $7ac35536217f28c8$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $7ac35536217f28c8$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, unstable_onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7ac35536217f28c8$var$DefaultErrorComponent() {
    let error = $7ac35536217f28c8$export$ed527bf60f6e05f2();
    let message = $7ac35536217f28c8$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($7ac35536217f28c8$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, /* @__PURE__ */ $1kowh.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $1kowh.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $1kowh.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $1kowh.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, /* @__PURE__ */ $1kowh.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $1kowh.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $1kowh.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $7ac35536217f28c8$var$defaultErrorElement = /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$DefaultErrorComponent, null);
var $7ac35536217f28c8$var$RenderErrorBoundary = class extends $1kowh.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
};
function $7ac35536217f28c8$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $1kowh.useContext($7ac35536217f28c8$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $7ac35536217f28c8$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, unstable_onError = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState === null || dataRouterState === void 0 ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors === null || errors === void 0 ? void 0 : errors[m.route.id]) !== void 0);
        $7ac35536217f28c8$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    let onError = dataRouterState && unstable_onError ? (error, errorInfo)=>{
        var _dataRouterState_matches_, _dataRouterState_matches;
        var _dataRouterState_matches__params;
        unstable_onError(error, {
            location: dataRouterState.location,
            params: (_dataRouterState_matches__params = (_dataRouterState_matches = dataRouterState.matches) === null || _dataRouterState_matches === void 0 ? void 0 : (_dataRouterState_matches_ = _dataRouterState_matches[0]) === null || _dataRouterState_matches_ === void 0 ? void 0 : _dataRouterState_matches_.params) !== null && _dataRouterState_matches__params !== void 0 ? _dataRouterState_matches__params : {},
            unstable_pattern: $7ac35536217f28c8$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $7ac35536217f28c8$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7ac35536217f28c8$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $1kowh.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $7ac35536217f28c8$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $7ac35536217f28c8$var$useDataRouterContext(hookName) {
    let ctx = $1kowh.useContext($7ac35536217f28c8$export$2eeee58951ff3c1c);
    $7ac35536217f28c8$export$f5708dca728d7177(ctx, $7ac35536217f28c8$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $7ac35536217f28c8$var$useDataRouterState(hookName) {
    let state = $1kowh.useContext($7ac35536217f28c8$export$315e3ffb01f217);
    $7ac35536217f28c8$export$f5708dca728d7177(state, $7ac35536217f28c8$var$getDataRouterConsoleError(hookName));
    return state;
}
function $7ac35536217f28c8$var$useRouteContext(hookName) {
    let route = $1kowh.useContext($7ac35536217f28c8$export$aac280ed165a4397);
    $7ac35536217f28c8$export$f5708dca728d7177(route, $7ac35536217f28c8$var$getDataRouterConsoleError(hookName));
    return route;
}
function $7ac35536217f28c8$var$useCurrentRouteId(hookName) {
    let route = $7ac35536217f28c8$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $7ac35536217f28c8$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $7ac35536217f28c8$var$useRouteId() {
    return $7ac35536217f28c8$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $7ac35536217f28c8$export$d0fd4b7106de2769() {
    let state = $7ac35536217f28c8$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $7ac35536217f28c8$export$600dc272ed516c15() {
    let dataRouterContext = $7ac35536217f28c8$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $7ac35536217f28c8$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $1kowh.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $1kowh.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $7ac35536217f28c8$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7ac35536217f28c8$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $1kowh.useMemo(()=>matches.map((m)=>$7ac35536217f28c8$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $7ac35536217f28c8$export$1448a5050d252c4d() {
    let state = $7ac35536217f28c8$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $7ac35536217f28c8$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $7ac35536217f28c8$export$fd5d37484eab868d(routeId) {
    let state = $7ac35536217f28c8$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $7ac35536217f28c8$export$fdc00f3f26066d5e() {
    let state = $7ac35536217f28c8$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $7ac35536217f28c8$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $7ac35536217f28c8$export$ed527bf60f6e05f2() {
    var _state_errors;
    let error = $1kowh.useContext($7ac35536217f28c8$var$RouteErrorContext);
    let state = $7ac35536217f28c8$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $7ac35536217f28c8$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return (_state_errors = state.errors) === null || _state_errors === void 0 ? void 0 : _state_errors[routeId];
}
function $7ac35536217f28c8$export$78a72ddb39bdd145() {
    let value = $1kowh.useContext($7ac35536217f28c8$var$AwaitContext);
    return value === null || value === void 0 ? void 0 : value._data;
}
function $7ac35536217f28c8$export$17f53340677d5831() {
    let value = $1kowh.useContext($7ac35536217f28c8$var$AwaitContext);
    return value === null || value === void 0 ? void 0 : value._error;
}
var $7ac35536217f28c8$var$blockerId = 0;
function $7ac35536217f28c8$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7ac35536217f28c8$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $7ac35536217f28c8$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $1kowh.useState("");
    let blockerFunction = $1kowh.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $7ac35536217f28c8$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $7ac35536217f28c8$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $1kowh.useEffect(()=>{
        let key = String(++$7ac35536217f28c8$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $1kowh.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $7ac35536217f28c8$export$386d57f03f0b2883;
}
function $7ac35536217f28c8$var$useNavigateStable() {
    let { router: router } = $7ac35536217f28c8$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $7ac35536217f28c8$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $1kowh.useRef(false);
    $7ac35536217f28c8$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $1kowh.useCallback(async (to, options = {})=>{
        $7ac35536217f28c8$var$warning(activeRef.current, $7ac35536217f28c8$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $7ac35536217f28c8$var$alreadyWarned = {};
function $7ac35536217f28c8$var$warningOnce(key, cond, message) {
    if (!cond && !$7ac35536217f28c8$var$alreadyWarned[key]) {
        $7ac35536217f28c8$var$alreadyWarned[key] = true;
        $7ac35536217f28c8$var$warning(false, message);
    }
}
function $7ac35536217f28c8$export$3f79f0b98112cf57(...args) {
    var _state_actionData;
    const currentRouteId = $7ac35536217f28c8$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    var _args_;
    const id = (_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : currentRouteId;
    const state = $7ac35536217f28c8$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: (_state_actionData = state.actionData) === null || _state_actionData === void 0 ? void 0 : _state_actionData[id]
    };
}
// lib/server-runtime/warnings.ts
var $7ac35536217f28c8$var$alreadyWarned2 = {};
function $7ac35536217f28c8$export$5b28268982f175ba(condition, message) {
    if (!condition && !$7ac35536217f28c8$var$alreadyWarned2[message]) {
        $7ac35536217f28c8$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $7ac35536217f28c8$var$USE_OPTIMISTIC = "useOptimistic";
var $7ac35536217f28c8$var$useOptimisticImpl = $1kowh[$7ac35536217f28c8$var$USE_OPTIMISTIC];
var $7ac35536217f28c8$var$stableUseOptimisticSetter = ()=>void 0;
function $7ac35536217f28c8$var$useOptimisticSafe(val) {
    if ($7ac35536217f28c8$var$useOptimisticImpl) return $7ac35536217f28c8$var$useOptimisticImpl(val);
    else return [
        val,
        $7ac35536217f28c8$var$stableUseOptimisticSetter
    ];
}
function $7ac35536217f28c8$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($7ac35536217f28c8$export$945fecf35a8ef089) {
            if (route.element) $7ac35536217f28c8$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $1kowh.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($7ac35536217f28c8$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $7ac35536217f28c8$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $1kowh.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($7ac35536217f28c8$export$945fecf35a8ef089) {
            if (route.errorElement) $7ac35536217f28c8$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $1kowh.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $7ac35536217f28c8$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $7ac35536217f28c8$export$f30f7e456d254e83(routes, opts) {
    return $7ac35536217f28c8$export$baddd0131ee8c05b({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: $7ac35536217f28c8$var$createMemoryHistory({
            initialEntries: opts === null || opts === void 0 ? void 0 : opts.initialEntries,
            initialIndex: opts === null || opts === void 0 ? void 0 : opts.initialIndex
        }),
        hydrationData: opts === null || opts === void 0 ? void 0 : opts.hydrationData,
        routes: routes,
        hydrationRouteProperties: $7ac35536217f28c8$export$e2fd2c03906469db,
        mapRouteProperties: $7ac35536217f28c8$export$9269a41d8c4635e,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        unstable_instrumentations: opts === null || opts === void 0 ? void 0 : opts.unstable_instrumentations
    }).initialize();
}
var $7ac35536217f28c8$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $7ac35536217f28c8$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError, unstable_useTransitions: unstable_useTransitions }) {
    let [_state, setStateImpl] = $1kowh.useState(router.state);
    let [state, setOptimisticState] = $7ac35536217f28c8$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $1kowh.useState();
    let [vtContext, setVtContext] = $1kowh.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $1kowh.useState();
    let [transition, setTransition] = $1kowh.useState();
    let [interruption, setInterruption] = $1kowh.useState();
    let fetcherData = $1kowh.useRef(/* @__PURE__ */ new Map());
    let setState = $1kowh.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && unstable_onError) Object.values(newErrors).forEach((error)=>{
            var _newState_matches_;
            var _newState_matches__params;
            return unstable_onError(error, {
                location: newState.location,
                params: (_newState_matches__params = (_newState_matches_ = newState.matches[0]) === null || _newState_matches_ === void 0 ? void 0 : _newState_matches_.params) !== null && _newState_matches__params !== void 0 ? _newState_matches__params : {},
                unstable_pattern: $7ac35536217f28c8$var$getRoutePattern(newState.matches)
            });
        });
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $7ac35536217f28c8$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $7ac35536217f28c8$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $1kowh.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$7ac35536217f28c8$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        unstable_onError
    ]);
    $1kowh.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $1kowh.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $7ac35536217f28c8$var$Deferred());
    }, [
        vtContext
    ]);
    $1kowh.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $1kowh.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$7ac35536217f28c8$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $1kowh.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $1kowh.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $1kowh.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $1kowh.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    return /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions === true
    }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    })))))), null);
}
function $7ac35536217f28c8$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $7ac35536217f28c8$var$MemoizedDataRoutes = $1kowh.memo($7ac35536217f28c8$var$DataRoutes);
function $7ac35536217f28c8$var$DataRoutes({ routes: routes, future: future, state: state, unstable_onError: unstable_onError }) {
    return $7ac35536217f28c8$var$useRoutesImpl(routes, void 0, state, unstable_onError, future);
}
function $7ac35536217f28c8$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $1kowh.useRef();
    if (historyRef.current == null) historyRef.current = $7ac35536217f28c8$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1kowh.useState({
        action: history.action,
        location: history.location
    });
    let setState = $1kowh.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $1kowh.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $1kowh.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function $7ac35536217f28c8$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $7ac35536217f28c8$export$f5708dca728d7177($7ac35536217f28c8$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $1kowh.useContext($7ac35536217f28c8$export$3044ab7fdabeaee6);
    $7ac35536217f28c8$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $1kowh.useContext($7ac35536217f28c8$export$aac280ed165a4397);
    let { pathname: locationPathname } = $7ac35536217f28c8$export$45d76561a5302f2b();
    let navigate = $7ac35536217f28c8$export$9770f232ac06a008();
    let path = $7ac35536217f28c8$var$resolveTo(to, $7ac35536217f28c8$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $1kowh.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $7ac35536217f28c8$export$910ae8079b2c2852(props) {
    return $7ac35536217f28c8$export$a3be3530d8e40d0b(props.context);
}
function $7ac35536217f28c8$export$e7b0ac011bb776c6(props) {
    $7ac35536217f28c8$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $7ac35536217f28c8$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $7ac35536217f28c8$export$f5708dca728d7177(!$7ac35536217f28c8$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $1kowh.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $7ac35536217f28c8$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $1kowh.useMemo(()=>{
        let trailingPathname = $7ac35536217f28c8$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $7ac35536217f28c8$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $7ac35536217f28c8$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $7ac35536217f28c8$export$5d3fca4a98652595($7ac35536217f28c8$export$16da398f5434bdec(children), location);
}
function $7ac35536217f28c8$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $1kowh.useContext($7ac35536217f28c8$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $1kowh.useContext($7ac35536217f28c8$export$315e3ffb01f217);
    let onError = $1kowh.useCallback((error, errorInfo)=>{
        var _dataRouterStateContext_matches_;
        if (dataRouterContext && dataRouterContext.unstable_onError && dataRouterStateContext) dataRouterContext.unstable_onError(error, {
            location: dataRouterStateContext.location,
            params: ((_dataRouterStateContext_matches_ = dataRouterStateContext.matches[0]) === null || _dataRouterStateContext_matches_ === void 0 ? void 0 : _dataRouterStateContext_matches_.params) || {},
            unstable_pattern: $7ac35536217f28c8$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$ResolveAwait, null, children));
}
var $7ac35536217f28c8$var$AwaitErrorBoundary = class extends $1kowh.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                var _this_props_onError, _this_props;
                (_this_props_onError = (_this_props = this.props).onError) === null || _this_props_onError === void 0 ? void 0 : _this_props_onError.call(_this_props, error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
};
function $7ac35536217f28c8$var$ResolveAwait({ children: children }) {
    let data2 = $7ac35536217f28c8$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, toRender);
}
function $7ac35536217f28c8$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $1kowh.Children.forEach(children, (element, index)=>{
        if (!$1kowh.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $1kowh.Fragment) {
            routes.push.apply(routes, $7ac35536217f28c8$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $7ac35536217f28c8$export$f5708dca728d7177(element.type === $7ac35536217f28c8$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $7ac35536217f28c8$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7ac35536217f28c8$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $7ac35536217f28c8$export$9b5b6d122dea0c88 = $7ac35536217f28c8$export$16da398f5434bdec;
function $7ac35536217f28c8$export$daf73786167a7f72(matches) {
    return $7ac35536217f28c8$var$_renderMatches(matches);
}
function $7ac35536217f28c8$var$useRouteComponentProps() {
    return {
        params: $7ac35536217f28c8$export$99eaa27ddbbb95ef(),
        loaderData: $7ac35536217f28c8$export$1448a5050d252c4d(),
        actionData: $7ac35536217f28c8$export$fdc00f3f26066d5e(),
        matches: $7ac35536217f28c8$export$2378eb7f5ff86053()
    };
}
function $7ac35536217f28c8$export$6c4f3826290c37af({ children: children }) {
    const props = $7ac35536217f28c8$var$useRouteComponentProps();
    return $1kowh.cloneElement(children, props);
}
function $7ac35536217f28c8$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $7ac35536217f28c8$var$useRouteComponentProps();
        return $1kowh.createElement(Component4, props);
    };
}
function $7ac35536217f28c8$var$useHydrateFallbackProps() {
    return {
        params: $7ac35536217f28c8$export$99eaa27ddbbb95ef(),
        loaderData: $7ac35536217f28c8$export$1448a5050d252c4d(),
        actionData: $7ac35536217f28c8$export$fdc00f3f26066d5e()
    };
}
function $7ac35536217f28c8$export$f8cff34f39c1932a({ children: children }) {
    const props = $7ac35536217f28c8$var$useHydrateFallbackProps();
    return $1kowh.cloneElement(children, props);
}
function $7ac35536217f28c8$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $7ac35536217f28c8$var$useHydrateFallbackProps();
        return $1kowh.createElement(HydrateFallback, props);
    };
}
function $7ac35536217f28c8$var$useErrorBoundaryProps() {
    return {
        params: $7ac35536217f28c8$export$99eaa27ddbbb95ef(),
        loaderData: $7ac35536217f28c8$export$1448a5050d252c4d(),
        actionData: $7ac35536217f28c8$export$fdc00f3f26066d5e(),
        error: $7ac35536217f28c8$export$ed527bf60f6e05f2()
    };
}
function $7ac35536217f28c8$export$e5afde5c4b6d747b({ children: children }) {
    const props = $7ac35536217f28c8$var$useErrorBoundaryProps();
    return $1kowh.cloneElement(children, props);
}
function $7ac35536217f28c8$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $7ac35536217f28c8$var$useErrorBoundaryProps();
        return $1kowh.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $7ac35536217f28c8$var$defaultMethod = "get";
var $7ac35536217f28c8$var$defaultEncType = "application/x-www-form-urlencoded";
function $7ac35536217f28c8$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $7ac35536217f28c8$var$isButtonElement(object) {
    return $7ac35536217f28c8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $7ac35536217f28c8$var$isFormElement(object) {
    return $7ac35536217f28c8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $7ac35536217f28c8$var$isInputElement(object) {
    return $7ac35536217f28c8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $7ac35536217f28c8$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $7ac35536217f28c8$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$7ac35536217f28c8$var$isModifiedEvent(event);
}
function $7ac35536217f28c8$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $7ac35536217f28c8$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $7ac35536217f28c8$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $7ac35536217f28c8$var$_formDataSupportsSubmitter = null;
function $7ac35536217f28c8$var$isFormDataSubmitterSupported() {
    if ($7ac35536217f28c8$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $7ac35536217f28c8$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $7ac35536217f28c8$var$_formDataSupportsSubmitter = true;
    }
    return $7ac35536217f28c8$var$_formDataSupportsSubmitter;
}
var $7ac35536217f28c8$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $7ac35536217f28c8$var$getFormEncType(encType) {
    if (encType != null && !$7ac35536217f28c8$var$supportedFormEncTypes.has(encType)) {
        $7ac35536217f28c8$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$7ac35536217f28c8$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $7ac35536217f28c8$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($7ac35536217f28c8$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $7ac35536217f28c8$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $7ac35536217f28c8$var$defaultMethod;
        encType = $7ac35536217f28c8$var$getFormEncType(target.getAttribute("enctype")) || $7ac35536217f28c8$var$defaultEncType;
        formData = new FormData(target);
    } else if ($7ac35536217f28c8$var$isButtonElement(target) || $7ac35536217f28c8$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $7ac35536217f28c8$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $7ac35536217f28c8$var$defaultMethod;
        encType = $7ac35536217f28c8$var$getFormEncType(target.getAttribute("formenctype")) || $7ac35536217f28c8$var$getFormEncType(form.getAttribute("enctype")) || $7ac35536217f28c8$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$7ac35536217f28c8$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($7ac35536217f28c8$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $7ac35536217f28c8$var$defaultMethod;
        action = null;
        encType = $7ac35536217f28c8$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $7ac35536217f28c8$var$HOLE = -1;
var $7ac35536217f28c8$var$NAN = -2;
var $7ac35536217f28c8$var$NEGATIVE_INFINITY = -3;
var $7ac35536217f28c8$var$NEGATIVE_ZERO = -4;
var $7ac35536217f28c8$var$NULL = -5;
var $7ac35536217f28c8$var$POSITIVE_INFINITY = -6;
var $7ac35536217f28c8$var$UNDEFINED = -7;
var $7ac35536217f28c8$var$TYPE_BIGINT = "B";
var $7ac35536217f28c8$var$TYPE_DATE = "D";
var $7ac35536217f28c8$var$TYPE_ERROR = "E";
var $7ac35536217f28c8$var$TYPE_MAP = "M";
var $7ac35536217f28c8$var$TYPE_NULL_OBJECT = "N";
var $7ac35536217f28c8$var$TYPE_PROMISE = "P";
var $7ac35536217f28c8$var$TYPE_REGEXP = "R";
var $7ac35536217f28c8$var$TYPE_SET = "S";
var $7ac35536217f28c8$var$TYPE_SYMBOL = "Y";
var $7ac35536217f28c8$var$TYPE_URL = "U";
var $7ac35536217f28c8$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $7ac35536217f28c8$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $7ac35536217f28c8$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $7ac35536217f28c8$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $7ac35536217f28c8$var$UNDEFINED;
    if (input === null) return $7ac35536217f28c8$var$NULL;
    if (Number.isNaN(input)) return $7ac35536217f28c8$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $7ac35536217f28c8$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $7ac35536217f28c8$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $7ac35536217f28c8$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $7ac35536217f28c8$var$stringify.call(this, input, index);
    return index;
}
function $7ac35536217f28c8$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$7ac35536217f28c8$var$flatten.call(this, k)}":${$7ac35536217f28c8$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$7ac35536217f28c8$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$7ac35536217f28c8$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$7ac35536217f28c8$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$7ac35536217f28c8$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $7ac35536217f28c8$var$flatten.call(this, input2[i]) : $7ac35536217f28c8$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$7ac35536217f28c8$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$7ac35536217f28c8$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$7ac35536217f28c8$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$7ac35536217f28c8$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$7ac35536217f28c8$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$7ac35536217f28c8$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$7ac35536217f28c8$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $7ac35536217f28c8$var$flatten.call(this, k),
                                    $7ac35536217f28c8$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$7ac35536217f28c8$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$7ac35536217f28c8$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$7ac35536217f28c8$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$7ac35536217f28c8$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($7ac35536217f28c8$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$7ac35536217f28c8$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$7ac35536217f28c8$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $7ac35536217f28c8$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $7ac35536217f28c8$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $7ac35536217f28c8$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $7ac35536217f28c8$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $7ac35536217f28c8$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $7ac35536217f28c8$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $7ac35536217f28c8$var$hydrate.call(this, startIndex);
}
function $7ac35536217f28c8$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $7ac35536217f28c8$var$UNDEFINED:
                set(void 0);
                continue;
            case $7ac35536217f28c8$var$NULL:
                set(null);
                continue;
            case $7ac35536217f28c8$var$NAN:
                set(NaN);
                continue;
            case $7ac35536217f28c8$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $7ac35536217f28c8$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $7ac35536217f28c8$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $7ac35536217f28c8$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $7ac35536217f28c8$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $7ac35536217f28c8$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $7ac35536217f28c8$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $7ac35536217f28c8$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $7ac35536217f28c8$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $7ac35536217f28c8$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $7ac35536217f28c8$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $7ac35536217f28c8$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $7ac35536217f28c8$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $7ac35536217f28c8$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $7ac35536217f28c8$var$globalObj && $7ac35536217f28c8$var$globalObj[errorType] ? new $7ac35536217f28c8$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $7ac35536217f28c8$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $7ac35536217f28c8$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $7ac35536217f28c8$var$decode(readable, options) {
    const { plugins: plugins } = options !== null && options !== void 0 ? options : {};
    const done = new $7ac35536217f28c8$var$Deferred2();
    const reader = readable.pipeThrough($7ac35536217f28c8$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $7ac35536217f28c8$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $7ac35536217f28c8$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $7ac35536217f28c8$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $7ac35536217f28c8$var$unflatten.call(this, line)
    };
}
async function $7ac35536217f28c8$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $7ac35536217f28c8$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $7ac35536217f28c8$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $7ac35536217f28c8$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $7ac35536217f28c8$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $7ac35536217f28c8$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options !== null && options !== void 0 ? options : {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $7ac35536217f28c8$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $7ac35536217f28c8$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$7ac35536217f28c8$var$TYPE_PROMISE}${deferredId}:[["${$7ac35536217f28c8$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$7ac35536217f28c8$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$7ac35536217f28c8$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $7ac35536217f28c8$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$7ac35536217f28c8$var$TYPE_ERROR}${deferredId}:[["${$7ac35536217f28c8$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$7ac35536217f28c8$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$7ac35536217f28c8$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $7ac35536217f28c8$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $7ac35536217f28c8$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $7ac35536217f28c8$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $7ac35536217f28c8$export$4cf11838cdc2a8a8(html) {
    return html.replace($7ac35536217f28c8$var$ESCAPE_REGEX, (match)=>$7ac35536217f28c8$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $7ac35536217f28c8$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $7ac35536217f28c8$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $7ac35536217f28c8$var$SingleFetchNoResultError = class extends Error {
};
var $7ac35536217f28c8$export$ae9272e641ead836 = 202;
var $7ac35536217f28c8$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $7ac35536217f28c8$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $1kowh.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$7ac35536217f28c8$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, scriptTag, /* @__PURE__ */ $1kowh.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, scriptTag, /* @__PURE__ */ $1kowh.createElement($1kowh.Suspense, null, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $7ac35536217f28c8$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = $7ac35536217f28c8$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $7ac35536217f28c8$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule === null || routeModule === void 0 ? void 0 : routeModule.shouldRevalidate)
        };
    }, $7ac35536217f28c8$var$fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $7ac35536217f28c8$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $7ac35536217f28c8$var$singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $7ac35536217f28c8$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return $7ac35536217f28c8$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return $7ac35536217f28c8$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut);
    };
}
async function $7ac35536217f28c8$var$singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $7ac35536217f28c8$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $7ac35536217f28c8$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($7ac35536217f28c8$export$3f1eb41d9a6a6a27(result.result) || $7ac35536217f28c8$export$972111febbeef05b(result.result) || $7ac35536217f28c8$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $7ac35536217f28c8$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $7ac35536217f28c8$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return $7ac35536217f28c8$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $7ac35536217f28c8$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$7ac35536217f28c8$var$createDeferred2());
    let singleFetchDfd = $7ac35536217f28c8$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return $7ac35536217f28c8$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $7ac35536217f28c8$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $7ac35536217f28c8$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $7ac35536217f28c8$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    var _results_match_route_id;
                    middlewareError = routeResult.error;
                    if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.result) == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $7ac35536217f28c8$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $7ac35536217f28c8$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $7ac35536217f28c8$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return $7ac35536217f28c8$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $7ac35536217f28c8$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $7ac35536217f28c8$export$7b977381851b2c(reqUrl, basename, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = `_root.${extension}`;
    else if (basename && $7ac35536217f28c8$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    return url;
}
async function $7ac35536217f28c8$var$fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request: request } = args;
    let url = $7ac35536217f28c8$export$7b977381851b2c(request.url, basename, "data");
    if (request.method === "GET") {
        url = $7ac35536217f28c8$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $7ac35536217f28c8$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $7ac35536217f28c8$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $7ac35536217f28c8$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($7ac35536217f28c8$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $7ac35536217f28c8$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $7ac35536217f28c8$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($7ac35536217f28c8$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$7ac35536217f28c8$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes === null || targetRoutes === void 0 ? void 0 : targetRoutes[0];
            $7ac35536217f28c8$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $7ac35536217f28c8$export$4023ad4ecd4126a2(body, global) {
    return $7ac35536217f28c8$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $7ac35536217f28c8$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$7ac35536217f28c8$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $7ac35536217f28c8$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $7ac35536217f28c8$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $7ac35536217f28c8$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $7ac35536217f28c8$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $7ac35536217f28c8$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $7ac35536217f28c8$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $7ac35536217f28c8$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        var _module_links;
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            (module === null || module === void 0 ? void 0 : (_module_links = module.links) === null || _module_links === void 0 ? void 0 : _module_links.call(module)) || []
        ];
    }).flat(2);
    let preloads = $7ac35536217f28c8$var$getModuleLinkHrefs(matches, manifest);
    return $7ac35536217f28c8$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $7ac35536217f28c8$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $7ac35536217f28c8$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $7ac35536217f28c8$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($7ac35536217f28c8$var$prefetchStyleLink));
}
async function $7ac35536217f28c8$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$7ac35536217f28c8$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$7ac35536217f28c8$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$7ac35536217f28c8$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($7ac35536217f28c8$var$prefetchStyleLink));
}
async function $7ac35536217f28c8$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $7ac35536217f28c8$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $7ac35536217f28c8$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $7ac35536217f28c8$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $7ac35536217f28c8$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $7ac35536217f28c8$var$dedupeLinkDescriptors(links.flat(1).filter($7ac35536217f28c8$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $7ac35536217f28c8$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        var // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        _currentMatches_index_route_path;
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || ((_currentMatches_index_route_path = currentMatches[index].route.path) === null || _currentMatches_index_route_path === void 0 ? void 0 : _currentMatches_index_route_path.endsWith("*")) && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            var _currentMatches_;
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: ((_currentMatches_ = currentMatches[0]) === null || _currentMatches_ === void 0 ? void 0 : _currentMatches_.params) || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $7ac35536217f28c8$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $7ac35536217f28c8$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $7ac35536217f28c8$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $7ac35536217f28c8$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $7ac35536217f28c8$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$7ac35536217f28c8$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($7ac35536217f28c8$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $7ac35536217f28c8$var$_isPreloadSupported;
function $7ac35536217f28c8$var$isPreloadSupported() {
    if ($7ac35536217f28c8$var$_isPreloadSupported !== void 0) return $7ac35536217f28c8$var$_isPreloadSupported;
    let el = document.createElement("link");
    $7ac35536217f28c8$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $7ac35536217f28c8$var$_isPreloadSupported;
}
function $7ac35536217f28c8$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $7ac35536217f28c8$export$945fecf35a8ef089 ? /* @__PURE__ */ $1kowh.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $7ac35536217f28c8$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $7ac35536217f28c8$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $7ac35536217f28c8$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $7ac35536217f28c8$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$RemixRootDefaultErrorBoundary, {
            error: $7ac35536217f28c8$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $1kowh.createElement(routeModule.Layout, null, /* @__PURE__ */ $1kowh.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $1kowh.createElement(routeModule.Layout, null, /* @__PURE__ */ $1kowh.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $1kowh.createElement(routeModule.Layout, null, /* @__PURE__ */ $1kowh.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $7ac35536217f28c8$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $7ac35536217f28c8$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $7ac35536217f28c8$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$7ac35536217f28c8$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $7ac35536217f28c8$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $7ac35536217f28c8$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $7ac35536217f28c8$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $7ac35536217f28c8$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $7ac35536217f28c8$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $7ac35536217f28c8$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $7ac35536217f28c8$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $7ac35536217f28c8$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $7ac35536217f28c8$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $7ac35536217f28c8$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $7ac35536217f28c8$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $7ac35536217f28c8$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $7ac35536217f28c8$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            var _initialState_loaderData, _initialState_errors, _routeModule_clientLoader;
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$7ac35536217f28c8$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $7ac35536217f28c8$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState === null || initialState === void 0 ? void 0 : (_initialState_loaderData = initialState.loaderData) === null || _initialState_loaderData === void 0 ? void 0 : _initialState_loaderData[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState === null || initialState === void 0 ? void 0 : (_initialState_errors = initialState.errors) === null || _initialState_errors === void 0 ? void 0 : _initialState_errors[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (((_routeModule_clientLoader = routeModule.clientLoader) === null || _routeModule_clientLoader === void 0 ? void 0 : _routeModule_clientLoader.hydrate) === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $7ac35536217f28c8$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $7ac35536217f28c8$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $7ac35536217f28c8$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $7ac35536217f28c8$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $7ac35536217f28c8$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $7ac35536217f28c8$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $7ac35536217f28c8$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $7ac35536217f28c8$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $7ac35536217f28c8$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $7ac35536217f28c8$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $7ac35536217f28c8$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $7ac35536217f28c8$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $7ac35536217f28c8$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $7ac35536217f28c8$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $7ac35536217f28c8$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $7ac35536217f28c8$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $7ac35536217f28c8$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $7ac35536217f28c8$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $7ac35536217f28c8$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $7ac35536217f28c8$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $7ac35536217f28c8$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $7ac35536217f28c8$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $7ac35536217f28c8$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $7ac35536217f28c8$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $7ac35536217f28c8$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $7ac35536217f28c8$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $7ac35536217f28c8$var$nextPaths = /* @__PURE__ */ new Set();
var $7ac35536217f28c8$var$discoveredPathsMaxSize = 1e3;
var $7ac35536217f28c8$var$discoveredPaths = /* @__PURE__ */ new Set();
var $7ac35536217f28c8$var$URL_LIMIT = 7680;
function $7ac35536217f28c8$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $7ac35536217f28c8$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $7ac35536217f28c8$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $7ac35536217f28c8$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$7ac35536217f28c8$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($7ac35536217f28c8$var$discoveredPaths.has(path)) return;
        await $7ac35536217f28c8$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $7ac35536217f28c8$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $1kowh.useEffect(()=>{
        var // @ts-expect-error - TS doesn't know about this yet
        _window_navigator_connection, _window_navigator;
        if (!$7ac35536217f28c8$var$isFogOfWarEnabled(routeDiscovery, ssr) || ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_connection = _window_navigator.connection) === null || _window_navigator_connection === void 0 ? void 0 : _window_navigator_connection.saveData) === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$7ac35536217f28c8$var$discoveredPaths.has(pathname)) $7ac35536217f28c8$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($7ac35536217f28c8$var$nextPaths.keys()).filter((path)=>{
                if ($7ac35536217f28c8$var$discoveredPaths.has(path)) {
                    $7ac35536217f28c8$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $7ac35536217f28c8$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $7ac35536217f28c8$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $7ac35536217f28c8$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $7ac35536217f28c8$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $7ac35536217f28c8$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($7ac35536217f28c8$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $7ac35536217f28c8$var$URL_LIMIT) {
        $7ac35536217f28c8$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($7ac35536217f28c8$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($7ac35536217f28c8$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($7ac35536217f28c8$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$7ac35536217f28c8$var$addToFifoQueue(p, $7ac35536217f28c8$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $7ac35536217f28c8$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $7ac35536217f28c8$var$addToFifoQueue(path, queue) {
    if (queue.size >= $7ac35536217f28c8$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $7ac35536217f28c8$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $7ac35536217f28c8$var$useDataRouterContext2() {
    let context = $1kowh.useContext($7ac35536217f28c8$export$2eeee58951ff3c1c);
    $7ac35536217f28c8$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $7ac35536217f28c8$var$useDataRouterStateContext() {
    let context = $1kowh.useContext($7ac35536217f28c8$export$315e3ffb01f217);
    $7ac35536217f28c8$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $7ac35536217f28c8$export$208d6a3bc3aa62bd = $1kowh.createContext(void 0);
$7ac35536217f28c8$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $7ac35536217f28c8$var$useFrameworkContext() {
    let context = $1kowh.useContext($7ac35536217f28c8$export$208d6a3bc3aa62bd);
    $7ac35536217f28c8$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $7ac35536217f28c8$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $1kowh.useContext($7ac35536217f28c8$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $1kowh.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $1kowh.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $1kowh.useRef(null);
    $1kowh.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $1kowh.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $7ac35536217f28c8$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $7ac35536217f28c8$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $7ac35536217f28c8$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $7ac35536217f28c8$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $7ac35536217f28c8$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $7ac35536217f28c8$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $7ac35536217f28c8$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$7ac35536217f28c8$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $7ac35536217f28c8$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $7ac35536217f28c8$export$b2e089eb3692b073({ nonce: nonce }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $7ac35536217f28c8$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $7ac35536217f28c8$var$useDataRouterStateContext();
    let matches = $7ac35536217f28c8$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $1kowh.useMemo(()=>$7ac35536217f28c8$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $1kowh.createElement("style", {
        [$7ac35536217f28c8$export$7e4ed4715c00dab0]: "",
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $1kowh.createElement("link", {
        [$7ac35536217f28c8$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce
    }) : null, keyedLinks.map(({ key: key, link: link })=>$7ac35536217f28c8$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link
        }) : /* @__PURE__ */ $1kowh.createElement("link", {
            key: key,
            nonce: nonce,
            ...link
        })));
}
function $7ac35536217f28c8$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $7ac35536217f28c8$var$useDataRouterContext2();
    let matches = $1kowh.useMemo(()=>$7ac35536217f28c8$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $7ac35536217f28c8$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $7ac35536217f28c8$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $1kowh.useState([]);
    $1kowh.useEffect(()=>{
        let interrupted = false;
        $7ac35536217f28c8$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $7ac35536217f28c8$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $7ac35536217f28c8$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $7ac35536217f28c8$var$useFrameworkContext();
    let { basename: basename } = $7ac35536217f28c8$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $7ac35536217f28c8$var$useDataRouterStateContext();
    let newMatchesForData = $1kowh.useMemo(()=>$7ac35536217f28c8$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $1kowh.useMemo(()=>$7ac35536217f28c8$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $1kowh.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            var _routeModules_m_route_id;
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && ((_routeModules_m_route_id = routeModules[m.route.id]) === null || _routeModules_m_route_id === void 0 ? void 0 : _routeModules_m_route_id.shouldRevalidate)) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $7ac35536217f28c8$export$7b977381851b2c(page, basename, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $1kowh.useMemo(()=>$7ac35536217f28c8$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $7ac35536217f28c8$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $1kowh.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $1kowh.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $1kowh.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link
        })));
}
function $7ac35536217f28c8$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $7ac35536217f28c8$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $7ac35536217f28c8$var$useDataRouterStateContext();
    let location = $7ac35536217f28c8$export$45d76561a5302f2b();
    let _matches = $7ac35536217f28c8$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule === null || routeModule === void 0 ? void 0 : routeModule.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$7ac35536217f28c8$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $1kowh.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $1kowh.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            var _metaProps_charSet;
            (_metaProps_charSet = metaProps.charSet) !== null && _metaProps_charSet !== void 0 ? _metaProps_charSet : metaProps.charSet = metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $1kowh.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $1kowh.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $7ac35536217f28c8$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $1kowh.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $7ac35536217f28c8$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $7ac35536217f28c8$var$isHydrated = false;
function $7ac35536217f28c8$export$3be068dde909e563() {
    $7ac35536217f28c8$var$isHydrated = true;
}
function $7ac35536217f28c8$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $7ac35536217f28c8$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $7ac35536217f28c8$var$useDataRouterContext2();
    let { matches: routerMatches } = $7ac35536217f28c8$var$useDataRouterStateContext();
    let isRSCRouterContext = $7ac35536217f28c8$var$useIsRSCRouterContext();
    let enableFogOfWar = $7ac35536217f28c8$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $7ac35536217f28c8$var$getActiveMatches(routerMatches, null, isSpaMode);
    $1kowh.useEffect(()=>{
        $7ac35536217f28c8$export$3be068dde909e563();
    }, []);
    let initialScripts = $1kowh.useMemo(()=>{
        var _manifest_hmr;
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${((_manifest_hmr = manifest.hmr) === null || _manifest_hmr === void 0 ? void 0 : _manifest_hmr.runtime) ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $7ac35536217f28c8$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($7ac35536217f28c8$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, /* @__PURE__ */ $1kowh.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $1kowh.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $7ac35536217f28c8$var$isHydrated || isRSCRouterContext ? [] : $7ac35536217f28c8$var$dedupe(manifest.entry.imports.concat($7ac35536217f28c8$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $7ac35536217f28c8$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $7ac35536217f28c8$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $1kowh.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $1kowh.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $1kowh.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $1kowh.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $7ac35536217f28c8$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $7ac35536217f28c8$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $7ac35536217f28c8$export$32e57f52df4b6e34 = class extends $1kowh.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
};
function $7ac35536217f28c8$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $1kowh.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($7ac35536217f28c8$export$972111febbeef05b(error)) return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $1kowh.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $7ac35536217f28c8$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $1kowh.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $1kowh.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $7ac35536217f28c8$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    var _routeModules_root;
    let { routeModules: routeModules } = $7ac35536217f28c8$var$useFrameworkContext();
    if (((_routeModules_root = routeModules.root) === null || _routeModules_root === void 0 ? void 0 : _routeModules_root.Layout) && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $1kowh.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $1kowh.createElement("head", null, /* @__PURE__ */ $1kowh.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $1kowh.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $1kowh.createElement("title", null, title)), /* @__PURE__ */ $1kowh.createElement("body", null, /* @__PURE__ */ $1kowh.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$ff0bf87698939488, null) : null)));
}
var $7ac35536217f28c8$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($7ac35536217f28c8$var$isBrowser) window.__reactRouterVersion = "7.10.1";
} catch (e) {}
function $7ac35536217f28c8$export$1f3f55432a00e06d(routes, opts) {
    return $7ac35536217f28c8$export$baddd0131ee8c05b({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: $7ac35536217f28c8$export$719fc203c4e16dee({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || $7ac35536217f28c8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $7ac35536217f28c8$export$9269a41d8c4635e,
        hydrationRouteProperties: $7ac35536217f28c8$export$e2fd2c03906469db,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        unstable_instrumentations: opts === null || opts === void 0 ? void 0 : opts.unstable_instrumentations
    }).initialize();
}
function $7ac35536217f28c8$export$1ba7ed8a3a7b3765(routes, opts) {
    return $7ac35536217f28c8$export$baddd0131ee8c05b({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: $7ac35536217f28c8$var$createHashHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || $7ac35536217f28c8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $7ac35536217f28c8$export$9269a41d8c4635e,
        hydrationRouteProperties: $7ac35536217f28c8$export$e2fd2c03906469db,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        unstable_instrumentations: opts === null || opts === void 0 ? void 0 : opts.unstable_instrumentations
    }).initialize();
}
function $7ac35536217f28c8$var$parseHydrationData() {
    var _window;
    let state = (_window = window) === null || _window === void 0 ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $7ac35536217f28c8$var$deserializeErrors(state.errors)
    };
    return state;
}
function $7ac35536217f28c8$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $7ac35536217f28c8$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $7ac35536217f28c8$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $1kowh.useRef();
    if (historyRef.current == null) historyRef.current = $7ac35536217f28c8$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1kowh.useState({
        action: history.action,
        location: history.location
    });
    let setState = $1kowh.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $1kowh.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $1kowh.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function $7ac35536217f28c8$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $1kowh.useRef();
    if (historyRef.current == null) historyRef.current = $7ac35536217f28c8$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1kowh.useState({
        action: history.action,
        location: history.location
    });
    let setState = $1kowh.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $1kowh.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $1kowh.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function $7ac35536217f28c8$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $1kowh.useState({
        action: history.action,
        location: history.location
    });
    let setState = $1kowh.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $1kowh.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $1kowh.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
$7ac35536217f28c8$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $7ac35536217f28c8$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $7ac35536217f28c8$export$a6c7ac8248d6e38a = $1kowh.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename, unstable_useTransitions: unstable_useTransitions } = $1kowh.useContext($7ac35536217f28c8$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $7ac35536217f28c8$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($7ac35536217f28c8$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $7ac35536217f28c8$export$b69e3301ce081aa3(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $7ac35536217f28c8$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $7ac35536217f28c8$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $7ac35536217f28c8$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $7ac35536217f28c8$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $1kowh.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $7ac35536217f28c8$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, link, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$7ac35536217f28c8$export$a6c7ac8248d6e38a.displayName = "Link";
var $7ac35536217f28c8$export$b0d92dbee9b5b60d = $1kowh.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $7ac35536217f28c8$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $7ac35536217f28c8$export$45d76561a5302f2b();
    let routerState = $1kowh.useContext($7ac35536217f28c8$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $1kowh.useContext($7ac35536217f28c8$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7ac35536217f28c8$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $7ac35536217f28c8$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$7ac35536217f28c8$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $7ac35536217f28c8$export$a7fed597f4b8afd8 = $1kowh.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $7ac35536217f28c8$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $1kowh.useContext($7ac35536217f28c8$export$3044ab7fdabeaee6);
    let submit = $7ac35536217f28c8$export$47c85c6e3a081d3();
    let formAction = $7ac35536217f28c8$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $7ac35536217f28c8$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition
            });
        if (unstable_useTransitions && navigate !== false) $1kowh.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $1kowh.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$7ac35536217f28c8$export$a7fed597f4b8afd8.displayName = "Form";
function $7ac35536217f28c8$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $1kowh.useContext($7ac35536217f28c8$export$208d6a3bc3aa62bd);
    let { basename: basename } = $1kowh.useContext($7ac35536217f28c8$export$3044ab7fdabeaee6);
    let location = $7ac35536217f28c8$export$45d76561a5302f2b();
    let matches = $7ac35536217f28c8$export$2378eb7f5ff86053();
    $7ac35536217f28c8$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $1kowh.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $7ac35536217f28c8$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $1kowh.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $7ac35536217f28c8$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$7ac35536217f28c8$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $7ac35536217f28c8$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $7ac35536217f28c8$var$useDataRouterContext3(hookName) {
    let ctx = $1kowh.useContext($7ac35536217f28c8$export$2eeee58951ff3c1c);
    $7ac35536217f28c8$export$f5708dca728d7177(ctx, $7ac35536217f28c8$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $7ac35536217f28c8$var$useDataRouterState2(hookName) {
    let state = $1kowh.useContext($7ac35536217f28c8$export$315e3ffb01f217);
    $7ac35536217f28c8$export$f5708dca728d7177(state, $7ac35536217f28c8$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $7ac35536217f28c8$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $7ac35536217f28c8$export$9770f232ac06a008();
    let location = $7ac35536217f28c8$export$45d76561a5302f2b();
    let path = $7ac35536217f28c8$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $1kowh.useCallback((event)=>{
        if ($7ac35536217f28c8$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $7ac35536217f28c8$export$fe53371bee54353d(location) === $7ac35536217f28c8$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition
                });
            if (unstable_useTransitions) $1kowh.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_useTransitions
    ]);
}
function $7ac35536217f28c8$export$f1a78c17382fe22a(defaultInit) {
    $7ac35536217f28c8$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $1kowh.useRef($7ac35536217f28c8$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $1kowh.useRef(false);
    let location = $7ac35536217f28c8$export$45d76561a5302f2b();
    let searchParams = $1kowh.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $7ac35536217f28c8$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $7ac35536217f28c8$export$9770f232ac06a008();
    let setSearchParams = $1kowh.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $7ac35536217f28c8$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $7ac35536217f28c8$var$fetcherId = 0;
var $7ac35536217f28c8$var$getUniqueFetcherId = ()=>`__${String(++$7ac35536217f28c8$var$fetcherId)}__`;
function $7ac35536217f28c8$export$47c85c6e3a081d3() {
    let { router: router } = $7ac35536217f28c8$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $1kowh.useContext($7ac35536217f28c8$export$3044ab7fdabeaee6);
    let currentRouteId = $7ac35536217f28c8$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $1kowh.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $7ac35536217f28c8$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $7ac35536217f28c8$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $7ac35536217f28c8$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $1kowh.useContext($7ac35536217f28c8$export$3044ab7fdabeaee6);
    let routeContext = $1kowh.useContext($7ac35536217f28c8$export$aac280ed165a4397);
    $7ac35536217f28c8$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$7ac35536217f28c8$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $7ac35536217f28c8$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $7ac35536217f28c8$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $7ac35536217f28c8$export$fe53371bee54353d(path);
}
function $7ac35536217f28c8$export$5b0d2d9a9921565a({ key: key } = {}) {
    var _route_matches_;
    let { router: router } = $7ac35536217f28c8$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $7ac35536217f28c8$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $1kowh.useContext($7ac35536217f28c8$export$cb3f1df1bef00a39);
    let route = $1kowh.useContext($7ac35536217f28c8$export$aac280ed165a4397);
    let routeId = (_route_matches_ = route.matches[route.matches.length - 1]) === null || _route_matches_ === void 0 ? void 0 : _route_matches_.route.id;
    $7ac35536217f28c8$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $7ac35536217f28c8$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $7ac35536217f28c8$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $1kowh.useId();
    let [fetcherKey, setFetcherKey] = $1kowh.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $1kowh.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $1kowh.useCallback(async (href, opts)=>{
        $7ac35536217f28c8$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $7ac35536217f28c8$export$47c85c6e3a081d3();
    let submit = $1kowh.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $1kowh.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $1kowh.useMemo(()=>{
        let FetcherForm2 = $1kowh.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $7ac35536217f28c8$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $1kowh.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $7ac35536217f28c8$export$fa996778a3a31087() {
    let state = $7ac35536217f28c8$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $7ac35536217f28c8$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $7ac35536217f28c8$var$savedScrollPositions = {};
function $7ac35536217f28c8$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $7ac35536217f28c8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $7ac35536217f28c8$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $7ac35536217f28c8$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $7ac35536217f28c8$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $1kowh.useContext($7ac35536217f28c8$export$3044ab7fdabeaee6);
    let location = $7ac35536217f28c8$export$45d76561a5302f2b();
    let matches = $7ac35536217f28c8$export$2378eb7f5ff86053();
    let navigation = $7ac35536217f28c8$export$d0fd4b7106de2769();
    $1kowh.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $7ac35536217f28c8$var$usePageHide($1kowh.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $7ac35536217f28c8$var$getScrollRestorationKey(location, matches, basename, getKey);
            $7ac35536217f28c8$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $7ac35536217f28c8$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($7ac35536217f28c8$var$savedScrollPositions));
        } catch (error) {
            $7ac35536217f28c8$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $1kowh.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $7ac35536217f28c8$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $7ac35536217f28c8$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $1kowh.useLayoutEffect(()=>{
            let disableScrollRestoration = router === null || router === void 0 ? void 0 : router.enableScrollRestoration($7ac35536217f28c8$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$7ac35536217f28c8$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $1kowh.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $7ac35536217f28c8$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $7ac35536217f28c8$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $1kowh.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $7ac35536217f28c8$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $1kowh.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $7ac35536217f28c8$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $7ac35536217f28c8$export$b273b3273281a049(when);
    $1kowh.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $1kowh.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $7ac35536217f28c8$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $1kowh.useContext($7ac35536217f28c8$export$3681f408decb40d1);
    $7ac35536217f28c8$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $7ac35536217f28c8$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $7ac35536217f28c8$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $7ac35536217f28c8$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $7ac35536217f28c8$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $7ac35536217f28c8$export$81336c211d5ff295(path.pathname, nextPath) != null || $7ac35536217f28c8$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $7ac35536217f28c8$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $7ac35536217f28c8$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $7ac35536217f28c8$var$getStatelessNavigator();
    return /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $7ac35536217f28c8$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $7ac35536217f28c8$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $7ac35536217f28c8$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $7ac35536217f28c8$var$serializeErrors(context.errors)
        };
        let json = $7ac35536217f28c8$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $1kowh.createElement($1kowh.Fragment, null, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $1kowh.createElement($7ac35536217f28c8$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $1kowh.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $7ac35536217f28c8$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $7ac35536217f28c8$var$useRoutesImpl(routes, void 0, state, void 0, future);
}
function $7ac35536217f28c8$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($7ac35536217f28c8$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $7ac35536217f28c8$var$getStatelessNavigator() {
    return {
        createHref: $7ac35536217f28c8$var$createHref,
        encodeLocation: $7ac35536217f28c8$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $7ac35536217f28c8$export$69163f0b72ec60d9(routes, opts) {
    return $7ac35536217f28c8$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $7ac35536217f28c8$export$9269a41d8c4635e
    });
}
function $7ac35536217f28c8$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $7ac35536217f28c8$export$87cb1a9238dc3fba(routes, $7ac35536217f28c8$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts === null || opts === void 0 ? void 0 : opts.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $7ac35536217f28c8$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $7ac35536217f28c8$var$createHref,
        encodeLocation: $7ac35536217f28c8$var$encodeLocation,
        getFetcher () {
            return $7ac35536217f28c8$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $7ac35536217f28c8$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $7ac35536217f28c8$var$createHref(to) {
    return typeof to === "string" ? to : $7ac35536217f28c8$export$fe53371bee54353d(to);
}
function $7ac35536217f28c8$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $7ac35536217f28c8$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $7ac35536217f28c8$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $7ac35536217f28c8$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $7ac35536217f28c8$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $7ac35536217f28c8$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $7ac35536217f28c8$var$htmlEscape(str) {
    return str.replace($7ac35536217f28c8$var$ESCAPE_REGEX2, (match)=>$7ac35536217f28c8$var$ESCAPE_LOOKUP2[match]);
}

});

parcelRegister("jadBd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df39800ae8d6a6e0$export$2e2bcd8739ae039; });

var $Rwt4Y = parcelRequire("Rwt4Y");

var $7lC2m = parcelRequire("7lC2m");

var $dzEWX = parcelRequire("dzEWX");

var $gwiww = parcelRequire("gwiww");

var $aHr85 = parcelRequire("aHr85");
var $9hkdV = parcelRequire("9hkdV");

var $4ji3S = parcelRequire("4ji3S");


var $bUjjs = parcelRequire("bUjjs");

var $8FcMD = parcelRequire("8FcMD");

var $6VUWh = parcelRequire("6VUWh");

var $8DEiJ = parcelRequire("8DEiJ");

var $jPDYS = parcelRequire("jPDYS");

var $b0gin = parcelRequire("b0gin");
const $df39800ae8d6a6e0$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $df39800ae8d6a6e0$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $7lC2m.default)(options, $df39800ae8d6a6e0$var$_excluded);
    if (options.vars) throw new Error((0, $dzEWX.default)(18));
    const palette = (0, $8FcMD.default)(paletteInput);
    const systemTheme = (0, $4ji3S.default)(options);
    let muiTheme = (0, $gwiww.default)(systemTheme, {
        mixins: (0, $bUjjs.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $8DEiJ.default).slice(),
        typography: (0, $6VUWh.default)(palette, typographyInput),
        transitions: (0, $jPDYS.default)(transitionsInput),
        zIndex: (0, $Rwt4Y.default)({}, (0, $b0gin.default))
    });
    muiTheme = (0, $gwiww.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $gwiww.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $Rwt4Y.default)({}, (0, $9hkdV.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $aHr85.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $df39800ae8d6a6e0$var$warnedOnce = false;
function $df39800ae8d6a6e0$export$c469355549431d9b(...args) {
    return $df39800ae8d6a6e0$var$createTheme(...args);
}
var $df39800ae8d6a6e0$export$2e2bcd8739ae039 = $df39800ae8d6a6e0$var$createTheme;

});
parcelRegister("Rwt4Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a0e22d30d2b8637$export$2e2bcd8739ae039; });
function $0a0e22d30d2b8637$export$2e2bcd8739ae039() {
    $0a0e22d30d2b8637$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0a0e22d30d2b8637$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("7lC2m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5597fff21f84e15a$export$2e2bcd8739ae039; });
function $5597fff21f84e15a$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("dzEWX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e1e4f094ab2be79$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $9e1e4f094ab2be79$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});

parcelRegister("gwiww", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $c06e00e3581bb3cc$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $c06e00e3581bb3cc$export$2e2bcd8739ae039; });

var $Rwt4Y = parcelRequire("Rwt4Y");
function $c06e00e3581bb3cc$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $c06e00e3581bb3cc$var$deepClone(source) {
    if (!$c06e00e3581bb3cc$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $c06e00e3581bb3cc$var$deepClone(source[key]);
    });
    return output;
}
function $c06e00e3581bb3cc$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $Rwt4Y.default)({}, target) : target;
    if ($c06e00e3581bb3cc$export$53b83ca8eaab0383(target) && $c06e00e3581bb3cc$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($c06e00e3581bb3cc$export$53b83ca8eaab0383(source[key]) && key in target && $c06e00e3581bb3cc$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $c06e00e3581bb3cc$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $c06e00e3581bb3cc$export$53b83ca8eaab0383(source[key]) ? $c06e00e3581bb3cc$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("aHr85", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $7ca2f6e0b30a9d3a$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $7ca2f6e0b30a9d3a$export$2e2bcd8739ae039; });

var $iaCWb = parcelRequire("iaCWb");

var $gbYbE = parcelRequire("gbYbE");

var $7GyBL = parcelRequire("7GyBL");

var $by4Ds = parcelRequire("by4Ds");

var $9hkdV = parcelRequire("9hkdV");
function $7ca2f6e0b30a9d3a$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $7ca2f6e0b30a9d3a$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $7ca2f6e0b30a9d3a$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $7GyBL.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $7GyBL.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $7GyBL.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $iaCWb.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $by4Ds.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $9hkdV.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $by4Ds.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $7ca2f6e0b30a9d3a$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $gbYbE.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $by4Ds.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($7ca2f6e0b30a9d3a$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $gbYbE.default)(css, breakpointsValues);
                        }
                    } else css = (0, $gbYbE.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $by4Ds.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $7ca2f6e0b30a9d3a$var$styleFunctionSx = $7ca2f6e0b30a9d3a$export$7d53d8bf2911e013();
$7ca2f6e0b30a9d3a$var$styleFunctionSx.filterProps = [
    "sx"
];
var $7ca2f6e0b30a9d3a$export$2e2bcd8739ae039 = $7ca2f6e0b30a9d3a$var$styleFunctionSx;

});
parcelRegister("iaCWb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3a75d5afdefbeab$export$2e2bcd8739ae039; });

var $dzEWX = parcelRequire("dzEWX");
function $d3a75d5afdefbeab$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $dzEWX.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});

parcelRegister("gbYbE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc9c5c4ddd3647b5$export$2e2bcd8739ae039; });

var $gwiww = parcelRequire("gwiww");
function $bc9c5c4ddd3647b5$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $gwiww.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $bc9c5c4ddd3647b5$export$2e2bcd8739ae039 = $bc9c5c4ddd3647b5$var$merge;

});

parcelRegister("7GyBL", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $59874d1af63f2558$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $59874d1af63f2558$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $59874d1af63f2558$export$2e2bcd8739ae039; });

var $iaCWb = parcelRequire("iaCWb");


var $by4Ds = parcelRequire("by4Ds");
function $59874d1af63f2558$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $59874d1af63f2558$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $59874d1af63f2558$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $59874d1af63f2558$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $59874d1af63f2558$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $59874d1af63f2558$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $59874d1af63f2558$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $iaCWb.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $by4Ds.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $59874d1af63f2558$export$2e2bcd8739ae039 = $59874d1af63f2558$var$style;

});
parcelRegister("by4Ds", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $86867729861d69b9$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $86867729861d69b9$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $86867729861d69b9$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $86867729861d69b9$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $86867729861d69b9$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $86867729861d69b9$export$980e6a259d807490; });

var $Rwt4Y = parcelRequire("Rwt4Y");


var $gwiww = parcelRequire("gwiww");

var $gbYbE = parcelRequire("gbYbE");
const $86867729861d69b9$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $86867729861d69b9$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$86867729861d69b9$export$68c286be0e7e55b7[key]}px)`
};
function $86867729861d69b9$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $86867729861d69b9$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $86867729861d69b9$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $86867729861d69b9$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $86867729861d69b9$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $86867729861d69b9$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $Rwt4Y.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $gbYbE.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $86867729861d69b9$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $86867729861d69b9$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $86867729861d69b9$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $86867729861d69b9$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $gwiww.default)(prev, next), {});
    return $86867729861d69b9$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $86867729861d69b9$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $86867729861d69b9$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $86867729861d69b9$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $86867729861d69b9$export$2e2bcd8739ae039 = $86867729861d69b9$var$breakpoints;

});


parcelRegister("9hkdV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c156391f2afef78$export$2e2bcd8739ae039; });

var $1AGAi = parcelRequire("1AGAi");

var $ebVtg = parcelRequire("ebVtg");

var $bzaz5 = parcelRequire("bzaz5");

var $anz7U = parcelRequire("anz7U");

var $bVcpc = parcelRequire("bVcpc");
const $6c156391f2afef78$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $ebVtg.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $ebVtg.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $ebVtg.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $ebVtg.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $ebVtg.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $ebVtg.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $ebVtg.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $anz7U.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $anz7U.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $anz7U.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $1AGAi.padding)
    },
    pt: {
        style: (0, $1AGAi.padding)
    },
    pr: {
        style: (0, $1AGAi.padding)
    },
    pb: {
        style: (0, $1AGAi.padding)
    },
    pl: {
        style: (0, $1AGAi.padding)
    },
    px: {
        style: (0, $1AGAi.padding)
    },
    py: {
        style: (0, $1AGAi.padding)
    },
    padding: {
        style: (0, $1AGAi.padding)
    },
    paddingTop: {
        style: (0, $1AGAi.padding)
    },
    paddingRight: {
        style: (0, $1AGAi.padding)
    },
    paddingBottom: {
        style: (0, $1AGAi.padding)
    },
    paddingLeft: {
        style: (0, $1AGAi.padding)
    },
    paddingX: {
        style: (0, $1AGAi.padding)
    },
    paddingY: {
        style: (0, $1AGAi.padding)
    },
    paddingInline: {
        style: (0, $1AGAi.padding)
    },
    paddingInlineStart: {
        style: (0, $1AGAi.padding)
    },
    paddingInlineEnd: {
        style: (0, $1AGAi.padding)
    },
    paddingBlock: {
        style: (0, $1AGAi.padding)
    },
    paddingBlockStart: {
        style: (0, $1AGAi.padding)
    },
    paddingBlockEnd: {
        style: (0, $1AGAi.padding)
    },
    m: {
        style: (0, $1AGAi.margin)
    },
    mt: {
        style: (0, $1AGAi.margin)
    },
    mr: {
        style: (0, $1AGAi.margin)
    },
    mb: {
        style: (0, $1AGAi.margin)
    },
    ml: {
        style: (0, $1AGAi.margin)
    },
    mx: {
        style: (0, $1AGAi.margin)
    },
    my: {
        style: (0, $1AGAi.margin)
    },
    margin: {
        style: (0, $1AGAi.margin)
    },
    marginTop: {
        style: (0, $1AGAi.margin)
    },
    marginRight: {
        style: (0, $1AGAi.margin)
    },
    marginBottom: {
        style: (0, $1AGAi.margin)
    },
    marginLeft: {
        style: (0, $1AGAi.margin)
    },
    marginX: {
        style: (0, $1AGAi.margin)
    },
    marginY: {
        style: (0, $1AGAi.margin)
    },
    marginInline: {
        style: (0, $1AGAi.margin)
    },
    marginInlineStart: {
        style: (0, $1AGAi.margin)
    },
    marginInlineEnd: {
        style: (0, $1AGAi.margin)
    },
    marginBlock: {
        style: (0, $1AGAi.margin)
    },
    marginBlockStart: {
        style: (0, $1AGAi.margin)
    },
    marginBlockEnd: {
        style: (0, $1AGAi.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $bzaz5.gap)
    },
    rowGap: {
        style: (0, $bzaz5.rowGap)
    },
    columnGap: {
        style: (0, $bzaz5.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $bVcpc.sizingTransform)
    },
    maxWidth: {
        style: (0, $bVcpc.maxWidth)
    },
    minWidth: {
        transform: (0, $bVcpc.sizingTransform)
    },
    height: {
        transform: (0, $bVcpc.sizingTransform)
    },
    maxHeight: {
        transform: (0, $bVcpc.sizingTransform)
    },
    minHeight: {
        transform: (0, $bVcpc.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $6c156391f2afef78$export$2e2bcd8739ae039 = $6c156391f2afef78$var$defaultSxConfig;

});
parcelRegister("1AGAi", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $128a2fa18ce063c3$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $128a2fa18ce063c3$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $128a2fa18ce063c3$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $128a2fa18ce063c3$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $128a2fa18ce063c3$export$6f98e8eaf0be1996; });


var $by4Ds = parcelRequire("by4Ds");

var $7GyBL = parcelRequire("7GyBL");

var $gbYbE = parcelRequire("gbYbE");

var $5Ef96 = parcelRequire("5Ef96");
const $128a2fa18ce063c3$var$properties = {
    m: "margin",
    p: "padding"
};
const $128a2fa18ce063c3$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $128a2fa18ce063c3$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $128a2fa18ce063c3$var$getCssProperties = (0, $5Ef96.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($128a2fa18ce063c3$var$aliases[prop]) prop = $128a2fa18ce063c3$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $128a2fa18ce063c3$var$properties[a];
    const direction = $128a2fa18ce063c3$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $128a2fa18ce063c3$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $128a2fa18ce063c3$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $128a2fa18ce063c3$var$spacingKeys = [
    ...$128a2fa18ce063c3$export$aab52a0dde05ad8a,
    ...$128a2fa18ce063c3$export$f8397d44f03ab6ad
];
function $128a2fa18ce063c3$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $7GyBL.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $128a2fa18ce063c3$export$1def6f833384e3d1(theme) {
    return $128a2fa18ce063c3$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $128a2fa18ce063c3$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $128a2fa18ce063c3$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $128a2fa18ce063c3$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $128a2fa18ce063c3$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $128a2fa18ce063c3$var$getCssProperties(prop);
    const styleFromPropValue = $128a2fa18ce063c3$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $by4Ds.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $128a2fa18ce063c3$var$style(props, keys) {
    const transformer = $128a2fa18ce063c3$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$128a2fa18ce063c3$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $gbYbE.default), {});
}
function $128a2fa18ce063c3$export$7ede87f9b603dd3c(props) {
    return $128a2fa18ce063c3$var$style(props, $128a2fa18ce063c3$export$aab52a0dde05ad8a);
}
$128a2fa18ce063c3$export$7ede87f9b603dd3c.propTypes = {};
$128a2fa18ce063c3$export$7ede87f9b603dd3c.filterProps = $128a2fa18ce063c3$export$aab52a0dde05ad8a;
function $128a2fa18ce063c3$export$6f98e8eaf0be1996(props) {
    return $128a2fa18ce063c3$var$style(props, $128a2fa18ce063c3$export$f8397d44f03ab6ad);
}
$128a2fa18ce063c3$export$6f98e8eaf0be1996.propTypes = {};
$128a2fa18ce063c3$export$6f98e8eaf0be1996.filterProps = $128a2fa18ce063c3$export$f8397d44f03ab6ad;
function $128a2fa18ce063c3$var$spacing(props) {
    return $128a2fa18ce063c3$var$style(props, $128a2fa18ce063c3$var$spacingKeys);
}
$128a2fa18ce063c3$var$spacing.propTypes = {};
$128a2fa18ce063c3$var$spacing.filterProps = $128a2fa18ce063c3$var$spacingKeys;
var $128a2fa18ce063c3$export$2e2bcd8739ae039 = $128a2fa18ce063c3$var$spacing;

});
parcelRegister("5Ef96", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41cc6fd4879bff43$export$2e2bcd8739ae039; });
function $41cc6fd4879bff43$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("ebVtg", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $a54eac51f6cd3266$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $a54eac51f6cd3266$export$7a57f79000377ca2; });


var $7GyBL = parcelRequire("7GyBL");

var $dJpMY = parcelRequire("dJpMY");

var $1AGAi = parcelRequire("1AGAi");

var $by4Ds = parcelRequire("by4Ds");
function $a54eac51f6cd3266$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $a54eac51f6cd3266$var$createBorderStyle(prop, transform) {
    return (0, $7GyBL.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $a54eac51f6cd3266$export$1edee58a52776cd9 = $a54eac51f6cd3266$var$createBorderStyle("border", $a54eac51f6cd3266$export$34e2febe53ae29cc);
const $a54eac51f6cd3266$export$f9a7b6bd24892946 = $a54eac51f6cd3266$var$createBorderStyle("borderTop", $a54eac51f6cd3266$export$34e2febe53ae29cc);
const $a54eac51f6cd3266$export$5abca33e6be905d2 = $a54eac51f6cd3266$var$createBorderStyle("borderRight", $a54eac51f6cd3266$export$34e2febe53ae29cc);
const $a54eac51f6cd3266$export$e2ce9f12a980a822 = $a54eac51f6cd3266$var$createBorderStyle("borderBottom", $a54eac51f6cd3266$export$34e2febe53ae29cc);
const $a54eac51f6cd3266$export$47658cca1a909427 = $a54eac51f6cd3266$var$createBorderStyle("borderLeft", $a54eac51f6cd3266$export$34e2febe53ae29cc);
const $a54eac51f6cd3266$export$e7fb0694ba2404fc = $a54eac51f6cd3266$var$createBorderStyle("borderColor");
const $a54eac51f6cd3266$export$126a92c968acdb85 = $a54eac51f6cd3266$var$createBorderStyle("borderTopColor");
const $a54eac51f6cd3266$export$85cc51cb8fbb8c0e = $a54eac51f6cd3266$var$createBorderStyle("borderRightColor");
const $a54eac51f6cd3266$export$340b0327727f6d1a = $a54eac51f6cd3266$var$createBorderStyle("borderBottomColor");
const $a54eac51f6cd3266$export$60beef91a985b4bf = $a54eac51f6cd3266$var$createBorderStyle("borderLeftColor");
const $a54eac51f6cd3266$export$f9258c55612cbed7 = $a54eac51f6cd3266$var$createBorderStyle("outline", $a54eac51f6cd3266$export$34e2febe53ae29cc);
const $a54eac51f6cd3266$export$621fe586efeb64b9 = $a54eac51f6cd3266$var$createBorderStyle("outlineColor");
const $a54eac51f6cd3266$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $1AGAi.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $1AGAi.getValue)(transformer, propValue)
            });
        return (0, $by4Ds.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$a54eac51f6cd3266$export$7a57f79000377ca2.propTypes = {};
$a54eac51f6cd3266$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $a54eac51f6cd3266$var$borders = (0, $dJpMY.default)($a54eac51f6cd3266$export$1edee58a52776cd9, $a54eac51f6cd3266$export$f9a7b6bd24892946, $a54eac51f6cd3266$export$5abca33e6be905d2, $a54eac51f6cd3266$export$e2ce9f12a980a822, $a54eac51f6cd3266$export$47658cca1a909427, $a54eac51f6cd3266$export$e7fb0694ba2404fc, $a54eac51f6cd3266$export$126a92c968acdb85, $a54eac51f6cd3266$export$85cc51cb8fbb8c0e, $a54eac51f6cd3266$export$340b0327727f6d1a, $a54eac51f6cd3266$export$60beef91a985b4bf, $a54eac51f6cd3266$export$7a57f79000377ca2, $a54eac51f6cd3266$export$f9258c55612cbed7, $a54eac51f6cd3266$export$621fe586efeb64b9);
var $a54eac51f6cd3266$export$2e2bcd8739ae039 = $a54eac51f6cd3266$var$borders;

});
parcelRegister("dJpMY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ff37b78e9b93f2d$export$2e2bcd8739ae039; });

var $gbYbE = parcelRequire("gbYbE");
function $9ff37b78e9b93f2d$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $gbYbE.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $9ff37b78e9b93f2d$export$2e2bcd8739ae039 = $9ff37b78e9b93f2d$var$compose;

});


parcelRegister("bzaz5", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $86bb288a5159f22b$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $86bb288a5159f22b$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $86bb288a5159f22b$export$8a833ffa5f5dbeda; });

var $7GyBL = parcelRequire("7GyBL");

var $dJpMY = parcelRequire("dJpMY");

var $1AGAi = parcelRequire("1AGAi");

var $by4Ds = parcelRequire("by4Ds");

const $86bb288a5159f22b$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $1AGAi.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $1AGAi.getValue)(transformer, propValue)
            });
        return (0, $by4Ds.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$86bb288a5159f22b$export$5df9adcb0db95e1e.propTypes = {};
$86bb288a5159f22b$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $86bb288a5159f22b$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $1AGAi.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $1AGAi.getValue)(transformer, propValue)
            });
        return (0, $by4Ds.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$86bb288a5159f22b$export$ec60d70ff941a580.propTypes = {};
$86bb288a5159f22b$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $86bb288a5159f22b$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $1AGAi.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $1AGAi.getValue)(transformer, propValue)
            });
        return (0, $by4Ds.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$86bb288a5159f22b$export$8a833ffa5f5dbeda.propTypes = {};
$86bb288a5159f22b$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $86bb288a5159f22b$export$baf44164ca3a34e8 = (0, $7GyBL.default)({
    prop: "gridColumn"
});
const $86bb288a5159f22b$export$8f7213a1cd01e832 = (0, $7GyBL.default)({
    prop: "gridRow"
});
const $86bb288a5159f22b$export$b0e0abbc49ba668 = (0, $7GyBL.default)({
    prop: "gridAutoFlow"
});
const $86bb288a5159f22b$export$bcd8b929d4b4142 = (0, $7GyBL.default)({
    prop: "gridAutoColumns"
});
const $86bb288a5159f22b$export$e5039a674e14c828 = (0, $7GyBL.default)({
    prop: "gridAutoRows"
});
const $86bb288a5159f22b$export$42bd9088661ffb03 = (0, $7GyBL.default)({
    prop: "gridTemplateColumns"
});
const $86bb288a5159f22b$export$920682ae05b999bc = (0, $7GyBL.default)({
    prop: "gridTemplateRows"
});
const $86bb288a5159f22b$export$1b88fbdd482fd33a = (0, $7GyBL.default)({
    prop: "gridTemplateAreas"
});
const $86bb288a5159f22b$export$bdb486e40d52d26f = (0, $7GyBL.default)({
    prop: "gridArea"
});
const $86bb288a5159f22b$var$grid = (0, $dJpMY.default)($86bb288a5159f22b$export$5df9adcb0db95e1e, $86bb288a5159f22b$export$ec60d70ff941a580, $86bb288a5159f22b$export$8a833ffa5f5dbeda, $86bb288a5159f22b$export$baf44164ca3a34e8, $86bb288a5159f22b$export$8f7213a1cd01e832, $86bb288a5159f22b$export$b0e0abbc49ba668, $86bb288a5159f22b$export$bcd8b929d4b4142, $86bb288a5159f22b$export$e5039a674e14c828, $86bb288a5159f22b$export$42bd9088661ffb03, $86bb288a5159f22b$export$920682ae05b999bc, $86bb288a5159f22b$export$1b88fbdd482fd33a, $86bb288a5159f22b$export$bdb486e40d52d26f);
var $86bb288a5159f22b$export$2e2bcd8739ae039 = $86bb288a5159f22b$var$grid;

});

parcelRegister("anz7U", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $78e74cc76616213e$export$dbaffd4420ea0ac6; });

var $7GyBL = parcelRequire("7GyBL");

var $dJpMY = parcelRequire("dJpMY");
function $78e74cc76616213e$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $78e74cc76616213e$export$35e9368ef982300f = (0, $7GyBL.default)({
    prop: "color",
    themeKey: "palette",
    transform: $78e74cc76616213e$export$dbaffd4420ea0ac6
});
const $78e74cc76616213e$export$2506f56c10355b33 = (0, $7GyBL.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $78e74cc76616213e$export$dbaffd4420ea0ac6
});
const $78e74cc76616213e$export$8c5a050822fd698c = (0, $7GyBL.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $78e74cc76616213e$export$dbaffd4420ea0ac6
});
const $78e74cc76616213e$var$palette = (0, $dJpMY.default)($78e74cc76616213e$export$35e9368ef982300f, $78e74cc76616213e$export$2506f56c10355b33, $78e74cc76616213e$export$8c5a050822fd698c);
var $78e74cc76616213e$export$2e2bcd8739ae039 = $78e74cc76616213e$var$palette;

});

parcelRegister("bVcpc", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $8adea410e7c0dc71$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $8adea410e7c0dc71$export$488fda99655ff65a; });

var $7GyBL = parcelRequire("7GyBL");

var $dJpMY = parcelRequire("dJpMY");

var $by4Ds = parcelRequire("by4Ds");
function $8adea410e7c0dc71$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $8adea410e7c0dc71$export$7e3df82ee760448c = (0, $7GyBL.default)({
    prop: "width",
    transform: $8adea410e7c0dc71$export$8afece71750ec241
});
const $8adea410e7c0dc71$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $by4Ds.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $8adea410e7c0dc71$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $by4Ds.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$8adea410e7c0dc71$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $8adea410e7c0dc71$export$ee148fbbe8357dd2 = (0, $7GyBL.default)({
    prop: "minWidth",
    transform: $8adea410e7c0dc71$export$8afece71750ec241
});
const $8adea410e7c0dc71$export$ac607276a8fe9f0a = (0, $7GyBL.default)({
    prop: "height",
    transform: $8adea410e7c0dc71$export$8afece71750ec241
});
const $8adea410e7c0dc71$export$dc0d8bd0b94f8570 = (0, $7GyBL.default)({
    prop: "maxHeight",
    transform: $8adea410e7c0dc71$export$8afece71750ec241
});
const $8adea410e7c0dc71$export$a43cf604e12f3b17 = (0, $7GyBL.default)({
    prop: "minHeight",
    transform: $8adea410e7c0dc71$export$8afece71750ec241
});
const $8adea410e7c0dc71$export$ffed9f14fb65e276 = (0, $7GyBL.default)({
    prop: "size",
    cssProperty: "width",
    transform: $8adea410e7c0dc71$export$8afece71750ec241
});
const $8adea410e7c0dc71$export$905076ed6620e671 = (0, $7GyBL.default)({
    prop: "size",
    cssProperty: "height",
    transform: $8adea410e7c0dc71$export$8afece71750ec241
});
const $8adea410e7c0dc71$export$6ccc93f785106a58 = (0, $7GyBL.default)({
    prop: "boxSizing"
});
const $8adea410e7c0dc71$var$sizing = (0, $dJpMY.default)($8adea410e7c0dc71$export$7e3df82ee760448c, $8adea410e7c0dc71$export$488fda99655ff65a, $8adea410e7c0dc71$export$ee148fbbe8357dd2, $8adea410e7c0dc71$export$ac607276a8fe9f0a, $8adea410e7c0dc71$export$dc0d8bd0b94f8570, $8adea410e7c0dc71$export$a43cf604e12f3b17, $8adea410e7c0dc71$export$6ccc93f785106a58);
var $8adea410e7c0dc71$export$2e2bcd8739ae039 = $8adea410e7c0dc71$var$sizing;

});



parcelRegister("4ji3S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3236f26fb95c8ef8$export$2e2bcd8739ae039; });

var $Rwt4Y = parcelRequire("Rwt4Y");

var $7lC2m = parcelRequire("7lC2m");

var $gwiww = parcelRequire("gwiww");

var $j1D7w = parcelRequire("j1D7w");

var $eT82F = parcelRequire("eT82F");

var $3YkXY = parcelRequire("3YkXY");

var $aHr85 = parcelRequire("aHr85");

var $9hkdV = parcelRequire("9hkdV");

var $fHnrl = parcelRequire("fHnrl");
const $3236f26fb95c8ef8$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $3236f26fb95c8ef8$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $7lC2m.default)(options, $3236f26fb95c8ef8$var$_excluded);
    const breakpoints = (0, $j1D7w.default)(breakpointsInput);
    const spacing = (0, $3YkXY.default)(spacingInput);
    let muiTheme = (0, $gwiww.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $Rwt4Y.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $Rwt4Y.default)({}, (0, $eT82F.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $fHnrl.default);
    muiTheme = args.reduce((acc, argument)=>(0, $gwiww.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $Rwt4Y.default)({}, (0, $9hkdV.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $aHr85.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $3236f26fb95c8ef8$export$2e2bcd8739ae039 = $3236f26fb95c8ef8$var$createTheme;

});
parcelRegister("j1D7w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd9c74cbc35bff76$export$2e2bcd8739ae039; });

var $7lC2m = parcelRequire("7lC2m");

var $Rwt4Y = parcelRequire("Rwt4Y");
const $dd9c74cbc35bff76$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $dd9c74cbc35bff76$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $dd9c74cbc35bff76$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $Rwt4Y.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $dd9c74cbc35bff76$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $7lC2m.default)(breakpoints, $dd9c74cbc35bff76$var$_excluded);
    const sortedValues = $dd9c74cbc35bff76$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $Rwt4Y.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("eT82F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad6c70bb0918f8e4$export$2e2bcd8739ae039; });
const $ad6c70bb0918f8e4$var$shape = {
    borderRadius: 4
};
var $ad6c70bb0918f8e4$export$2e2bcd8739ae039 = $ad6c70bb0918f8e4$var$shape;

});

parcelRegister("3YkXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e473d288eeb43d9$export$2e2bcd8739ae039; });

var $1AGAi = parcelRequire("1AGAi");
function $2e473d288eeb43d9$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $1AGAi.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("fHnrl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6dd0dd8d152ebba$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $b6dd0dd8d152ebba$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("bUjjs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ab3e7ca8365bd53$export$2e2bcd8739ae039; });

var $Rwt4Y = parcelRequire("Rwt4Y");
function $8ab3e7ca8365bd53$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $Rwt4Y.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("8FcMD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64ec119995a6dd70$export$2e2bcd8739ae039; });

var $Rwt4Y = parcelRequire("Rwt4Y");

var $7lC2m = parcelRequire("7lC2m");

var $dzEWX = parcelRequire("dzEWX");

var $gwiww = parcelRequire("gwiww");

var $3YF6Q = parcelRequire("3YF6Q");

var $liwkz = parcelRequire("liwkz");

var $9SDoJ = parcelRequire("9SDoJ");

var $j23zS = parcelRequire("j23zS");

var $4urGk = parcelRequire("4urGk");

var $iQjMo = parcelRequire("iQjMo");

var $evEZJ = parcelRequire("evEZJ");

var $hSUJ9 = parcelRequire("hSUJ9");

var $iGljl = parcelRequire("iGljl");
const $64ec119995a6dd70$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $64ec119995a6dd70$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $liwkz.default).white,
        default: (0, $liwkz.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $64ec119995a6dd70$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $liwkz.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $liwkz.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $64ec119995a6dd70$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $3YF6Q.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $3YF6Q.darken)(intent.main, tonalOffsetDark);
    }
}
function $64ec119995a6dd70$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $evEZJ.default)[200],
        light: (0, $evEZJ.default)[50],
        dark: (0, $evEZJ.default)[400]
    };
    return {
        main: (0, $evEZJ.default)[700],
        light: (0, $evEZJ.default)[400],
        dark: (0, $evEZJ.default)[800]
    };
}
function $64ec119995a6dd70$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $j23zS.default)[200],
        light: (0, $j23zS.default)[50],
        dark: (0, $j23zS.default)[400]
    };
    return {
        main: (0, $j23zS.default)[500],
        light: (0, $j23zS.default)[300],
        dark: (0, $j23zS.default)[700]
    };
}
function $64ec119995a6dd70$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $4urGk.default)[500],
        light: (0, $4urGk.default)[300],
        dark: (0, $4urGk.default)[700]
    };
    return {
        main: (0, $4urGk.default)[700],
        light: (0, $4urGk.default)[400],
        dark: (0, $4urGk.default)[800]
    };
}
function $64ec119995a6dd70$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $hSUJ9.default)[400],
        light: (0, $hSUJ9.default)[300],
        dark: (0, $hSUJ9.default)[700]
    };
    return {
        main: (0, $hSUJ9.default)[700],
        light: (0, $hSUJ9.default)[500],
        dark: (0, $hSUJ9.default)[900]
    };
}
function $64ec119995a6dd70$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $iGljl.default)[400],
        light: (0, $iGljl.default)[300],
        dark: (0, $iGljl.default)[700]
    };
    return {
        main: (0, $iGljl.default)[800],
        light: (0, $iGljl.default)[500],
        dark: (0, $iGljl.default)[900]
    };
}
function $64ec119995a6dd70$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $iQjMo.default)[400],
        light: (0, $iQjMo.default)[300],
        dark: (0, $iQjMo.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $iQjMo.default)[500],
        dark: (0, $iQjMo.default)[900]
    };
}
function $64ec119995a6dd70$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $7lC2m.default)(palette, $64ec119995a6dd70$var$_excluded);
    const primary = palette.primary || $64ec119995a6dd70$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $64ec119995a6dd70$var$getDefaultSecondary(mode);
    const error = palette.error || $64ec119995a6dd70$var$getDefaultError(mode);
    const info = palette.info || $64ec119995a6dd70$var$getDefaultInfo(mode);
    const success = palette.success || $64ec119995a6dd70$var$getDefaultSuccess(mode);
    const warning = palette.warning || $64ec119995a6dd70$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $3YF6Q.getContrastRatio)(background, $64ec119995a6dd70$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $64ec119995a6dd70$export$55ce6f3a06c59543.text.primary : $64ec119995a6dd70$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $Rwt4Y.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $dzEWX.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $dzEWX.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $64ec119995a6dd70$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $64ec119995a6dd70$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $64ec119995a6dd70$export$55ce6f3a06c59543,
        light: $64ec119995a6dd70$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $gwiww.default)((0, $Rwt4Y.default)({
        // A collection of common colors.
        common: (0, $Rwt4Y.default)({}, (0, $liwkz.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $9SDoJ.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("3YF6Q", function(module, exports) {
"use strict";

var $eLsQG = parcelRequire("eLsQG");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $2e56dd25f0806863$var$alpha;
module.exports.blend = $2e56dd25f0806863$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $2e56dd25f0806863$var$darken;
module.exports.decomposeColor = $2e56dd25f0806863$var$decomposeColor;
module.exports.emphasize = $2e56dd25f0806863$var$emphasize;
module.exports.getContrastRatio = $2e56dd25f0806863$var$getContrastRatio;
module.exports.getLuminance = $2e56dd25f0806863$var$getLuminance;
module.exports.hexToRgb = $2e56dd25f0806863$var$hexToRgb;
module.exports.hslToRgb = $2e56dd25f0806863$var$hslToRgb;
module.exports.lighten = $2e56dd25f0806863$var$lighten;
module.exports.private_safeAlpha = $2e56dd25f0806863$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $2e56dd25f0806863$var$private_safeDarken;
module.exports.private_safeEmphasize = $2e56dd25f0806863$var$private_safeEmphasize;
module.exports.private_safeLighten = $2e56dd25f0806863$var$private_safeLighten;
module.exports.recomposeColor = $2e56dd25f0806863$var$recomposeColor;
module.exports.rgbToHex = $2e56dd25f0806863$var$rgbToHex;

var $2e56dd25f0806863$var$_formatMuiErrorMessage2 = $eLsQG((parcelRequire("aWmS2")));

var $2e56dd25f0806863$var$_clamp = $eLsQG((parcelRequire("kR930")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $2e56dd25f0806863$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $2e56dd25f0806863$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $2e56dd25f0806863$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $2e56dd25f0806863$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $2e56dd25f0806863$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $2e56dd25f0806863$var$decomposeColor($2e56dd25f0806863$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $2e56dd25f0806863$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $2e56dd25f0806863$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $2e56dd25f0806863$var$colorChannel = (color)=>{
    const decomposedColor = $2e56dd25f0806863$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $2e56dd25f0806863$var$colorChannel;
const $2e56dd25f0806863$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $2e56dd25f0806863$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $2e56dd25f0806863$var$private_safeColorChannel;
function $2e56dd25f0806863$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $2e56dd25f0806863$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $2e56dd25f0806863$var$decomposeColor(color);
    return `#${values.map((n, i)=>$2e56dd25f0806863$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $2e56dd25f0806863$var$hslToRgb(color) {
    color = $2e56dd25f0806863$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $2e56dd25f0806863$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $2e56dd25f0806863$var$getLuminance(color) {
    color = $2e56dd25f0806863$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $2e56dd25f0806863$var$decomposeColor($2e56dd25f0806863$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $2e56dd25f0806863$var$getContrastRatio(foreground, background) {
    const lumA = $2e56dd25f0806863$var$getLuminance(foreground);
    const lumB = $2e56dd25f0806863$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $2e56dd25f0806863$var$alpha(color, value) {
    color = $2e56dd25f0806863$var$decomposeColor(color);
    value = $2e56dd25f0806863$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $2e56dd25f0806863$var$recomposeColor(color);
}
function $2e56dd25f0806863$var$private_safeAlpha(color, value, warning) {
    try {
        return $2e56dd25f0806863$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $2e56dd25f0806863$var$darken(color, coefficient) {
    color = $2e56dd25f0806863$var$decomposeColor(color);
    coefficient = $2e56dd25f0806863$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $2e56dd25f0806863$var$recomposeColor(color);
}
function $2e56dd25f0806863$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $2e56dd25f0806863$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $2e56dd25f0806863$var$lighten(color, coefficient) {
    color = $2e56dd25f0806863$var$decomposeColor(color);
    coefficient = $2e56dd25f0806863$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $2e56dd25f0806863$var$recomposeColor(color);
}
function $2e56dd25f0806863$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $2e56dd25f0806863$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $2e56dd25f0806863$var$emphasize(color, coefficient = 0.15) {
    return $2e56dd25f0806863$var$getLuminance(color) > 0.5 ? $2e56dd25f0806863$var$darken(color, coefficient) : $2e56dd25f0806863$var$lighten(color, coefficient);
}
function $2e56dd25f0806863$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $2e56dd25f0806863$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $2e56dd25f0806863$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $2e56dd25f0806863$var$decomposeColor(background);
    const overlayColor = $2e56dd25f0806863$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $2e56dd25f0806863$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("eLsQG", function(module, exports) {
function $abfbd53d4f3ca8fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $abfbd53d4f3ca8fb$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aWmS2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("dzEWX")).default; });

var $dzEWX = parcelRequire("dzEWX");

});

parcelRegister("kR930", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("j0PmA")).default; });

var $j0PmA = parcelRequire("j0PmA");

});
parcelRegister("j0PmA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd75dc1695513882$export$2e2bcd8739ae039; });
function $dd75dc1695513882$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $dd75dc1695513882$export$2e2bcd8739ae039 = $dd75dc1695513882$var$clamp;

});



parcelRegister("liwkz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8145ba80e39f2c8$export$2e2bcd8739ae039; });
const $f8145ba80e39f2c8$var$common = {
    black: "#000",
    white: "#fff"
};
var $f8145ba80e39f2c8$export$2e2bcd8739ae039 = $f8145ba80e39f2c8$var$common;

});

parcelRegister("9SDoJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7317b7d1429324fb$export$2e2bcd8739ae039; });
const $7317b7d1429324fb$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $7317b7d1429324fb$export$2e2bcd8739ae039 = $7317b7d1429324fb$var$grey;

});

parcelRegister("j23zS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddb0faa79c8c1e9b$export$2e2bcd8739ae039; });
const $ddb0faa79c8c1e9b$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $ddb0faa79c8c1e9b$export$2e2bcd8739ae039 = $ddb0faa79c8c1e9b$var$purple;

});

parcelRegister("4urGk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $344f6fc6367908ca$export$2e2bcd8739ae039; });
const $344f6fc6367908ca$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $344f6fc6367908ca$export$2e2bcd8739ae039 = $344f6fc6367908ca$var$red;

});

parcelRegister("iQjMo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db7c6d1dabf73b30$export$2e2bcd8739ae039; });
const $db7c6d1dabf73b30$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $db7c6d1dabf73b30$export$2e2bcd8739ae039 = $db7c6d1dabf73b30$var$orange;

});

parcelRegister("evEZJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a903c29a907d135b$export$2e2bcd8739ae039; });
const $a903c29a907d135b$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $a903c29a907d135b$export$2e2bcd8739ae039 = $a903c29a907d135b$var$blue;

});

parcelRegister("hSUJ9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0537ba536cd4c6d$export$2e2bcd8739ae039; });
const $d0537ba536cd4c6d$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $d0537ba536cd4c6d$export$2e2bcd8739ae039 = $d0537ba536cd4c6d$var$lightBlue;

});

parcelRegister("iGljl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d99cae2a4b0b4f27$export$2e2bcd8739ae039; });
const $d99cae2a4b0b4f27$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $d99cae2a4b0b4f27$export$2e2bcd8739ae039 = $d99cae2a4b0b4f27$var$green;

});


parcelRegister("6VUWh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50c43bd633e2fa5d$export$2e2bcd8739ae039; });

var $Rwt4Y = parcelRequire("Rwt4Y");

var $7lC2m = parcelRequire("7lC2m");

var $gwiww = parcelRequire("gwiww");
const $50c43bd633e2fa5d$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $50c43bd633e2fa5d$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $50c43bd633e2fa5d$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $50c43bd633e2fa5d$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $50c43bd633e2fa5d$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $50c43bd633e2fa5d$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $7lC2m.default)(_ref, $50c43bd633e2fa5d$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $Rwt4Y.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $50c43bd633e2fa5d$var$defaultFontFamily ? {
            letterSpacing: `${$50c43bd633e2fa5d$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $50c43bd633e2fa5d$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $50c43bd633e2fa5d$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $gwiww.default)((0, $Rwt4Y.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("8DEiJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64a13a35b997dfe9$export$2e2bcd8739ae039; });
const $64a13a35b997dfe9$var$shadowKeyUmbraOpacity = 0.2;
const $64a13a35b997dfe9$var$shadowKeyPenumbraOpacity = 0.14;
const $64a13a35b997dfe9$var$shadowAmbientShadowOpacity = 0.12;
function $64a13a35b997dfe9$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$64a13a35b997dfe9$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$64a13a35b997dfe9$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$64a13a35b997dfe9$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $64a13a35b997dfe9$var$shadows = [
    "none",
    $64a13a35b997dfe9$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $64a13a35b997dfe9$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $64a13a35b997dfe9$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $64a13a35b997dfe9$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $64a13a35b997dfe9$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $64a13a35b997dfe9$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $64a13a35b997dfe9$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $64a13a35b997dfe9$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $64a13a35b997dfe9$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $64a13a35b997dfe9$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $64a13a35b997dfe9$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $64a13a35b997dfe9$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $64a13a35b997dfe9$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $64a13a35b997dfe9$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $64a13a35b997dfe9$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $64a13a35b997dfe9$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $64a13a35b997dfe9$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $64a13a35b997dfe9$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $64a13a35b997dfe9$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $64a13a35b997dfe9$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $64a13a35b997dfe9$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $64a13a35b997dfe9$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $64a13a35b997dfe9$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $64a13a35b997dfe9$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $64a13a35b997dfe9$export$2e2bcd8739ae039 = $64a13a35b997dfe9$var$shadows;

});

parcelRegister("jPDYS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e701cb2241af6a37$export$2e2bcd8739ae039; });

var $7lC2m = parcelRequire("7lC2m");

var $Rwt4Y = parcelRequire("Rwt4Y");
const $e701cb2241af6a37$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $e701cb2241af6a37$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $e701cb2241af6a37$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $e701cb2241af6a37$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $e701cb2241af6a37$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $e701cb2241af6a37$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $Rwt4Y.default)({}, $e701cb2241af6a37$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $Rwt4Y.default)({}, $e701cb2241af6a37$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $7lC2m.default)(options, $e701cb2241af6a37$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $e701cb2241af6a37$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $e701cb2241af6a37$var$formatMs(delay)}`).join(",");
    };
    return (0, $Rwt4Y.default)({
        getAutoHeightDuration: $e701cb2241af6a37$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("b0gin", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $802c55bc8a33cb26$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $802c55bc8a33cb26$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $802c55bc8a33cb26$export$2e2bcd8739ae039 = $802c55bc8a33cb26$var$zIndex;

});


parcelRegister("D2szs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07558d1a2a1998a9$export$2e2bcd8739ae039; });

var $Rwt4Y = parcelRequire("Rwt4Y");

var $7lC2m = parcelRequire("7lC2m");
parcelRequire("1kowh");


var $fTlHm = parcelRequire("fTlHm");

var $25rSD = parcelRequire("25rSD");

var $3QTul = parcelRequire("3QTul");
"use client";
const $07558d1a2a1998a9$var$_excluded = [
    "theme"
];
function $07558d1a2a1998a9$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $7lC2m.default)(_ref, $07558d1a2a1998a9$var$_excluded);
    const scopedTheme = themeInput[0, $25rSD.default];
    return /*#__PURE__*/ (0, $3QTul.jsx)((0, $fTlHm.default), (0, $Rwt4Y.default)({}, props, {
        themeId: scopedTheme ? (0, $25rSD.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}

});
parcelRegister("fTlHm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b91cd2e5d1dd4f78$export$2e2bcd8739ae039; });

var $Rwt4Y = parcelRequire("Rwt4Y");

var $1kowh = parcelRequire("1kowh");


var $kx8Rz = parcelRequire("kx8Rz");
var $ifxcD = parcelRequire("ifxcD");

parcelRequire("1bkmv");
var $eKWiI = parcelRequire("eKWiI");

var $bsrF1 = parcelRequire("bsrF1");

var $ldvJf = parcelRequire("ldvJf");

var $3QTul = parcelRequire("3QTul");
"use client";
const $b91cd2e5d1dd4f78$var$EMPTY_THEME = {};
function $b91cd2e5d1dd4f78$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $1kowh.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $Rwt4Y.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $Rwt4Y.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $Rwt4Y.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $b91cd2e5d1dd4f78$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $bsrF1.default)($b91cd2e5d1dd4f78$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $ifxcD.default)() || $b91cd2e5d1dd4f78$var$EMPTY_THEME;
    const engineTheme = $b91cd2e5d1dd4f78$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $b91cd2e5d1dd4f78$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === "rtl";
    return /*#__PURE__*/ (0, $3QTul.jsx)((0, $kx8Rz.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $3QTul.jsx)((0, $eKWiI.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $3QTul.jsx)((0, $ldvJf.default), {
                value: rtlValue,
                children: children
            })
        })
    });
}
var $b91cd2e5d1dd4f78$export$2e2bcd8739ae039 = $b91cd2e5d1dd4f78$var$ThemeProvider;

});
parcelRegister("kx8Rz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef2dc3b856a66945$export$2e2bcd8739ae039; });

var $Rwt4Y = parcelRequire("Rwt4Y");

var $1kowh = parcelRequire("1kowh");



var $h7z85 = parcelRequire("h7z85");

var $ifxcD = parcelRequire("ifxcD");

var $hVjiI = parcelRequire("hVjiI");

var $3QTul = parcelRequire("3QTul");
function $ef2dc3b856a66945$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $Rwt4Y.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $ef2dc3b856a66945$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $ifxcD.default)();
    const theme = $1kowh.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $ef2dc3b856a66945$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $hVjiI.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $3QTul.jsx)((0, $h7z85.default).Provider, {
        value: theme,
        children: children
    });
}
var $ef2dc3b856a66945$export$2e2bcd8739ae039 = $ef2dc3b856a66945$var$ThemeProvider;

});
parcelRegister("h7z85", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c76e571c94b8ca11$export$2e2bcd8739ae039; });

var $1kowh = parcelRequire("1kowh");
const $c76e571c94b8ca11$var$ThemeContext = /*#__PURE__*/ $1kowh.createContext(null);
var $c76e571c94b8ca11$export$2e2bcd8739ae039 = $c76e571c94b8ca11$var$ThemeContext;

});

parcelRegister("ifxcD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4936219db74d062$export$2e2bcd8739ae039; });

var $1kowh = parcelRequire("1kowh");

var $h7z85 = parcelRequire("h7z85");
function $d4936219db74d062$export$2e2bcd8739ae039() {
    const theme = $1kowh.useContext((0, $h7z85.default));
    return theme;
}

});

parcelRegister("hVjiI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0c6bb4e04e974fc$export$2e2bcd8739ae039; });
const $d0c6bb4e04e974fc$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $d0c6bb4e04e974fc$export$2e2bcd8739ae039 = $d0c6bb4e04e974fc$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRegister("1bkmv", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $0dc69cfb6e425699$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $0dc69cfb6e425699$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $0dc69cfb6e425699$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("eKWiI")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("eKWiI")).w; });

var $eKWiI = parcelRequire("eKWiI");

var $1kowh = parcelRequire("1kowh");

var $gynzZ = parcelRequire("gynzZ");

var $6wkQa = parcelRequire("6wkQa");

var $aN96n = parcelRequire("aN96n");
parcelRequire("fV0eH");
parcelRequire("bfNLT");
parcelRequire("1Xq23");

parcelRequire("gTcgP");
var $0dc69cfb6e425699$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eKWiI.h).call(props, "css")) return $1kowh.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eKWiI.E);
    createElementArgArray[1] = (0, $eKWiI.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $1kowh.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($0dc69cfb6e425699$export$c8a8987d4410bf2d || ($0dc69cfb6e425699$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $0dc69cfb6e425699$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eKWiI.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $aN96n.serializeStyles)([
        styles
    ], undefined, $1kowh.useContext((0, $eKWiI.T)));
    if (!(0, $eKWiI.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $1kowh.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $1kowh.useRef();
    (0, $6wkQa.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $6wkQa.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $gynzZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $0dc69cfb6e425699$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $aN96n.serializeStyles)(args);
}
function $0dc69cfb6e425699$export$d25ddfdf17c3ad3e() {
    var insertable = $0dc69cfb6e425699$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $0dc69cfb6e425699$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $0dc69cfb6e425699$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $gynzZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $0dc69cfb6e425699$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $6wkQa.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $gynzZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eKWiI.i) && res !== undefined) rules += res;
        }
        if (!(0, $eKWiI.i)) return rules;
    });
    if (!(0, $eKWiI.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $1kowh.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $0dc69cfb6e425699$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eKWiI.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eKWiI.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $aN96n.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $gynzZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eKWiI.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $0dc69cfb6e425699$var$merge(cache.registered, css, $0dc69cfb6e425699$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $1kowh.useContext((0, $eKWiI.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $1kowh.createElement($1kowh.Fragment, null, /*#__PURE__*/ $1kowh.createElement($0dc69cfb6e425699$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eKWiI", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $abe295e44ef9a2e2$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $abe295e44ef9a2e2$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $abe295e44ef9a2e2$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $abe295e44ef9a2e2$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $abe295e44ef9a2e2$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $abe295e44ef9a2e2$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $abe295e44ef9a2e2$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $abe295e44ef9a2e2$export$a9c23c6ac3fc3eca; });

var $1kowh = parcelRequire("1kowh");

var $fV0eH = parcelRequire("fV0eH");

var $2mKDo = parcelRequire("2mKDo");

var $1Xq23 = parcelRequire("1Xq23");

var $l8Lcr = parcelRequire("l8Lcr");

var $gynzZ = parcelRequire("gynzZ");

var $aN96n = parcelRequire("aN96n");

var $6wkQa = parcelRequire("6wkQa");
var $abe295e44ef9a2e2$export$407448d2b89b1813 = false;
var $abe295e44ef9a2e2$export$23f2a1d2818174ef = typeof document !== "undefined";
var $abe295e44ef9a2e2$var$EmotionCacheContext = /* #__PURE__ */ $1kowh.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $fV0eH.default)({
    key: "css"
}) : null);
var $abe295e44ef9a2e2$export$e7094788287c5e9b = $abe295e44ef9a2e2$var$EmotionCacheContext.Provider;
var $abe295e44ef9a2e2$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $1kowh.useContext)($abe295e44ef9a2e2$var$EmotionCacheContext);
};
var $abe295e44ef9a2e2$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $1kowh.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $1kowh.useContext)($abe295e44ef9a2e2$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$abe295e44ef9a2e2$export$23f2a1d2818174ef) $abe295e44ef9a2e2$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $1kowh.useContext)($abe295e44ef9a2e2$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $fV0eH.default)({
                key: "css"
            });
            return /*#__PURE__*/ $1kowh.createElement($abe295e44ef9a2e2$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $abe295e44ef9a2e2$export$971d5caa766a69d7 = /* #__PURE__ */ $1kowh.createContext({});
var $abe295e44ef9a2e2$export$3b14a55fb2447963 = function useTheme() {
    return $1kowh.useContext($abe295e44ef9a2e2$export$971d5caa766a69d7);
};
var $abe295e44ef9a2e2$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $2mKDo.default)({}, outerTheme, theme);
};
var $abe295e44ef9a2e2$var$createCacheWithTheme = /* #__PURE__ */ (0, $1Xq23.default)(function(outerTheme) {
    return (0, $1Xq23.default)(function(theme) {
        return $abe295e44ef9a2e2$var$getTheme(outerTheme, theme);
    });
});
var $abe295e44ef9a2e2$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $1kowh.useContext($abe295e44ef9a2e2$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $abe295e44ef9a2e2$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $1kowh.createElement($abe295e44ef9a2e2$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $abe295e44ef9a2e2$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var WithTheme = /*#__PURE__*/ $1kowh.forwardRef(function render(props, ref) {
        var theme = $1kowh.useContext($abe295e44ef9a2e2$export$971d5caa766a69d7);
        return /*#__PURE__*/ $1kowh.createElement(Component, (0, $2mKDo.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $l8Lcr.default)(WithTheme, Component);
}
var $abe295e44ef9a2e2$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $abe295e44ef9a2e2$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $abe295e44ef9a2e2$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($abe295e44ef9a2e2$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$abe295e44ef9a2e2$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $abe295e44ef9a2e2$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $gynzZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $6wkQa.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $gynzZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$abe295e44ef9a2e2$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $1kowh.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $abe295e44ef9a2e2$var$Emotion = /* #__PURE__ */ $abe295e44ef9a2e2$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$abe295e44ef9a2e2$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $gynzZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $aN96n.serializeStyles)(registeredStyles, undefined, $1kowh.useContext($abe295e44ef9a2e2$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($abe295e44ef9a2e2$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== "css" && _key2 !== $abe295e44ef9a2e2$var$typePropName && !$abe295e44ef9a2e2$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $1kowh.createElement($1kowh.Fragment, null, /*#__PURE__*/ $1kowh.createElement($abe295e44ef9a2e2$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $1kowh.createElement(WrappedComponent, newProps));
});
var $abe295e44ef9a2e2$export$a9c23c6ac3fc3eca = $abe295e44ef9a2e2$var$Emotion;

});
parcelRegister("fV0eH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b96c5cc879b78332$export$2e2bcd8739ae039; });

var $yhr24 = parcelRequire("yhr24");

var $t3G57 = parcelRequire("t3G57");

var $1Xq23 = parcelRequire("1Xq23");

var $d3nIO = parcelRequire("d3nIO");
var $b96c5cc879b78332$var$isBrowser = typeof document !== "undefined";
var $b96c5cc879b78332$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $t3G57.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $t3G57.token)(character)) break;
        (0, $t3G57.next)();
    }
    return (0, $t3G57.slice)(begin, (0, $t3G57.position));
};
var $b96c5cc879b78332$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $t3G57.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $t3G57.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $b96c5cc879b78332$var$identifierWithPointTracking((0, $t3G57.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $t3G57.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $t3G57.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $t3G57.from)(character);
    }
    while (character = (0, $t3G57.next)());
    return parsed;
};
var $b96c5cc879b78332$var$getRules = function getRules(value, points) {
    return (0, $t3G57.dealloc)($b96c5cc879b78332$var$toRules((0, $t3G57.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $b96c5cc879b78332$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $b96c5cc879b78332$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$b96c5cc879b78332$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $b96c5cc879b78332$var$fixedElements.set(element, true);
    var points = [];
    var rules = $b96c5cc879b78332$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $b96c5cc879b78332$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $b96c5cc879b78332$var$prefix(value, length) {
    switch((0, $t3G57.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $t3G57.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $t3G57.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MOZ) + value + (0, $t3G57.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + value + value;
        // order
        case 6165:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.replace)(value, /(\w+).+(:[^]+)/, (0, $t3G57.WEBKIT) + "box-$1$2" + (0, $t3G57.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + "flex-item-" + (0, $t3G57.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + "flex-line-pack" + (0, $t3G57.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + (0, $t3G57.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + (0, $t3G57.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $t3G57.WEBKIT) + "box-" + (0, $t3G57.replace)(value, "-grow", "") + (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + (0, $t3G57.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $t3G57.WEBKIT) + (0, $t3G57.replace)(value, /([^-])(transform)/g, "$1" + (0, $t3G57.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $t3G57.replace)((0, $t3G57.replace)((0, $t3G57.replace)(value, /(zoom-|grab)/, (0, $t3G57.WEBKIT) + "$1"), /(image-set)/, (0, $t3G57.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $t3G57.replace)(value, /(image-set\([^]*)/, (0, $t3G57.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $t3G57.replace)((0, $t3G57.replace)(value, /(.+:)(flex-)?(.*)/, (0, $t3G57.WEBKIT) + "box-pack:$3" + (0, $t3G57.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $t3G57.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $t3G57.replace)(value, /(.+)-inline(.+)/, (0, $t3G57.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $t3G57.strlen)(value) - 1 - length > 6) switch((0, $t3G57.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $t3G57.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $t3G57.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $t3G57.WEBKIT) + "$2-$3" + "$1" + (0, $t3G57.MOZ) + ((0, $t3G57.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $t3G57.indexof)(value, "stretch") ? $b96c5cc879b78332$var$prefix((0, $t3G57.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $t3G57.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $t3G57.charat)(value, (0, $t3G57.strlen)(value) - 3 - (~(0, $t3G57.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $t3G57.replace)(value, ":", ":" + (0, $t3G57.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $t3G57.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $t3G57.WEBKIT) + ((0, $t3G57.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $t3G57.WEBKIT) + "$2$3" + "$1" + (0, $t3G57.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $t3G57.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + (0, $t3G57.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + (0, $t3G57.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + (0, $t3G57.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + value + value;
    }
    return value;
}
var $b96c5cc879b78332$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $t3G57.DECLARATION:
                element["return"] = $b96c5cc879b78332$var$prefix(element.value, element.length);
                break;
            case 0, $t3G57.KEYFRAMES:
                return (0, $t3G57.serialize)([
                    (0, $t3G57.copy)(element, {
                        value: (0, $t3G57.replace)(element.value, "@", "@" + (0, $t3G57.WEBKIT))
                    })
                ], callback);
            case 0, $t3G57.RULESET:
                if (element.length) return (0, $t3G57.combine)(element.props, function(value) {
                    switch((0, $t3G57.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $t3G57.serialize)([
                                (0, $t3G57.copy)(element, {
                                    props: [
                                        (0, $t3G57.replace)(value, /:(read-\w+)/, ":" + (0, $t3G57.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $t3G57.serialize)([
                                (0, $t3G57.copy)(element, {
                                    props: [
                                        (0, $t3G57.replace)(value, /:(plac\w+)/, ":" + (0, $t3G57.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $t3G57.copy)(element, {
                                    props: [
                                        (0, $t3G57.replace)(value, /:(plac\w+)/, ":" + (0, $t3G57.MOZ) + "$1")
                                    ]
                                }),
                                (0, $t3G57.copy)(element, {
                                    props: [
                                        (0, $t3G57.replace)(value, /:(plac\w+)/, (0, $t3G57.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $b96c5cc879b78332$var$getServerStylisCache = $b96c5cc879b78332$var$isBrowser ? undefined : (0, $1Xq23.default)(function() {
    return (0, $d3nIO.default)(function() {
        return {};
    });
});
var $b96c5cc879b78332$var$defaultStylisPlugins = [
    $b96c5cc879b78332$var$prefixer
];
var $b96c5cc879b78332$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($b96c5cc879b78332$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $b96c5cc879b78332$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($b96c5cc879b78332$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $b96c5cc879b78332$var$compat,
        $b96c5cc879b78332$var$removeLabel
    ];
    if (!$b96c5cc879b78332$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $t3G57.stringify),
            (0, $t3G57.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $t3G57.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $t3G57.serialize)((0, $t3G57.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $t3G57.stringify)
        ];
        var _serializer = (0, $t3G57.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $t3G57.serialize)((0, $t3G57.compile)(styles), _serializer);
        };
        var serverStylisCache = $b96c5cc879b78332$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $yhr24.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("yhr24", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $0670b351e87d54e0$export$9d753cd7ae895cce; });
var $0670b351e87d54e0$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $0670b351e87d54e0$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $0670b351e87d54e0$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $0670b351e87d54e0$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$0670b351e87d54e0$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($0670b351e87d54e0$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $0670b351e87d54e0$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("t3G57", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $c57b5939d774ff51$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $c57b5939d774ff51$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $c57b5939d774ff51$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $c57b5939d774ff51$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $c57b5939d774ff51$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $c57b5939d774ff51$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $c57b5939d774ff51$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $c57b5939d774ff51$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $c57b5939d774ff51$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $c57b5939d774ff51$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $c57b5939d774ff51$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $c57b5939d774ff51$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $c57b5939d774ff51$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $c57b5939d774ff51$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $c57b5939d774ff51$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $c57b5939d774ff51$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $c57b5939d774ff51$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $c57b5939d774ff51$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $c57b5939d774ff51$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $c57b5939d774ff51$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $c57b5939d774ff51$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $c57b5939d774ff51$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $c57b5939d774ff51$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $c57b5939d774ff51$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $c57b5939d774ff51$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $c57b5939d774ff51$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $c57b5939d774ff51$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $c57b5939d774ff51$export$38bcb760f1d4871c; });
var $c57b5939d774ff51$export$71ad59f2e432cfe8 = "-ms-";
var $c57b5939d774ff51$export$2c0f367103c8d01c = "-moz-";
var $c57b5939d774ff51$export$39dfd62a25e0fe93 = "-webkit-";
var $c57b5939d774ff51$export$a29989082612d0d9 = "comm";
var $c57b5939d774ff51$export$aa3a2e812ca8570d = "rule";
var $c57b5939d774ff51$export$527d108ccf083c2b = "decl";
var $c57b5939d774ff51$export$d3d35020fa5b54f0 = "@page";
var $c57b5939d774ff51$export$500415a86c544f73 = "@media";
var $c57b5939d774ff51$export$a763edbf796b780a = "@import";
var $c57b5939d774ff51$export$2790aeb8b4e5c826 = "@charset";
var $c57b5939d774ff51$export$1cc683e23b84b133 = "@viewport";
var $c57b5939d774ff51$export$9447a5efea57e862 = "@supports";
var $c57b5939d774ff51$export$ef011b4e114b1fba = "@document";
var $c57b5939d774ff51$export$6aad947bda0f3f46 = "@namespace";
var $c57b5939d774ff51$export$b44a8529a35fcb60 = "@keyframes";
var $c57b5939d774ff51$export$2c16de31893252e6 = "@font-face";
var $c57b5939d774ff51$export$3d846dd52e150c6f = "@counter-style";
var $c57b5939d774ff51$export$22314bfbb57653fe = "@font-feature-values";
var $c57b5939d774ff51$export$d773506282b3cfe6 = "@layer";
var $c57b5939d774ff51$export$2335f513bbd82c6d = Math.abs;
var $c57b5939d774ff51$export$6788812c4e6611e6 = String.fromCharCode;
var $c57b5939d774ff51$export$e6e34fd1f2686227 = Object.assign;
function $c57b5939d774ff51$export$d6af199866bfb566(e, r) {
    return $c57b5939d774ff51$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $c57b5939d774ff51$export$a9db5e087081082d(e, 0)) << 2 ^ $c57b5939d774ff51$export$a9db5e087081082d(e, 1)) << 2 ^ $c57b5939d774ff51$export$a9db5e087081082d(e, 2)) << 2 ^ $c57b5939d774ff51$export$a9db5e087081082d(e, 3) : 0;
}
function $c57b5939d774ff51$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $c57b5939d774ff51$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $c57b5939d774ff51$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $c57b5939d774ff51$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $c57b5939d774ff51$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $c57b5939d774ff51$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $c57b5939d774ff51$export$36776f635604f274(e) {
    return e.length;
}
function $c57b5939d774ff51$export$f9084667e487ed46(e) {
    return e.length;
}
function $c57b5939d774ff51$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $c57b5939d774ff51$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $c57b5939d774ff51$export$53f1d5ea8de3d7c = 1;
var $c57b5939d774ff51$export$4e0c71f277ca26b3 = 1;
var $c57b5939d774ff51$export$f24224f1c91d8156 = 0;
var $c57b5939d774ff51$export$5880b8b5730aff45 = 0;
var $c57b5939d774ff51$export$c0306caf338ac095 = 0;
var $c57b5939d774ff51$export$30a86d91af8ff6e6 = "";
function $c57b5939d774ff51$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $c57b5939d774ff51$export$53f1d5ea8de3d7c,
        column: $c57b5939d774ff51$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $c57b5939d774ff51$export$784d13d8ee351f07(e, r) {
    return $c57b5939d774ff51$export$e6e34fd1f2686227($c57b5939d774ff51$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $c57b5939d774ff51$export$eba6f6f03b0a92e7() {
    return $c57b5939d774ff51$export$c0306caf338ac095;
}
function $c57b5939d774ff51$export$232faf9add678146() {
    $c57b5939d774ff51$export$c0306caf338ac095 = $c57b5939d774ff51$export$5880b8b5730aff45 > 0 ? $c57b5939d774ff51$export$a9db5e087081082d($c57b5939d774ff51$export$30a86d91af8ff6e6, --$c57b5939d774ff51$export$5880b8b5730aff45) : 0;
    if ($c57b5939d774ff51$export$4e0c71f277ca26b3--, $c57b5939d774ff51$export$c0306caf338ac095 === 10) $c57b5939d774ff51$export$4e0c71f277ca26b3 = 1, $c57b5939d774ff51$export$53f1d5ea8de3d7c--;
    return $c57b5939d774ff51$export$c0306caf338ac095;
}
function $c57b5939d774ff51$export$48cfd1e771a65c4f() {
    $c57b5939d774ff51$export$c0306caf338ac095 = $c57b5939d774ff51$export$5880b8b5730aff45 < $c57b5939d774ff51$export$f24224f1c91d8156 ? $c57b5939d774ff51$export$a9db5e087081082d($c57b5939d774ff51$export$30a86d91af8ff6e6, $c57b5939d774ff51$export$5880b8b5730aff45++) : 0;
    if ($c57b5939d774ff51$export$4e0c71f277ca26b3++, $c57b5939d774ff51$export$c0306caf338ac095 === 10) $c57b5939d774ff51$export$4e0c71f277ca26b3 = 1, $c57b5939d774ff51$export$53f1d5ea8de3d7c++;
    return $c57b5939d774ff51$export$c0306caf338ac095;
}
function $c57b5939d774ff51$export$4d3fb11e950abb9e() {
    return $c57b5939d774ff51$export$a9db5e087081082d($c57b5939d774ff51$export$30a86d91af8ff6e6, $c57b5939d774ff51$export$5880b8b5730aff45);
}
function $c57b5939d774ff51$export$e88cb2efb12ae807() {
    return $c57b5939d774ff51$export$5880b8b5730aff45;
}
function $c57b5939d774ff51$export$58adb3bec8346d0f(e, r) {
    return $c57b5939d774ff51$export$2f35ab04d2335697($c57b5939d774ff51$export$30a86d91af8ff6e6, e, r);
}
function $c57b5939d774ff51$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $c57b5939d774ff51$export$2de70f21292aac9e(e) {
    return $c57b5939d774ff51$export$53f1d5ea8de3d7c = $c57b5939d774ff51$export$4e0c71f277ca26b3 = 1, $c57b5939d774ff51$export$f24224f1c91d8156 = $c57b5939d774ff51$export$36776f635604f274($c57b5939d774ff51$export$30a86d91af8ff6e6 = e), $c57b5939d774ff51$export$5880b8b5730aff45 = 0, [];
}
function $c57b5939d774ff51$export$45918ac1574455b1(e) {
    return $c57b5939d774ff51$export$30a86d91af8ff6e6 = "", e;
}
function $c57b5939d774ff51$export$410ac95b9ec204b8(e) {
    return $c57b5939d774ff51$export$87c2784dc9fc4ab($c57b5939d774ff51$export$58adb3bec8346d0f($c57b5939d774ff51$export$5880b8b5730aff45 - 1, $c57b5939d774ff51$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $c57b5939d774ff51$export$660b2ee2d4fb4eff(e) {
    return $c57b5939d774ff51$export$45918ac1574455b1($c57b5939d774ff51$export$5f8c09e3ae6f64e1($c57b5939d774ff51$export$2de70f21292aac9e(e)));
}
function $c57b5939d774ff51$export$7af1228ff777d175(e) {
    while($c57b5939d774ff51$export$c0306caf338ac095 = $c57b5939d774ff51$export$4d3fb11e950abb9e())if ($c57b5939d774ff51$export$c0306caf338ac095 < 33) $c57b5939d774ff51$export$48cfd1e771a65c4f();
    else break;
    return $c57b5939d774ff51$export$9e1725a4cfeada27(e) > 2 || $c57b5939d774ff51$export$9e1725a4cfeada27($c57b5939d774ff51$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $c57b5939d774ff51$export$5f8c09e3ae6f64e1(e) {
    while($c57b5939d774ff51$export$48cfd1e771a65c4f())switch($c57b5939d774ff51$export$9e1725a4cfeada27($c57b5939d774ff51$export$c0306caf338ac095)){
        case 0:
            $c57b5939d774ff51$export$10d8903dec122b9d($c57b5939d774ff51$export$c2ab62c7bf24634($c57b5939d774ff51$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $c57b5939d774ff51$export$10d8903dec122b9d($c57b5939d774ff51$export$410ac95b9ec204b8($c57b5939d774ff51$export$c0306caf338ac095), e);
            break;
        default:
            $c57b5939d774ff51$export$10d8903dec122b9d($c57b5939d774ff51$export$6788812c4e6611e6($c57b5939d774ff51$export$c0306caf338ac095), e);
    }
    return e;
}
function $c57b5939d774ff51$export$955ba06d119e085e(e, r) {
    while(--r && $c57b5939d774ff51$export$48cfd1e771a65c4f())if ($c57b5939d774ff51$export$c0306caf338ac095 < 48 || $c57b5939d774ff51$export$c0306caf338ac095 > 102 || $c57b5939d774ff51$export$c0306caf338ac095 > 57 && $c57b5939d774ff51$export$c0306caf338ac095 < 65 || $c57b5939d774ff51$export$c0306caf338ac095 > 70 && $c57b5939d774ff51$export$c0306caf338ac095 < 97) break;
    return $c57b5939d774ff51$export$58adb3bec8346d0f(e, $c57b5939d774ff51$export$e88cb2efb12ae807() + (r < 6 && $c57b5939d774ff51$export$4d3fb11e950abb9e() == 32 && $c57b5939d774ff51$export$48cfd1e771a65c4f() == 32));
}
function $c57b5939d774ff51$export$c889f2fcc19dbf12(e) {
    while($c57b5939d774ff51$export$48cfd1e771a65c4f())switch($c57b5939d774ff51$export$c0306caf338ac095){
        case e:
            return $c57b5939d774ff51$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $c57b5939d774ff51$export$c889f2fcc19dbf12($c57b5939d774ff51$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $c57b5939d774ff51$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $c57b5939d774ff51$export$48cfd1e771a65c4f();
            break;
    }
    return $c57b5939d774ff51$export$5880b8b5730aff45;
}
function $c57b5939d774ff51$export$4254d4e2b3745c4c(e, r) {
    while($c57b5939d774ff51$export$48cfd1e771a65c4f())if (e + $c57b5939d774ff51$export$c0306caf338ac095 === 57) break;
    else if (e + $c57b5939d774ff51$export$c0306caf338ac095 === 84 && $c57b5939d774ff51$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $c57b5939d774ff51$export$58adb3bec8346d0f(r, $c57b5939d774ff51$export$5880b8b5730aff45 - 1) + "*" + $c57b5939d774ff51$export$6788812c4e6611e6(e === 47 ? e : $c57b5939d774ff51$export$48cfd1e771a65c4f());
}
function $c57b5939d774ff51$export$c2ab62c7bf24634(e) {
    while(!$c57b5939d774ff51$export$9e1725a4cfeada27($c57b5939d774ff51$export$4d3fb11e950abb9e()))$c57b5939d774ff51$export$48cfd1e771a65c4f();
    return $c57b5939d774ff51$export$58adb3bec8346d0f(e, $c57b5939d774ff51$export$5880b8b5730aff45);
}
function $c57b5939d774ff51$export$ef7acd7185315e22(e) {
    return $c57b5939d774ff51$export$45918ac1574455b1($c57b5939d774ff51$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $c57b5939d774ff51$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $c57b5939d774ff51$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $c57b5939d774ff51$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $c57b5939d774ff51$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($c57b5939d774ff51$export$f8e21b1e77979a08(j += $c57b5939d774ff51$export$77ad94ebf1c2b9ed($c57b5939d774ff51$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $c57b5939d774ff51$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $c57b5939d774ff51$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $c57b5939d774ff51$export$955ba06d119e085e($c57b5939d774ff51$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($c57b5939d774ff51$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $c57b5939d774ff51$export$10d8903dec122b9d($c57b5939d774ff51$export$4a34f930e789283c($c57b5939d774ff51$export$4254d4e2b3745c4c($c57b5939d774ff51$export$48cfd1e771a65c4f(), $c57b5939d774ff51$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $c57b5939d774ff51$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $c57b5939d774ff51$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $c57b5939d774ff51$export$36776f635604f274(j) - l) $c57b5939d774ff51$export$10d8903dec122b9d(p > 32 ? $c57b5939d774ff51$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $c57b5939d774ff51$export$f8483753829ec8f3($c57b5939d774ff51$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $c57b5939d774ff51$export$10d8903dec122b9d(y = $c57b5939d774ff51$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $c57b5939d774ff51$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $c57b5939d774ff51$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $c57b5939d774ff51$export$98e6a39c04603d36(e, y, y, n && $c57b5939d774ff51$export$10d8903dec122b9d($c57b5939d774ff51$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $c57b5939d774ff51$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $c57b5939d774ff51$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $c57b5939d774ff51$export$232faf9add678146() == 125) continue;
            }
            switch(j += $c57b5939d774ff51$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($c57b5939d774ff51$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($c57b5939d774ff51$export$4d3fb11e950abb9e() === 45) j += $c57b5939d774ff51$export$410ac95b9ec204b8($c57b5939d774ff51$export$48cfd1e771a65c4f());
                    v = $c57b5939d774ff51$export$4d3fb11e950abb9e(), o = l = $c57b5939d774ff51$export$36776f635604f274(g = j += $c57b5939d774ff51$export$c2ab62c7bf24634($c57b5939d774ff51$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $c57b5939d774ff51$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $c57b5939d774ff51$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $c57b5939d774ff51$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $c57b5939d774ff51$export$2f35ab04d2335697(e, v + 1, v = $c57b5939d774ff51$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $c57b5939d774ff51$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $c57b5939d774ff51$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $c57b5939d774ff51$export$35059013cd4a06db(e, r, a, s === 0 ? $c57b5939d774ff51$export$aa3a2e812ca8570d : i, f, o, l);
}
function $c57b5939d774ff51$export$4a34f930e789283c(e, r, a) {
    return $c57b5939d774ff51$export$35059013cd4a06db(e, r, a, $c57b5939d774ff51$export$a29989082612d0d9, $c57b5939d774ff51$export$6788812c4e6611e6($c57b5939d774ff51$export$eba6f6f03b0a92e7()), $c57b5939d774ff51$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $c57b5939d774ff51$export$f8483753829ec8f3(e, r, a, n) {
    return $c57b5939d774ff51$export$35059013cd4a06db(e, r, a, $c57b5939d774ff51$export$527d108ccf083c2b, $c57b5939d774ff51$export$2f35ab04d2335697(e, 0, n), $c57b5939d774ff51$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $c57b5939d774ff51$export$82e9f45cca5ba907(n, c, s) {
    switch($c57b5939d774ff51$export$d6af199866bfb566(n, c)){
        case 5103:
            return $c57b5939d774ff51$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $c57b5939d774ff51$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + $c57b5939d774ff51$export$2c0f367103c8d01c + n + $c57b5939d774ff51$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($c57b5939d774ff51$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + $c57b5939d774ff51$export$71ad59f2e432cfe8 + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + $c57b5939d774ff51$export$71ad59f2e432cfe8 + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + $c57b5939d774ff51$export$71ad59f2e432cfe8 + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + $c57b5939d774ff51$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + $c57b5939d774ff51$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $c57b5939d774ff51$export$39dfd62a25e0fe93 + "box-$1$2" + $c57b5939d774ff51$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + $c57b5939d774ff51$export$71ad59f2e432cfe8 + "flex-item-" + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$c57b5939d774ff51$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $c57b5939d774ff51$export$71ad59f2e432cfe8 + "grid-row-" + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + $c57b5939d774ff51$export$71ad59f2e432cfe8 + "flex-line-pack" + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + $c57b5939d774ff51$export$71ad59f2e432cfe8 + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + $c57b5939d774ff51$export$71ad59f2e432cfe8 + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $c57b5939d774ff51$export$39dfd62a25e0fe93 + "box-" + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, "-grow", "") + $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + $c57b5939d774ff51$export$71ad59f2e432cfe8 + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $c57b5939d774ff51$export$39dfd62a25e0fe93 + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $c57b5939d774ff51$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $c57b5939d774ff51$export$77ad94ebf1c2b9ed($c57b5939d774ff51$export$77ad94ebf1c2b9ed($c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $c57b5939d774ff51$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $c57b5939d774ff51$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $c57b5939d774ff51$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $c57b5939d774ff51$export$77ad94ebf1c2b9ed($c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $c57b5939d774ff51$export$39dfd62a25e0fe93 + "box-pack:$3" + $c57b5939d774ff51$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $c57b5939d774ff51$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$c57b5939d774ff51$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $c57b5939d774ff51$export$71ad59f2e432cfe8 + "grid-column-align" + $c57b5939d774ff51$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $c57b5939d774ff51$export$71ad59f2e432cfe8 + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $c57b5939d774ff51$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$c57b5939d774ff51$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $c57b5939d774ff51$export$71ad59f2e432cfe8 + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $c57b5939d774ff51$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$c57b5939d774ff51$export$f8e21b1e77979a08(s, "span") ? $c57b5939d774ff51$export$4659b591c19bdf3d(s, /\d+/) : +$c57b5939d774ff51$export$4659b591c19bdf3d(s, /\d+/) - +$c57b5939d774ff51$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $c57b5939d774ff51$export$71ad59f2e432cfe8 + $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $c57b5939d774ff51$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $c57b5939d774ff51$export$71ad59f2e432cfe8 + $c57b5939d774ff51$export$77ad94ebf1c2b9ed($c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $c57b5939d774ff51$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($c57b5939d774ff51$export$36776f635604f274(n) - 1 - c > 6) switch($c57b5939d774ff51$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($c57b5939d774ff51$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $c57b5939d774ff51$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $c57b5939d774ff51$export$2c0f367103c8d01c + ($c57b5939d774ff51$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$c57b5939d774ff51$export$f8e21b1e77979a08(n, "stretch") ? $c57b5939d774ff51$export$82e9f45cca5ba907($c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $c57b5939d774ff51$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $c57b5939d774ff51$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($c57b5939d774ff51$export$a9db5e087081082d(n, c + 6) === 121) return $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, ":", ":" + $c57b5939d774ff51$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($c57b5939d774ff51$export$a9db5e087081082d(n, $c57b5939d774ff51$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $c57b5939d774ff51$export$39dfd62a25e0fe93 + ($c57b5939d774ff51$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $c57b5939d774ff51$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $c57b5939d774ff51$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, ":", ":" + $c57b5939d774ff51$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $c57b5939d774ff51$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $c57b5939d774ff51$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $c57b5939d774ff51$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $c57b5939d774ff51$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $c57b5939d774ff51$export$a763edbf796b780a:
        case $c57b5939d774ff51$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $c57b5939d774ff51$export$a29989082612d0d9:
            return "";
        case $c57b5939d774ff51$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $c57b5939d774ff51$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $c57b5939d774ff51$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $c57b5939d774ff51$export$36776f635604f274(a = $c57b5939d774ff51$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $c57b5939d774ff51$export$5a7767152ae0305f(e) {
    var r = $c57b5939d774ff51$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $c57b5939d774ff51$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $c57b5939d774ff51$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $c57b5939d774ff51$export$527d108ccf083c2b:
                n.return = $c57b5939d774ff51$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $c57b5939d774ff51$export$b44a8529a35fcb60:
                return $c57b5939d774ff51$export$dfdc1655ccc5b9cb([
                    $c57b5939d774ff51$export$784d13d8ee351f07(n, {
                        value: $c57b5939d774ff51$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $c57b5939d774ff51$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $c57b5939d774ff51$export$aa3a2e812ca8570d:
                if (n.length) return $c57b5939d774ff51$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($c57b5939d774ff51$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $c57b5939d774ff51$export$dfdc1655ccc5b9cb([
                                $c57b5939d774ff51$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c57b5939d774ff51$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $c57b5939d774ff51$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $c57b5939d774ff51$export$dfdc1655ccc5b9cb([
                                $c57b5939d774ff51$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c57b5939d774ff51$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c57b5939d774ff51$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $c57b5939d774ff51$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c57b5939d774ff51$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c57b5939d774ff51$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $c57b5939d774ff51$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c57b5939d774ff51$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $c57b5939d774ff51$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $c57b5939d774ff51$export$76a88f7de6507443(e) {
    switch(e.type){
        case $c57b5939d774ff51$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $c57b5939d774ff51$export$1be1fc439b849fdf($c57b5939d774ff51$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($c57b5939d774ff51$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $c57b5939d774ff51$export$2f35ab04d2335697(r, 1, $c57b5939d774ff51$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $c57b5939d774ff51$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $c57b5939d774ff51$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $c57b5939d774ff51$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("1Xq23", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16cf7e9184abac44$export$2e2bcd8739ae039; });
var $16cf7e9184abac44$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("d3nIO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $980df4d243ae18ea$export$2e2bcd8739ae039; });
function $980df4d243ae18ea$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("2mKDo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b91cf7962d28195$export$2e2bcd8739ae039; });
function $1b91cf7962d28195$export$2e2bcd8739ae039() {
    $1b91cf7962d28195$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1b91cf7962d28195$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("l8Lcr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f63ef52e20bca60d$export$2e2bcd8739ae039; });

var $gTcgP = parcelRequire("gTcgP");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f63ef52e20bca60d$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gTcgP)))(targetComponent, sourceComponent);
};

});
parcelRegister("gTcgP", function(module, exports) {
"use strict";

var $8BY6f = parcelRequire("8BY6f");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $c4bb4d06a840dc5c$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $c4bb4d06a840dc5c$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $c4bb4d06a840dc5c$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $c4bb4d06a840dc5c$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $c4bb4d06a840dc5c$var$TYPE_STATICS = {};
$c4bb4d06a840dc5c$var$TYPE_STATICS[$8BY6f.ForwardRef] = $c4bb4d06a840dc5c$var$FORWARD_REF_STATICS;
$c4bb4d06a840dc5c$var$TYPE_STATICS[$8BY6f.Memo] = $c4bb4d06a840dc5c$var$MEMO_STATICS;
function $c4bb4d06a840dc5c$var$getStatics(component) {
    // React v16.11 and below
    if ($8BY6f.isMemo(component)) return $c4bb4d06a840dc5c$var$MEMO_STATICS;
     // React v16.12 and above
    return $c4bb4d06a840dc5c$var$TYPE_STATICS[component["$$typeof"]] || $c4bb4d06a840dc5c$var$REACT_STATICS;
}
var $c4bb4d06a840dc5c$var$defineProperty = Object.defineProperty;
var $c4bb4d06a840dc5c$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $c4bb4d06a840dc5c$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c4bb4d06a840dc5c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $c4bb4d06a840dc5c$var$getPrototypeOf = Object.getPrototypeOf;
var $c4bb4d06a840dc5c$var$objectPrototype = Object.prototype;
function $c4bb4d06a840dc5c$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($c4bb4d06a840dc5c$var$objectPrototype) {
            var inheritedComponent = $c4bb4d06a840dc5c$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $c4bb4d06a840dc5c$var$objectPrototype) $c4bb4d06a840dc5c$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $c4bb4d06a840dc5c$var$getOwnPropertyNames(sourceComponent);
        if ($c4bb4d06a840dc5c$var$getOwnPropertySymbols) keys = keys.concat($c4bb4d06a840dc5c$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $c4bb4d06a840dc5c$var$getStatics(targetComponent);
        var sourceStatics = $c4bb4d06a840dc5c$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$c4bb4d06a840dc5c$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $c4bb4d06a840dc5c$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $c4bb4d06a840dc5c$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $c4bb4d06a840dc5c$var$hoistNonReactStatics;

});
parcelRegister("8BY6f", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5LyWW"));

});
parcelRegister("5LyWW", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $432c73cdb3bfdc0f$export$2b8d127b894957b9; }, function (v) { return $432c73cdb3bfdc0f$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $432c73cdb3bfdc0f$export$cea3a54a6425200c; }, function (v) { return $432c73cdb3bfdc0f$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $432c73cdb3bfdc0f$export$a7c73072b1a182ae; }, function (v) { return $432c73cdb3bfdc0f$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $432c73cdb3bfdc0f$export$9f27bc3417b4524d; }, function (v) { return $432c73cdb3bfdc0f$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $432c73cdb3bfdc0f$export$db77ccec0bb4ccac; }, function (v) { return $432c73cdb3bfdc0f$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $432c73cdb3bfdc0f$export$8392c0c9d3dcbd35; }, function (v) { return $432c73cdb3bfdc0f$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $432c73cdb3bfdc0f$export$ffb0004e005737fa; }, function (v) { return $432c73cdb3bfdc0f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $432c73cdb3bfdc0f$export$b624eff549462981; }, function (v) { return $432c73cdb3bfdc0f$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $432c73cdb3bfdc0f$export$7897aa7841a5380c; }, function (v) { return $432c73cdb3bfdc0f$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $432c73cdb3bfdc0f$export$602eac185826482c; }, function (v) { return $432c73cdb3bfdc0f$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $432c73cdb3bfdc0f$export$e2c29f18771995cb; }, function (v) { return $432c73cdb3bfdc0f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $432c73cdb3bfdc0f$export$5f8d39834fd61797; }, function (v) { return $432c73cdb3bfdc0f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $432c73cdb3bfdc0f$export$74bf444e3cd11ea5; }, function (v) { return $432c73cdb3bfdc0f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $432c73cdb3bfdc0f$export$92387174baf9b227; }, function (v) { return $432c73cdb3bfdc0f$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $432c73cdb3bfdc0f$export$ec112efeb987d9c6; }, function (v) { return $432c73cdb3bfdc0f$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $432c73cdb3bfdc0f$export$b706b080d889d2c9; }, function (v) { return $432c73cdb3bfdc0f$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $432c73cdb3bfdc0f$export$5be5a87408f70ddc; }, function (v) { return $432c73cdb3bfdc0f$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $432c73cdb3bfdc0f$export$45a5e7f76e0caa8d; }, function (v) { return $432c73cdb3bfdc0f$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $432c73cdb3bfdc0f$export$455c2e768291efa6; }, function (v) { return $432c73cdb3bfdc0f$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $432c73cdb3bfdc0f$export$9522e17588c12572; }, function (v) { return $432c73cdb3bfdc0f$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $432c73cdb3bfdc0f$export$2110ac352bb060b9; }, function (v) { return $432c73cdb3bfdc0f$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $432c73cdb3bfdc0f$export$56885ab8b9c456ab; }, function (v) { return $432c73cdb3bfdc0f$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $432c73cdb3bfdc0f$export$d927fcb6adf8f9de; }, function (v) { return $432c73cdb3bfdc0f$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $432c73cdb3bfdc0f$export$b82d16f27459e05a; }, function (v) { return $432c73cdb3bfdc0f$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $432c73cdb3bfdc0f$export$522c17b4f5e123e8; }, function (v) { return $432c73cdb3bfdc0f$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $432c73cdb3bfdc0f$export$1aabd8a0274ecfd6; }, function (v) { return $432c73cdb3bfdc0f$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $432c73cdb3bfdc0f$export$9b621391a187a31a; }, function (v) { return $432c73cdb3bfdc0f$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $432c73cdb3bfdc0f$export$f5bbd400c2f4426f; }, function (v) { return $432c73cdb3bfdc0f$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $432c73cdb3bfdc0f$export$2b8d127b894957b9;
var $432c73cdb3bfdc0f$export$cea3a54a6425200c;
var $432c73cdb3bfdc0f$export$a7c73072b1a182ae;
var $432c73cdb3bfdc0f$export$9f27bc3417b4524d;
var $432c73cdb3bfdc0f$export$db77ccec0bb4ccac;
var $432c73cdb3bfdc0f$export$8392c0c9d3dcbd35;
var $432c73cdb3bfdc0f$export$ffb0004e005737fa;
var $432c73cdb3bfdc0f$export$b624eff549462981;
var $432c73cdb3bfdc0f$export$7897aa7841a5380c;
var $432c73cdb3bfdc0f$export$602eac185826482c;
var $432c73cdb3bfdc0f$export$e2c29f18771995cb;
var $432c73cdb3bfdc0f$export$5f8d39834fd61797;
var $432c73cdb3bfdc0f$export$74bf444e3cd11ea5;
var $432c73cdb3bfdc0f$export$92387174baf9b227;
var $432c73cdb3bfdc0f$export$ec112efeb987d9c6;
var $432c73cdb3bfdc0f$export$b706b080d889d2c9;
var $432c73cdb3bfdc0f$export$5be5a87408f70ddc;
var $432c73cdb3bfdc0f$export$45a5e7f76e0caa8d;
var $432c73cdb3bfdc0f$export$455c2e768291efa6;
var $432c73cdb3bfdc0f$export$9522e17588c12572;
var $432c73cdb3bfdc0f$export$2110ac352bb060b9;
var $432c73cdb3bfdc0f$export$56885ab8b9c456ab;
var $432c73cdb3bfdc0f$export$d927fcb6adf8f9de;
var $432c73cdb3bfdc0f$export$b82d16f27459e05a;
var $432c73cdb3bfdc0f$export$522c17b4f5e123e8;
var $432c73cdb3bfdc0f$export$1aabd8a0274ecfd6;
var $432c73cdb3bfdc0f$export$9b621391a187a31a;
var $432c73cdb3bfdc0f$export$f5bbd400c2f4426f;
"use strict";
var $432c73cdb3bfdc0f$var$b = "function" === typeof Symbol && Symbol.for, $432c73cdb3bfdc0f$var$c = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.element") : 60103, $432c73cdb3bfdc0f$var$d = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.portal") : 60106, $432c73cdb3bfdc0f$var$e = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.fragment") : 60107, $432c73cdb3bfdc0f$var$f = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.strict_mode") : 60108, $432c73cdb3bfdc0f$var$g = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.profiler") : 60114, $432c73cdb3bfdc0f$var$h = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.provider") : 60109, $432c73cdb3bfdc0f$var$k = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.context") : 60110, $432c73cdb3bfdc0f$var$l = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.async_mode") : 60111, $432c73cdb3bfdc0f$var$m = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $432c73cdb3bfdc0f$var$n = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.forward_ref") : 60112, $432c73cdb3bfdc0f$var$p = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.suspense") : 60113, $432c73cdb3bfdc0f$var$q = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.suspense_list") : 60120, $432c73cdb3bfdc0f$var$r = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.memo") : 60115, $432c73cdb3bfdc0f$var$t = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.lazy") : 60116, $432c73cdb3bfdc0f$var$v = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.block") : 60121, $432c73cdb3bfdc0f$var$w = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.fundamental") : 60117, $432c73cdb3bfdc0f$var$x = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.responder") : 60118, $432c73cdb3bfdc0f$var$y = $432c73cdb3bfdc0f$var$b ? Symbol.for("react.scope") : 60119;
function $432c73cdb3bfdc0f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $432c73cdb3bfdc0f$var$c:
                switch(a = a.type, a){
                    case $432c73cdb3bfdc0f$var$l:
                    case $432c73cdb3bfdc0f$var$m:
                    case $432c73cdb3bfdc0f$var$e:
                    case $432c73cdb3bfdc0f$var$g:
                    case $432c73cdb3bfdc0f$var$f:
                    case $432c73cdb3bfdc0f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $432c73cdb3bfdc0f$var$k:
                            case $432c73cdb3bfdc0f$var$n:
                            case $432c73cdb3bfdc0f$var$t:
                            case $432c73cdb3bfdc0f$var$r:
                            case $432c73cdb3bfdc0f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $432c73cdb3bfdc0f$var$d:
                return u;
        }
    }
}
function $432c73cdb3bfdc0f$var$A(a) {
    return $432c73cdb3bfdc0f$var$z(a) === $432c73cdb3bfdc0f$var$m;
}
$432c73cdb3bfdc0f$export$2b8d127b894957b9 = $432c73cdb3bfdc0f$var$l;
$432c73cdb3bfdc0f$export$cea3a54a6425200c = $432c73cdb3bfdc0f$var$m;
$432c73cdb3bfdc0f$export$a7c73072b1a182ae = $432c73cdb3bfdc0f$var$k;
$432c73cdb3bfdc0f$export$9f27bc3417b4524d = $432c73cdb3bfdc0f$var$h;
$432c73cdb3bfdc0f$export$db77ccec0bb4ccac = $432c73cdb3bfdc0f$var$c;
$432c73cdb3bfdc0f$export$8392c0c9d3dcbd35 = $432c73cdb3bfdc0f$var$n;
$432c73cdb3bfdc0f$export$ffb0004e005737fa = $432c73cdb3bfdc0f$var$e;
$432c73cdb3bfdc0f$export$b624eff549462981 = $432c73cdb3bfdc0f$var$t;
$432c73cdb3bfdc0f$export$7897aa7841a5380c = $432c73cdb3bfdc0f$var$r;
$432c73cdb3bfdc0f$export$602eac185826482c = $432c73cdb3bfdc0f$var$d;
$432c73cdb3bfdc0f$export$e2c29f18771995cb = $432c73cdb3bfdc0f$var$g;
$432c73cdb3bfdc0f$export$5f8d39834fd61797 = $432c73cdb3bfdc0f$var$f;
$432c73cdb3bfdc0f$export$74bf444e3cd11ea5 = $432c73cdb3bfdc0f$var$p;
$432c73cdb3bfdc0f$export$92387174baf9b227 = function(a) {
    return $432c73cdb3bfdc0f$var$A(a) || $432c73cdb3bfdc0f$var$z(a) === $432c73cdb3bfdc0f$var$l;
};
$432c73cdb3bfdc0f$export$ec112efeb987d9c6 = $432c73cdb3bfdc0f$var$A;
$432c73cdb3bfdc0f$export$b706b080d889d2c9 = function(a) {
    return $432c73cdb3bfdc0f$var$z(a) === $432c73cdb3bfdc0f$var$k;
};
$432c73cdb3bfdc0f$export$5be5a87408f70ddc = function(a) {
    return $432c73cdb3bfdc0f$var$z(a) === $432c73cdb3bfdc0f$var$h;
};
$432c73cdb3bfdc0f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $432c73cdb3bfdc0f$var$c;
};
$432c73cdb3bfdc0f$export$455c2e768291efa6 = function(a) {
    return $432c73cdb3bfdc0f$var$z(a) === $432c73cdb3bfdc0f$var$n;
};
$432c73cdb3bfdc0f$export$9522e17588c12572 = function(a) {
    return $432c73cdb3bfdc0f$var$z(a) === $432c73cdb3bfdc0f$var$e;
};
$432c73cdb3bfdc0f$export$2110ac352bb060b9 = function(a) {
    return $432c73cdb3bfdc0f$var$z(a) === $432c73cdb3bfdc0f$var$t;
};
$432c73cdb3bfdc0f$export$56885ab8b9c456ab = function(a) {
    return $432c73cdb3bfdc0f$var$z(a) === $432c73cdb3bfdc0f$var$r;
};
$432c73cdb3bfdc0f$export$d927fcb6adf8f9de = function(a) {
    return $432c73cdb3bfdc0f$var$z(a) === $432c73cdb3bfdc0f$var$d;
};
$432c73cdb3bfdc0f$export$b82d16f27459e05a = function(a) {
    return $432c73cdb3bfdc0f$var$z(a) === $432c73cdb3bfdc0f$var$g;
};
$432c73cdb3bfdc0f$export$522c17b4f5e123e8 = function(a) {
    return $432c73cdb3bfdc0f$var$z(a) === $432c73cdb3bfdc0f$var$f;
};
$432c73cdb3bfdc0f$export$1aabd8a0274ecfd6 = function(a) {
    return $432c73cdb3bfdc0f$var$z(a) === $432c73cdb3bfdc0f$var$p;
};
$432c73cdb3bfdc0f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $432c73cdb3bfdc0f$var$e || a === $432c73cdb3bfdc0f$var$m || a === $432c73cdb3bfdc0f$var$g || a === $432c73cdb3bfdc0f$var$f || a === $432c73cdb3bfdc0f$var$p || a === $432c73cdb3bfdc0f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $432c73cdb3bfdc0f$var$t || a.$$typeof === $432c73cdb3bfdc0f$var$r || a.$$typeof === $432c73cdb3bfdc0f$var$h || a.$$typeof === $432c73cdb3bfdc0f$var$k || a.$$typeof === $432c73cdb3bfdc0f$var$n || a.$$typeof === $432c73cdb3bfdc0f$var$w || a.$$typeof === $432c73cdb3bfdc0f$var$x || a.$$typeof === $432c73cdb3bfdc0f$var$y || a.$$typeof === $432c73cdb3bfdc0f$var$v);
};
$432c73cdb3bfdc0f$export$f5bbd400c2f4426f = $432c73cdb3bfdc0f$var$z;

});




parcelRegister("gynzZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $c0d21cb09134ec8e$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $c0d21cb09134ec8e$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $c0d21cb09134ec8e$export$6f077d94b33a01aa; });
var $c0d21cb09134ec8e$var$isBrowser = typeof document !== "undefined";
function $c0d21cb09134ec8e$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $c0d21cb09134ec8e$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $c0d21cb09134ec8e$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $c0d21cb09134ec8e$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $c0d21cb09134ec8e$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$c0d21cb09134ec8e$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$c0d21cb09134ec8e$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("aN96n", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $7db58a692d50779f$export$6321afa313b251b5; });

var $afeih = parcelRequire("afeih");

var $68zyg = parcelRequire("68zyg");

var $d3nIO = parcelRequire("d3nIO");
var $7db58a692d50779f$var$isDevelopment = false;
var $7db58a692d50779f$var$hyphenateRegex = /[A-Z]|^ms/g;
var $7db58a692d50779f$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $7db58a692d50779f$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $7db58a692d50779f$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $7db58a692d50779f$var$processStyleName = /* #__PURE__ */ (0, $d3nIO.default)(function(styleName) {
    return $7db58a692d50779f$var$isCustomProperty(styleName) ? styleName : styleName.replace($7db58a692d50779f$var$hyphenateRegex, "-$&").toLowerCase();
});
var $7db58a692d50779f$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($7db58a692d50779f$var$animationRegex, function(match, p1, p2) {
                $7db58a692d50779f$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $7db58a692d50779f$var$cursor
                };
                return p1;
            });
    }
    if ((0, $68zyg.default)[key] !== 1 && !$7db58a692d50779f$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $7db58a692d50779f$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $7db58a692d50779f$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $7db58a692d50779f$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $7db58a692d50779f$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $7db58a692d50779f$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $7db58a692d50779f$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $7db58a692d50779f$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $7db58a692d50779f$var$cursor;
                var result = interpolation(mergedProps);
                $7db58a692d50779f$var$cursor = previousCursor;
                return $7db58a692d50779f$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $7db58a692d50779f$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $7db58a692d50779f$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($7db58a692d50779f$var$isProcessableValue(asString)) string += $7db58a692d50779f$var$processStyleName(key) + ":" + $7db58a692d50779f$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $7db58a692d50779f$var$isDevelopment) throw new Error($7db58a692d50779f$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($7db58a692d50779f$var$isProcessableValue(value[_i])) string += $7db58a692d50779f$var$processStyleName(key) + ":" + $7db58a692d50779f$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $7db58a692d50779f$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $7db58a692d50779f$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $7db58a692d50779f$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $7db58a692d50779f$var$cursor;
function $7db58a692d50779f$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $7db58a692d50779f$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $7db58a692d50779f$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $7db58a692d50779f$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $7db58a692d50779f$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $7db58a692d50779f$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $afeih.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $7db58a692d50779f$var$cursor
    };
}

});
parcelRegister("afeih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7756648f0c2d4ed4$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $7756648f0c2d4ed4$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("68zyg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $477f1145c8ff80b5$export$2e2bcd8739ae039; });
var $477f1145c8ff80b5$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("6wkQa", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $4bf5e5b4aabe0b7f$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $4bf5e5b4aabe0b7f$export$811a713a7276cb9d; });

var $1kowh = parcelRequire("1kowh");
var $4bf5e5b4aabe0b7f$var$isBrowser = typeof document !== "undefined";
var $4bf5e5b4aabe0b7f$var$syncFallback = function syncFallback(create) {
    return create();
};
var $4bf5e5b4aabe0b7f$var$useInsertionEffect = $1kowh.useInsertionEffect ? $1kowh.useInsertionEffect : false;
var $4bf5e5b4aabe0b7f$export$db21c7ffa21794e7 = !$4bf5e5b4aabe0b7f$var$isBrowser ? $4bf5e5b4aabe0b7f$var$syncFallback : $4bf5e5b4aabe0b7f$var$useInsertionEffect || $4bf5e5b4aabe0b7f$var$syncFallback;
var $4bf5e5b4aabe0b7f$export$811a713a7276cb9d = $4bf5e5b4aabe0b7f$var$useInsertionEffect || $1kowh.useLayoutEffect;

});


parcelRegister("bfNLT", function(module, exports) {
function $8317b403696f2b9e$var$_extends() {
    module.exports = $8317b403696f2b9e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $8317b403696f2b9e$var$_extends.apply(this, arguments);
}
module.exports = $8317b403696f2b9e$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bsrF1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8577c413ac0e42fa$export$2e2bcd8739ae039; });

var $1kowh = parcelRequire("1kowh");
parcelRequire("1bkmv");
var $eKWiI = parcelRequire("eKWiI");
"use client";
function $8577c413ac0e42fa$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $8577c413ac0e42fa$var$useTheme(defaultTheme = null) {
    const contextTheme = $1kowh.useContext((0, $eKWiI.T));
    return !contextTheme || $8577c413ac0e42fa$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $8577c413ac0e42fa$export$2e2bcd8739ae039 = $8577c413ac0e42fa$var$useTheme;

});

parcelRegister("ldvJf", function(module, exports) {

$parcel$export(module.exports, "useRtl", function () { return $f7236c9171ceb98d$export$b2dd014b6c321cb; });
$parcel$export(module.exports, "default", function () { return $f7236c9171ceb98d$export$2e2bcd8739ae039; });

var $Rwt4Y = parcelRequire("Rwt4Y");

var $7lC2m = parcelRequire("7lC2m");

var $1kowh = parcelRequire("1kowh");


var $3QTul = parcelRequire("3QTul");
const $f7236c9171ceb98d$var$_excluded = [
    "value"
];
const $f7236c9171ceb98d$var$RtlContext = /*#__PURE__*/ $1kowh.createContext();
function $f7236c9171ceb98d$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $7lC2m.default)(_ref, $f7236c9171ceb98d$var$_excluded);
    return /*#__PURE__*/ (0, $3QTul.jsx)($f7236c9171ceb98d$var$RtlContext.Provider, (0, $Rwt4Y.default)({
        value: value != null ? value : true
    }, props));
}
const $f7236c9171ceb98d$export$b2dd014b6c321cb = ()=>{
    const value = $1kowh.useContext($f7236c9171ceb98d$var$RtlContext);
    return value != null ? value : false;
};
var $f7236c9171ceb98d$export$2e2bcd8739ae039 = $f7236c9171ceb98d$var$RtlProvider;

});


parcelRegister("25rSD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1851acd855150044$export$2e2bcd8739ae039; });
var $1851acd855150044$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("RD2UU", function(module, exports) {

$parcel$export(module.exports, "alpha", function () { return $0a133d1551b803d1$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $0a133d1551b803d1$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $0a133d1551b803d1$export$c0816ed86df316af; });
$parcel$export(module.exports, "emphasize", function () { return $0a133d1551b803d1$export$e665714f76e581fd; });

var $dzEWX = parcelRequire("dzEWX");

var $j0PmA = parcelRequire("j0PmA");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $0a133d1551b803d1$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $j0PmA.default)(value, min, max);
}
function $0a133d1551b803d1$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $0a133d1551b803d1$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $0a133d1551b803d1$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $0a133d1551b803d1$export$677b39864803984e($0a133d1551b803d1$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $dzEWX.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $dzEWX.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $0a133d1551b803d1$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $0a133d1551b803d1$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $0a133d1551b803d1$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $0a133d1551b803d1$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $0a133d1551b803d1$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $0a133d1551b803d1$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $0a133d1551b803d1$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$0a133d1551b803d1$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $0a133d1551b803d1$export$29fb7152bd3f781a(color) {
    color = $0a133d1551b803d1$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $0a133d1551b803d1$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $0a133d1551b803d1$export$c852d90bf7403b62(color) {
    color = $0a133d1551b803d1$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $0a133d1551b803d1$export$677b39864803984e($0a133d1551b803d1$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $0a133d1551b803d1$export$d061e26956a60b0a(foreground, background) {
    const lumA = $0a133d1551b803d1$export$c852d90bf7403b62(foreground);
    const lumB = $0a133d1551b803d1$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $0a133d1551b803d1$export$58f0f39f63f3cf42(color, value) {
    color = $0a133d1551b803d1$export$677b39864803984e(color);
    value = $0a133d1551b803d1$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $0a133d1551b803d1$export$211a73f2b8c10ce4(color);
}
function $0a133d1551b803d1$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $0a133d1551b803d1$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $0a133d1551b803d1$export$4b073707ff63303(color, coefficient) {
    color = $0a133d1551b803d1$export$677b39864803984e(color);
    coefficient = $0a133d1551b803d1$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $0a133d1551b803d1$export$211a73f2b8c10ce4(color);
}
function $0a133d1551b803d1$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $0a133d1551b803d1$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $0a133d1551b803d1$export$c0816ed86df316af(color, coefficient) {
    color = $0a133d1551b803d1$export$677b39864803984e(color);
    coefficient = $0a133d1551b803d1$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $0a133d1551b803d1$export$211a73f2b8c10ce4(color);
}
function $0a133d1551b803d1$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $0a133d1551b803d1$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $0a133d1551b803d1$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $0a133d1551b803d1$export$c852d90bf7403b62(color) > 0.5 ? $0a133d1551b803d1$export$4b073707ff63303(color, coefficient) : $0a133d1551b803d1$export$c0816ed86df316af(color, coefficient);
}
function $0a133d1551b803d1$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $0a133d1551b803d1$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $0a133d1551b803d1$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $0a133d1551b803d1$export$677b39864803984e(background);
    const overlayColor = $0a133d1551b803d1$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $0a133d1551b803d1$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}

});

parcelRegister("fgCTa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1d6842171a44156$export$2e2bcd8739ae039; });

var $7lC2m = parcelRequire("7lC2m");

var $Rwt4Y = parcelRequire("Rwt4Y");

var $1kowh = parcelRequire("1kowh");


var $4IMR9 = parcelRequire("4IMR9");


var $g6GaX = parcelRequire("g6GaX");

var $1bkmv = parcelRequire("1bkmv");

var $c2aca = parcelRequire("c2aca");

var $g98HC = parcelRequire("g98HC");

var $1r1xG = parcelRequire("1r1xG");

var $dtFw4 = parcelRequire("dtFw4");

var $3QTul = parcelRequire("3QTul");
"use client";
let $b1d6842171a44156$var$_ = (t)=>t, $b1d6842171a44156$var$t, $b1d6842171a44156$var$t1, $b1d6842171a44156$var$t2, $b1d6842171a44156$var$t3;
const $b1d6842171a44156$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $b1d6842171a44156$var$_1 = (t)=>t, $b1d6842171a44156$var$_t, $b1d6842171a44156$var$_t2, $b1d6842171a44156$var$_t3, $b1d6842171a44156$var$_t4;
const $b1d6842171a44156$var$SIZE = 44;
const $b1d6842171a44156$var$circularRotateKeyframe = (0, $1bkmv.keyframes)($b1d6842171a44156$var$_t || ($b1d6842171a44156$var$_t = $b1d6842171a44156$var$_1($b1d6842171a44156$var$t || ($b1d6842171a44156$var$t = $b1d6842171a44156$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`))));
const $b1d6842171a44156$var$circularDashKeyframe = (0, $1bkmv.keyframes)($b1d6842171a44156$var$_t2 || ($b1d6842171a44156$var$_t2 = $b1d6842171a44156$var$_1($b1d6842171a44156$var$t1 || ($b1d6842171a44156$var$t1 = $b1d6842171a44156$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`))));
const $b1d6842171a44156$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $c2aca.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $c2aca.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $g6GaX.default)(slots, (0, $dtFw4.getCircularProgressUtilityClass), classes);
};
const $b1d6842171a44156$var$CircularProgressRoot = (0, $1r1xG.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $c2aca.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $Rwt4Y.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $1bkmv.css)($b1d6842171a44156$var$_t3 || ($b1d6842171a44156$var$_t3 = $b1d6842171a44156$var$_1($b1d6842171a44156$var$t2 || ($b1d6842171a44156$var$t2 = $b1d6842171a44156$var$_`
      animation: ${0} 1.4s linear infinite;
    `), 0)), $b1d6842171a44156$var$circularRotateKeyframe));
const $b1d6842171a44156$var$CircularProgressSVG = (0, $1r1xG.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $b1d6842171a44156$var$CircularProgressCircle = (0, $1r1xG.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $c2aca.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $Rwt4Y.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $1bkmv.css)($b1d6842171a44156$var$_t4 || ($b1d6842171a44156$var$_t4 = $b1d6842171a44156$var$_1($b1d6842171a44156$var$t3 || ($b1d6842171a44156$var$t3 = $b1d6842171a44156$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), 0)), $b1d6842171a44156$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $b1d6842171a44156$var$CircularProgress = /*#__PURE__*/ $1kowh.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $g98HC.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $7lC2m.default)(props, $b1d6842171a44156$var$_excluded);
    const ownerState = (0, $Rwt4Y.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $b1d6842171a44156$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($b1d6842171a44156$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $3QTul.jsx)($b1d6842171a44156$var$CircularProgressRoot, (0, $Rwt4Y.default)({
        className: (0, $4IMR9.default)(classes.root, className),
        style: (0, $Rwt4Y.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $3QTul.jsx)($b1d6842171a44156$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$b1d6842171a44156$var$SIZE / 2} ${$b1d6842171a44156$var$SIZE / 2} ${$b1d6842171a44156$var$SIZE} ${$b1d6842171a44156$var$SIZE}`,
            children: /*#__PURE__*/ (0, $3QTul.jsx)($b1d6842171a44156$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $b1d6842171a44156$var$SIZE,
                cy: $b1d6842171a44156$var$SIZE,
                r: ($b1d6842171a44156$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $b1d6842171a44156$export$2e2bcd8739ae039 = $b1d6842171a44156$var$CircularProgress;

});
parcelRegister("4IMR9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $044093296df0e76c$export$2e2bcd8739ae039; });
function $044093296df0e76c$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $044093296df0e76c$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $044093296df0e76c$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $044093296df0e76c$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $044093296df0e76c$export$2e2bcd8739ae039 = $044093296df0e76c$export$4f5d2d50c9deca37;

});

parcelRegister("g6GaX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb9dec14315eac66$export$2e2bcd8739ae039; });
function $bb9dec14315eac66$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("c2aca", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c2d947d0820e8b1$export$2e2bcd8739ae039; });

var $iaCWb = parcelRequire("iaCWb");
var $8c2d947d0820e8b1$export$2e2bcd8739ae039 = (0, $iaCWb.default);

});

parcelRegister("g98HC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc143cbe587cb736$export$2e2bcd8739ae039; });

var $hJrhd = parcelRequire("hJrhd");

var $2clJG = parcelRequire("2clJG");

var $25rSD = parcelRequire("25rSD");
"use client";
function $bc143cbe587cb736$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $hJrhd.default)({
        props: props,
        name: name,
        defaultTheme: $2clJG.default,
        themeId: (0, $25rSD.default)
    });
}

});
parcelRegister("hJrhd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce8bcc3cf67da37e$export$2e2bcd8739ae039; });

var $6PFBU = parcelRequire("6PFBU");

var $inf70 = parcelRequire("inf70");
"use client";
function $ce8bcc3cf67da37e$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $inf70.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $6PFBU.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("6PFBU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f97c87963540606$export$2e2bcd8739ae039; });

var $8jDRf = parcelRequire("8jDRf");
function $4f97c87963540606$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $8jDRf.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("8jDRf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60df0409fe057725$export$2e2bcd8739ae039; });

var $Rwt4Y = parcelRequire("Rwt4Y");
function $60df0409fe057725$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $Rwt4Y.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $Rwt4Y.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $Rwt4Y.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $60df0409fe057725$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("inf70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d60618e11cd6626a$export$2e2bcd8739ae039; });

var $4ji3S = parcelRequire("4ji3S");

var $bsrF1 = parcelRequire("bsrF1");
"use client";
const $d60618e11cd6626a$export$35e57303dbd8a66 = (0, $4ji3S.default)();
function $d60618e11cd6626a$var$useTheme(defaultTheme = $d60618e11cd6626a$export$35e57303dbd8a66) {
    return (0, $bsrF1.default)(defaultTheme);
}
var $d60618e11cd6626a$export$2e2bcd8739ae039 = $d60618e11cd6626a$var$useTheme;

});


parcelRegister("2clJG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $199d9008cebf350a$export$2e2bcd8739ae039; });

var $jadBd = parcelRequire("jadBd");
"use client";
const $199d9008cebf350a$var$defaultTheme = (0, $jadBd.default)();
var $199d9008cebf350a$export$2e2bcd8739ae039 = $199d9008cebf350a$var$defaultTheme;

});


parcelRegister("1r1xG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10b9824fb85a54ad$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("rho0F")).default; });

var $hh7oq = parcelRequire("hh7oq");

var $2clJG = parcelRequire("2clJG");

var $25rSD = parcelRequire("25rSD");

var $rho0F = parcelRequire("rho0F");

"use client";
const $10b9824fb85a54ad$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($hh7oq)))({
    themeId: (0, $25rSD.default),
    defaultTheme: $2clJG.default,
    rootShouldForwardProp: $rho0F.default
});
var $10b9824fb85a54ad$export$2e2bcd8739ae039 = $10b9824fb85a54ad$var$styled;

});
parcelRegister("hh7oq", function(module, exports) {
"use strict";

var $eLsQG = parcelRequire("eLsQG");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c939c2467f5b7918$var$createStyled;
module.exports.shouldForwardProp = $c939c2467f5b7918$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $c939c2467f5b7918$var$_extends2 = $eLsQG((parcelRequire("3JwIc")));

var $c939c2467f5b7918$var$_objectWithoutPropertiesLoose2 = $eLsQG((parcelRequire("aEubR")));

var $c939c2467f5b7918$var$_styledEngine = $c939c2467f5b7918$var$_interopRequireWildcard((parcelRequire("16ubh")));

var $gwiww = parcelRequire("gwiww");

var $c939c2467f5b7918$var$_capitalize = $eLsQG((parcelRequire("i5LeB")));

var $c939c2467f5b7918$var$_getDisplayName = $eLsQG((parcelRequire("cam8T")));

var $c939c2467f5b7918$var$_createTheme = $eLsQG((parcelRequire("57Fdy")));

var $c939c2467f5b7918$var$_styleFunctionSx = $eLsQG((parcelRequire("e5NBz")));
const $c939c2467f5b7918$var$_excluded = [
    "ownerState"
], $c939c2467f5b7918$var$_excluded2 = [
    "variants"
], $c939c2467f5b7918$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $c939c2467f5b7918$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c939c2467f5b7918$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $c939c2467f5b7918$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $c939c2467f5b7918$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $c939c2467f5b7918$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $c939c2467f5b7918$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $c939c2467f5b7918$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $c939c2467f5b7918$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $c939c2467f5b7918$var$_createTheme.default)();
const $c939c2467f5b7918$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $c939c2467f5b7918$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $c939c2467f5b7918$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $c939c2467f5b7918$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $c939c2467f5b7918$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $c939c2467f5b7918$var$_objectWithoutPropertiesLoose2.default)(_ref, $c939c2467f5b7918$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $c939c2467f5b7918$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$c939c2467f5b7918$var$processStyleArg(resolvedStyle, (0, $c939c2467f5b7918$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $c939c2467f5b7918$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $c939c2467f5b7918$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $c939c2467f5b7918$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $c939c2467f5b7918$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $c939c2467f5b7918$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $c939c2467f5b7918$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $c939c2467f5b7918$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $c939c2467f5b7918$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $c939c2467f5b7918$var$_styleFunctionSx.default)((0, $c939c2467f5b7918$var$_extends2.default)({}, props, {
            theme: $c939c2467f5b7918$var$resolveTheme((0, $c939c2467f5b7918$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $c939c2467f5b7918$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $c939c2467f5b7918$var$defaultOverridesResolver($c939c2467f5b7918$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $c939c2467f5b7918$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $c939c2467f5b7918$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $c939c2467f5b7918$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($c939c2467f5b7918$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $c939c2467f5b7918$var$_styledEngine.default)(tag, (0, $c939c2467f5b7918$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $gwiww.isPlainObject)(stylesArg)) return (props)=>$c939c2467f5b7918$var$processStyleArg(stylesArg, (0, $c939c2467f5b7918$var$_extends2.default)({}, props, {
                    theme: $c939c2467f5b7918$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $c939c2467f5b7918$var$resolveTheme((0, $c939c2467f5b7918$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $c939c2467f5b7918$var$processStyleArg(slotStyle, (0, $c939c2467f5b7918$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $c939c2467f5b7918$var$resolveTheme((0, $c939c2467f5b7918$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $c939c2467f5b7918$var$processStyleArg({
                    variants: themeVariants
                }, (0, $c939c2467f5b7918$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("3JwIc", function(module, exports) {
function $2b7ef2fdeedfdd5c$var$_extends() {
    module.exports = $2b7ef2fdeedfdd5c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $2b7ef2fdeedfdd5c$var$_extends.apply(this, arguments);
}
module.exports = $2b7ef2fdeedfdd5c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aEubR", function(module, exports) {
function $7c150efa6a2d1a00$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $7c150efa6a2d1a00$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("16ubh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0cddc34bc15177bc$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $0cddc34bc15177bc$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("eKWiI")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("1bkmv")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("1bkmv")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("lrjQ7")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("bbQ5I")).default; });
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $7j2oQ = parcelRequire("7j2oQ");

var $1bkmv = parcelRequire("1bkmv");
var $eKWiI = parcelRequire("eKWiI");

var $lrjQ7 = parcelRequire("lrjQ7");

var $bbQ5I = parcelRequire("bbQ5I");
"use client";
function $0cddc34bc15177bc$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $7j2oQ.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $0cddc34bc15177bc$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("7j2oQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $551c2b42b3918328$export$2e2bcd8739ae039; });

var $h5gx3 = parcelRequire("h5gx3");
parcelRequire("bfNLT");

parcelRequire("aN96n");
parcelRequire("6wkQa");
parcelRequire("gynzZ");
parcelRequire("1kowh");
parcelRequire("cWQX4");
var $551c2b42b3918328$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
// bind it to avoid mutating the original function
var $551c2b42b3918328$export$2e2bcd8739ae039 = (0, $h5gx3.default).bind(null);
$551c2b42b3918328$var$tags.forEach(function(tagName) {
    $551c2b42b3918328$export$2e2bcd8739ae039[tagName] = $551c2b42b3918328$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("h5gx3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6ffba36db2bbc0a$export$2e2bcd8739ae039; });

var $2mKDo = parcelRequire("2mKDo");
parcelRequire("1bkmv");
var $eKWiI = parcelRequire("eKWiI");

var $aN96n = parcelRequire("aN96n");

var $6wkQa = parcelRequire("6wkQa");

var $gynzZ = parcelRequire("gynzZ");

var $1kowh = parcelRequire("1kowh");

var $cWQX4 = parcelRequire("cWQX4");
var $c6ffba36db2bbc0a$var$isBrowser = typeof document !== "undefined";
var $c6ffba36db2bbc0a$var$isDevelopment = false;
var $c6ffba36db2bbc0a$var$testOmitPropsOnStringTag = (0, $cWQX4.default);
var $c6ffba36db2bbc0a$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $c6ffba36db2bbc0a$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $c6ffba36db2bbc0a$var$testOmitPropsOnStringTag : $c6ffba36db2bbc0a$var$testOmitPropsOnComponent;
};
var $c6ffba36db2bbc0a$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $c6ffba36db2bbc0a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $gynzZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $6wkQa.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $gynzZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$c6ffba36db2bbc0a$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $1kowh.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $c6ffba36db2bbc0a$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $c6ffba36db2bbc0a$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $c6ffba36db2bbc0a$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $eKWiI.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $1kowh.useContext((0, $eKWiI.T));
            }
            if (typeof props.className === "string") className = (0, $gynzZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $aN96n.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $c6ffba36db2bbc0a$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $1kowh.createElement($1kowh.Fragment, null, /*#__PURE__*/ $1kowh.createElement($c6ffba36db2bbc0a$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $1kowh.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $c6ffba36db2bbc0a$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $2mKDo.default)({}, options, nextOptions, {
                shouldForwardProp: $c6ffba36db2bbc0a$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("cWQX4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96d3f9e8381f3766$export$2e2bcd8739ae039; });

var $d3nIO = parcelRequire("d3nIO");
// eslint-disable-next-line no-undef
var $96d3f9e8381f3766$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $96d3f9e8381f3766$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $d3nIO.default)(function(prop) {
    return $96d3f9e8381f3766$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("lrjQ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9bb824fbb14081a$export$2e2bcd8739ae039; });
parcelRequire("1kowh");


var $eKWiI = parcelRequire("eKWiI");

var $gnoPI = parcelRequire("gnoPI");

var $3QTul = parcelRequire("3QTul");
"use client";
let $f9bb824fbb14081a$var$cache;
if (typeof document === "object") $f9bb824fbb14081a$var$cache = (0, $gnoPI.default)({
    key: "css",
    prepend: true
});
function $f9bb824fbb14081a$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $f9bb824fbb14081a$var$cache ? /*#__PURE__*/ (0, $3QTul.jsx)((0, $eKWiI.C), {
        value: $f9bb824fbb14081a$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("gnoPI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bec20ea88d0cdc67$export$2e2bcd8739ae039; });

var $6RUcK = parcelRequire("6RUcK");

var $t3G57 = parcelRequire("t3G57");
parcelRequire("BHw2G");
parcelRequire("4EHfM");
var $bec20ea88d0cdc67$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $t3G57.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $t3G57.token)(character)) break;
        (0, $t3G57.next)();
    }
    return (0, $t3G57.slice)(begin, (0, $t3G57.position));
};
var $bec20ea88d0cdc67$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $t3G57.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $t3G57.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $bec20ea88d0cdc67$var$identifierWithPointTracking((0, $t3G57.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $t3G57.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $t3G57.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $t3G57.from)(character);
    }
    while (character = (0, $t3G57.next)());
    return parsed;
};
var $bec20ea88d0cdc67$var$getRules = function getRules(value, points) {
    return (0, $t3G57.dealloc)($bec20ea88d0cdc67$var$toRules((0, $t3G57.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $bec20ea88d0cdc67$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $bec20ea88d0cdc67$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$bec20ea88d0cdc67$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $bec20ea88d0cdc67$var$fixedElements.set(element, true);
    var points = [];
    var rules = $bec20ea88d0cdc67$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $bec20ea88d0cdc67$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $bec20ea88d0cdc67$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $bec20ea88d0cdc67$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($bec20ea88d0cdc67$var$ignoreFlag) > -1;
};
var $bec20ea88d0cdc67$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($bec20ea88d0cdc67$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $bec20ea88d0cdc67$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $bec20ea88d0cdc67$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$bec20ea88d0cdc67$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $bec20ea88d0cdc67$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $bec20ea88d0cdc67$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$bec20ea88d0cdc67$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $bec20ea88d0cdc67$var$nullifyElement(element);
    } else if ($bec20ea88d0cdc67$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $bec20ea88d0cdc67$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $bec20ea88d0cdc67$var$prefix(value, length) {
    switch((0, $t3G57.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $t3G57.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $t3G57.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MOZ) + value + (0, $t3G57.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + value + value;
        // order
        case 6165:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.replace)(value, /(\w+).+(:[^]+)/, (0, $t3G57.WEBKIT) + "box-$1$2" + (0, $t3G57.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + "flex-item-" + (0, $t3G57.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + "flex-line-pack" + (0, $t3G57.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + (0, $t3G57.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + (0, $t3G57.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $t3G57.WEBKIT) + "box-" + (0, $t3G57.replace)(value, "-grow", "") + (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + (0, $t3G57.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $t3G57.WEBKIT) + (0, $t3G57.replace)(value, /([^-])(transform)/g, "$1" + (0, $t3G57.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $t3G57.replace)((0, $t3G57.replace)((0, $t3G57.replace)(value, /(zoom-|grab)/, (0, $t3G57.WEBKIT) + "$1"), /(image-set)/, (0, $t3G57.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $t3G57.replace)(value, /(image-set\([^]*)/, (0, $t3G57.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $t3G57.replace)((0, $t3G57.replace)(value, /(.+:)(flex-)?(.*)/, (0, $t3G57.WEBKIT) + "box-pack:$3" + (0, $t3G57.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $t3G57.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $t3G57.replace)(value, /(.+)-inline(.+)/, (0, $t3G57.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $t3G57.strlen)(value) - 1 - length > 6) switch((0, $t3G57.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $t3G57.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $t3G57.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $t3G57.WEBKIT) + "$2-$3" + "$1" + (0, $t3G57.MOZ) + ((0, $t3G57.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $t3G57.indexof)(value, "stretch") ? $bec20ea88d0cdc67$var$prefix((0, $t3G57.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $t3G57.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $t3G57.charat)(value, (0, $t3G57.strlen)(value) - 3 - (~(0, $t3G57.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $t3G57.replace)(value, ":", ":" + (0, $t3G57.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $t3G57.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $t3G57.WEBKIT) + ((0, $t3G57.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $t3G57.WEBKIT) + "$2$3" + "$1" + (0, $t3G57.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $t3G57.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + (0, $t3G57.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + (0, $t3G57.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + (0, $t3G57.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $t3G57.WEBKIT) + value + (0, $t3G57.MS) + value + value;
    }
    return value;
}
var $bec20ea88d0cdc67$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $t3G57.DECLARATION:
                element["return"] = $bec20ea88d0cdc67$var$prefix(element.value, element.length);
                break;
            case 0, $t3G57.KEYFRAMES:
                return (0, $t3G57.serialize)([
                    (0, $t3G57.copy)(element, {
                        value: (0, $t3G57.replace)(element.value, "@", "@" + (0, $t3G57.WEBKIT))
                    })
                ], callback);
            case 0, $t3G57.RULESET:
                if (element.length) return (0, $t3G57.combine)(element.props, function(value) {
                    switch((0, $t3G57.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $t3G57.serialize)([
                                (0, $t3G57.copy)(element, {
                                    props: [
                                        (0, $t3G57.replace)(value, /:(read-\w+)/, ":" + (0, $t3G57.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $t3G57.serialize)([
                                (0, $t3G57.copy)(element, {
                                    props: [
                                        (0, $t3G57.replace)(value, /:(plac\w+)/, ":" + (0, $t3G57.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $t3G57.copy)(element, {
                                    props: [
                                        (0, $t3G57.replace)(value, /:(plac\w+)/, ":" + (0, $t3G57.MOZ) + "$1")
                                    ]
                                }),
                                (0, $t3G57.copy)(element, {
                                    props: [
                                        (0, $t3G57.replace)(value, /:(plac\w+)/, (0, $t3G57.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $bec20ea88d0cdc67$var$defaultStylisPlugins = [
    $bec20ea88d0cdc67$var$prefixer
];
var $bec20ea88d0cdc67$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $bec20ea88d0cdc67$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $bec20ea88d0cdc67$var$compat,
        $bec20ea88d0cdc67$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $t3G57.stringify),
        (0, $t3G57.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $t3G57.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $t3G57.serialize)((0, $t3G57.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $6RUcK.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("6RUcK", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $50034a66c9dfddca$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $50034a66c9dfddca$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $50034a66c9dfddca$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $50034a66c9dfddca$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($50034a66c9dfddca$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $50034a66c9dfddca$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("BHw2G", function(module, exports) {
var $071536265326613f$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("4EHfM", function(module, exports) {
function $363c731dfcc5f926$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("bbQ5I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $021a3635b71bbbc4$export$2e2bcd8739ae039; });
parcelRequire("1kowh");


var $1bkmv = parcelRequire("1bkmv");

var $3QTul = parcelRequire("3QTul");
"use client";
function $021a3635b71bbbc4$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $021a3635b71bbbc4$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($021a3635b71bbbc4$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $3QTul.jsx)((0, $1bkmv.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("i5LeB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("iaCWb")).default; });

var $iaCWb = parcelRequire("iaCWb");

});

parcelRegister("cam8T", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9GZzp")).default; });

var $9GZzp = parcelRequire("9GZzp");
$parcel$exportWildcard(module.exports, $9GZzp);

});
parcelRegister("9GZzp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $70e7cbd9456781e2$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $70e7cbd9456781e2$export$2e2bcd8739ae039; });

var $bF1rc = parcelRequire("bF1rc");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $70e7cbd9456781e2$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $70e7cbd9456781e2$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($70e7cbd9456781e2$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $70e7cbd9456781e2$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $70e7cbd9456781e2$export$aad197c7121a6651(Component) || fallback;
}
function $70e7cbd9456781e2$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $70e7cbd9456781e2$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $70e7cbd9456781e2$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $70e7cbd9456781e2$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $bF1rc.ForwardRef:
            return $70e7cbd9456781e2$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $bF1rc.Memo:
            return $70e7cbd9456781e2$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("bF1rc", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7lA5E"));

});
parcelRegister("7lA5E", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $55967d501394a250$export$a7c73072b1a182ae; }, function (v) { return $55967d501394a250$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $55967d501394a250$export$9f27bc3417b4524d; }, function (v) { return $55967d501394a250$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $55967d501394a250$export$db77ccec0bb4ccac; }, function (v) { return $55967d501394a250$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $55967d501394a250$export$8392c0c9d3dcbd35; }, function (v) { return $55967d501394a250$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $55967d501394a250$export$ffb0004e005737fa; }, function (v) { return $55967d501394a250$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $55967d501394a250$export$b624eff549462981; }, function (v) { return $55967d501394a250$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $55967d501394a250$export$7897aa7841a5380c; }, function (v) { return $55967d501394a250$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $55967d501394a250$export$602eac185826482c; }, function (v) { return $55967d501394a250$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $55967d501394a250$export$e2c29f18771995cb; }, function (v) { return $55967d501394a250$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $55967d501394a250$export$5f8d39834fd61797; }, function (v) { return $55967d501394a250$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $55967d501394a250$export$74bf444e3cd11ea5; }, function (v) { return $55967d501394a250$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $55967d501394a250$export$998bcd577473dd93; }, function (v) { return $55967d501394a250$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $55967d501394a250$export$92387174baf9b227; }, function (v) { return $55967d501394a250$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $55967d501394a250$export$ec112efeb987d9c6; }, function (v) { return $55967d501394a250$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $55967d501394a250$export$b706b080d889d2c9; }, function (v) { return $55967d501394a250$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $55967d501394a250$export$5be5a87408f70ddc; }, function (v) { return $55967d501394a250$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $55967d501394a250$export$45a5e7f76e0caa8d; }, function (v) { return $55967d501394a250$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $55967d501394a250$export$455c2e768291efa6; }, function (v) { return $55967d501394a250$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $55967d501394a250$export$9522e17588c12572; }, function (v) { return $55967d501394a250$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $55967d501394a250$export$2110ac352bb060b9; }, function (v) { return $55967d501394a250$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $55967d501394a250$export$56885ab8b9c456ab; }, function (v) { return $55967d501394a250$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $55967d501394a250$export$d927fcb6adf8f9de; }, function (v) { return $55967d501394a250$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $55967d501394a250$export$b82d16f27459e05a; }, function (v) { return $55967d501394a250$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $55967d501394a250$export$522c17b4f5e123e8; }, function (v) { return $55967d501394a250$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $55967d501394a250$export$1aabd8a0274ecfd6; }, function (v) { return $55967d501394a250$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $55967d501394a250$export$3d6c20d97e46b957; }, function (v) { return $55967d501394a250$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $55967d501394a250$export$9b621391a187a31a; }, function (v) { return $55967d501394a250$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $55967d501394a250$export$f5bbd400c2f4426f; }, function (v) { return $55967d501394a250$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $55967d501394a250$export$a7c73072b1a182ae;
var $55967d501394a250$export$9f27bc3417b4524d;
var $55967d501394a250$export$db77ccec0bb4ccac;
var $55967d501394a250$export$8392c0c9d3dcbd35;
var $55967d501394a250$export$ffb0004e005737fa;
var $55967d501394a250$export$b624eff549462981;
var $55967d501394a250$export$7897aa7841a5380c;
var $55967d501394a250$export$602eac185826482c;
var $55967d501394a250$export$e2c29f18771995cb;
var $55967d501394a250$export$5f8d39834fd61797;
var $55967d501394a250$export$74bf444e3cd11ea5;
var $55967d501394a250$export$998bcd577473dd93;
var $55967d501394a250$export$92387174baf9b227;
var $55967d501394a250$export$ec112efeb987d9c6;
var $55967d501394a250$export$b706b080d889d2c9;
var $55967d501394a250$export$5be5a87408f70ddc;
var $55967d501394a250$export$45a5e7f76e0caa8d;
var $55967d501394a250$export$455c2e768291efa6;
var $55967d501394a250$export$9522e17588c12572;
var $55967d501394a250$export$2110ac352bb060b9;
var $55967d501394a250$export$56885ab8b9c456ab;
var $55967d501394a250$export$d927fcb6adf8f9de;
var $55967d501394a250$export$b82d16f27459e05a;
var $55967d501394a250$export$522c17b4f5e123e8;
var $55967d501394a250$export$1aabd8a0274ecfd6;
var $55967d501394a250$export$3d6c20d97e46b957;
var $55967d501394a250$export$9b621391a187a31a;
var $55967d501394a250$export$f5bbd400c2f4426f;
"use strict";
var $55967d501394a250$var$b = Symbol.for("react.element"), $55967d501394a250$var$c = Symbol.for("react.portal"), $55967d501394a250$var$d = Symbol.for("react.fragment"), $55967d501394a250$var$e = Symbol.for("react.strict_mode"), $55967d501394a250$var$f = Symbol.for("react.profiler"), $55967d501394a250$var$g = Symbol.for("react.provider"), $55967d501394a250$var$h = Symbol.for("react.context"), $55967d501394a250$var$k = Symbol.for("react.server_context"), $55967d501394a250$var$l = Symbol.for("react.forward_ref"), $55967d501394a250$var$m = Symbol.for("react.suspense"), $55967d501394a250$var$n = Symbol.for("react.suspense_list"), $55967d501394a250$var$p = Symbol.for("react.memo"), $55967d501394a250$var$q = Symbol.for("react.lazy"), $55967d501394a250$var$t = Symbol.for("react.offscreen"), $55967d501394a250$var$u;
$55967d501394a250$var$u = Symbol.for("react.module.reference");
function $55967d501394a250$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $55967d501394a250$var$b:
                switch(a = a.type, a){
                    case $55967d501394a250$var$d:
                    case $55967d501394a250$var$f:
                    case $55967d501394a250$var$e:
                    case $55967d501394a250$var$m:
                    case $55967d501394a250$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $55967d501394a250$var$k:
                            case $55967d501394a250$var$h:
                            case $55967d501394a250$var$l:
                            case $55967d501394a250$var$q:
                            case $55967d501394a250$var$p:
                            case $55967d501394a250$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $55967d501394a250$var$c:
                return r;
        }
    }
}
$55967d501394a250$export$a7c73072b1a182ae = $55967d501394a250$var$h;
$55967d501394a250$export$9f27bc3417b4524d = $55967d501394a250$var$g;
$55967d501394a250$export$db77ccec0bb4ccac = $55967d501394a250$var$b;
$55967d501394a250$export$8392c0c9d3dcbd35 = $55967d501394a250$var$l;
$55967d501394a250$export$ffb0004e005737fa = $55967d501394a250$var$d;
$55967d501394a250$export$b624eff549462981 = $55967d501394a250$var$q;
$55967d501394a250$export$7897aa7841a5380c = $55967d501394a250$var$p;
$55967d501394a250$export$602eac185826482c = $55967d501394a250$var$c;
$55967d501394a250$export$e2c29f18771995cb = $55967d501394a250$var$f;
$55967d501394a250$export$5f8d39834fd61797 = $55967d501394a250$var$e;
$55967d501394a250$export$74bf444e3cd11ea5 = $55967d501394a250$var$m;
$55967d501394a250$export$998bcd577473dd93 = $55967d501394a250$var$n;
$55967d501394a250$export$92387174baf9b227 = function() {
    return !1;
};
$55967d501394a250$export$ec112efeb987d9c6 = function() {
    return !1;
};
$55967d501394a250$export$b706b080d889d2c9 = function(a) {
    return $55967d501394a250$var$v(a) === $55967d501394a250$var$h;
};
$55967d501394a250$export$5be5a87408f70ddc = function(a) {
    return $55967d501394a250$var$v(a) === $55967d501394a250$var$g;
};
$55967d501394a250$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $55967d501394a250$var$b;
};
$55967d501394a250$export$455c2e768291efa6 = function(a) {
    return $55967d501394a250$var$v(a) === $55967d501394a250$var$l;
};
$55967d501394a250$export$9522e17588c12572 = function(a) {
    return $55967d501394a250$var$v(a) === $55967d501394a250$var$d;
};
$55967d501394a250$export$2110ac352bb060b9 = function(a) {
    return $55967d501394a250$var$v(a) === $55967d501394a250$var$q;
};
$55967d501394a250$export$56885ab8b9c456ab = function(a) {
    return $55967d501394a250$var$v(a) === $55967d501394a250$var$p;
};
$55967d501394a250$export$d927fcb6adf8f9de = function(a) {
    return $55967d501394a250$var$v(a) === $55967d501394a250$var$c;
};
$55967d501394a250$export$b82d16f27459e05a = function(a) {
    return $55967d501394a250$var$v(a) === $55967d501394a250$var$f;
};
$55967d501394a250$export$522c17b4f5e123e8 = function(a) {
    return $55967d501394a250$var$v(a) === $55967d501394a250$var$e;
};
$55967d501394a250$export$1aabd8a0274ecfd6 = function(a) {
    return $55967d501394a250$var$v(a) === $55967d501394a250$var$m;
};
$55967d501394a250$export$3d6c20d97e46b957 = function(a) {
    return $55967d501394a250$var$v(a) === $55967d501394a250$var$n;
};
$55967d501394a250$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $55967d501394a250$var$d || a === $55967d501394a250$var$f || a === $55967d501394a250$var$e || a === $55967d501394a250$var$m || a === $55967d501394a250$var$n || a === $55967d501394a250$var$t || "object" === typeof a && null !== a && (a.$$typeof === $55967d501394a250$var$q || a.$$typeof === $55967d501394a250$var$p || a.$$typeof === $55967d501394a250$var$g || a.$$typeof === $55967d501394a250$var$h || a.$$typeof === $55967d501394a250$var$l || a.$$typeof === $55967d501394a250$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$55967d501394a250$export$f5bbd400c2f4426f = $55967d501394a250$var$v;

});




parcelRegister("57Fdy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("4ji3S")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("j1D7w")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("fHnrl")).default; });

var $4ji3S = parcelRequire("4ji3S");

var $j1D7w = parcelRequire("j1D7w");

var $fHnrl = parcelRequire("fHnrl");

});

parcelRegister("e5NBz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("aHr85")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("aHr85")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("6pXe5")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("9hkdV")).default; });

var $aHr85 = parcelRequire("aHr85");

var $6pXe5 = parcelRequire("6pXe5");

var $9hkdV = parcelRequire("9hkdV");

});
parcelRegister("6pXe5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ac304f441bca525$export$2e2bcd8739ae039; });

var $Rwt4Y = parcelRequire("Rwt4Y");

var $7lC2m = parcelRequire("7lC2m");

var $gwiww = parcelRequire("gwiww");

var $9hkdV = parcelRequire("9hkdV");
const $4ac304f441bca525$var$_excluded = [
    "sx"
];
const $4ac304f441bca525$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $9hkdV.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $4ac304f441bca525$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $7lC2m.default)(props, $4ac304f441bca525$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $4ac304f441bca525$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $gwiww.isPlainObject)(result)) return systemProps;
        return (0, $Rwt4Y.default)({}, systemProps, result);
    };
    else finalSx = (0, $Rwt4Y.default)({}, systemProps, inSx);
    return (0, $Rwt4Y.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRegister("rho0F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $052002476ecd9dd5$export$2e2bcd8739ae039; });

var $5dlF4 = parcelRequire("5dlF4");
const $052002476ecd9dd5$var$rootShouldForwardProp = (prop)=>(0, $5dlF4.default)(prop) && prop !== "classes";
var $052002476ecd9dd5$export$2e2bcd8739ae039 = $052002476ecd9dd5$var$rootShouldForwardProp;

});
parcelRegister("5dlF4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cbef82e180fd19e$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $3cbef82e180fd19e$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $3cbef82e180fd19e$export$2e2bcd8739ae039 = $3cbef82e180fd19e$var$slotShouldForwardProp;

});



parcelRegister("dtFw4", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", function () { return $9cfe30144817dbd7$export$29cad1383b3f235d; });

var $bvdDN = parcelRequire("bvdDN");

var $6umim = parcelRequire("6umim");
function $9cfe30144817dbd7$export$29cad1383b3f235d(slot) {
    return (0, $6umim.default)("MuiCircularProgress", slot);
}
const $9cfe30144817dbd7$var$circularProgressClasses = (0, $bvdDN.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $9cfe30144817dbd7$export$2e2bcd8739ae039 = $9cfe30144817dbd7$var$circularProgressClasses;

});
parcelRegister("bvdDN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85fd2bba854f054a$export$2e2bcd8739ae039; });

var $6umim = parcelRequire("6umim");
function $85fd2bba854f054a$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $6umim.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("6umim", function(module, exports) {

$parcel$export(module.exports, "globalStateClasses", function () { return $4b96d6c2ea6816ff$export$9d6b9120de57c54; });
$parcel$export(module.exports, "default", function () { return $4b96d6c2ea6816ff$export$2e2bcd8739ae039; });

var $frE2f = parcelRequire("frE2f");
const $4b96d6c2ea6816ff$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $4b96d6c2ea6816ff$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $4b96d6c2ea6816ff$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $frE2f.default).generate(componentName)}-${slot}`;
}
function $4b96d6c2ea6816ff$export$34c0130b1f3e8ae3(slot) {
    return $4b96d6c2ea6816ff$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("frE2f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3e86ed006fea5df$export$2e2bcd8739ae039; });
const $b3e86ed006fea5df$var$defaultGenerator = (componentName)=>componentName;
const $b3e86ed006fea5df$var$createClassNameGenerator = ()=>{
    let generate = $b3e86ed006fea5df$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $b3e86ed006fea5df$var$defaultGenerator;
        }
    };
};
const $b3e86ed006fea5df$var$ClassNameGenerator = $b3e86ed006fea5df$var$createClassNameGenerator();
var $b3e86ed006fea5df$export$2e2bcd8739ae039 = $b3e86ed006fea5df$var$ClassNameGenerator;

});





parcelRegister("lNqKO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fde2ed638f3dcb04$export$2e2bcd8739ae039; });

var $1kowh = parcelRequire("1kowh");

var $hdWa3 = parcelRequire("hdWa3");

var $6PFBU = parcelRequire("6PFBU");

var $bsrF1 = parcelRequire("bsrF1");
"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $fde2ed638f3dcb04$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $1kowh.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $hdWa3.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $fde2ed638f3dcb04$var$maybeReactUseSyncExternalStore = $1kowh.useSyncExternalStore;
function $fde2ed638f3dcb04$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $1kowh.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $1kowh.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $1kowh.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $fde2ed638f3dcb04$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $fde2ed638f3dcb04$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $bsrF1.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $6PFBU.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $fde2ed638f3dcb04$var$maybeReactUseSyncExternalStore !== undefined ? $fde2ed638f3dcb04$var$useMediaQueryNew : $fde2ed638f3dcb04$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}

});
parcelRegister("hdWa3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8a0c427f339bdec$export$2e2bcd8739ae039; });

var $1kowh = parcelRequire("1kowh");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $c8a0c427f339bdec$var$useEnhancedEffect = typeof window !== "undefined" ? $1kowh.useLayoutEffect : $1kowh.useEffect;
var $c8a0c427f339bdec$export$2e2bcd8739ae039 = $c8a0c427f339bdec$var$useEnhancedEffect;

});


parcelRegister("glGBC", function(module, exports) {

$parcel$export(module.exports, "pages", function () { return $4538275d9304a9a6$export$da3bc2f57520e3c3; });
$parcel$export(module.exports, "filteredPages", function () { return $4538275d9304a9a6$export$e0041c700ae6c2ef; });

var $1kowh = parcelRequire("1kowh");
const $4538275d9304a9a6$var$NAVBAR_EXCLUDES = [
    "imprint"
];



const $4538275d9304a9a6$export$da3bc2f57520e3c3 = {
    // resume: {
    //   title: "Résumé",
    //   path: "resume",
    //   Element: lazy(() => import("./pages/Resume")),
    // },
    about: {
        title: "About Me",
        path: "*",
        explizitPath: "about",
        Element: /*#__PURE__*/ (0, $1kowh.lazy)(()=>(parcelRequire("6gxN0")))
    },
    projects: {
        title: "Projects / Achievements",
        path: "projects-and-achievements",
        Element: /*#__PURE__*/ (0, $1kowh.lazy)(()=>(parcelRequire("bFbgE")))
    },
    imprint: {
        title: "Imprint (Impressum)",
        path: "imprint",
        Element: /*#__PURE__*/ (0, $1kowh.lazy)(()=>(parcelRequire("fzu0z")))
    }
};
const $4538275d9304a9a6$export$e0041c700ae6c2ef = Object.entries($4538275d9304a9a6$export$da3bc2f57520e3c3).filter(([_, { path: path }])=>!$4538275d9304a9a6$var$NAVBAR_EXCLUDES.includes(path)).reduce((obj, [key, value])=>({
        ...obj,
        [key]: value
    }), {});

});
parcelRegister("6gxN0", function(module, exports) {

var $9EGp1 = parcelRequire("9EGp1");
module.exports = $9EGp1("aL34s").then(()=>parcelRequire("5He8Q"));

});
parcelRegister("9EGp1", function(module, exports) {
"use strict";

function $7078bdc5b3473d31$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("h4c0n")).resolve(id));
}
module.exports = $7078bdc5b3473d31$var$load;

});


parcelRegister("bFbgE", function(module, exports) {

var $9EGp1 = parcelRequire("9EGp1");


module.exports = Promise.all([
    (parcelRequire("2buXn"))((parcelRequire("h4c0n")).resolve("cMaWm")),
    $9EGp1("4aRns"),
    $9EGp1("6oH5X")
]).then(()=>parcelRequire("fyW5H"));

});
parcelRegister("2buXn", function(module, exports) {
"use strict";

var $dpAVl = parcelRequire("dpAVl");
module.exports = $dpAVl(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("dpAVl", function(module, exports) {
"use strict";
var $9c3a4076ee5f0697$var$cachedBundles = {};
var $9c3a4076ee5f0697$var$cachedPreloads = {};
var $9c3a4076ee5f0697$var$cachedPrefetches = {};
function $9c3a4076ee5f0697$var$getCache(type) {
    switch(type){
        case "preload":
            return $9c3a4076ee5f0697$var$cachedPreloads;
        case "prefetch":
            return $9c3a4076ee5f0697$var$cachedPrefetches;
        default:
            return $9c3a4076ee5f0697$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $9c3a4076ee5f0697$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("fzu0z", function(module, exports) {

var $9EGp1 = parcelRequire("9EGp1");
module.exports = $9EGp1("d1aLq").then(()=>parcelRequire("1CLo8"));

});


parcelRegister("i9aPd", function(module, exports) {

$parcel$export(module.exports, "useIsMobile", function () { return $b92ddfaa5ee1953b$export$2b96349243a56116; });
$parcel$export(module.exports, "useIsDarkTheme", function () { return $b92ddfaa5ee1953b$export$bd656dda9b97c79c; });

var $1kowh = parcelRequire("1kowh");
function $b92ddfaa5ee1953b$export$2b96349243a56116() {
    return (0, $1kowh.useMemo)(()=>navigator.userAgent.includes("Mobile"), []);
}
function $b92ddfaa5ee1953b$export$bd656dda9b97c79c(theme) {
    return (0, $1kowh.useMemo)(()=>theme.palette.mode === "dark", [
        theme.palette.mode
    ]);
}
function $b92ddfaa5ee1953b$var$getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width: width,
        height: height
    };
}
function $b92ddfaa5ee1953b$export$f715c0e61b2c1a36() {
    const [windowDimensions, setWindowDimensions] = (0, $1kowh.useState)($b92ddfaa5ee1953b$var$getWindowDimensions());
    (0, $1kowh.useEffect)(()=>{
        function handleResize() {
            setWindowDimensions($b92ddfaa5ee1953b$var$getWindowDimensions());
        }
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowDimensions;
}

});

parcelRegister("4usDK", function(module, exports) {
module.exports = new URL("bg-light.7952c70f.png", import.meta.url).toString();

});

parcelRegister("eaYKj", function(module, exports) {
module.exports = new URL("bg-dark.eb61a23f.png", import.meta.url).toString();

});

parcelRegister("TYiiF", function(module, exports) {

var $9EGp1 = parcelRequire("9EGp1");
module.exports = $9EGp1("kmETd").then(()=>parcelRequire("kEd24"));

});

parcelRegister("cUYUb", function(module, exports) {

var $9EGp1 = parcelRequire("9EGp1");
module.exports = Promise.all([
    $9EGp1("5Kutp"),
    $9EGp1("f0KeL"),
    $9EGp1("hpOac")
]).then(()=>parcelRequire("b5qRi"));

});

parcelRegister("5mfdE", function(module, exports) {

var $9EGp1 = parcelRequire("9EGp1");
module.exports = $9EGp1("99AO6").then(()=>parcelRequire("iNZvi"));

});

parcelRegister("6HttA", function(module, exports) {

var $9EGp1 = parcelRequire("9EGp1");
module.exports = $9EGp1("iPCoQ").then(()=>parcelRequire("bRL6O"));

});

parcelRegister("55XjS", function(module, exports) {

var $9EGp1 = parcelRequire("9EGp1");
module.exports = $9EGp1("4jlb8").then(()=>parcelRequire("7KahY"));

});



var $3QTul = parcelRequire("3QTul");
var $d1e08b7efacb84c8$exports = {};
"use strict";
function $d1e08b7efacb84c8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d1e08b7efacb84c8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d1e08b7efacb84c8$var$checkDCE();

$d1e08b7efacb84c8$exports = (parcelRequire("40TyJ"));




var $f0C8E = parcelRequire("f0C8E");
/**
 * Why? Because I can...
 */ const $2fc3b44ef601bd14$var$crazyStyle = "font-weight: bold; font-size: 50px;color: red; text-shadow: 3px 3px 0 rgb(217,31,38) , 6px 6px 0 rgb(226,91,14) , 9px 9px 0 rgb(245,221,8) , 12px 12px 0 rgb(5,148,68) , 15px 15px 0 rgb(2,135,206) , 18px 18px 0 rgb(4,77,145) , 21px 21px 0 rgb(42,21,113)";
const $2fc3b44ef601bd14$var$defaultTextStyle = "color: rgb(2,135,206); font-size: 15px";
const $2fc3b44ef601bd14$var$divider = `%c ${"#".repeat(14)} `;
console.info($2fc3b44ef601bd14$var$divider, $2fc3b44ef601bd14$var$crazyStyle);
console.info("%c	Hi \uD83D\uDE0A\uD83D\uDC4B	", $2fc3b44ef601bd14$var$crazyStyle);
console.info("%cWhat are you looking for? Here is nothing to see.", $2fc3b44ef601bd14$var$defaultTextStyle);
console.info("%cFeel free to visit my GitHub: https://github.com/flokol120", $2fc3b44ef601bd14$var$defaultTextStyle);
console.info($2fc3b44ef601bd14$var$divider, $2fc3b44ef601bd14$var$crazyStyle);



var $1kowh = parcelRequire("1kowh");
const $4a5191623062d5ff$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($d1e08b7efacb84c8$exports))).createRoot(document.getElementById("root"));
$4a5191623062d5ff$var$root.render(/*#__PURE__*/ (0, $3QTul.jsx)((0, $1kowh.StrictMode), {
    children: /*#__PURE__*/ (0, $3QTul.jsx)((0, $f0C8E.default), {})
}));


//# sourceMappingURL=index.908543d0.js.map
